import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  GraphQLBigInt: { input: any; output: any; }
  GraphQLStringOrFloat: { input: any; output: any; }
  Hash: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export enum EventEnum {
  Create = 'create',
  Delete = 'delete',
  Update = 'update'
}

export type Mutation = {
  __typename?: 'Mutation';
  create_attorney_case_mp_preference_item?: Maybe<Attorney_Case_Mp_Preference>;
  create_attorney_case_mp_preference_items: Array<Attorney_Case_Mp_Preference>;
  create_attorney_favorite_item?: Maybe<Attorney_Favorite>;
  create_attorney_favorite_items: Array<Attorney_Favorite>;
  create_attorney_invite_item?: Maybe<Attorney_Invite>;
  create_attorney_invite_items: Array<Attorney_Invite>;
  create_attorney_oauth_integration_item?: Maybe<Attorney_Oauth_Integration>;
  create_attorney_oauth_integration_items: Array<Attorney_Oauth_Integration>;
  create_attorney_profile_award_item?: Maybe<Attorney_Profile_Award>;
  create_attorney_profile_award_items: Array<Attorney_Profile_Award>;
  create_attorney_profile_case_management_software_item?: Maybe<Attorney_Profile_Case_Management_Software>;
  create_attorney_profile_case_management_software_items: Array<Attorney_Profile_Case_Management_Software>;
  create_attorney_profile_communication_preference_item?: Maybe<Attorney_Profile_Communication_Preference>;
  create_attorney_profile_communication_preference_items: Array<Attorney_Profile_Communication_Preference>;
  create_attorney_profile_contact_item?: Maybe<Attorney_Profile_Contact>;
  create_attorney_profile_contact_items: Array<Attorney_Profile_Contact>;
  create_attorney_profile_education_item?: Maybe<Attorney_Profile_Education>;
  create_attorney_profile_education_items: Array<Attorney_Profile_Education>;
  create_attorney_profile_firm_item?: Maybe<Attorney_Profile_Firm>;
  create_attorney_profile_firm_items: Array<Attorney_Profile_Firm>;
  create_attorney_profile_language_item?: Maybe<Attorney_Profile_Language>;
  create_attorney_profile_language_items: Array<Attorney_Profile_Language>;
  create_attorney_profile_license_insurance_item?: Maybe<Attorney_Profile_License_Insurance>;
  create_attorney_profile_license_insurance_items: Array<Attorney_Profile_License_Insurance>;
  create_attorney_profile_license_item?: Maybe<Attorney_Profile_License>;
  create_attorney_profile_license_items: Array<Attorney_Profile_License>;
  create_attorney_profile_notification_level_item?: Maybe<Attorney_Profile_Notification_Level>;
  create_attorney_profile_notification_level_items: Array<Attorney_Profile_Notification_Level>;
  create_attorney_profile_practice_area_item?: Maybe<Attorney_Profile_Practice_Area>;
  create_attorney_profile_practice_area_items: Array<Attorney_Profile_Practice_Area>;
  create_attorney_stripe_item?: Maybe<Attorney_Stripe>;
  create_attorney_stripe_items: Array<Attorney_Stripe>;
  create_attorney_waterfall_item?: Maybe<Attorney_Waterfall>;
  create_attorney_waterfall_items: Array<Attorney_Waterfall>;
  create_attorney_waterfall_list_item?: Maybe<Attorney_Waterfall_List>;
  create_attorney_waterfall_list_item_item?: Maybe<Attorney_Waterfall_List_Item>;
  create_attorney_waterfall_list_item_items: Array<Attorney_Waterfall_List_Item>;
  create_attorney_waterfall_list_items: Array<Attorney_Waterfall_List>;
  create_attorney_waterfall_list_jdx_item?: Maybe<Attorney_Waterfall_List_Jdx>;
  create_attorney_waterfall_list_jdx_items: Array<Attorney_Waterfall_List_Jdx>;
  create_attorney_waterfall_list_pa_item?: Maybe<Attorney_Waterfall_List_Pa>;
  create_attorney_waterfall_list_pa_items: Array<Attorney_Waterfall_List_Pa>;
  create_case_affiliation_item?: Maybe<Case_Affiliation>;
  create_case_affiliation_items: Array<Case_Affiliation>;
  create_case_fee_overrides_item?: Maybe<Case_Fee_Overrides>;
  create_case_fee_overrides_items: Array<Case_Fee_Overrides>;
  create_case_file_item?: Maybe<Case_File>;
  create_case_file_items: Array<Case_File>;
  create_case_item?: Maybe<Case>;
  create_case_items: Array<Case>;
  create_case_lead_contact_item?: Maybe<Case_Lead_Contact>;
  create_case_lead_contact_items: Array<Case_Lead_Contact>;
  create_case_lead_item?: Maybe<Case_Lead>;
  create_case_lead_items: Array<Case_Lead>;
  create_case_ownership_item?: Maybe<Case_Ownership>;
  create_case_ownership_items: Array<Case_Ownership>;
  create_case_purchase_activity_item?: Maybe<Case_Purchase_Activity>;
  create_case_purchase_activity_items: Array<Case_Purchase_Activity>;
  create_case_purchase_item?: Maybe<Case_Purchase>;
  create_case_purchase_items: Array<Case_Purchase>;
  create_case_purchase_ownership_item?: Maybe<Case_Purchase_Ownership>;
  create_case_purchase_ownership_items: Array<Case_Purchase_Ownership>;
  create_case_purchase_payment_item?: Maybe<Case_Purchase_Payment>;
  create_case_purchase_payment_items: Array<Case_Purchase_Payment>;
  create_case_status_update_item?: Maybe<Case_Status_Update>;
  create_case_status_update_items: Array<Case_Status_Update>;
  create_case_status_update_scheduler_task_item?: Maybe<Case_Status_Update_Scheduler_Task>;
  create_case_status_update_scheduler_task_items: Array<Case_Status_Update_Scheduler_Task>;
  create_config_lcms_leaddocket_item?: Maybe<Config_Lcms_Leaddocket>;
  create_config_lcms_leaddocket_items: Array<Config_Lcms_Leaddocket>;
  create_filter_redundant_item?: Maybe<Filter_Redundant>;
  create_filter_redundant_items: Array<Filter_Redundant>;
  create_lcms_case_mapping_item?: Maybe<Lcms_Case_Mapping>;
  create_lcms_case_mapping_items: Array<Lcms_Case_Mapping>;
  create_lcms_health_check_item?: Maybe<Lcms_Health_Check>;
  create_lcms_health_check_items: Array<Lcms_Health_Check>;
  create_network_user_invite_item?: Maybe<Network_User_Invite>;
  create_network_user_invite_items: Array<Network_User_Invite>;
  create_organization_block_item?: Maybe<Organization_Block>;
  create_organization_block_items: Array<Organization_Block>;
  create_organization_connected_lcms_item?: Maybe<Organization_Connected_Lcms>;
  create_organization_connected_lcms_items: Array<Organization_Connected_Lcms>;
  create_organization_referral_settings_item?: Maybe<Organization_Referral_Settings>;
  create_organization_referral_settings_items: Array<Organization_Referral_Settings>;
  create_practice_attorney_mapping_item?: Maybe<Practice_Attorney_Mapping>;
  create_practice_attorney_mapping_items: Array<Practice_Attorney_Mapping>;
  create_school_item?: Maybe<School>;
  create_school_items: Array<School>;
  create_user_file_access_request_item?: Maybe<User_File_Access_Request>;
  create_user_file_access_request_items: Array<User_File_Access_Request>;
  delete_attorney_case_mp_preference_item?: Maybe<Delete_One>;
  delete_attorney_case_mp_preference_items?: Maybe<Delete_Many>;
  delete_attorney_favorite_item?: Maybe<Delete_One>;
  delete_attorney_favorite_items?: Maybe<Delete_Many>;
  delete_attorney_oauth_integration_item?: Maybe<Delete_One>;
  delete_attorney_oauth_integration_items?: Maybe<Delete_Many>;
  delete_attorney_profile_award_item?: Maybe<Delete_One>;
  delete_attorney_profile_award_items?: Maybe<Delete_Many>;
  delete_attorney_profile_case_management_software_item?: Maybe<Delete_One>;
  delete_attorney_profile_case_management_software_items?: Maybe<Delete_Many>;
  delete_attorney_profile_contact_item?: Maybe<Delete_One>;
  delete_attorney_profile_contact_items?: Maybe<Delete_Many>;
  delete_attorney_profile_education_item?: Maybe<Delete_One>;
  delete_attorney_profile_education_items?: Maybe<Delete_Many>;
  delete_attorney_profile_firm_item?: Maybe<Delete_One>;
  delete_attorney_profile_firm_items?: Maybe<Delete_Many>;
  delete_attorney_profile_language_item?: Maybe<Delete_One>;
  delete_attorney_profile_language_items?: Maybe<Delete_Many>;
  delete_attorney_profile_license_insurance_item?: Maybe<Delete_One>;
  delete_attorney_profile_license_insurance_items?: Maybe<Delete_Many>;
  delete_attorney_profile_license_item?: Maybe<Delete_One>;
  delete_attorney_profile_license_items?: Maybe<Delete_Many>;
  delete_attorney_profile_practice_area_item?: Maybe<Delete_One>;
  delete_attorney_profile_practice_area_items?: Maybe<Delete_Many>;
  delete_attorney_stripe_item?: Maybe<Delete_One>;
  delete_attorney_stripe_items?: Maybe<Delete_Many>;
  delete_attorney_waterfall_item?: Maybe<Delete_One>;
  delete_attorney_waterfall_items?: Maybe<Delete_Many>;
  delete_attorney_waterfall_list_item?: Maybe<Delete_One>;
  delete_attorney_waterfall_list_item_item?: Maybe<Delete_One>;
  delete_attorney_waterfall_list_item_items?: Maybe<Delete_Many>;
  delete_attorney_waterfall_list_items?: Maybe<Delete_Many>;
  delete_attorney_waterfall_list_jdx_item?: Maybe<Delete_One>;
  delete_attorney_waterfall_list_jdx_items?: Maybe<Delete_Many>;
  delete_attorney_waterfall_list_pa_item?: Maybe<Delete_One>;
  delete_attorney_waterfall_list_pa_items?: Maybe<Delete_Many>;
  delete_case_affiliation_item?: Maybe<Delete_One>;
  delete_case_affiliation_items?: Maybe<Delete_Many>;
  delete_case_fee_overrides_item?: Maybe<Delete_One>;
  delete_case_fee_overrides_items?: Maybe<Delete_Many>;
  delete_case_file_item?: Maybe<Delete_One>;
  delete_case_file_items?: Maybe<Delete_Many>;
  delete_case_item?: Maybe<Delete_One>;
  delete_case_items?: Maybe<Delete_Many>;
  delete_case_lead_contact_item?: Maybe<Delete_One>;
  delete_case_lead_contact_items?: Maybe<Delete_Many>;
  delete_case_lead_item?: Maybe<Delete_One>;
  delete_case_lead_items?: Maybe<Delete_Many>;
  delete_case_ownership_item?: Maybe<Delete_One>;
  delete_case_ownership_items?: Maybe<Delete_Many>;
  delete_case_purchase_ownership_item?: Maybe<Delete_One>;
  delete_case_purchase_ownership_items?: Maybe<Delete_Many>;
  delete_case_status_update_scheduler_task_item?: Maybe<Delete_One>;
  delete_case_status_update_scheduler_task_items?: Maybe<Delete_Many>;
  delete_config_lcms_leaddocket_item?: Maybe<Delete_One>;
  delete_config_lcms_leaddocket_items?: Maybe<Delete_Many>;
  delete_filter_redundant_item?: Maybe<Delete_One>;
  delete_filter_redundant_items?: Maybe<Delete_Many>;
  delete_organization_block_item?: Maybe<Delete_One>;
  delete_organization_block_items?: Maybe<Delete_Many>;
  delete_organization_connected_lcms_item?: Maybe<Delete_One>;
  delete_organization_connected_lcms_items?: Maybe<Delete_Many>;
  delete_practice_attorney_mapping_item?: Maybe<Delete_One>;
  delete_practice_attorney_mapping_items?: Maybe<Delete_Many>;
  delete_user_file_access_request_item?: Maybe<Delete_One>;
  delete_user_file_access_request_items?: Maybe<Delete_Many>;
  update_attorney_invite_batch: Array<Attorney_Invite>;
  update_attorney_invite_item?: Maybe<Attorney_Invite>;
  update_attorney_invite_items: Array<Attorney_Invite>;
  update_attorney_oauth_integration_batch: Array<Attorney_Oauth_Integration>;
  update_attorney_oauth_integration_item?: Maybe<Attorney_Oauth_Integration>;
  update_attorney_oauth_integration_items: Array<Attorney_Oauth_Integration>;
  update_attorney_profile_award_batch: Array<Attorney_Profile_Award>;
  update_attorney_profile_award_item?: Maybe<Attorney_Profile_Award>;
  update_attorney_profile_award_items: Array<Attorney_Profile_Award>;
  update_attorney_profile_batch: Array<Attorney_Profile>;
  update_attorney_profile_case_management_software_batch: Array<Attorney_Profile_Case_Management_Software>;
  update_attorney_profile_case_management_software_item?: Maybe<Attorney_Profile_Case_Management_Software>;
  update_attorney_profile_case_management_software_items: Array<Attorney_Profile_Case_Management_Software>;
  update_attorney_profile_communication_preference_batch: Array<Attorney_Profile_Communication_Preference>;
  update_attorney_profile_communication_preference_item?: Maybe<Attorney_Profile_Communication_Preference>;
  update_attorney_profile_communication_preference_items: Array<Attorney_Profile_Communication_Preference>;
  update_attorney_profile_contact_batch: Array<Attorney_Profile_Contact>;
  update_attorney_profile_contact_item?: Maybe<Attorney_Profile_Contact>;
  update_attorney_profile_contact_items: Array<Attorney_Profile_Contact>;
  update_attorney_profile_education_batch: Array<Attorney_Profile_Education>;
  update_attorney_profile_education_item?: Maybe<Attorney_Profile_Education>;
  update_attorney_profile_education_items: Array<Attorney_Profile_Education>;
  update_attorney_profile_firm_batch: Array<Attorney_Profile_Firm>;
  update_attorney_profile_firm_item?: Maybe<Attorney_Profile_Firm>;
  update_attorney_profile_firm_items: Array<Attorney_Profile_Firm>;
  update_attorney_profile_item?: Maybe<Attorney_Profile>;
  update_attorney_profile_items: Array<Attorney_Profile>;
  update_attorney_profile_language_batch: Array<Attorney_Profile_Language>;
  update_attorney_profile_language_item?: Maybe<Attorney_Profile_Language>;
  update_attorney_profile_language_items: Array<Attorney_Profile_Language>;
  update_attorney_profile_license_batch: Array<Attorney_Profile_License>;
  update_attorney_profile_license_insurance_batch: Array<Attorney_Profile_License_Insurance>;
  update_attorney_profile_license_insurance_item?: Maybe<Attorney_Profile_License_Insurance>;
  update_attorney_profile_license_insurance_items: Array<Attorney_Profile_License_Insurance>;
  update_attorney_profile_license_item?: Maybe<Attorney_Profile_License>;
  update_attorney_profile_license_items: Array<Attorney_Profile_License>;
  update_attorney_profile_notification_level_batch: Array<Attorney_Profile_Notification_Level>;
  update_attorney_profile_notification_level_item?: Maybe<Attorney_Profile_Notification_Level>;
  update_attorney_profile_notification_level_items: Array<Attorney_Profile_Notification_Level>;
  update_attorney_profile_practice_area_batch: Array<Attorney_Profile_Practice_Area>;
  update_attorney_profile_practice_area_item?: Maybe<Attorney_Profile_Practice_Area>;
  update_attorney_profile_practice_area_items: Array<Attorney_Profile_Practice_Area>;
  update_attorney_waterfall_batch: Array<Attorney_Waterfall>;
  update_attorney_waterfall_item?: Maybe<Attorney_Waterfall>;
  update_attorney_waterfall_items: Array<Attorney_Waterfall>;
  update_attorney_waterfall_list_batch: Array<Attorney_Waterfall_List>;
  update_attorney_waterfall_list_item?: Maybe<Attorney_Waterfall_List>;
  update_attorney_waterfall_list_item_batch: Array<Attorney_Waterfall_List_Item>;
  update_attorney_waterfall_list_item_item?: Maybe<Attorney_Waterfall_List_Item>;
  update_attorney_waterfall_list_item_items: Array<Attorney_Waterfall_List_Item>;
  update_attorney_waterfall_list_items: Array<Attorney_Waterfall_List>;
  update_attorney_waterfall_list_jdx_batch: Array<Attorney_Waterfall_List_Jdx>;
  update_attorney_waterfall_list_jdx_item?: Maybe<Attorney_Waterfall_List_Jdx>;
  update_attorney_waterfall_list_jdx_items: Array<Attorney_Waterfall_List_Jdx>;
  update_attorney_waterfall_list_pa_batch: Array<Attorney_Waterfall_List_Pa>;
  update_attorney_waterfall_list_pa_item?: Maybe<Attorney_Waterfall_List_Pa>;
  update_attorney_waterfall_list_pa_items: Array<Attorney_Waterfall_List_Pa>;
  update_case_affiliation_batch: Array<Case_Affiliation>;
  update_case_affiliation_item?: Maybe<Case_Affiliation>;
  update_case_affiliation_items: Array<Case_Affiliation>;
  update_case_batch: Array<Case>;
  update_case_fee_overrides_batch: Array<Case_Fee_Overrides>;
  update_case_fee_overrides_item?: Maybe<Case_Fee_Overrides>;
  update_case_fee_overrides_items: Array<Case_Fee_Overrides>;
  update_case_file_batch: Array<Case_File>;
  update_case_file_item?: Maybe<Case_File>;
  update_case_file_items: Array<Case_File>;
  update_case_item?: Maybe<Case>;
  update_case_items: Array<Case>;
  update_case_lead_batch: Array<Case_Lead>;
  update_case_lead_contact_batch: Array<Case_Lead_Contact>;
  update_case_lead_contact_item?: Maybe<Case_Lead_Contact>;
  update_case_lead_contact_items: Array<Case_Lead_Contact>;
  update_case_lead_item?: Maybe<Case_Lead>;
  update_case_lead_items: Array<Case_Lead>;
  update_case_ownership_batch: Array<Case_Ownership>;
  update_case_ownership_item?: Maybe<Case_Ownership>;
  update_case_ownership_items: Array<Case_Ownership>;
  update_case_purchase_batch: Array<Case_Purchase>;
  update_case_purchase_item?: Maybe<Case_Purchase>;
  update_case_purchase_items: Array<Case_Purchase>;
  update_case_purchase_ownership_batch: Array<Case_Purchase_Ownership>;
  update_case_purchase_ownership_item?: Maybe<Case_Purchase_Ownership>;
  update_case_purchase_ownership_items: Array<Case_Purchase_Ownership>;
  update_case_status_update_scheduler_task_batch: Array<Case_Status_Update_Scheduler_Task>;
  update_case_status_update_scheduler_task_item?: Maybe<Case_Status_Update_Scheduler_Task>;
  update_case_status_update_scheduler_task_items: Array<Case_Status_Update_Scheduler_Task>;
  update_config_lcms_leaddocket_batch: Array<Config_Lcms_Leaddocket>;
  update_config_lcms_leaddocket_item?: Maybe<Config_Lcms_Leaddocket>;
  update_config_lcms_leaddocket_items: Array<Config_Lcms_Leaddocket>;
  update_filter_redundant_batch: Array<Filter_Redundant>;
  update_filter_redundant_item?: Maybe<Filter_Redundant>;
  update_filter_redundant_items: Array<Filter_Redundant>;
  update_lcms_case_mapping_batch: Array<Lcms_Case_Mapping>;
  update_lcms_case_mapping_item?: Maybe<Lcms_Case_Mapping>;
  update_lcms_case_mapping_items: Array<Lcms_Case_Mapping>;
  update_network_user_invite_batch: Array<Network_User_Invite>;
  update_network_user_invite_item?: Maybe<Network_User_Invite>;
  update_network_user_invite_items: Array<Network_User_Invite>;
  update_organization_batch: Array<Organization>;
  update_organization_block_batch: Array<Organization_Block>;
  update_organization_block_item?: Maybe<Organization_Block>;
  update_organization_block_items: Array<Organization_Block>;
  update_organization_connected_lcms_batch: Array<Organization_Connected_Lcms>;
  update_organization_connected_lcms_item?: Maybe<Organization_Connected_Lcms>;
  update_organization_connected_lcms_items: Array<Organization_Connected_Lcms>;
  update_organization_item?: Maybe<Organization>;
  update_organization_items: Array<Organization>;
  update_organization_profile_batch: Array<Organization_Profile>;
  update_organization_profile_item?: Maybe<Organization_Profile>;
  update_organization_profile_items: Array<Organization_Profile>;
  update_organization_referral_settings_batch: Array<Organization_Referral_Settings>;
  update_organization_referral_settings_item?: Maybe<Organization_Referral_Settings>;
  update_organization_referral_settings_items: Array<Organization_Referral_Settings>;
  update_organization_user_batch: Array<Organization_User>;
  update_organization_user_item?: Maybe<Organization_User>;
  update_organization_user_items: Array<Organization_User>;
  update_practice_attorney_mapping_batch: Array<Practice_Attorney_Mapping>;
  update_practice_attorney_mapping_item?: Maybe<Practice_Attorney_Mapping>;
  update_practice_attorney_mapping_items: Array<Practice_Attorney_Mapping>;
  update_user_file_access_request_batch: Array<User_File_Access_Request>;
  update_user_file_access_request_item?: Maybe<User_File_Access_Request>;
  update_user_file_access_request_items: Array<User_File_Access_Request>;
};


export type MutationCreate_Attorney_Case_Mp_Preference_ItemArgs = {
  data: Create_Attorney_Case_Mp_Preference_Input;
};


export type MutationCreate_Attorney_Case_Mp_Preference_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Case_Mp_Preference_Input>>;
  filter?: InputMaybe<Attorney_Case_Mp_Preference_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Favorite_ItemArgs = {
  data: Create_Attorney_Favorite_Input;
};


export type MutationCreate_Attorney_Favorite_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Favorite_Input>>;
  filter?: InputMaybe<Attorney_Favorite_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Invite_ItemArgs = {
  data: Create_Attorney_Invite_Input;
};


export type MutationCreate_Attorney_Invite_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Invite_Input>>;
  filter?: InputMaybe<Attorney_Invite_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Oauth_Integration_ItemArgs = {
  data: Create_Attorney_Oauth_Integration_Input;
};


export type MutationCreate_Attorney_Oauth_Integration_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Oauth_Integration_Input>>;
  filter?: InputMaybe<Attorney_Oauth_Integration_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Profile_Award_ItemArgs = {
  data: Create_Attorney_Profile_Award_Input;
};


export type MutationCreate_Attorney_Profile_Award_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Profile_Award_Input>>;
  filter?: InputMaybe<Attorney_Profile_Award_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Profile_Case_Management_Software_ItemArgs = {
  data: Create_Attorney_Profile_Case_Management_Software_Input;
};


export type MutationCreate_Attorney_Profile_Case_Management_Software_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Profile_Case_Management_Software_Input>>;
  filter?: InputMaybe<Attorney_Profile_Case_Management_Software_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Profile_Communication_Preference_ItemArgs = {
  data: Create_Attorney_Profile_Communication_Preference_Input;
};


export type MutationCreate_Attorney_Profile_Communication_Preference_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Profile_Communication_Preference_Input>>;
  filter?: InputMaybe<Attorney_Profile_Communication_Preference_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Profile_Contact_ItemArgs = {
  data: Create_Attorney_Profile_Contact_Input;
};


export type MutationCreate_Attorney_Profile_Contact_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Profile_Contact_Input>>;
  filter?: InputMaybe<Attorney_Profile_Contact_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Profile_Education_ItemArgs = {
  data: Create_Attorney_Profile_Education_Input;
};


export type MutationCreate_Attorney_Profile_Education_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Profile_Education_Input>>;
  filter?: InputMaybe<Attorney_Profile_Education_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Profile_Firm_ItemArgs = {
  data: Create_Attorney_Profile_Firm_Input;
};


export type MutationCreate_Attorney_Profile_Firm_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Profile_Firm_Input>>;
  filter?: InputMaybe<Attorney_Profile_Firm_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Profile_Language_ItemArgs = {
  data: Create_Attorney_Profile_Language_Input;
};


export type MutationCreate_Attorney_Profile_Language_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Profile_Language_Input>>;
  filter?: InputMaybe<Attorney_Profile_Language_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Profile_License_Insurance_ItemArgs = {
  data: Create_Attorney_Profile_License_Insurance_Input;
};


export type MutationCreate_Attorney_Profile_License_Insurance_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Profile_License_Insurance_Input>>;
  filter?: InputMaybe<Attorney_Profile_License_Insurance_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Profile_License_ItemArgs = {
  data: Create_Attorney_Profile_License_Input;
};


export type MutationCreate_Attorney_Profile_License_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Profile_License_Input>>;
  filter?: InputMaybe<Attorney_Profile_License_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Profile_Notification_Level_ItemArgs = {
  data: Create_Attorney_Profile_Notification_Level_Input;
};


export type MutationCreate_Attorney_Profile_Notification_Level_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Profile_Notification_Level_Input>>;
  filter?: InputMaybe<Attorney_Profile_Notification_Level_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Profile_Practice_Area_ItemArgs = {
  data: Create_Attorney_Profile_Practice_Area_Input;
};


export type MutationCreate_Attorney_Profile_Practice_Area_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Profile_Practice_Area_Input>>;
  filter?: InputMaybe<Attorney_Profile_Practice_Area_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Stripe_ItemArgs = {
  data: Create_Attorney_Stripe_Input;
};


export type MutationCreate_Attorney_Stripe_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Stripe_Input>>;
  filter?: InputMaybe<Attorney_Stripe_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Waterfall_ItemArgs = {
  data: Create_Attorney_Waterfall_Input;
};


export type MutationCreate_Attorney_Waterfall_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Waterfall_Input>>;
  filter?: InputMaybe<Attorney_Waterfall_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Waterfall_List_ItemArgs = {
  data: Create_Attorney_Waterfall_List_Input;
};


export type MutationCreate_Attorney_Waterfall_List_Item_ItemArgs = {
  data: Create_Attorney_Waterfall_List_Item_Input;
};


export type MutationCreate_Attorney_Waterfall_List_Item_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Waterfall_List_Item_Input>>;
  filter?: InputMaybe<Attorney_Waterfall_List_Item_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Waterfall_List_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Waterfall_List_Input>>;
  filter?: InputMaybe<Attorney_Waterfall_List_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Waterfall_List_Jdx_ItemArgs = {
  data: Create_Attorney_Waterfall_List_Jdx_Input;
};


export type MutationCreate_Attorney_Waterfall_List_Jdx_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Waterfall_List_Jdx_Input>>;
  filter?: InputMaybe<Attorney_Waterfall_List_Jdx_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Attorney_Waterfall_List_Pa_ItemArgs = {
  data: Create_Attorney_Waterfall_List_Pa_Input;
};


export type MutationCreate_Attorney_Waterfall_List_Pa_ItemsArgs = {
  data?: InputMaybe<Array<Create_Attorney_Waterfall_List_Pa_Input>>;
  filter?: InputMaybe<Attorney_Waterfall_List_Pa_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Case_Affiliation_ItemArgs = {
  data: Create_Case_Affiliation_Input;
};


export type MutationCreate_Case_Affiliation_ItemsArgs = {
  data?: InputMaybe<Array<Create_Case_Affiliation_Input>>;
  filter?: InputMaybe<Case_Affiliation_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Case_Fee_Overrides_ItemArgs = {
  data: Create_Case_Fee_Overrides_Input;
};


export type MutationCreate_Case_Fee_Overrides_ItemsArgs = {
  data?: InputMaybe<Array<Create_Case_Fee_Overrides_Input>>;
  filter?: InputMaybe<Case_Fee_Overrides_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Case_File_ItemArgs = {
  data: Create_Case_File_Input;
};


export type MutationCreate_Case_File_ItemsArgs = {
  data?: InputMaybe<Array<Create_Case_File_Input>>;
  filter?: InputMaybe<Case_File_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Case_ItemArgs = {
  data: Create_Case_Input;
};


export type MutationCreate_Case_ItemsArgs = {
  data?: InputMaybe<Array<Create_Case_Input>>;
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Case_Lead_Contact_ItemArgs = {
  data: Create_Case_Lead_Contact_Input;
};


export type MutationCreate_Case_Lead_Contact_ItemsArgs = {
  data?: InputMaybe<Array<Create_Case_Lead_Contact_Input>>;
  filter?: InputMaybe<Case_Lead_Contact_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Case_Lead_ItemArgs = {
  data: Create_Case_Lead_Input;
};


export type MutationCreate_Case_Lead_ItemsArgs = {
  data?: InputMaybe<Array<Create_Case_Lead_Input>>;
  filter?: InputMaybe<Case_Lead_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Case_Ownership_ItemArgs = {
  data: Create_Case_Ownership_Input;
};


export type MutationCreate_Case_Ownership_ItemsArgs = {
  data?: InputMaybe<Array<Create_Case_Ownership_Input>>;
  filter?: InputMaybe<Case_Ownership_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Case_Purchase_Activity_ItemArgs = {
  data: Create_Case_Purchase_Activity_Input;
};


export type MutationCreate_Case_Purchase_Activity_ItemsArgs = {
  data?: InputMaybe<Array<Create_Case_Purchase_Activity_Input>>;
  filter?: InputMaybe<Case_Purchase_Activity_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Case_Purchase_ItemArgs = {
  data: Create_Case_Purchase_Input;
};


export type MutationCreate_Case_Purchase_ItemsArgs = {
  data?: InputMaybe<Array<Create_Case_Purchase_Input>>;
  filter?: InputMaybe<Case_Purchase_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Case_Purchase_Ownership_ItemArgs = {
  data: Create_Case_Purchase_Ownership_Input;
};


export type MutationCreate_Case_Purchase_Ownership_ItemsArgs = {
  data?: InputMaybe<Array<Create_Case_Purchase_Ownership_Input>>;
  filter?: InputMaybe<Case_Purchase_Ownership_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Case_Purchase_Payment_ItemArgs = {
  data: Create_Case_Purchase_Payment_Input;
};


export type MutationCreate_Case_Purchase_Payment_ItemsArgs = {
  data?: InputMaybe<Array<Create_Case_Purchase_Payment_Input>>;
  filter?: InputMaybe<Case_Purchase_Payment_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Case_Status_Update_ItemArgs = {
  data: Create_Case_Status_Update_Input;
};


export type MutationCreate_Case_Status_Update_ItemsArgs = {
  data?: InputMaybe<Array<Create_Case_Status_Update_Input>>;
  filter?: InputMaybe<Case_Status_Update_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Case_Status_Update_Scheduler_Task_ItemArgs = {
  data: Create_Case_Status_Update_Scheduler_Task_Input;
};


export type MutationCreate_Case_Status_Update_Scheduler_Task_ItemsArgs = {
  data?: InputMaybe<Array<Create_Case_Status_Update_Scheduler_Task_Input>>;
  filter?: InputMaybe<Case_Status_Update_Scheduler_Task_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Config_Lcms_Leaddocket_ItemArgs = {
  data: Create_Config_Lcms_Leaddocket_Input;
};


export type MutationCreate_Config_Lcms_Leaddocket_ItemsArgs = {
  data?: InputMaybe<Array<Create_Config_Lcms_Leaddocket_Input>>;
  filter?: InputMaybe<Config_Lcms_Leaddocket_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Filter_Redundant_ItemArgs = {
  data: Create_Filter_Redundant_Input;
};


export type MutationCreate_Filter_Redundant_ItemsArgs = {
  data?: InputMaybe<Array<Create_Filter_Redundant_Input>>;
  filter?: InputMaybe<Filter_Redundant_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Lcms_Case_Mapping_ItemArgs = {
  data: Create_Lcms_Case_Mapping_Input;
};


export type MutationCreate_Lcms_Case_Mapping_ItemsArgs = {
  data?: InputMaybe<Array<Create_Lcms_Case_Mapping_Input>>;
  filter?: InputMaybe<Lcms_Case_Mapping_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Lcms_Health_Check_ItemArgs = {
  data: Create_Lcms_Health_Check_Input;
};


export type MutationCreate_Lcms_Health_Check_ItemsArgs = {
  data?: InputMaybe<Array<Create_Lcms_Health_Check_Input>>;
  filter?: InputMaybe<Lcms_Health_Check_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Network_User_Invite_ItemArgs = {
  data: Create_Network_User_Invite_Input;
};


export type MutationCreate_Network_User_Invite_ItemsArgs = {
  data?: InputMaybe<Array<Create_Network_User_Invite_Input>>;
  filter?: InputMaybe<Network_User_Invite_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Organization_Block_ItemArgs = {
  data: Create_Organization_Block_Input;
};


export type MutationCreate_Organization_Block_ItemsArgs = {
  data?: InputMaybe<Array<Create_Organization_Block_Input>>;
  filter?: InputMaybe<Organization_Block_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Organization_Connected_Lcms_ItemArgs = {
  data: Create_Organization_Connected_Lcms_Input;
};


export type MutationCreate_Organization_Connected_Lcms_ItemsArgs = {
  data?: InputMaybe<Array<Create_Organization_Connected_Lcms_Input>>;
  filter?: InputMaybe<Organization_Connected_Lcms_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Organization_Referral_Settings_ItemArgs = {
  data: Create_Organization_Referral_Settings_Input;
};


export type MutationCreate_Organization_Referral_Settings_ItemsArgs = {
  data?: InputMaybe<Array<Create_Organization_Referral_Settings_Input>>;
  filter?: InputMaybe<Organization_Referral_Settings_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_Practice_Attorney_Mapping_ItemArgs = {
  data: Create_Practice_Attorney_Mapping_Input;
};


export type MutationCreate_Practice_Attorney_Mapping_ItemsArgs = {
  data?: InputMaybe<Array<Create_Practice_Attorney_Mapping_Input>>;
  filter?: InputMaybe<Practice_Attorney_Mapping_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_School_ItemArgs = {
  data: Create_School_Input;
};


export type MutationCreate_School_ItemsArgs = {
  data?: InputMaybe<Array<Create_School_Input>>;
  filter?: InputMaybe<School_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreate_User_File_Access_Request_ItemArgs = {
  data: Create_User_File_Access_Request_Input;
};


export type MutationCreate_User_File_Access_Request_ItemsArgs = {
  data?: InputMaybe<Array<Create_User_File_Access_Request_Input>>;
  filter?: InputMaybe<User_File_Access_Request_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDelete_Attorney_Case_Mp_Preference_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Case_Mp_Preference_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Favorite_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Favorite_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Oauth_Integration_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Oauth_Integration_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Profile_Award_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Profile_Award_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Profile_Case_Management_Software_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Profile_Case_Management_Software_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Profile_Contact_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Profile_Contact_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Profile_Education_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Profile_Education_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Profile_Firm_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Profile_Firm_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Profile_Language_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Profile_Language_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Profile_License_Insurance_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Profile_License_Insurance_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Profile_License_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Profile_License_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Profile_Practice_Area_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Profile_Practice_Area_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Stripe_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Stripe_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Waterfall_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Waterfall_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Waterfall_List_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Waterfall_List_Item_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Waterfall_List_Item_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Waterfall_List_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Waterfall_List_Jdx_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Waterfall_List_Jdx_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Attorney_Waterfall_List_Pa_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Attorney_Waterfall_List_Pa_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Case_Affiliation_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Case_Affiliation_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Case_Fee_Overrides_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Case_Fee_Overrides_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Case_File_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Case_File_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Case_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Case_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Case_Lead_Contact_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Case_Lead_Contact_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Case_Lead_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Case_Lead_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Case_Ownership_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Case_Ownership_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Case_Purchase_Ownership_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Case_Purchase_Ownership_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Case_Status_Update_Scheduler_Task_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Case_Status_Update_Scheduler_Task_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Config_Lcms_Leaddocket_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Config_Lcms_Leaddocket_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Filter_Redundant_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Filter_Redundant_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Organization_Block_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Organization_Block_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Organization_Connected_Lcms_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Organization_Connected_Lcms_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_Practice_Attorney_Mapping_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_Practice_Attorney_Mapping_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDelete_User_File_Access_Request_ItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDelete_User_File_Access_Request_ItemsArgs = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationUpdate_Attorney_Invite_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Invite_Input>>;
  filter?: InputMaybe<Attorney_Invite_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Invite_ItemArgs = {
  data: Update_Attorney_Invite_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Invite_ItemsArgs = {
  data: Update_Attorney_Invite_Input;
  filter?: InputMaybe<Attorney_Invite_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Oauth_Integration_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Oauth_Integration_Input>>;
  filter?: InputMaybe<Attorney_Oauth_Integration_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Oauth_Integration_ItemArgs = {
  data: Update_Attorney_Oauth_Integration_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Oauth_Integration_ItemsArgs = {
  data: Update_Attorney_Oauth_Integration_Input;
  filter?: InputMaybe<Attorney_Oauth_Integration_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Award_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Profile_Award_Input>>;
  filter?: InputMaybe<Attorney_Profile_Award_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Award_ItemArgs = {
  data: Update_Attorney_Profile_Award_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Profile_Award_ItemsArgs = {
  data: Update_Attorney_Profile_Award_Input;
  filter?: InputMaybe<Attorney_Profile_Award_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Profile_Input>>;
  filter?: InputMaybe<Attorney_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Case_Management_Software_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Profile_Case_Management_Software_Input>>;
  filter?: InputMaybe<Attorney_Profile_Case_Management_Software_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Case_Management_Software_ItemArgs = {
  data: Update_Attorney_Profile_Case_Management_Software_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Profile_Case_Management_Software_ItemsArgs = {
  data: Update_Attorney_Profile_Case_Management_Software_Input;
  filter?: InputMaybe<Attorney_Profile_Case_Management_Software_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Communication_Preference_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Profile_Communication_Preference_Input>>;
  filter?: InputMaybe<Attorney_Profile_Communication_Preference_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Communication_Preference_ItemArgs = {
  data: Update_Attorney_Profile_Communication_Preference_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Profile_Communication_Preference_ItemsArgs = {
  data: Update_Attorney_Profile_Communication_Preference_Input;
  filter?: InputMaybe<Attorney_Profile_Communication_Preference_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Contact_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Profile_Contact_Input>>;
  filter?: InputMaybe<Attorney_Profile_Contact_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Contact_ItemArgs = {
  data: Update_Attorney_Profile_Contact_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Profile_Contact_ItemsArgs = {
  data: Update_Attorney_Profile_Contact_Input;
  filter?: InputMaybe<Attorney_Profile_Contact_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Education_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Profile_Education_Input>>;
  filter?: InputMaybe<Attorney_Profile_Education_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Education_ItemArgs = {
  data: Update_Attorney_Profile_Education_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Profile_Education_ItemsArgs = {
  data: Update_Attorney_Profile_Education_Input;
  filter?: InputMaybe<Attorney_Profile_Education_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Firm_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Profile_Firm_Input>>;
  filter?: InputMaybe<Attorney_Profile_Firm_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Firm_ItemArgs = {
  data: Update_Attorney_Profile_Firm_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Profile_Firm_ItemsArgs = {
  data: Update_Attorney_Profile_Firm_Input;
  filter?: InputMaybe<Attorney_Profile_Firm_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_ItemArgs = {
  data: Update_Attorney_Profile_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Profile_ItemsArgs = {
  data: Update_Attorney_Profile_Input;
  filter?: InputMaybe<Attorney_Profile_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Language_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Profile_Language_Input>>;
  filter?: InputMaybe<Attorney_Profile_Language_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Language_ItemArgs = {
  data: Update_Attorney_Profile_Language_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Profile_Language_ItemsArgs = {
  data: Update_Attorney_Profile_Language_Input;
  filter?: InputMaybe<Attorney_Profile_Language_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_License_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Profile_License_Input>>;
  filter?: InputMaybe<Attorney_Profile_License_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_License_Insurance_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Profile_License_Insurance_Input>>;
  filter?: InputMaybe<Attorney_Profile_License_Insurance_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_License_Insurance_ItemArgs = {
  data: Update_Attorney_Profile_License_Insurance_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Profile_License_Insurance_ItemsArgs = {
  data: Update_Attorney_Profile_License_Insurance_Input;
  filter?: InputMaybe<Attorney_Profile_License_Insurance_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_License_ItemArgs = {
  data: Update_Attorney_Profile_License_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Profile_License_ItemsArgs = {
  data: Update_Attorney_Profile_License_Input;
  filter?: InputMaybe<Attorney_Profile_License_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Notification_Level_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Profile_Notification_Level_Input>>;
  filter?: InputMaybe<Attorney_Profile_Notification_Level_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Notification_Level_ItemArgs = {
  data: Update_Attorney_Profile_Notification_Level_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Profile_Notification_Level_ItemsArgs = {
  data: Update_Attorney_Profile_Notification_Level_Input;
  filter?: InputMaybe<Attorney_Profile_Notification_Level_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Practice_Area_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Profile_Practice_Area_Input>>;
  filter?: InputMaybe<Attorney_Profile_Practice_Area_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Profile_Practice_Area_ItemArgs = {
  data: Update_Attorney_Profile_Practice_Area_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Profile_Practice_Area_ItemsArgs = {
  data: Update_Attorney_Profile_Practice_Area_Input;
  filter?: InputMaybe<Attorney_Profile_Practice_Area_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Waterfall_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Waterfall_Input>>;
  filter?: InputMaybe<Attorney_Waterfall_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Waterfall_ItemArgs = {
  data: Update_Attorney_Waterfall_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Waterfall_ItemsArgs = {
  data: Update_Attorney_Waterfall_Input;
  filter?: InputMaybe<Attorney_Waterfall_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Waterfall_List_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Waterfall_List_Input>>;
  filter?: InputMaybe<Attorney_Waterfall_List_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Waterfall_List_ItemArgs = {
  data: Update_Attorney_Waterfall_List_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Waterfall_List_Item_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Waterfall_List_Item_Input>>;
  filter?: InputMaybe<Attorney_Waterfall_List_Item_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Waterfall_List_Item_ItemArgs = {
  data: Update_Attorney_Waterfall_List_Item_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Waterfall_List_Item_ItemsArgs = {
  data: Update_Attorney_Waterfall_List_Item_Input;
  filter?: InputMaybe<Attorney_Waterfall_List_Item_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Waterfall_List_ItemsArgs = {
  data: Update_Attorney_Waterfall_List_Input;
  filter?: InputMaybe<Attorney_Waterfall_List_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Waterfall_List_Jdx_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Waterfall_List_Jdx_Input>>;
  filter?: InputMaybe<Attorney_Waterfall_List_Jdx_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Waterfall_List_Jdx_ItemArgs = {
  data: Update_Attorney_Waterfall_List_Jdx_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Waterfall_List_Jdx_ItemsArgs = {
  data: Update_Attorney_Waterfall_List_Jdx_Input;
  filter?: InputMaybe<Attorney_Waterfall_List_Jdx_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Waterfall_List_Pa_BatchArgs = {
  data?: InputMaybe<Array<Update_Attorney_Waterfall_List_Pa_Input>>;
  filter?: InputMaybe<Attorney_Waterfall_List_Pa_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Attorney_Waterfall_List_Pa_ItemArgs = {
  data: Update_Attorney_Waterfall_List_Pa_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Attorney_Waterfall_List_Pa_ItemsArgs = {
  data: Update_Attorney_Waterfall_List_Pa_Input;
  filter?: InputMaybe<Attorney_Waterfall_List_Pa_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Affiliation_BatchArgs = {
  data?: InputMaybe<Array<Update_Case_Affiliation_Input>>;
  filter?: InputMaybe<Case_Affiliation_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Affiliation_ItemArgs = {
  data: Update_Case_Affiliation_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Case_Affiliation_ItemsArgs = {
  data: Update_Case_Affiliation_Input;
  filter?: InputMaybe<Case_Affiliation_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_BatchArgs = {
  data?: InputMaybe<Array<Update_Case_Input>>;
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Fee_Overrides_BatchArgs = {
  data?: InputMaybe<Array<Update_Case_Fee_Overrides_Input>>;
  filter?: InputMaybe<Case_Fee_Overrides_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Fee_Overrides_ItemArgs = {
  data: Update_Case_Fee_Overrides_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Case_Fee_Overrides_ItemsArgs = {
  data: Update_Case_Fee_Overrides_Input;
  filter?: InputMaybe<Case_Fee_Overrides_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_File_BatchArgs = {
  data?: InputMaybe<Array<Update_Case_File_Input>>;
  filter?: InputMaybe<Case_File_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_File_ItemArgs = {
  data: Update_Case_File_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Case_File_ItemsArgs = {
  data: Update_Case_File_Input;
  filter?: InputMaybe<Case_File_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_ItemArgs = {
  data: Update_Case_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Case_ItemsArgs = {
  data: Update_Case_Input;
  filter?: InputMaybe<Case_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Lead_BatchArgs = {
  data?: InputMaybe<Array<Update_Case_Lead_Input>>;
  filter?: InputMaybe<Case_Lead_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Lead_Contact_BatchArgs = {
  data?: InputMaybe<Array<Update_Case_Lead_Contact_Input>>;
  filter?: InputMaybe<Case_Lead_Contact_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Lead_Contact_ItemArgs = {
  data: Update_Case_Lead_Contact_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Case_Lead_Contact_ItemsArgs = {
  data: Update_Case_Lead_Contact_Input;
  filter?: InputMaybe<Case_Lead_Contact_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Lead_ItemArgs = {
  data: Update_Case_Lead_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Case_Lead_ItemsArgs = {
  data: Update_Case_Lead_Input;
  filter?: InputMaybe<Case_Lead_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Ownership_BatchArgs = {
  data?: InputMaybe<Array<Update_Case_Ownership_Input>>;
  filter?: InputMaybe<Case_Ownership_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Ownership_ItemArgs = {
  data: Update_Case_Ownership_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Case_Ownership_ItemsArgs = {
  data: Update_Case_Ownership_Input;
  filter?: InputMaybe<Case_Ownership_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Purchase_BatchArgs = {
  data?: InputMaybe<Array<Update_Case_Purchase_Input>>;
  filter?: InputMaybe<Case_Purchase_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Purchase_ItemArgs = {
  data: Update_Case_Purchase_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Case_Purchase_ItemsArgs = {
  data: Update_Case_Purchase_Input;
  filter?: InputMaybe<Case_Purchase_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Purchase_Ownership_BatchArgs = {
  data?: InputMaybe<Array<Update_Case_Purchase_Ownership_Input>>;
  filter?: InputMaybe<Case_Purchase_Ownership_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Purchase_Ownership_ItemArgs = {
  data: Update_Case_Purchase_Ownership_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Case_Purchase_Ownership_ItemsArgs = {
  data: Update_Case_Purchase_Ownership_Input;
  filter?: InputMaybe<Case_Purchase_Ownership_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Status_Update_Scheduler_Task_BatchArgs = {
  data?: InputMaybe<Array<Update_Case_Status_Update_Scheduler_Task_Input>>;
  filter?: InputMaybe<Case_Status_Update_Scheduler_Task_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Case_Status_Update_Scheduler_Task_ItemArgs = {
  data: Update_Case_Status_Update_Scheduler_Task_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Case_Status_Update_Scheduler_Task_ItemsArgs = {
  data: Update_Case_Status_Update_Scheduler_Task_Input;
  filter?: InputMaybe<Case_Status_Update_Scheduler_Task_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Config_Lcms_Leaddocket_BatchArgs = {
  data?: InputMaybe<Array<Update_Config_Lcms_Leaddocket_Input>>;
  filter?: InputMaybe<Config_Lcms_Leaddocket_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Config_Lcms_Leaddocket_ItemArgs = {
  data: Update_Config_Lcms_Leaddocket_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Config_Lcms_Leaddocket_ItemsArgs = {
  data: Update_Config_Lcms_Leaddocket_Input;
  filter?: InputMaybe<Config_Lcms_Leaddocket_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Filter_Redundant_BatchArgs = {
  data?: InputMaybe<Array<Update_Filter_Redundant_Input>>;
  filter?: InputMaybe<Filter_Redundant_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Filter_Redundant_ItemArgs = {
  data: Update_Filter_Redundant_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Filter_Redundant_ItemsArgs = {
  data: Update_Filter_Redundant_Input;
  filter?: InputMaybe<Filter_Redundant_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Lcms_Case_Mapping_BatchArgs = {
  data?: InputMaybe<Array<Update_Lcms_Case_Mapping_Input>>;
  filter?: InputMaybe<Lcms_Case_Mapping_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Lcms_Case_Mapping_ItemArgs = {
  data: Update_Lcms_Case_Mapping_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Lcms_Case_Mapping_ItemsArgs = {
  data: Update_Lcms_Case_Mapping_Input;
  filter?: InputMaybe<Lcms_Case_Mapping_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Network_User_Invite_BatchArgs = {
  data?: InputMaybe<Array<Update_Network_User_Invite_Input>>;
  filter?: InputMaybe<Network_User_Invite_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Network_User_Invite_ItemArgs = {
  data: Update_Network_User_Invite_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Network_User_Invite_ItemsArgs = {
  data: Update_Network_User_Invite_Input;
  filter?: InputMaybe<Network_User_Invite_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Organization_BatchArgs = {
  data?: InputMaybe<Array<Update_Organization_Input>>;
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Organization_Block_BatchArgs = {
  data?: InputMaybe<Array<Update_Organization_Block_Input>>;
  filter?: InputMaybe<Organization_Block_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Organization_Block_ItemArgs = {
  data: Update_Organization_Block_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Organization_Block_ItemsArgs = {
  data: Update_Organization_Block_Input;
  filter?: InputMaybe<Organization_Block_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Organization_Connected_Lcms_BatchArgs = {
  data?: InputMaybe<Array<Update_Organization_Connected_Lcms_Input>>;
  filter?: InputMaybe<Organization_Connected_Lcms_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Organization_Connected_Lcms_ItemArgs = {
  data: Update_Organization_Connected_Lcms_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Organization_Connected_Lcms_ItemsArgs = {
  data: Update_Organization_Connected_Lcms_Input;
  filter?: InputMaybe<Organization_Connected_Lcms_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Organization_ItemArgs = {
  data: Update_Organization_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Organization_ItemsArgs = {
  data: Update_Organization_Input;
  filter?: InputMaybe<Organization_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Organization_Profile_BatchArgs = {
  data?: InputMaybe<Array<Update_Organization_Profile_Input>>;
  filter?: InputMaybe<Organization_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Organization_Profile_ItemArgs = {
  data: Update_Organization_Profile_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Organization_Profile_ItemsArgs = {
  data: Update_Organization_Profile_Input;
  filter?: InputMaybe<Organization_Profile_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Organization_Referral_Settings_BatchArgs = {
  data?: InputMaybe<Array<Update_Organization_Referral_Settings_Input>>;
  filter?: InputMaybe<Organization_Referral_Settings_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Organization_Referral_Settings_ItemArgs = {
  data: Update_Organization_Referral_Settings_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Organization_Referral_Settings_ItemsArgs = {
  data: Update_Organization_Referral_Settings_Input;
  filter?: InputMaybe<Organization_Referral_Settings_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Organization_User_BatchArgs = {
  data?: InputMaybe<Array<Update_Organization_User_Input>>;
  filter?: InputMaybe<Organization_User_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Organization_User_ItemArgs = {
  data: Update_Organization_User_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Organization_User_ItemsArgs = {
  data: Update_Organization_User_Input;
  filter?: InputMaybe<Organization_User_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Practice_Attorney_Mapping_BatchArgs = {
  data?: InputMaybe<Array<Update_Practice_Attorney_Mapping_Input>>;
  filter?: InputMaybe<Practice_Attorney_Mapping_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_Practice_Attorney_Mapping_ItemArgs = {
  data: Update_Practice_Attorney_Mapping_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_Practice_Attorney_Mapping_ItemsArgs = {
  data: Update_Practice_Attorney_Mapping_Input;
  filter?: InputMaybe<Practice_Attorney_Mapping_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_User_File_Access_Request_BatchArgs = {
  data?: InputMaybe<Array<Update_User_File_Access_Request_Input>>;
  filter?: InputMaybe<User_File_Access_Request_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdate_User_File_Access_Request_ItemArgs = {
  data: Update_User_File_Access_Request_Input;
  id: Scalars['ID']['input'];
};


export type MutationUpdate_User_File_Access_Request_ItemsArgs = {
  data: Update_User_File_Access_Request_Input;
  filter?: InputMaybe<User_File_Access_Request_Filter>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Query = {
  __typename?: 'Query';
  affiliation_discount: Array<Affiliation_Discount>;
  affiliation_discount_aggregated: Array<Affiliation_Discount_Aggregated>;
  affiliation_discount_by_id?: Maybe<Affiliation_Discount>;
  affiliation_discount_by_version?: Maybe<Version_Affiliation_Discount>;
  attorney: Array<Attorney>;
  attorney_aggregated: Array<Attorney_Aggregated>;
  attorney_by_id?: Maybe<Attorney>;
  attorney_by_version?: Maybe<Version_Attorney>;
  attorney_case_mp_preference: Array<Attorney_Case_Mp_Preference>;
  attorney_case_mp_preference_aggregated: Array<Attorney_Case_Mp_Preference_Aggregated>;
  attorney_case_mp_preference_by_id?: Maybe<Attorney_Case_Mp_Preference>;
  attorney_case_mp_preference_by_version?: Maybe<Version_Attorney_Case_Mp_Preference>;
  attorney_chat_key: Array<Attorney_Chat_Key>;
  attorney_chat_key_aggregated: Array<Attorney_Chat_Key_Aggregated>;
  attorney_chat_key_by_id?: Maybe<Attorney_Chat_Key>;
  attorney_chat_key_by_version?: Maybe<Version_Attorney_Chat_Key>;
  attorney_favorite: Array<Attorney_Favorite>;
  attorney_favorite_aggregated: Array<Attorney_Favorite_Aggregated>;
  attorney_favorite_by_id?: Maybe<Attorney_Favorite>;
  attorney_favorite_by_version?: Maybe<Version_Attorney_Favorite>;
  attorney_invite: Array<Attorney_Invite>;
  attorney_invite_aggregated: Array<Attorney_Invite_Aggregated>;
  attorney_invite_by_id?: Maybe<Attorney_Invite>;
  attorney_invite_by_version?: Maybe<Version_Attorney_Invite>;
  attorney_invite_link_visit: Array<Attorney_Invite_Link_Visit>;
  attorney_invite_link_visit_aggregated: Array<Attorney_Invite_Link_Visit_Aggregated>;
  attorney_invite_link_visit_by_id?: Maybe<Attorney_Invite_Link_Visit>;
  attorney_invite_link_visit_by_version?: Maybe<Version_Attorney_Invite_Link_Visit>;
  attorney_oauth_integration: Array<Attorney_Oauth_Integration>;
  attorney_oauth_integration_aggregated: Array<Attorney_Oauth_Integration_Aggregated>;
  attorney_oauth_integration_by_id?: Maybe<Attorney_Oauth_Integration>;
  attorney_oauth_integration_by_version?: Maybe<Version_Attorney_Oauth_Integration>;
  attorney_payment_membership: Array<Attorney_Payment_Membership>;
  attorney_payment_membership_aggregated: Array<Attorney_Payment_Membership_Aggregated>;
  attorney_payment_membership_by_id?: Maybe<Attorney_Payment_Membership>;
  attorney_payment_membership_by_version?: Maybe<Version_Attorney_Payment_Membership>;
  attorney_profile: Array<Attorney_Profile>;
  attorney_profile_affiliation: Array<Attorney_Profile_Affiliation>;
  attorney_profile_affiliation_aggregated: Array<Attorney_Profile_Affiliation_Aggregated>;
  attorney_profile_affiliation_by_id?: Maybe<Attorney_Profile_Affiliation>;
  attorney_profile_affiliation_by_version?: Maybe<Version_Attorney_Profile_Affiliation>;
  attorney_profile_aggregated: Array<Attorney_Profile_Aggregated>;
  attorney_profile_award: Array<Attorney_Profile_Award>;
  attorney_profile_award_aggregated: Array<Attorney_Profile_Award_Aggregated>;
  attorney_profile_award_by_id?: Maybe<Attorney_Profile_Award>;
  attorney_profile_award_by_version?: Maybe<Version_Attorney_Profile_Award>;
  attorney_profile_by_id?: Maybe<Attorney_Profile>;
  attorney_profile_by_version?: Maybe<Version_Attorney_Profile>;
  attorney_profile_case_management_software: Array<Attorney_Profile_Case_Management_Software>;
  attorney_profile_case_management_software_aggregated: Array<Attorney_Profile_Case_Management_Software_Aggregated>;
  attorney_profile_case_management_software_by_id?: Maybe<Attorney_Profile_Case_Management_Software>;
  attorney_profile_case_management_software_by_version?: Maybe<Version_Attorney_Profile_Case_Management_Software>;
  attorney_profile_communication_preference: Array<Attorney_Profile_Communication_Preference>;
  attorney_profile_communication_preference_aggregated: Array<Attorney_Profile_Communication_Preference_Aggregated>;
  attorney_profile_communication_preference_by_id?: Maybe<Attorney_Profile_Communication_Preference>;
  attorney_profile_communication_preference_by_version?: Maybe<Version_Attorney_Profile_Communication_Preference>;
  attorney_profile_contact: Array<Attorney_Profile_Contact>;
  attorney_profile_contact_aggregated: Array<Attorney_Profile_Contact_Aggregated>;
  attorney_profile_contact_by_id?: Maybe<Attorney_Profile_Contact>;
  attorney_profile_contact_by_version?: Maybe<Version_Attorney_Profile_Contact>;
  attorney_profile_education: Array<Attorney_Profile_Education>;
  attorney_profile_education_aggregated: Array<Attorney_Profile_Education_Aggregated>;
  attorney_profile_education_by_id?: Maybe<Attorney_Profile_Education>;
  attorney_profile_education_by_version?: Maybe<Version_Attorney_Profile_Education>;
  attorney_profile_firm: Array<Attorney_Profile_Firm>;
  attorney_profile_firm_aggregated: Array<Attorney_Profile_Firm_Aggregated>;
  attorney_profile_firm_by_id?: Maybe<Attorney_Profile_Firm>;
  attorney_profile_firm_by_version?: Maybe<Version_Attorney_Profile_Firm>;
  attorney_profile_language: Array<Attorney_Profile_Language>;
  attorney_profile_language_aggregated: Array<Attorney_Profile_Language_Aggregated>;
  attorney_profile_language_by_id?: Maybe<Attorney_Profile_Language>;
  attorney_profile_language_by_version?: Maybe<Version_Attorney_Profile_Language>;
  attorney_profile_license: Array<Attorney_Profile_License>;
  attorney_profile_license_aggregated: Array<Attorney_Profile_License_Aggregated>;
  attorney_profile_license_by_id?: Maybe<Attorney_Profile_License>;
  attorney_profile_license_by_version?: Maybe<Version_Attorney_Profile_License>;
  attorney_profile_license_insurance: Array<Attorney_Profile_License_Insurance>;
  attorney_profile_license_insurance_aggregated: Array<Attorney_Profile_License_Insurance_Aggregated>;
  attorney_profile_license_insurance_by_id?: Maybe<Attorney_Profile_License_Insurance>;
  attorney_profile_license_insurance_by_version?: Maybe<Version_Attorney_Profile_License_Insurance>;
  attorney_profile_notification_level: Array<Attorney_Profile_Notification_Level>;
  attorney_profile_notification_level_aggregated: Array<Attorney_Profile_Notification_Level_Aggregated>;
  attorney_profile_notification_level_by_id?: Maybe<Attorney_Profile_Notification_Level>;
  attorney_profile_notification_level_by_version?: Maybe<Version_Attorney_Profile_Notification_Level>;
  attorney_profile_practice_area: Array<Attorney_Profile_Practice_Area>;
  attorney_profile_practice_area_aggregated: Array<Attorney_Profile_Practice_Area_Aggregated>;
  attorney_profile_practice_area_by_id?: Maybe<Attorney_Profile_Practice_Area>;
  attorney_profile_practice_area_by_version?: Maybe<Version_Attorney_Profile_Practice_Area>;
  attorney_stripe: Array<Attorney_Stripe>;
  attorney_stripe_aggregated: Array<Attorney_Stripe_Aggregated>;
  attorney_stripe_by_id?: Maybe<Attorney_Stripe>;
  attorney_stripe_by_version?: Maybe<Version_Attorney_Stripe>;
  attorney_waterfall: Array<Attorney_Waterfall>;
  attorney_waterfall_aggregated: Array<Attorney_Waterfall_Aggregated>;
  attorney_waterfall_by_id?: Maybe<Attorney_Waterfall>;
  attorney_waterfall_by_version?: Maybe<Version_Attorney_Waterfall>;
  attorney_waterfall_list: Array<Attorney_Waterfall_List>;
  attorney_waterfall_list_aggregated: Array<Attorney_Waterfall_List_Aggregated>;
  attorney_waterfall_list_by_id?: Maybe<Attorney_Waterfall_List>;
  attorney_waterfall_list_by_version?: Maybe<Version_Attorney_Waterfall_List>;
  attorney_waterfall_list_item: Array<Attorney_Waterfall_List_Item>;
  attorney_waterfall_list_item_aggregated: Array<Attorney_Waterfall_List_Item_Aggregated>;
  attorney_waterfall_list_item_by_id?: Maybe<Attorney_Waterfall_List_Item>;
  attorney_waterfall_list_item_by_version?: Maybe<Version_Attorney_Waterfall_List_Item>;
  attorney_waterfall_list_jdx: Array<Attorney_Waterfall_List_Jdx>;
  attorney_waterfall_list_jdx_aggregated: Array<Attorney_Waterfall_List_Jdx_Aggregated>;
  attorney_waterfall_list_jdx_by_id?: Maybe<Attorney_Waterfall_List_Jdx>;
  attorney_waterfall_list_jdx_by_version?: Maybe<Version_Attorney_Waterfall_List_Jdx>;
  attorney_waterfall_list_pa: Array<Attorney_Waterfall_List_Pa>;
  attorney_waterfall_list_pa_aggregated: Array<Attorney_Waterfall_List_Pa_Aggregated>;
  attorney_waterfall_list_pa_by_id?: Maybe<Attorney_Waterfall_List_Pa>;
  attorney_waterfall_list_pa_by_version?: Maybe<Version_Attorney_Waterfall_List_Pa>;
  case: Array<Case>;
  case_affiliation: Array<Case_Affiliation>;
  case_affiliation_aggregated: Array<Case_Affiliation_Aggregated>;
  case_affiliation_by_id?: Maybe<Case_Affiliation>;
  case_affiliation_by_version?: Maybe<Version_Case_Affiliation>;
  case_aggregated: Array<Case_Aggregated>;
  case_by_id?: Maybe<Case>;
  case_by_version?: Maybe<Version_Case>;
  case_fee_overrides: Array<Case_Fee_Overrides>;
  case_fee_overrides_aggregated: Array<Case_Fee_Overrides_Aggregated>;
  case_fee_overrides_by_id?: Maybe<Case_Fee_Overrides>;
  case_fee_overrides_by_version?: Maybe<Version_Case_Fee_Overrides>;
  case_file: Array<Case_File>;
  case_file_aggregated: Array<Case_File_Aggregated>;
  case_file_by_id?: Maybe<Case_File>;
  case_file_by_version?: Maybe<Version_Case_File>;
  case_lead: Array<Case_Lead>;
  case_lead_aggregated: Array<Case_Lead_Aggregated>;
  case_lead_by_id?: Maybe<Case_Lead>;
  case_lead_by_version?: Maybe<Version_Case_Lead>;
  case_lead_contact: Array<Case_Lead_Contact>;
  case_lead_contact_aggregated: Array<Case_Lead_Contact_Aggregated>;
  case_lead_contact_by_id?: Maybe<Case_Lead_Contact>;
  case_lead_contact_by_version?: Maybe<Version_Case_Lead_Contact>;
  case_lead_score: Array<Case_Lead_Score>;
  case_lead_score_aggregated: Array<Case_Lead_Score_Aggregated>;
  case_lead_score_by_id?: Maybe<Case_Lead_Score>;
  case_lead_score_by_version?: Maybe<Version_Case_Lead_Score>;
  case_management_software: Array<Case_Management_Software>;
  case_management_software_aggregated: Array<Case_Management_Software_Aggregated>;
  case_management_software_by_id?: Maybe<Case_Management_Software>;
  case_management_software_by_version?: Maybe<Version_Case_Management_Software>;
  case_ownership: Array<Case_Ownership>;
  case_ownership_aggregated: Array<Case_Ownership_Aggregated>;
  case_ownership_by_id?: Maybe<Case_Ownership>;
  case_ownership_by_version?: Maybe<Version_Case_Ownership>;
  case_purchase: Array<Case_Purchase>;
  case_purchase_activity: Array<Case_Purchase_Activity>;
  case_purchase_activity_aggregated: Array<Case_Purchase_Activity_Aggregated>;
  case_purchase_activity_by_id?: Maybe<Case_Purchase_Activity>;
  case_purchase_activity_by_version?: Maybe<Version_Case_Purchase_Activity>;
  case_purchase_aggregated: Array<Case_Purchase_Aggregated>;
  case_purchase_by_id?: Maybe<Case_Purchase>;
  case_purchase_by_version?: Maybe<Version_Case_Purchase>;
  case_purchase_ownership: Array<Case_Purchase_Ownership>;
  case_purchase_ownership_aggregated: Array<Case_Purchase_Ownership_Aggregated>;
  case_purchase_ownership_by_id?: Maybe<Case_Purchase_Ownership>;
  case_purchase_ownership_by_version?: Maybe<Version_Case_Purchase_Ownership>;
  case_purchase_payment: Array<Case_Purchase_Payment>;
  case_purchase_payment_aggregated: Array<Case_Purchase_Payment_Aggregated>;
  case_purchase_payment_by_id?: Maybe<Case_Purchase_Payment>;
  case_purchase_payment_by_version?: Maybe<Version_Case_Purchase_Payment>;
  case_purchase_sign_request: Array<Case_Purchase_Sign_Request>;
  case_purchase_sign_request_aggregated: Array<Case_Purchase_Sign_Request_Aggregated>;
  case_purchase_sign_request_by_id?: Maybe<Case_Purchase_Sign_Request>;
  case_purchase_sign_request_by_version?: Maybe<Version_Case_Purchase_Sign_Request>;
  case_status_update: Array<Case_Status_Update>;
  case_status_update_aggregated: Array<Case_Status_Update_Aggregated>;
  case_status_update_by_id?: Maybe<Case_Status_Update>;
  case_status_update_by_version?: Maybe<Version_Case_Status_Update>;
  case_status_update_scheduler_task: Array<Case_Status_Update_Scheduler_Task>;
  case_status_update_scheduler_task_aggregated: Array<Case_Status_Update_Scheduler_Task_Aggregated>;
  case_status_update_scheduler_task_by_id?: Maybe<Case_Status_Update_Scheduler_Task>;
  case_status_update_scheduler_task_by_version?: Maybe<Version_Case_Status_Update_Scheduler_Task>;
  catalog_access_request_status: Array<Catalog_Access_Request_Status>;
  catalog_access_request_status_aggregated: Array<Catalog_Access_Request_Status_Aggregated>;
  catalog_access_request_status_by_id?: Maybe<Catalog_Access_Request_Status>;
  catalog_access_request_status_by_version?: Maybe<Version_Catalog_Access_Request_Status>;
  catalog_account_type: Array<Catalog_Account_Type>;
  catalog_account_type_aggregated: Array<Catalog_Account_Type_Aggregated>;
  catalog_account_type_by_id?: Maybe<Catalog_Account_Type>;
  catalog_account_type_by_version?: Maybe<Version_Catalog_Account_Type>;
  catalog_activity_origin: Array<Catalog_Activity_Origin>;
  catalog_activity_origin_aggregated: Array<Catalog_Activity_Origin_Aggregated>;
  catalog_activity_origin_by_id?: Maybe<Catalog_Activity_Origin>;
  catalog_activity_origin_by_version?: Maybe<Version_Catalog_Activity_Origin>;
  catalog_affiliation: Array<Catalog_Affiliation>;
  catalog_affiliation_aggregated: Array<Catalog_Affiliation_Aggregated>;
  catalog_affiliation_by_id?: Maybe<Catalog_Affiliation>;
  catalog_affiliation_by_version?: Maybe<Version_Catalog_Affiliation>;
  catalog_award: Array<Catalog_Award>;
  catalog_award_aggregated: Array<Catalog_Award_Aggregated>;
  catalog_award_by_id?: Maybe<Catalog_Award>;
  catalog_award_by_version?: Maybe<Version_Catalog_Award>;
  catalog_case_alert: Array<Catalog_Case_Alert>;
  catalog_case_alert_aggregated: Array<Catalog_Case_Alert_Aggregated>;
  catalog_case_alert_by_id?: Maybe<Catalog_Case_Alert>;
  catalog_case_alert_by_version?: Maybe<Version_Catalog_Case_Alert>;
  catalog_case_file_type: Array<Catalog_Case_File_Type>;
  catalog_case_file_type_aggregated: Array<Catalog_Case_File_Type_Aggregated>;
  catalog_case_file_type_by_id?: Maybe<Catalog_Case_File_Type>;
  catalog_case_file_type_by_version?: Maybe<Version_Catalog_Case_File_Type>;
  catalog_case_mp_preference: Array<Catalog_Case_Mp_Preference>;
  catalog_case_mp_preference_aggregated: Array<Catalog_Case_Mp_Preference_Aggregated>;
  catalog_case_mp_preference_by_id?: Maybe<Catalog_Case_Mp_Preference>;
  catalog_case_mp_preference_by_version?: Maybe<Version_Catalog_Case_Mp_Preference>;
  catalog_case_mp_visibility: Array<Catalog_Case_Mp_Visibility>;
  catalog_case_mp_visibility_aggregated: Array<Catalog_Case_Mp_Visibility_Aggregated>;
  catalog_case_mp_visibility_by_id?: Maybe<Catalog_Case_Mp_Visibility>;
  catalog_case_mp_visibility_by_version?: Maybe<Version_Catalog_Case_Mp_Visibility>;
  catalog_case_purchase_decline_reason: Array<Catalog_Case_Purchase_Decline_Reason>;
  catalog_case_purchase_decline_reason_aggregated: Array<Catalog_Case_Purchase_Decline_Reason_Aggregated>;
  catalog_case_purchase_decline_reason_by_id?: Maybe<Catalog_Case_Purchase_Decline_Reason>;
  catalog_case_purchase_decline_reason_by_version?: Maybe<Version_Catalog_Case_Purchase_Decline_Reason>;
  catalog_case_purchase_status: Array<Catalog_Case_Purchase_Status>;
  catalog_case_purchase_status_aggregated: Array<Catalog_Case_Purchase_Status_Aggregated>;
  catalog_case_purchase_status_by_id?: Maybe<Catalog_Case_Purchase_Status>;
  catalog_case_purchase_status_by_version?: Maybe<Version_Catalog_Case_Purchase_Status>;
  catalog_case_purchase_unmatch_reason: Array<Catalog_Case_Purchase_Unmatch_Reason>;
  catalog_case_purchase_unmatch_reason_aggregated: Array<Catalog_Case_Purchase_Unmatch_Reason_Aggregated>;
  catalog_case_purchase_unmatch_reason_by_id?: Maybe<Catalog_Case_Purchase_Unmatch_Reason>;
  catalog_case_purchase_unmatch_reason_by_version?: Maybe<Version_Catalog_Case_Purchase_Unmatch_Reason>;
  catalog_case_source: Array<Catalog_Case_Source>;
  catalog_case_source_aggregated: Array<Catalog_Case_Source_Aggregated>;
  catalog_case_source_by_id?: Maybe<Catalog_Case_Source>;
  catalog_case_source_by_version?: Maybe<Version_Catalog_Case_Source>;
  catalog_case_status_update_matter_stage: Array<Catalog_Case_Status_Update_Matter_Stage>;
  catalog_case_status_update_matter_stage_aggregated: Array<Catalog_Case_Status_Update_Matter_Stage_Aggregated>;
  catalog_case_status_update_matter_stage_by_id?: Maybe<Catalog_Case_Status_Update_Matter_Stage>;
  catalog_case_status_update_matter_stage_by_version?: Maybe<Version_Catalog_Case_Status_Update_Matter_Stage>;
  catalog_case_status_update_matter_status: Array<Catalog_Case_Status_Update_Matter_Status>;
  catalog_case_status_update_matter_status_aggregated: Array<Catalog_Case_Status_Update_Matter_Status_Aggregated>;
  catalog_case_status_update_matter_status_by_id?: Maybe<Catalog_Case_Status_Update_Matter_Status>;
  catalog_case_status_update_matter_status_by_version?: Maybe<Version_Catalog_Case_Status_Update_Matter_Status>;
  catalog_communication_preference: Array<Catalog_Communication_Preference>;
  catalog_communication_preference_aggregated: Array<Catalog_Communication_Preference_Aggregated>;
  catalog_communication_preference_by_id?: Maybe<Catalog_Communication_Preference>;
  catalog_communication_preference_by_version?: Maybe<Version_Catalog_Communication_Preference>;
  catalog_community_expiration_duration: Array<Catalog_Community_Expiration_Duration>;
  catalog_community_expiration_duration_aggregated: Array<Catalog_Community_Expiration_Duration_Aggregated>;
  catalog_community_expiration_duration_by_id?: Maybe<Catalog_Community_Expiration_Duration>;
  catalog_community_expiration_duration_by_version?: Maybe<Version_Catalog_Community_Expiration_Duration>;
  catalog_company_size: Array<Catalog_Company_Size>;
  catalog_company_size_aggregated: Array<Catalog_Company_Size_Aggregated>;
  catalog_company_size_by_id?: Maybe<Catalog_Company_Size>;
  catalog_company_size_by_version?: Maybe<Version_Catalog_Company_Size>;
  catalog_contact_type: Array<Catalog_Contact_Type>;
  catalog_contact_type_aggregated: Array<Catalog_Contact_Type_Aggregated>;
  catalog_contact_type_by_id?: Maybe<Catalog_Contact_Type>;
  catalog_contact_type_by_version?: Maybe<Version_Catalog_Contact_Type>;
  catalog_credit_price_type: Array<Catalog_Credit_Price_Type>;
  catalog_credit_price_type_aggregated: Array<Catalog_Credit_Price_Type_Aggregated>;
  catalog_credit_price_type_by_id?: Maybe<Catalog_Credit_Price_Type>;
  catalog_credit_price_type_by_version?: Maybe<Version_Catalog_Credit_Price_Type>;
  catalog_credit_status: Array<Catalog_Credit_Status>;
  catalog_credit_status_aggregated: Array<Catalog_Credit_Status_Aggregated>;
  catalog_credit_status_by_id?: Maybe<Catalog_Credit_Status>;
  catalog_credit_status_by_version?: Maybe<Version_Catalog_Credit_Status>;
  catalog_education_grade: Array<Catalog_Education_Grade>;
  catalog_education_grade_aggregated: Array<Catalog_Education_Grade_Aggregated>;
  catalog_education_grade_by_id?: Maybe<Catalog_Education_Grade>;
  catalog_education_grade_by_version?: Maybe<Version_Catalog_Education_Grade>;
  catalog_exempt_email_domain: Array<Catalog_Exempt_Email_Domain>;
  catalog_exempt_email_domain_aggregated: Array<Catalog_Exempt_Email_Domain_Aggregated>;
  catalog_exempt_email_domain_by_id?: Maybe<Catalog_Exempt_Email_Domain>;
  catalog_exempt_email_domain_by_version?: Maybe<Version_Catalog_Exempt_Email_Domain>;
  catalog_fee: Array<Catalog_Fee>;
  catalog_fee_aggregated: Array<Catalog_Fee_Aggregated>;
  catalog_fee_agreement_status: Array<Catalog_Fee_Agreement_Status>;
  catalog_fee_agreement_status_aggregated: Array<Catalog_Fee_Agreement_Status_Aggregated>;
  catalog_fee_agreement_status_by_id?: Maybe<Catalog_Fee_Agreement_Status>;
  catalog_fee_agreement_status_by_version?: Maybe<Version_Catalog_Fee_Agreement_Status>;
  catalog_fee_by_id?: Maybe<Catalog_Fee>;
  catalog_fee_by_version?: Maybe<Version_Catalog_Fee>;
  catalog_financing_source: Array<Catalog_Financing_Source>;
  catalog_financing_source_aggregated: Array<Catalog_Financing_Source_Aggregated>;
  catalog_financing_source_by_id?: Maybe<Catalog_Financing_Source>;
  catalog_financing_source_by_version?: Maybe<Version_Catalog_Financing_Source>;
  catalog_firm_relationship: Array<Catalog_Firm_Relationship>;
  catalog_firm_relationship_aggregated: Array<Catalog_Firm_Relationship_Aggregated>;
  catalog_firm_relationship_by_id?: Maybe<Catalog_Firm_Relationship>;
  catalog_firm_relationship_by_version?: Maybe<Version_Catalog_Firm_Relationship>;
  catalog_invite_status: Array<Catalog_Invite_Status>;
  catalog_invite_status_aggregated: Array<Catalog_Invite_Status_Aggregated>;
  catalog_invite_status_by_id?: Maybe<Catalog_Invite_Status>;
  catalog_invite_status_by_version?: Maybe<Version_Catalog_Invite_Status>;
  catalog_language: Array<Catalog_Language>;
  catalog_language_aggregated: Array<Catalog_Language_Aggregated>;
  catalog_language_by_id?: Maybe<Catalog_Language>;
  catalog_language_by_version?: Maybe<Version_Catalog_Language>;
  catalog_license_status: Array<Catalog_License_Status>;
  catalog_license_status_aggregated: Array<Catalog_License_Status_Aggregated>;
  catalog_license_status_by_id?: Maybe<Catalog_License_Status>;
  catalog_license_status_by_version?: Maybe<Version_Catalog_License_Status>;
  catalog_malpractice_insurance: Array<Catalog_Malpractice_Insurance>;
  catalog_malpractice_insurance_aggregated: Array<Catalog_Malpractice_Insurance_Aggregated>;
  catalog_malpractice_insurance_by_id?: Maybe<Catalog_Malpractice_Insurance>;
  catalog_malpractice_insurance_by_version?: Maybe<Version_Catalog_Malpractice_Insurance>;
  catalog_membership_type: Array<Catalog_Membership_Type>;
  catalog_membership_type_aggregated: Array<Catalog_Membership_Type_Aggregated>;
  catalog_membership_type_by_id?: Maybe<Catalog_Membership_Type>;
  catalog_membership_type_by_version?: Maybe<Version_Catalog_Membership_Type>;
  catalog_notification_level: Array<Catalog_Notification_Level>;
  catalog_notification_level_aggregated: Array<Catalog_Notification_Level_Aggregated>;
  catalog_notification_level_by_id?: Maybe<Catalog_Notification_Level>;
  catalog_notification_level_by_version?: Maybe<Version_Catalog_Notification_Level>;
  catalog_oauth_integration: Array<Catalog_Oauth_Integration>;
  catalog_oauth_integration_aggregated: Array<Catalog_Oauth_Integration_Aggregated>;
  catalog_oauth_integration_by_id?: Maybe<Catalog_Oauth_Integration>;
  catalog_oauth_integration_by_version?: Maybe<Version_Catalog_Oauth_Integration>;
  catalog_payment_method: Array<Catalog_Payment_Method>;
  catalog_payment_method_aggregated: Array<Catalog_Payment_Method_Aggregated>;
  catalog_payment_method_by_id?: Maybe<Catalog_Payment_Method>;
  catalog_payment_method_by_version?: Maybe<Version_Catalog_Payment_Method>;
  catalog_payment_status: Array<Catalog_Payment_Status>;
  catalog_payment_status_aggregated: Array<Catalog_Payment_Status_Aggregated>;
  catalog_payment_status_by_id?: Maybe<Catalog_Payment_Status>;
  catalog_payment_status_by_version?: Maybe<Version_Catalog_Payment_Status>;
  catalog_practice_area: Array<Catalog_Practice_Area>;
  catalog_practice_area_aggregated: Array<Catalog_Practice_Area_Aggregated>;
  catalog_practice_area_bundle: Array<Catalog_Practice_Area_Bundle>;
  catalog_practice_area_bundle_aggregated: Array<Catalog_Practice_Area_Bundle_Aggregated>;
  catalog_practice_area_bundle_by_id?: Maybe<Catalog_Practice_Area_Bundle>;
  catalog_practice_area_bundle_by_version?: Maybe<Version_Catalog_Practice_Area_Bundle>;
  catalog_practice_area_by_id?: Maybe<Catalog_Practice_Area>;
  catalog_practice_area_by_version?: Maybe<Version_Catalog_Practice_Area>;
  catalog_process_stage: Array<Catalog_Process_Stage>;
  catalog_process_stage_aggregated: Array<Catalog_Process_Stage_Aggregated>;
  catalog_process_stage_by_id?: Maybe<Catalog_Process_Stage>;
  catalog_process_stage_by_version?: Maybe<Version_Catalog_Process_Stage>;
  catalog_referral_network_list_item_status: Array<Catalog_Referral_Network_List_Item_Status>;
  catalog_referral_network_list_item_status_aggregated: Array<Catalog_Referral_Network_List_Item_Status_Aggregated>;
  catalog_referral_network_list_item_status_by_id?: Maybe<Catalog_Referral_Network_List_Item_Status>;
  catalog_referral_network_list_item_status_by_version?: Maybe<Version_Catalog_Referral_Network_List_Item_Status>;
  catalog_referral_network_list_status: Array<Catalog_Referral_Network_List_Status>;
  catalog_referral_network_list_status_aggregated: Array<Catalog_Referral_Network_List_Status_Aggregated>;
  catalog_referral_network_list_status_by_id?: Maybe<Catalog_Referral_Network_List_Status>;
  catalog_referral_network_list_status_by_version?: Maybe<Version_Catalog_Referral_Network_List_Status>;
  catalog_referral_network_type: Array<Catalog_Referral_Network_Type>;
  catalog_referral_network_type_aggregated: Array<Catalog_Referral_Network_Type_Aggregated>;
  catalog_referral_network_type_by_id?: Maybe<Catalog_Referral_Network_Type>;
  catalog_referral_network_type_by_version?: Maybe<Version_Catalog_Referral_Network_Type>;
  catalog_role_invite: Array<Catalog_Role_Invite>;
  catalog_role_invite_aggregated: Array<Catalog_Role_Invite_Aggregated>;
  catalog_role_invite_by_id?: Maybe<Catalog_Role_Invite>;
  catalog_role_invite_by_version?: Maybe<Version_Catalog_Role_Invite>;
  catalog_sign_request_status: Array<Catalog_Sign_Request_Status>;
  catalog_sign_request_status_aggregated: Array<Catalog_Sign_Request_Status_Aggregated>;
  catalog_sign_request_status_by_id?: Maybe<Catalog_Sign_Request_Status>;
  catalog_sign_request_status_by_version?: Maybe<Version_Catalog_Sign_Request_Status>;
  catalog_time_unit: Array<Catalog_Time_Unit>;
  catalog_time_unit_aggregated: Array<Catalog_Time_Unit_Aggregated>;
  catalog_time_unit_by_id?: Maybe<Catalog_Time_Unit>;
  catalog_time_unit_by_version?: Maybe<Version_Catalog_Time_Unit>;
  catalog_us_state: Array<Catalog_Us_State>;
  catalog_us_state_aggregated: Array<Catalog_Us_State_Aggregated>;
  catalog_us_state_by_id?: Maybe<Catalog_Us_State>;
  catalog_us_state_by_version?: Maybe<Version_Catalog_Us_State>;
  catalog_waterfall_duration: Array<Catalog_Waterfall_Duration>;
  catalog_waterfall_duration_aggregated: Array<Catalog_Waterfall_Duration_Aggregated>;
  catalog_waterfall_duration_by_id?: Maybe<Catalog_Waterfall_Duration>;
  catalog_waterfall_duration_by_version?: Maybe<Version_Catalog_Waterfall_Duration>;
  catalog_waterfall_status: Array<Catalog_Waterfall_Status>;
  catalog_waterfall_status_aggregated: Array<Catalog_Waterfall_Status_Aggregated>;
  catalog_waterfall_status_by_id?: Maybe<Catalog_Waterfall_Status>;
  catalog_waterfall_status_by_version?: Maybe<Version_Catalog_Waterfall_Status>;
  catalog_years_practice: Array<Catalog_Years_Practice>;
  catalog_years_practice_aggregated: Array<Catalog_Years_Practice_Aggregated>;
  catalog_years_practice_by_id?: Maybe<Catalog_Years_Practice>;
  catalog_years_practice_by_version?: Maybe<Version_Catalog_Years_Practice>;
  catalog_zip_code: Array<Catalog_Zip_Code>;
  catalog_zip_code_aggregated: Array<Catalog_Zip_Code_Aggregated>;
  catalog_zip_code_by_id?: Maybe<Catalog_Zip_Code>;
  catalog_zip_code_by_version?: Maybe<Version_Catalog_Zip_Code>;
  config_lcms_leaddocket: Array<Config_Lcms_Leaddocket>;
  config_lcms_leaddocket_aggregated: Array<Config_Lcms_Leaddocket_Aggregated>;
  config_lcms_leaddocket_by_id?: Maybe<Config_Lcms_Leaddocket>;
  config_lcms_leaddocket_by_version?: Maybe<Version_Config_Lcms_Leaddocket>;
  dismissed_invite_suggestions: Array<Dismissed_Invite_Suggestions>;
  dismissed_invite_suggestions_aggregated: Array<Dismissed_Invite_Suggestions_Aggregated>;
  dismissed_invite_suggestions_by_id?: Maybe<Dismissed_Invite_Suggestions>;
  dismissed_invite_suggestions_by_version?: Maybe<Version_Dismissed_Invite_Suggestions>;
  fct_affiliation_members: Array<Fct_Affiliation_Members>;
  fct_affiliation_members_aggregated: Array<Fct_Affiliation_Members_Aggregated>;
  fct_affiliation_members_by_id?: Maybe<Fct_Affiliation_Members>;
  fct_affiliation_members_by_version?: Maybe<Version_Fct_Affiliation_Members>;
  filter_daily_digest_pending: Array<Filter_Daily_Digest_Pending>;
  filter_daily_digest_pending_aggregated: Array<Filter_Daily_Digest_Pending_Aggregated>;
  filter_daily_digest_pending_by_id?: Maybe<Filter_Daily_Digest_Pending>;
  filter_daily_digest_pending_by_version?: Maybe<Version_Filter_Daily_Digest_Pending>;
  filter_redundant: Array<Filter_Redundant>;
  filter_redundant_aggregated: Array<Filter_Redundant_Aggregated>;
  filter_redundant_by_id?: Maybe<Filter_Redundant>;
  filter_redundant_by_version?: Maybe<Version_Filter_Redundant>;
  invitation_discount: Array<Invitation_Discount>;
  invitation_discount_aggregated: Array<Invitation_Discount_Aggregated>;
  invitation_discount_by_id?: Maybe<Invitation_Discount>;
  invitation_discount_by_version?: Maybe<Version_Invitation_Discount>;
  lcms_case_mapping: Array<Lcms_Case_Mapping>;
  lcms_case_mapping_aggregated: Array<Lcms_Case_Mapping_Aggregated>;
  lcms_case_mapping_by_id?: Maybe<Lcms_Case_Mapping>;
  lcms_case_mapping_by_version?: Maybe<Version_Lcms_Case_Mapping>;
  lcms_health_check: Array<Lcms_Health_Check>;
  lcms_health_check_aggregated: Array<Lcms_Health_Check_Aggregated>;
  lcms_health_check_by_id?: Maybe<Lcms_Health_Check>;
  lcms_health_check_by_version?: Maybe<Version_Lcms_Health_Check>;
  master_attorney: Array<Master_Attorney>;
  master_attorney_aggregated: Array<Master_Attorney_Aggregated>;
  master_attorney_by_id?: Maybe<Master_Attorney>;
  master_attorney_by_version?: Maybe<Version_Master_Attorney>;
  master_case: Array<Master_Case>;
  master_case_aggregated: Array<Master_Case_Aggregated>;
  master_case_by_id?: Maybe<Master_Case>;
  master_case_by_version?: Maybe<Version_Master_Case>;
  master_organization: Array<Master_Organization>;
  master_organization_aggregated: Array<Master_Organization_Aggregated>;
  master_organization_by_id?: Maybe<Master_Organization>;
  master_organization_by_version?: Maybe<Version_Master_Organization>;
  master_referral: Array<Master_Referral>;
  master_referral_aggregated: Array<Master_Referral_Aggregated>;
  master_referral_by_id?: Maybe<Master_Referral>;
  master_referral_by_version?: Maybe<Version_Master_Referral>;
  network_user_invite: Array<Network_User_Invite>;
  network_user_invite_aggregated: Array<Network_User_Invite_Aggregated>;
  network_user_invite_by_id?: Maybe<Network_User_Invite>;
  network_user_invite_by_version?: Maybe<Version_Network_User_Invite>;
  notification: Array<Notification>;
  notification_aggregated: Array<Notification_Aggregated>;
  notification_by_id?: Maybe<Notification>;
  notification_by_version?: Maybe<Version_Notification>;
  organization: Array<Organization>;
  organization_aggregated: Array<Organization_Aggregated>;
  organization_block: Array<Organization_Block>;
  organization_block_aggregated: Array<Organization_Block_Aggregated>;
  organization_block_by_id?: Maybe<Organization_Block>;
  organization_block_by_version?: Maybe<Version_Organization_Block>;
  organization_by_id?: Maybe<Organization>;
  organization_by_version?: Maybe<Version_Organization>;
  organization_connected_lcms: Array<Organization_Connected_Lcms>;
  organization_connected_lcms_aggregated: Array<Organization_Connected_Lcms_Aggregated>;
  organization_connected_lcms_by_id?: Maybe<Organization_Connected_Lcms>;
  organization_connected_lcms_by_version?: Maybe<Version_Organization_Connected_Lcms>;
  organization_discount: Array<Organization_Discount>;
  organization_discount_aggregated: Array<Organization_Discount_Aggregated>;
  organization_discount_by_id?: Maybe<Organization_Discount>;
  organization_discount_by_version?: Maybe<Version_Organization_Discount>;
  organization_profile: Array<Organization_Profile>;
  organization_profile_aggregated: Array<Organization_Profile_Aggregated>;
  organization_profile_by_id?: Maybe<Organization_Profile>;
  organization_profile_by_version?: Maybe<Version_Organization_Profile>;
  organization_referral_settings: Array<Organization_Referral_Settings>;
  organization_referral_settings_aggregated: Array<Organization_Referral_Settings_Aggregated>;
  organization_referral_settings_by_id?: Maybe<Organization_Referral_Settings>;
  organization_referral_settings_by_version?: Maybe<Version_Organization_Referral_Settings>;
  organization_user: Array<Organization_User>;
  organization_user_aggregated: Array<Organization_User_Aggregated>;
  organization_user_by_id?: Maybe<Organization_User>;
  organization_user_by_version?: Maybe<Version_Organization_User>;
  practice_area_overrides: Array<Practice_Area_Overrides>;
  practice_area_overrides_aggregated: Array<Practice_Area_Overrides_Aggregated>;
  practice_area_overrides_by_id?: Maybe<Practice_Area_Overrides>;
  practice_area_overrides_by_version?: Maybe<Version_Practice_Area_Overrides>;
  practice_attorney_mapping: Array<Practice_Attorney_Mapping>;
  practice_attorney_mapping_aggregated: Array<Practice_Attorney_Mapping_Aggregated>;
  practice_attorney_mapping_by_id?: Maybe<Practice_Attorney_Mapping>;
  practice_attorney_mapping_by_version?: Maybe<Version_Practice_Attorney_Mapping>;
  referral_network: Array<Referral_Network>;
  referral_network_aggregated: Array<Referral_Network_Aggregated>;
  referral_network_broadcast_audit: Array<Referral_Network_Broadcast_Audit>;
  referral_network_broadcast_audit_aggregated: Array<Referral_Network_Broadcast_Audit_Aggregated>;
  referral_network_broadcast_audit_by_id?: Maybe<Referral_Network_Broadcast_Audit>;
  referral_network_broadcast_audit_by_version?: Maybe<Version_Referral_Network_Broadcast_Audit>;
  referral_network_by_id?: Maybe<Referral_Network>;
  referral_network_by_version?: Maybe<Version_Referral_Network>;
  referral_network_list: Array<Referral_Network_List>;
  referral_network_list_aggregated: Array<Referral_Network_List_Aggregated>;
  referral_network_list_by_id?: Maybe<Referral_Network_List>;
  referral_network_list_by_version?: Maybe<Version_Referral_Network_List>;
  referral_network_list_item: Array<Referral_Network_List_Item>;
  referral_network_list_item_aggregated: Array<Referral_Network_List_Item_Aggregated>;
  referral_network_list_item_by_id?: Maybe<Referral_Network_List_Item>;
  referral_network_list_item_by_version?: Maybe<Version_Referral_Network_List_Item>;
  referral_network_member: Array<Referral_Network_Member>;
  referral_network_member_aggregated: Array<Referral_Network_Member_Aggregated>;
  referral_network_member_by_id?: Maybe<Referral_Network_Member>;
  referral_network_member_by_version?: Maybe<Version_Referral_Network_Member>;
  referral_network_member_jurisdiction: Array<Referral_Network_Member_Jurisdiction>;
  referral_network_member_jurisdiction_aggregated: Array<Referral_Network_Member_Jurisdiction_Aggregated>;
  referral_network_member_jurisdiction_by_id?: Maybe<Referral_Network_Member_Jurisdiction>;
  referral_network_member_jurisdiction_by_version?: Maybe<Version_Referral_Network_Member_Jurisdiction>;
  saved_filters: Array<Saved_Filters>;
  saved_filters_aggregated: Array<Saved_Filters_Aggregated>;
  saved_filters_by_id?: Maybe<Saved_Filters>;
  saved_filters_by_version?: Maybe<Version_Saved_Filters>;
  school: Array<School>;
  school_aggregated: Array<School_Aggregated>;
  school_by_id?: Maybe<School>;
  school_by_version?: Maybe<Version_School>;
  sum_analytics_attorney_metrics: Array<Sum_Analytics_Attorney_Metrics>;
  sum_analytics_attorney_metrics_aggregated: Array<Sum_Analytics_Attorney_Metrics_Aggregated>;
  sum_analytics_attorney_metrics_by_id?: Maybe<Sum_Analytics_Attorney_Metrics>;
  sum_analytics_attorney_metrics_by_version?: Maybe<Version_Sum_Analytics_Attorney_Metrics>;
  sum_analytics_freshness: Array<Sum_Analytics_Freshness>;
  sum_analytics_freshness_aggregated: Array<Sum_Analytics_Freshness_Aggregated>;
  sum_analytics_freshness_by_id?: Maybe<Sum_Analytics_Freshness>;
  sum_analytics_freshness_by_version?: Maybe<Version_Sum_Analytics_Freshness>;
  sum_analytics_org_metrics: Array<Sum_Analytics_Org_Metrics>;
  sum_analytics_org_metrics_aggregated: Array<Sum_Analytics_Org_Metrics_Aggregated>;
  sum_analytics_org_metrics_by_id?: Maybe<Sum_Analytics_Org_Metrics>;
  sum_analytics_org_metrics_by_version?: Maybe<Version_Sum_Analytics_Org_Metrics>;
  sum_analytics_org_practice_areas_buyer: Array<Sum_Analytics_Org_Practice_Areas_Buyer>;
  sum_analytics_org_practice_areas_buyer_aggregated: Array<Sum_Analytics_Org_Practice_Areas_Buyer_Aggregated>;
  sum_analytics_org_practice_areas_buyer_by_id?: Maybe<Sum_Analytics_Org_Practice_Areas_Buyer>;
  sum_analytics_org_practice_areas_buyer_by_version?: Maybe<Version_Sum_Analytics_Org_Practice_Areas_Buyer>;
  sum_analytics_org_practice_areas_seller: Array<Sum_Analytics_Org_Practice_Areas_Seller>;
  sum_analytics_org_practice_areas_seller_aggregated: Array<Sum_Analytics_Org_Practice_Areas_Seller_Aggregated>;
  sum_analytics_org_practice_areas_seller_by_id?: Maybe<Sum_Analytics_Org_Practice_Areas_Seller>;
  sum_analytics_org_practice_areas_seller_by_version?: Maybe<Version_Sum_Analytics_Org_Practice_Areas_Seller>;
  sum_analytics_org_top_attorneys_buyer: Array<Sum_Analytics_Org_Top_Attorneys_Buyer>;
  sum_analytics_org_top_attorneys_buyer_aggregated: Array<Sum_Analytics_Org_Top_Attorneys_Buyer_Aggregated>;
  sum_analytics_org_top_attorneys_buyer_by_id?: Maybe<Sum_Analytics_Org_Top_Attorneys_Buyer>;
  sum_analytics_org_top_attorneys_buyer_by_version?: Maybe<Version_Sum_Analytics_Org_Top_Attorneys_Buyer>;
  sum_analytics_org_top_attorneys_seller: Array<Sum_Analytics_Org_Top_Attorneys_Seller>;
  sum_analytics_org_top_attorneys_seller_aggregated: Array<Sum_Analytics_Org_Top_Attorneys_Seller_Aggregated>;
  sum_analytics_org_top_attorneys_seller_by_id?: Maybe<Sum_Analytics_Org_Top_Attorneys_Seller>;
  sum_analytics_org_top_attorneys_seller_by_version?: Maybe<Version_Sum_Analytics_Org_Top_Attorneys_Seller>;
  sum_analytics_top_attorneys: Array<Sum_Analytics_Top_Attorneys>;
  sum_analytics_top_attorneys_aggregated: Array<Sum_Analytics_Top_Attorneys_Aggregated>;
  sum_analytics_top_attorneys_by_id?: Maybe<Sum_Analytics_Top_Attorneys>;
  sum_analytics_top_attorneys_by_version?: Maybe<Version_Sum_Analytics_Top_Attorneys>;
  sum_analytics_top_practice_areas: Array<Sum_Analytics_Top_Practice_Areas>;
  sum_analytics_top_practice_areas_aggregated: Array<Sum_Analytics_Top_Practice_Areas_Aggregated>;
  sum_analytics_top_practice_areas_by_id?: Maybe<Sum_Analytics_Top_Practice_Areas>;
  sum_analytics_top_practice_areas_by_version?: Maybe<Version_Sum_Analytics_Top_Practice_Areas>;
  sum_ratings_attorney_buyer: Array<Sum_Ratings_Attorney_Buyer>;
  sum_ratings_attorney_buyer_aggregated: Array<Sum_Ratings_Attorney_Buyer_Aggregated>;
  sum_ratings_attorney_buyer_by_id?: Maybe<Sum_Ratings_Attorney_Buyer>;
  sum_ratings_attorney_buyer_by_version?: Maybe<Version_Sum_Ratings_Attorney_Buyer>;
  sum_ratings_attorney_seller: Array<Sum_Ratings_Attorney_Seller>;
  sum_ratings_attorney_seller_aggregated: Array<Sum_Ratings_Attorney_Seller_Aggregated>;
  sum_ratings_attorney_seller_by_id?: Maybe<Sum_Ratings_Attorney_Seller>;
  sum_ratings_attorney_seller_by_version?: Maybe<Version_Sum_Ratings_Attorney_Seller>;
  user_account_type: Array<User_Account_Type>;
  user_account_type_aggregated: Array<User_Account_Type_Aggregated>;
  user_account_type_by_id?: Maybe<User_Account_Type>;
  user_account_type_by_version?: Maybe<Version_User_Account_Type>;
  user_allowed_file: Array<User_Allowed_File>;
  user_allowed_file_aggregated: Array<User_Allowed_File_Aggregated>;
  user_allowed_file_by_id?: Maybe<User_Allowed_File>;
  user_allowed_file_by_version?: Maybe<Version_User_Allowed_File>;
  user_email_validation: Array<User_Email_Validation>;
  user_email_validation_aggregated: Array<User_Email_Validation_Aggregated>;
  user_email_validation_by_id?: Maybe<User_Email_Validation>;
  user_email_validation_by_version?: Maybe<Version_User_Email_Validation>;
  user_file_access_request: Array<User_File_Access_Request>;
  user_file_access_request_aggregated: Array<User_File_Access_Request_Aggregated>;
  user_file_access_request_by_id?: Maybe<User_File_Access_Request>;
  user_file_access_request_by_version?: Maybe<Version_User_File_Access_Request>;
};


export type QueryAffiliation_DiscountArgs = {
  filter?: InputMaybe<Affiliation_Discount_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAffiliation_Discount_AggregatedArgs = {
  filter?: InputMaybe<Affiliation_Discount_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAffiliation_Discount_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAffiliation_Discount_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorneyArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Case_Mp_PreferenceArgs = {
  filter?: InputMaybe<Attorney_Case_Mp_Preference_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Case_Mp_Preference_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Case_Mp_Preference_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Case_Mp_Preference_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Case_Mp_Preference_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Chat_KeyArgs = {
  filter?: InputMaybe<Attorney_Chat_Key_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Chat_Key_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Chat_Key_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Chat_Key_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Chat_Key_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_FavoriteArgs = {
  filter?: InputMaybe<Attorney_Favorite_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Favorite_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Favorite_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Favorite_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Favorite_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_InviteArgs = {
  filter?: InputMaybe<Attorney_Invite_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Invite_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Invite_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Invite_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Invite_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Invite_Link_VisitArgs = {
  filter?: InputMaybe<Attorney_Invite_Link_Visit_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Invite_Link_Visit_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Invite_Link_Visit_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Invite_Link_Visit_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Invite_Link_Visit_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Oauth_IntegrationArgs = {
  filter?: InputMaybe<Attorney_Oauth_Integration_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Oauth_Integration_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Oauth_Integration_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Oauth_Integration_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Oauth_Integration_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Payment_MembershipArgs = {
  filter?: InputMaybe<Attorney_Payment_Membership_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Payment_Membership_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Payment_Membership_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Payment_Membership_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Payment_Membership_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_ProfileArgs = {
  filter?: InputMaybe<Attorney_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_AffiliationArgs = {
  filter?: InputMaybe<Attorney_Profile_Affiliation_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Affiliation_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Profile_Affiliation_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Affiliation_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Profile_Affiliation_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Profile_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Profile_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_AwardArgs = {
  filter?: InputMaybe<Attorney_Profile_Award_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Award_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Profile_Award_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Award_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Profile_Award_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Profile_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Profile_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Profile_Case_Management_SoftwareArgs = {
  filter?: InputMaybe<Attorney_Profile_Case_Management_Software_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Case_Management_Software_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Profile_Case_Management_Software_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Case_Management_Software_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Profile_Case_Management_Software_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Profile_Communication_PreferenceArgs = {
  filter?: InputMaybe<Attorney_Profile_Communication_Preference_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Communication_Preference_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Profile_Communication_Preference_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Communication_Preference_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Profile_Communication_Preference_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Profile_ContactArgs = {
  filter?: InputMaybe<Attorney_Profile_Contact_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Contact_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Profile_Contact_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Contact_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Profile_Contact_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Profile_EducationArgs = {
  filter?: InputMaybe<Attorney_Profile_Education_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Education_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Profile_Education_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Education_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Profile_Education_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Profile_FirmArgs = {
  filter?: InputMaybe<Attorney_Profile_Firm_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Firm_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Profile_Firm_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Firm_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Profile_Firm_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Profile_LanguageArgs = {
  filter?: InputMaybe<Attorney_Profile_Language_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Language_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Profile_Language_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Language_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Profile_Language_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Profile_LicenseArgs = {
  filter?: InputMaybe<Attorney_Profile_License_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_License_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Profile_License_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_License_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Profile_License_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Profile_License_InsuranceArgs = {
  filter?: InputMaybe<Attorney_Profile_License_Insurance_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_License_Insurance_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Profile_License_Insurance_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_License_Insurance_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Profile_License_Insurance_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Profile_Notification_LevelArgs = {
  filter?: InputMaybe<Attorney_Profile_Notification_Level_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Notification_Level_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Profile_Notification_Level_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Notification_Level_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Profile_Notification_Level_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Profile_Practice_AreaArgs = {
  filter?: InputMaybe<Attorney_Profile_Practice_Area_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Practice_Area_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Profile_Practice_Area_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Profile_Practice_Area_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Profile_Practice_Area_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_StripeArgs = {
  filter?: InputMaybe<Attorney_Stripe_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Stripe_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Stripe_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Stripe_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Stripe_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_WaterfallArgs = {
  filter?: InputMaybe<Attorney_Waterfall_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Waterfall_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Waterfall_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Waterfall_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Waterfall_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Waterfall_ListArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Waterfall_List_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Waterfall_List_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Waterfall_List_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Waterfall_List_ItemArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Item_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Waterfall_List_Item_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Item_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Waterfall_List_Item_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Waterfall_List_Item_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Waterfall_List_JdxArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Jdx_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Waterfall_List_Jdx_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Jdx_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Waterfall_List_Jdx_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Waterfall_List_Jdx_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryAttorney_Waterfall_List_PaArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Pa_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Waterfall_List_Pa_AggregatedArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Pa_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAttorney_Waterfall_List_Pa_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttorney_Waterfall_List_Pa_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCaseArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_AffiliationArgs = {
  filter?: InputMaybe<Case_Affiliation_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Affiliation_AggregatedArgs = {
  filter?: InputMaybe<Case_Affiliation_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Affiliation_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_Affiliation_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_AggregatedArgs = {
  filter?: InputMaybe<Case_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_Fee_OverridesArgs = {
  filter?: InputMaybe<Case_Fee_Overrides_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Fee_Overrides_AggregatedArgs = {
  filter?: InputMaybe<Case_Fee_Overrides_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Fee_Overrides_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_Fee_Overrides_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_FileArgs = {
  filter?: InputMaybe<Case_File_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_File_AggregatedArgs = {
  filter?: InputMaybe<Case_File_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_File_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_File_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_LeadArgs = {
  filter?: InputMaybe<Case_Lead_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Lead_AggregatedArgs = {
  filter?: InputMaybe<Case_Lead_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Lead_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_Lead_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_Lead_ContactArgs = {
  filter?: InputMaybe<Case_Lead_Contact_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Lead_Contact_AggregatedArgs = {
  filter?: InputMaybe<Case_Lead_Contact_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Lead_Contact_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_Lead_Contact_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_Lead_ScoreArgs = {
  filter?: InputMaybe<Case_Lead_Score_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Lead_Score_AggregatedArgs = {
  filter?: InputMaybe<Case_Lead_Score_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Lead_Score_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_Lead_Score_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_Management_SoftwareArgs = {
  filter?: InputMaybe<Case_Management_Software_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Management_Software_AggregatedArgs = {
  filter?: InputMaybe<Case_Management_Software_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Management_Software_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_Management_Software_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_OwnershipArgs = {
  filter?: InputMaybe<Case_Ownership_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Ownership_AggregatedArgs = {
  filter?: InputMaybe<Case_Ownership_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Ownership_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_Ownership_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_PurchaseArgs = {
  filter?: InputMaybe<Case_Purchase_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Purchase_ActivityArgs = {
  filter?: InputMaybe<Case_Purchase_Activity_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Purchase_Activity_AggregatedArgs = {
  filter?: InputMaybe<Case_Purchase_Activity_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Purchase_Activity_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_Purchase_Activity_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_Purchase_AggregatedArgs = {
  filter?: InputMaybe<Case_Purchase_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Purchase_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_Purchase_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_Purchase_OwnershipArgs = {
  filter?: InputMaybe<Case_Purchase_Ownership_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Purchase_Ownership_AggregatedArgs = {
  filter?: InputMaybe<Case_Purchase_Ownership_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Purchase_Ownership_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_Purchase_Ownership_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_Purchase_PaymentArgs = {
  filter?: InputMaybe<Case_Purchase_Payment_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Purchase_Payment_AggregatedArgs = {
  filter?: InputMaybe<Case_Purchase_Payment_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Purchase_Payment_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_Purchase_Payment_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_Purchase_Sign_RequestArgs = {
  filter?: InputMaybe<Case_Purchase_Sign_Request_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Purchase_Sign_Request_AggregatedArgs = {
  filter?: InputMaybe<Case_Purchase_Sign_Request_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Purchase_Sign_Request_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_Purchase_Sign_Request_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_Status_UpdateArgs = {
  filter?: InputMaybe<Case_Status_Update_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Status_Update_AggregatedArgs = {
  filter?: InputMaybe<Case_Status_Update_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Status_Update_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_Status_Update_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCase_Status_Update_Scheduler_TaskArgs = {
  filter?: InputMaybe<Case_Status_Update_Scheduler_Task_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Status_Update_Scheduler_Task_AggregatedArgs = {
  filter?: InputMaybe<Case_Status_Update_Scheduler_Task_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCase_Status_Update_Scheduler_Task_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCase_Status_Update_Scheduler_Task_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Access_Request_StatusArgs = {
  filter?: InputMaybe<Catalog_Access_Request_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Access_Request_Status_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Access_Request_Status_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Access_Request_Status_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Access_Request_Status_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Account_TypeArgs = {
  filter?: InputMaybe<Catalog_Account_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Account_Type_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Account_Type_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Account_Type_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Account_Type_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Activity_OriginArgs = {
  filter?: InputMaybe<Catalog_Activity_Origin_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Activity_Origin_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Activity_Origin_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Activity_Origin_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Activity_Origin_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_AffiliationArgs = {
  filter?: InputMaybe<Catalog_Affiliation_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Affiliation_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Affiliation_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Affiliation_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Affiliation_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_AwardArgs = {
  filter?: InputMaybe<Catalog_Award_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Award_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Award_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Award_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Award_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Case_AlertArgs = {
  filter?: InputMaybe<Catalog_Case_Alert_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Alert_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Case_Alert_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Alert_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Case_Alert_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Case_File_TypeArgs = {
  filter?: InputMaybe<Catalog_Case_File_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_File_Type_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Case_File_Type_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_File_Type_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Case_File_Type_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Case_Mp_PreferenceArgs = {
  filter?: InputMaybe<Catalog_Case_Mp_Preference_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Mp_Preference_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Case_Mp_Preference_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Mp_Preference_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Case_Mp_Preference_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Case_Mp_VisibilityArgs = {
  filter?: InputMaybe<Catalog_Case_Mp_Visibility_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Mp_Visibility_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Case_Mp_Visibility_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Mp_Visibility_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Case_Mp_Visibility_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Case_Purchase_Decline_ReasonArgs = {
  filter?: InputMaybe<Catalog_Case_Purchase_Decline_Reason_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Purchase_Decline_Reason_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Case_Purchase_Decline_Reason_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Purchase_Decline_Reason_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Case_Purchase_Decline_Reason_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Case_Purchase_StatusArgs = {
  filter?: InputMaybe<Catalog_Case_Purchase_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Purchase_Status_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Case_Purchase_Status_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Purchase_Status_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Case_Purchase_Status_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Case_Purchase_Unmatch_ReasonArgs = {
  filter?: InputMaybe<Catalog_Case_Purchase_Unmatch_Reason_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Purchase_Unmatch_Reason_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Case_Purchase_Unmatch_Reason_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Purchase_Unmatch_Reason_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Case_Purchase_Unmatch_Reason_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Case_SourceArgs = {
  filter?: InputMaybe<Catalog_Case_Source_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Source_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Case_Source_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Source_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Case_Source_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Case_Status_Update_Matter_StageArgs = {
  filter?: InputMaybe<Catalog_Case_Status_Update_Matter_Stage_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Status_Update_Matter_Stage_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Case_Status_Update_Matter_Stage_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Status_Update_Matter_Stage_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Case_Status_Update_Matter_Stage_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Case_Status_Update_Matter_StatusArgs = {
  filter?: InputMaybe<Catalog_Case_Status_Update_Matter_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Status_Update_Matter_Status_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Case_Status_Update_Matter_Status_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Case_Status_Update_Matter_Status_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Case_Status_Update_Matter_Status_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Communication_PreferenceArgs = {
  filter?: InputMaybe<Catalog_Communication_Preference_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Communication_Preference_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Communication_Preference_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Communication_Preference_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Communication_Preference_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Community_Expiration_DurationArgs = {
  filter?: InputMaybe<Catalog_Community_Expiration_Duration_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Community_Expiration_Duration_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Community_Expiration_Duration_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Community_Expiration_Duration_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Community_Expiration_Duration_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Company_SizeArgs = {
  filter?: InputMaybe<Catalog_Company_Size_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Company_Size_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Company_Size_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Company_Size_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Company_Size_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Contact_TypeArgs = {
  filter?: InputMaybe<Catalog_Contact_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Contact_Type_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Contact_Type_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Contact_Type_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Contact_Type_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Credit_Price_TypeArgs = {
  filter?: InputMaybe<Catalog_Credit_Price_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Credit_Price_Type_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Credit_Price_Type_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Credit_Price_Type_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Credit_Price_Type_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Credit_StatusArgs = {
  filter?: InputMaybe<Catalog_Credit_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Credit_Status_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Credit_Status_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Credit_Status_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Credit_Status_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Education_GradeArgs = {
  filter?: InputMaybe<Catalog_Education_Grade_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Education_Grade_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Education_Grade_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Education_Grade_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Education_Grade_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Exempt_Email_DomainArgs = {
  filter?: InputMaybe<Catalog_Exempt_Email_Domain_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Exempt_Email_Domain_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Exempt_Email_Domain_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Exempt_Email_Domain_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Exempt_Email_Domain_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_FeeArgs = {
  filter?: InputMaybe<Catalog_Fee_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Fee_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Fee_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Fee_Agreement_StatusArgs = {
  filter?: InputMaybe<Catalog_Fee_Agreement_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Fee_Agreement_Status_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Fee_Agreement_Status_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Fee_Agreement_Status_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Fee_Agreement_Status_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Fee_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Fee_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Financing_SourceArgs = {
  filter?: InputMaybe<Catalog_Financing_Source_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Financing_Source_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Financing_Source_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Financing_Source_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Financing_Source_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Firm_RelationshipArgs = {
  filter?: InputMaybe<Catalog_Firm_Relationship_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Firm_Relationship_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Firm_Relationship_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Firm_Relationship_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Firm_Relationship_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Invite_StatusArgs = {
  filter?: InputMaybe<Catalog_Invite_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Invite_Status_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Invite_Status_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Invite_Status_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Invite_Status_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_LanguageArgs = {
  filter?: InputMaybe<Catalog_Language_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Language_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Language_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Language_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Language_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_License_StatusArgs = {
  filter?: InputMaybe<Catalog_License_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_License_Status_AggregatedArgs = {
  filter?: InputMaybe<Catalog_License_Status_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_License_Status_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_License_Status_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Malpractice_InsuranceArgs = {
  filter?: InputMaybe<Catalog_Malpractice_Insurance_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Malpractice_Insurance_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Malpractice_Insurance_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Malpractice_Insurance_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Malpractice_Insurance_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Membership_TypeArgs = {
  filter?: InputMaybe<Catalog_Membership_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Membership_Type_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Membership_Type_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Membership_Type_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Membership_Type_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Notification_LevelArgs = {
  filter?: InputMaybe<Catalog_Notification_Level_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Notification_Level_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Notification_Level_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Notification_Level_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Notification_Level_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Oauth_IntegrationArgs = {
  filter?: InputMaybe<Catalog_Oauth_Integration_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Oauth_Integration_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Oauth_Integration_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Oauth_Integration_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Oauth_Integration_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Payment_MethodArgs = {
  filter?: InputMaybe<Catalog_Payment_Method_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Payment_Method_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Payment_Method_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Payment_Method_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Payment_Method_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Payment_StatusArgs = {
  filter?: InputMaybe<Catalog_Payment_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Payment_Status_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Payment_Status_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Payment_Status_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Payment_Status_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Practice_AreaArgs = {
  filter?: InputMaybe<Catalog_Practice_Area_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Practice_Area_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Practice_Area_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Practice_Area_BundleArgs = {
  filter?: InputMaybe<Catalog_Practice_Area_Bundle_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Practice_Area_Bundle_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Practice_Area_Bundle_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Practice_Area_Bundle_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Practice_Area_Bundle_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Practice_Area_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Practice_Area_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Process_StageArgs = {
  filter?: InputMaybe<Catalog_Process_Stage_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Process_Stage_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Process_Stage_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Process_Stage_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Process_Stage_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Referral_Network_List_Item_StatusArgs = {
  filter?: InputMaybe<Catalog_Referral_Network_List_Item_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Referral_Network_List_Item_Status_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Referral_Network_List_Item_Status_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Referral_Network_List_Item_Status_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Referral_Network_List_Item_Status_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Referral_Network_List_StatusArgs = {
  filter?: InputMaybe<Catalog_Referral_Network_List_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Referral_Network_List_Status_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Referral_Network_List_Status_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Referral_Network_List_Status_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Referral_Network_List_Status_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Referral_Network_TypeArgs = {
  filter?: InputMaybe<Catalog_Referral_Network_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Referral_Network_Type_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Referral_Network_Type_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Referral_Network_Type_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Referral_Network_Type_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Role_InviteArgs = {
  filter?: InputMaybe<Catalog_Role_Invite_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Role_Invite_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Role_Invite_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Role_Invite_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Role_Invite_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Sign_Request_StatusArgs = {
  filter?: InputMaybe<Catalog_Sign_Request_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Sign_Request_Status_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Sign_Request_Status_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Sign_Request_Status_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Sign_Request_Status_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Time_UnitArgs = {
  filter?: InputMaybe<Catalog_Time_Unit_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Time_Unit_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Time_Unit_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Time_Unit_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Time_Unit_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Us_StateArgs = {
  filter?: InputMaybe<Catalog_Us_State_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Us_State_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Us_State_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Us_State_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Us_State_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Waterfall_DurationArgs = {
  filter?: InputMaybe<Catalog_Waterfall_Duration_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Waterfall_Duration_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Waterfall_Duration_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Waterfall_Duration_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Waterfall_Duration_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Waterfall_StatusArgs = {
  filter?: InputMaybe<Catalog_Waterfall_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Waterfall_Status_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Waterfall_Status_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Waterfall_Status_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Waterfall_Status_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Years_PracticeArgs = {
  filter?: InputMaybe<Catalog_Years_Practice_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Years_Practice_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Years_Practice_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Years_Practice_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Years_Practice_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryCatalog_Zip_CodeArgs = {
  filter?: InputMaybe<Catalog_Zip_Code_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Zip_Code_AggregatedArgs = {
  filter?: InputMaybe<Catalog_Zip_Code_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCatalog_Zip_Code_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCatalog_Zip_Code_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryConfig_Lcms_LeaddocketArgs = {
  filter?: InputMaybe<Config_Lcms_Leaddocket_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryConfig_Lcms_Leaddocket_AggregatedArgs = {
  filter?: InputMaybe<Config_Lcms_Leaddocket_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryConfig_Lcms_Leaddocket_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryConfig_Lcms_Leaddocket_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryDismissed_Invite_SuggestionsArgs = {
  filter?: InputMaybe<Dismissed_Invite_Suggestions_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDismissed_Invite_Suggestions_AggregatedArgs = {
  filter?: InputMaybe<Dismissed_Invite_Suggestions_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDismissed_Invite_Suggestions_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDismissed_Invite_Suggestions_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryFct_Affiliation_MembersArgs = {
  filter?: InputMaybe<Fct_Affiliation_Members_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFct_Affiliation_Members_AggregatedArgs = {
  filter?: InputMaybe<Fct_Affiliation_Members_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFct_Affiliation_Members_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFct_Affiliation_Members_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryFilter_Daily_Digest_PendingArgs = {
  filter?: InputMaybe<Filter_Daily_Digest_Pending_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFilter_Daily_Digest_Pending_AggregatedArgs = {
  filter?: InputMaybe<Filter_Daily_Digest_Pending_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFilter_Daily_Digest_Pending_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFilter_Daily_Digest_Pending_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryFilter_RedundantArgs = {
  filter?: InputMaybe<Filter_Redundant_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFilter_Redundant_AggregatedArgs = {
  filter?: InputMaybe<Filter_Redundant_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFilter_Redundant_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFilter_Redundant_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryInvitation_DiscountArgs = {
  filter?: InputMaybe<Invitation_Discount_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryInvitation_Discount_AggregatedArgs = {
  filter?: InputMaybe<Invitation_Discount_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryInvitation_Discount_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvitation_Discount_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryLcms_Case_MappingArgs = {
  filter?: InputMaybe<Lcms_Case_Mapping_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLcms_Case_Mapping_AggregatedArgs = {
  filter?: InputMaybe<Lcms_Case_Mapping_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLcms_Case_Mapping_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLcms_Case_Mapping_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryLcms_Health_CheckArgs = {
  filter?: InputMaybe<Lcms_Health_Check_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLcms_Health_Check_AggregatedArgs = {
  filter?: InputMaybe<Lcms_Health_Check_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLcms_Health_Check_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLcms_Health_Check_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryMaster_AttorneyArgs = {
  filter?: InputMaybe<Master_Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMaster_Attorney_AggregatedArgs = {
  filter?: InputMaybe<Master_Attorney_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMaster_Attorney_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMaster_Attorney_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryMaster_CaseArgs = {
  filter?: InputMaybe<Master_Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMaster_Case_AggregatedArgs = {
  filter?: InputMaybe<Master_Case_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMaster_Case_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMaster_Case_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryMaster_OrganizationArgs = {
  filter?: InputMaybe<Master_Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMaster_Organization_AggregatedArgs = {
  filter?: InputMaybe<Master_Organization_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMaster_Organization_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMaster_Organization_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryMaster_ReferralArgs = {
  filter?: InputMaybe<Master_Referral_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMaster_Referral_AggregatedArgs = {
  filter?: InputMaybe<Master_Referral_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMaster_Referral_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMaster_Referral_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryNetwork_User_InviteArgs = {
  filter?: InputMaybe<Network_User_Invite_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryNetwork_User_Invite_AggregatedArgs = {
  filter?: InputMaybe<Network_User_Invite_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryNetwork_User_Invite_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNetwork_User_Invite_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryNotificationArgs = {
  filter?: InputMaybe<Notification_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryNotification_AggregatedArgs = {
  filter?: InputMaybe<Notification_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryNotification_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryOrganizationArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganization_AggregatedArgs = {
  filter?: InputMaybe<Organization_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganization_BlockArgs = {
  filter?: InputMaybe<Organization_Block_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganization_Block_AggregatedArgs = {
  filter?: InputMaybe<Organization_Block_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganization_Block_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganization_Block_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryOrganization_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganization_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryOrganization_Connected_LcmsArgs = {
  filter?: InputMaybe<Organization_Connected_Lcms_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganization_Connected_Lcms_AggregatedArgs = {
  filter?: InputMaybe<Organization_Connected_Lcms_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganization_Connected_Lcms_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganization_Connected_Lcms_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryOrganization_DiscountArgs = {
  filter?: InputMaybe<Organization_Discount_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganization_Discount_AggregatedArgs = {
  filter?: InputMaybe<Organization_Discount_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganization_Discount_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganization_Discount_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryOrganization_ProfileArgs = {
  filter?: InputMaybe<Organization_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganization_Profile_AggregatedArgs = {
  filter?: InputMaybe<Organization_Profile_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganization_Profile_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganization_Profile_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryOrganization_Referral_SettingsArgs = {
  filter?: InputMaybe<Organization_Referral_Settings_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganization_Referral_Settings_AggregatedArgs = {
  filter?: InputMaybe<Organization_Referral_Settings_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganization_Referral_Settings_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganization_Referral_Settings_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryOrganization_UserArgs = {
  filter?: InputMaybe<Organization_User_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganization_User_AggregatedArgs = {
  filter?: InputMaybe<Organization_User_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryOrganization_User_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganization_User_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryPractice_Area_OverridesArgs = {
  filter?: InputMaybe<Practice_Area_Overrides_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPractice_Area_Overrides_AggregatedArgs = {
  filter?: InputMaybe<Practice_Area_Overrides_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPractice_Area_Overrides_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPractice_Area_Overrides_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryPractice_Attorney_MappingArgs = {
  filter?: InputMaybe<Practice_Attorney_Mapping_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPractice_Attorney_Mapping_AggregatedArgs = {
  filter?: InputMaybe<Practice_Attorney_Mapping_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPractice_Attorney_Mapping_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPractice_Attorney_Mapping_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryReferral_NetworkArgs = {
  filter?: InputMaybe<Referral_Network_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReferral_Network_AggregatedArgs = {
  filter?: InputMaybe<Referral_Network_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReferral_Network_Broadcast_AuditArgs = {
  filter?: InputMaybe<Referral_Network_Broadcast_Audit_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReferral_Network_Broadcast_Audit_AggregatedArgs = {
  filter?: InputMaybe<Referral_Network_Broadcast_Audit_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReferral_Network_Broadcast_Audit_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReferral_Network_Broadcast_Audit_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryReferral_Network_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReferral_Network_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryReferral_Network_ListArgs = {
  filter?: InputMaybe<Referral_Network_List_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReferral_Network_List_AggregatedArgs = {
  filter?: InputMaybe<Referral_Network_List_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReferral_Network_List_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReferral_Network_List_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryReferral_Network_List_ItemArgs = {
  filter?: InputMaybe<Referral_Network_List_Item_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReferral_Network_List_Item_AggregatedArgs = {
  filter?: InputMaybe<Referral_Network_List_Item_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReferral_Network_List_Item_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReferral_Network_List_Item_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryReferral_Network_MemberArgs = {
  filter?: InputMaybe<Referral_Network_Member_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReferral_Network_Member_AggregatedArgs = {
  filter?: InputMaybe<Referral_Network_Member_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReferral_Network_Member_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReferral_Network_Member_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryReferral_Network_Member_JurisdictionArgs = {
  filter?: InputMaybe<Referral_Network_Member_Jurisdiction_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReferral_Network_Member_Jurisdiction_AggregatedArgs = {
  filter?: InputMaybe<Referral_Network_Member_Jurisdiction_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReferral_Network_Member_Jurisdiction_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReferral_Network_Member_Jurisdiction_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QuerySaved_FiltersArgs = {
  filter?: InputMaybe<Saved_Filters_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySaved_Filters_AggregatedArgs = {
  filter?: InputMaybe<Saved_Filters_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySaved_Filters_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySaved_Filters_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QuerySchoolArgs = {
  filter?: InputMaybe<School_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySchool_AggregatedArgs = {
  filter?: InputMaybe<School_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySchool_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySchool_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QuerySum_Analytics_Attorney_MetricsArgs = {
  filter?: InputMaybe<Sum_Analytics_Attorney_Metrics_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Attorney_Metrics_AggregatedArgs = {
  filter?: InputMaybe<Sum_Analytics_Attorney_Metrics_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Attorney_Metrics_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySum_Analytics_Attorney_Metrics_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QuerySum_Analytics_FreshnessArgs = {
  filter?: InputMaybe<Sum_Analytics_Freshness_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Freshness_AggregatedArgs = {
  filter?: InputMaybe<Sum_Analytics_Freshness_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Freshness_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySum_Analytics_Freshness_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QuerySum_Analytics_Org_MetricsArgs = {
  filter?: InputMaybe<Sum_Analytics_Org_Metrics_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Org_Metrics_AggregatedArgs = {
  filter?: InputMaybe<Sum_Analytics_Org_Metrics_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Org_Metrics_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySum_Analytics_Org_Metrics_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QuerySum_Analytics_Org_Practice_Areas_BuyerArgs = {
  filter?: InputMaybe<Sum_Analytics_Org_Practice_Areas_Buyer_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Org_Practice_Areas_Buyer_AggregatedArgs = {
  filter?: InputMaybe<Sum_Analytics_Org_Practice_Areas_Buyer_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Org_Practice_Areas_Buyer_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySum_Analytics_Org_Practice_Areas_Buyer_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QuerySum_Analytics_Org_Practice_Areas_SellerArgs = {
  filter?: InputMaybe<Sum_Analytics_Org_Practice_Areas_Seller_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Org_Practice_Areas_Seller_AggregatedArgs = {
  filter?: InputMaybe<Sum_Analytics_Org_Practice_Areas_Seller_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Org_Practice_Areas_Seller_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySum_Analytics_Org_Practice_Areas_Seller_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QuerySum_Analytics_Org_Top_Attorneys_BuyerArgs = {
  filter?: InputMaybe<Sum_Analytics_Org_Top_Attorneys_Buyer_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Org_Top_Attorneys_Buyer_AggregatedArgs = {
  filter?: InputMaybe<Sum_Analytics_Org_Top_Attorneys_Buyer_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Org_Top_Attorneys_Buyer_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySum_Analytics_Org_Top_Attorneys_Buyer_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QuerySum_Analytics_Org_Top_Attorneys_SellerArgs = {
  filter?: InputMaybe<Sum_Analytics_Org_Top_Attorneys_Seller_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Org_Top_Attorneys_Seller_AggregatedArgs = {
  filter?: InputMaybe<Sum_Analytics_Org_Top_Attorneys_Seller_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Org_Top_Attorneys_Seller_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySum_Analytics_Org_Top_Attorneys_Seller_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QuerySum_Analytics_Top_AttorneysArgs = {
  filter?: InputMaybe<Sum_Analytics_Top_Attorneys_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Top_Attorneys_AggregatedArgs = {
  filter?: InputMaybe<Sum_Analytics_Top_Attorneys_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Top_Attorneys_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySum_Analytics_Top_Attorneys_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QuerySum_Analytics_Top_Practice_AreasArgs = {
  filter?: InputMaybe<Sum_Analytics_Top_Practice_Areas_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Top_Practice_Areas_AggregatedArgs = {
  filter?: InputMaybe<Sum_Analytics_Top_Practice_Areas_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Analytics_Top_Practice_Areas_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySum_Analytics_Top_Practice_Areas_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QuerySum_Ratings_Attorney_BuyerArgs = {
  filter?: InputMaybe<Sum_Ratings_Attorney_Buyer_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Ratings_Attorney_Buyer_AggregatedArgs = {
  filter?: InputMaybe<Sum_Ratings_Attorney_Buyer_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Ratings_Attorney_Buyer_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySum_Ratings_Attorney_Buyer_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QuerySum_Ratings_Attorney_SellerArgs = {
  filter?: InputMaybe<Sum_Ratings_Attorney_Seller_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Ratings_Attorney_Seller_AggregatedArgs = {
  filter?: InputMaybe<Sum_Ratings_Attorney_Seller_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySum_Ratings_Attorney_Seller_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySum_Ratings_Attorney_Seller_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryUser_Account_TypeArgs = {
  filter?: InputMaybe<User_Account_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUser_Account_Type_AggregatedArgs = {
  filter?: InputMaybe<User_Account_Type_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUser_Account_Type_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUser_Account_Type_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryUser_Allowed_FileArgs = {
  filter?: InputMaybe<User_Allowed_File_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUser_Allowed_File_AggregatedArgs = {
  filter?: InputMaybe<User_Allowed_File_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUser_Allowed_File_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUser_Allowed_File_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryUser_Email_ValidationArgs = {
  filter?: InputMaybe<User_Email_Validation_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUser_Email_Validation_AggregatedArgs = {
  filter?: InputMaybe<User_Email_Validation_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUser_Email_Validation_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUser_Email_Validation_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type QueryUser_File_Access_RequestArgs = {
  filter?: InputMaybe<User_File_Access_Request_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUser_File_Access_Request_AggregatedArgs = {
  filter?: InputMaybe<User_File_Access_Request_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUser_File_Access_Request_By_IdArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUser_File_Access_Request_By_VersionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  affiliation_discount_mutated?: Maybe<Affiliation_Discount_Mutated>;
  attorney_case_mp_preference_mutated?: Maybe<Attorney_Case_Mp_Preference_Mutated>;
  attorney_chat_key_mutated?: Maybe<Attorney_Chat_Key_Mutated>;
  attorney_favorite_mutated?: Maybe<Attorney_Favorite_Mutated>;
  attorney_invite_link_visit_mutated?: Maybe<Attorney_Invite_Link_Visit_Mutated>;
  attorney_invite_mutated?: Maybe<Attorney_Invite_Mutated>;
  attorney_mutated?: Maybe<Attorney_Mutated>;
  attorney_oauth_integration_mutated?: Maybe<Attorney_Oauth_Integration_Mutated>;
  attorney_payment_membership_mutated?: Maybe<Attorney_Payment_Membership_Mutated>;
  attorney_profile_affiliation_mutated?: Maybe<Attorney_Profile_Affiliation_Mutated>;
  attorney_profile_award_mutated?: Maybe<Attorney_Profile_Award_Mutated>;
  attorney_profile_case_management_software_mutated?: Maybe<Attorney_Profile_Case_Management_Software_Mutated>;
  attorney_profile_communication_preference_mutated?: Maybe<Attorney_Profile_Communication_Preference_Mutated>;
  attorney_profile_contact_mutated?: Maybe<Attorney_Profile_Contact_Mutated>;
  attorney_profile_education_mutated?: Maybe<Attorney_Profile_Education_Mutated>;
  attorney_profile_firm_mutated?: Maybe<Attorney_Profile_Firm_Mutated>;
  attorney_profile_language_mutated?: Maybe<Attorney_Profile_Language_Mutated>;
  attorney_profile_license_insurance_mutated?: Maybe<Attorney_Profile_License_Insurance_Mutated>;
  attorney_profile_license_mutated?: Maybe<Attorney_Profile_License_Mutated>;
  attorney_profile_mutated?: Maybe<Attorney_Profile_Mutated>;
  attorney_profile_notification_level_mutated?: Maybe<Attorney_Profile_Notification_Level_Mutated>;
  attorney_profile_practice_area_mutated?: Maybe<Attorney_Profile_Practice_Area_Mutated>;
  attorney_stripe_mutated?: Maybe<Attorney_Stripe_Mutated>;
  attorney_waterfall_list_item_mutated?: Maybe<Attorney_Waterfall_List_Item_Mutated>;
  attorney_waterfall_list_jdx_mutated?: Maybe<Attorney_Waterfall_List_Jdx_Mutated>;
  attorney_waterfall_list_mutated?: Maybe<Attorney_Waterfall_List_Mutated>;
  attorney_waterfall_list_pa_mutated?: Maybe<Attorney_Waterfall_List_Pa_Mutated>;
  attorney_waterfall_mutated?: Maybe<Attorney_Waterfall_Mutated>;
  case_affiliation_mutated?: Maybe<Case_Affiliation_Mutated>;
  case_fee_overrides_mutated?: Maybe<Case_Fee_Overrides_Mutated>;
  case_file_mutated?: Maybe<Case_File_Mutated>;
  case_lead_contact_mutated?: Maybe<Case_Lead_Contact_Mutated>;
  case_lead_mutated?: Maybe<Case_Lead_Mutated>;
  case_lead_score_mutated?: Maybe<Case_Lead_Score_Mutated>;
  case_management_software_mutated?: Maybe<Case_Management_Software_Mutated>;
  case_mutated?: Maybe<Case_Mutated>;
  case_ownership_mutated?: Maybe<Case_Ownership_Mutated>;
  case_purchase_activity_mutated?: Maybe<Case_Purchase_Activity_Mutated>;
  case_purchase_mutated?: Maybe<Case_Purchase_Mutated>;
  case_purchase_ownership_mutated?: Maybe<Case_Purchase_Ownership_Mutated>;
  case_purchase_payment_mutated?: Maybe<Case_Purchase_Payment_Mutated>;
  case_purchase_sign_request_mutated?: Maybe<Case_Purchase_Sign_Request_Mutated>;
  case_status_update_mutated?: Maybe<Case_Status_Update_Mutated>;
  case_status_update_scheduler_task_mutated?: Maybe<Case_Status_Update_Scheduler_Task_Mutated>;
  catalog_access_request_status_mutated?: Maybe<Catalog_Access_Request_Status_Mutated>;
  catalog_account_type_mutated?: Maybe<Catalog_Account_Type_Mutated>;
  catalog_activity_origin_mutated?: Maybe<Catalog_Activity_Origin_Mutated>;
  catalog_affiliation_mutated?: Maybe<Catalog_Affiliation_Mutated>;
  catalog_award_mutated?: Maybe<Catalog_Award_Mutated>;
  catalog_case_alert_mutated?: Maybe<Catalog_Case_Alert_Mutated>;
  catalog_case_file_type_mutated?: Maybe<Catalog_Case_File_Type_Mutated>;
  catalog_case_mp_preference_mutated?: Maybe<Catalog_Case_Mp_Preference_Mutated>;
  catalog_case_mp_visibility_mutated?: Maybe<Catalog_Case_Mp_Visibility_Mutated>;
  catalog_case_purchase_decline_reason_mutated?: Maybe<Catalog_Case_Purchase_Decline_Reason_Mutated>;
  catalog_case_purchase_status_mutated?: Maybe<Catalog_Case_Purchase_Status_Mutated>;
  catalog_case_purchase_unmatch_reason_mutated?: Maybe<Catalog_Case_Purchase_Unmatch_Reason_Mutated>;
  catalog_case_source_mutated?: Maybe<Catalog_Case_Source_Mutated>;
  catalog_case_status_update_matter_stage_mutated?: Maybe<Catalog_Case_Status_Update_Matter_Stage_Mutated>;
  catalog_case_status_update_matter_status_mutated?: Maybe<Catalog_Case_Status_Update_Matter_Status_Mutated>;
  catalog_communication_preference_mutated?: Maybe<Catalog_Communication_Preference_Mutated>;
  catalog_community_expiration_duration_mutated?: Maybe<Catalog_Community_Expiration_Duration_Mutated>;
  catalog_company_size_mutated?: Maybe<Catalog_Company_Size_Mutated>;
  catalog_contact_type_mutated?: Maybe<Catalog_Contact_Type_Mutated>;
  catalog_credit_price_type_mutated?: Maybe<Catalog_Credit_Price_Type_Mutated>;
  catalog_credit_status_mutated?: Maybe<Catalog_Credit_Status_Mutated>;
  catalog_education_grade_mutated?: Maybe<Catalog_Education_Grade_Mutated>;
  catalog_exempt_email_domain_mutated?: Maybe<Catalog_Exempt_Email_Domain_Mutated>;
  catalog_fee_agreement_status_mutated?: Maybe<Catalog_Fee_Agreement_Status_Mutated>;
  catalog_fee_mutated?: Maybe<Catalog_Fee_Mutated>;
  catalog_financing_source_mutated?: Maybe<Catalog_Financing_Source_Mutated>;
  catalog_firm_relationship_mutated?: Maybe<Catalog_Firm_Relationship_Mutated>;
  catalog_invite_status_mutated?: Maybe<Catalog_Invite_Status_Mutated>;
  catalog_language_mutated?: Maybe<Catalog_Language_Mutated>;
  catalog_license_status_mutated?: Maybe<Catalog_License_Status_Mutated>;
  catalog_malpractice_insurance_mutated?: Maybe<Catalog_Malpractice_Insurance_Mutated>;
  catalog_membership_type_mutated?: Maybe<Catalog_Membership_Type_Mutated>;
  catalog_notification_level_mutated?: Maybe<Catalog_Notification_Level_Mutated>;
  catalog_oauth_integration_mutated?: Maybe<Catalog_Oauth_Integration_Mutated>;
  catalog_payment_method_mutated?: Maybe<Catalog_Payment_Method_Mutated>;
  catalog_payment_status_mutated?: Maybe<Catalog_Payment_Status_Mutated>;
  catalog_practice_area_bundle_mutated?: Maybe<Catalog_Practice_Area_Bundle_Mutated>;
  catalog_practice_area_mutated?: Maybe<Catalog_Practice_Area_Mutated>;
  catalog_process_stage_mutated?: Maybe<Catalog_Process_Stage_Mutated>;
  catalog_referral_network_list_item_status_mutated?: Maybe<Catalog_Referral_Network_List_Item_Status_Mutated>;
  catalog_referral_network_list_status_mutated?: Maybe<Catalog_Referral_Network_List_Status_Mutated>;
  catalog_referral_network_type_mutated?: Maybe<Catalog_Referral_Network_Type_Mutated>;
  catalog_role_invite_mutated?: Maybe<Catalog_Role_Invite_Mutated>;
  catalog_sign_request_status_mutated?: Maybe<Catalog_Sign_Request_Status_Mutated>;
  catalog_time_unit_mutated?: Maybe<Catalog_Time_Unit_Mutated>;
  catalog_us_state_mutated?: Maybe<Catalog_Us_State_Mutated>;
  catalog_waterfall_duration_mutated?: Maybe<Catalog_Waterfall_Duration_Mutated>;
  catalog_waterfall_status_mutated?: Maybe<Catalog_Waterfall_Status_Mutated>;
  catalog_years_practice_mutated?: Maybe<Catalog_Years_Practice_Mutated>;
  catalog_zip_code_mutated?: Maybe<Catalog_Zip_Code_Mutated>;
  config_lcms_leaddocket_mutated?: Maybe<Config_Lcms_Leaddocket_Mutated>;
  directus_dashboards_mutated?: Maybe<Directus_Dashboards_Mutated>;
  directus_files_mutated?: Maybe<Directus_Files_Mutated>;
  directus_flows_mutated?: Maybe<Directus_Flows_Mutated>;
  directus_folders_mutated?: Maybe<Directus_Folders_Mutated>;
  directus_panels_mutated?: Maybe<Directus_Panels_Mutated>;
  directus_roles_mutated?: Maybe<Directus_Roles_Mutated>;
  directus_shares_mutated?: Maybe<Directus_Shares_Mutated>;
  directus_users_mutated?: Maybe<Directus_Users_Mutated>;
  dismissed_invite_suggestions_mutated?: Maybe<Dismissed_Invite_Suggestions_Mutated>;
  fct_affiliation_members_mutated?: Maybe<Fct_Affiliation_Members_Mutated>;
  filter_daily_digest_pending_mutated?: Maybe<Filter_Daily_Digest_Pending_Mutated>;
  filter_redundant_mutated?: Maybe<Filter_Redundant_Mutated>;
  invitation_discount_mutated?: Maybe<Invitation_Discount_Mutated>;
  lcms_case_mapping_mutated?: Maybe<Lcms_Case_Mapping_Mutated>;
  lcms_health_check_mutated?: Maybe<Lcms_Health_Check_Mutated>;
  master_attorney_mutated?: Maybe<Master_Attorney_Mutated>;
  master_case_mutated?: Maybe<Master_Case_Mutated>;
  master_organization_mutated?: Maybe<Master_Organization_Mutated>;
  master_referral_mutated?: Maybe<Master_Referral_Mutated>;
  network_user_invite_mutated?: Maybe<Network_User_Invite_Mutated>;
  notification_mutated?: Maybe<Notification_Mutated>;
  organization_block_mutated?: Maybe<Organization_Block_Mutated>;
  organization_connected_lcms_mutated?: Maybe<Organization_Connected_Lcms_Mutated>;
  organization_discount_mutated?: Maybe<Organization_Discount_Mutated>;
  organization_mutated?: Maybe<Organization_Mutated>;
  organization_profile_mutated?: Maybe<Organization_Profile_Mutated>;
  organization_referral_settings_mutated?: Maybe<Organization_Referral_Settings_Mutated>;
  organization_user_mutated?: Maybe<Organization_User_Mutated>;
  practice_area_overrides_mutated?: Maybe<Practice_Area_Overrides_Mutated>;
  practice_attorney_mapping_mutated?: Maybe<Practice_Attorney_Mapping_Mutated>;
  referral_network_broadcast_audit_mutated?: Maybe<Referral_Network_Broadcast_Audit_Mutated>;
  referral_network_list_item_mutated?: Maybe<Referral_Network_List_Item_Mutated>;
  referral_network_list_mutated?: Maybe<Referral_Network_List_Mutated>;
  referral_network_member_jurisdiction_mutated?: Maybe<Referral_Network_Member_Jurisdiction_Mutated>;
  referral_network_member_mutated?: Maybe<Referral_Network_Member_Mutated>;
  referral_network_mutated?: Maybe<Referral_Network_Mutated>;
  saved_filters_mutated?: Maybe<Saved_Filters_Mutated>;
  school_mutated?: Maybe<School_Mutated>;
  sum_analytics_attorney_metrics_mutated?: Maybe<Sum_Analytics_Attorney_Metrics_Mutated>;
  sum_analytics_freshness_mutated?: Maybe<Sum_Analytics_Freshness_Mutated>;
  sum_analytics_org_metrics_mutated?: Maybe<Sum_Analytics_Org_Metrics_Mutated>;
  sum_analytics_org_practice_areas_buyer_mutated?: Maybe<Sum_Analytics_Org_Practice_Areas_Buyer_Mutated>;
  sum_analytics_org_practice_areas_seller_mutated?: Maybe<Sum_Analytics_Org_Practice_Areas_Seller_Mutated>;
  sum_analytics_org_top_attorneys_buyer_mutated?: Maybe<Sum_Analytics_Org_Top_Attorneys_Buyer_Mutated>;
  sum_analytics_org_top_attorneys_seller_mutated?: Maybe<Sum_Analytics_Org_Top_Attorneys_Seller_Mutated>;
  sum_analytics_top_attorneys_mutated?: Maybe<Sum_Analytics_Top_Attorneys_Mutated>;
  sum_analytics_top_practice_areas_mutated?: Maybe<Sum_Analytics_Top_Practice_Areas_Mutated>;
  sum_ratings_attorney_buyer_mutated?: Maybe<Sum_Ratings_Attorney_Buyer_Mutated>;
  sum_ratings_attorney_seller_mutated?: Maybe<Sum_Ratings_Attorney_Seller_Mutated>;
  user_account_type_mutated?: Maybe<User_Account_Type_Mutated>;
  user_allowed_file_mutated?: Maybe<User_Allowed_File_Mutated>;
  user_email_validation_mutated?: Maybe<User_Email_Validation_Mutated>;
  user_file_access_request_mutated?: Maybe<User_File_Access_Request_Mutated>;
};


export type SubscriptionAffiliation_Discount_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Case_Mp_Preference_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Chat_Key_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Favorite_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Invite_Link_Visit_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Invite_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Oauth_Integration_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Payment_Membership_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Profile_Affiliation_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Profile_Award_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Profile_Case_Management_Software_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Profile_Communication_Preference_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Profile_Contact_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Profile_Education_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Profile_Firm_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Profile_Language_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Profile_License_Insurance_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Profile_License_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Profile_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Profile_Notification_Level_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Profile_Practice_Area_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Stripe_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Waterfall_List_Item_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Waterfall_List_Jdx_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Waterfall_List_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Waterfall_List_Pa_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionAttorney_Waterfall_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_Affiliation_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_Fee_Overrides_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_File_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_Lead_Contact_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_Lead_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_Lead_Score_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_Management_Software_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_Ownership_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_Purchase_Activity_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_Purchase_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_Purchase_Ownership_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_Purchase_Payment_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_Purchase_Sign_Request_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_Status_Update_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCase_Status_Update_Scheduler_Task_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Access_Request_Status_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Account_Type_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Activity_Origin_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Affiliation_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Award_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Case_Alert_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Case_File_Type_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Case_Mp_Preference_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Case_Mp_Visibility_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Case_Purchase_Decline_Reason_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Case_Purchase_Status_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Case_Purchase_Unmatch_Reason_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Case_Source_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Case_Status_Update_Matter_Stage_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Case_Status_Update_Matter_Status_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Communication_Preference_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Community_Expiration_Duration_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Company_Size_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Contact_Type_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Credit_Price_Type_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Credit_Status_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Education_Grade_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Exempt_Email_Domain_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Fee_Agreement_Status_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Fee_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Financing_Source_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Firm_Relationship_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Invite_Status_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Language_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_License_Status_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Malpractice_Insurance_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Membership_Type_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Notification_Level_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Oauth_Integration_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Payment_Method_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Payment_Status_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Practice_Area_Bundle_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Practice_Area_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Process_Stage_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Referral_Network_List_Item_Status_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Referral_Network_List_Status_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Referral_Network_Type_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Role_Invite_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Sign_Request_Status_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Time_Unit_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Us_State_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Waterfall_Duration_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Waterfall_Status_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Years_Practice_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionCatalog_Zip_Code_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionConfig_Lcms_Leaddocket_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionDirectus_Dashboards_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionDirectus_Files_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionDirectus_Flows_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionDirectus_Folders_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionDirectus_Panels_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionDirectus_Roles_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionDirectus_Shares_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionDirectus_Users_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionDismissed_Invite_Suggestions_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionFct_Affiliation_Members_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionFilter_Daily_Digest_Pending_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionFilter_Redundant_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionInvitation_Discount_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionLcms_Case_Mapping_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionLcms_Health_Check_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionMaster_Attorney_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionMaster_Case_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionMaster_Organization_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionMaster_Referral_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionNetwork_User_Invite_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionNotification_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionOrganization_Block_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionOrganization_Connected_Lcms_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionOrganization_Discount_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionOrganization_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionOrganization_Profile_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionOrganization_Referral_Settings_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionOrganization_User_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionPractice_Area_Overrides_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionPractice_Attorney_Mapping_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionReferral_Network_Broadcast_Audit_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionReferral_Network_List_Item_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionReferral_Network_List_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionReferral_Network_Member_Jurisdiction_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionReferral_Network_Member_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionReferral_Network_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionSaved_Filters_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionSchool_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionSum_Analytics_Attorney_Metrics_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionSum_Analytics_Freshness_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionSum_Analytics_Org_Metrics_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionSum_Analytics_Org_Practice_Areas_Buyer_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionSum_Analytics_Org_Practice_Areas_Seller_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionSum_Analytics_Org_Top_Attorneys_Buyer_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionSum_Analytics_Org_Top_Attorneys_Seller_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionSum_Analytics_Top_Attorneys_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionSum_Analytics_Top_Practice_Areas_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionSum_Ratings_Attorney_Buyer_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionSum_Ratings_Attorney_Seller_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionUser_Account_Type_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionUser_Allowed_File_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionUser_Email_Validation_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};


export type SubscriptionUser_File_Access_Request_MutatedArgs = {
  event?: InputMaybe<EventEnum>;
};

export type Affiliation_Discount = {
  __typename?: 'affiliation_discount';
  affiliation_id?: Maybe<Catalog_Affiliation>;
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  end_date?: Maybe<Scalars['Date']['output']>;
  end_date_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  start_date?: Maybe<Scalars['Date']['output']>;
  start_date_func?: Maybe<Datetime_Functions>;
};


export type Affiliation_DiscountAffiliation_IdArgs = {
  filter?: InputMaybe<Catalog_Affiliation_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Affiliation_Discount_Aggregated = {
  __typename?: 'affiliation_discount_aggregated';
  avg?: Maybe<Affiliation_Discount_Aggregated_Fields>;
  avgDistinct?: Maybe<Affiliation_Discount_Aggregated_Fields>;
  count?: Maybe<Affiliation_Discount_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Affiliation_Discount_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Affiliation_Discount_Aggregated_Fields>;
  min?: Maybe<Affiliation_Discount_Aggregated_Fields>;
  sum?: Maybe<Affiliation_Discount_Aggregated_Fields>;
  sumDistinct?: Maybe<Affiliation_Discount_Aggregated_Fields>;
};

export type Affiliation_Discount_Aggregated_Count = {
  __typename?: 'affiliation_discount_aggregated_count';
  affiliation_id?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['Int']['output']>;
};

export type Affiliation_Discount_Aggregated_Fields = {
  __typename?: 'affiliation_discount_aggregated_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type Affiliation_Discount_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Affiliation_Discount_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Affiliation_Discount_Filter>>>;
  affiliation_id?: InputMaybe<Catalog_Affiliation_Filter>;
  amount?: InputMaybe<Number_Filter_Operators>;
  description?: InputMaybe<String_Filter_Operators>;
  end_date?: InputMaybe<Date_Filter_Operators>;
  end_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  start_date?: InputMaybe<Date_Filter_Operators>;
  start_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
};

export type Affiliation_Discount_Mutated = {
  __typename?: 'affiliation_discount_mutated';
  data?: Maybe<Affiliation_Discount>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney = {
  __typename?: 'attorney';
  cases?: Maybe<Array<Maybe<Case>>>;
  cases_func?: Maybe<Count_Functions>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  favorites?: Maybe<Array<Maybe<Attorney_Favorite>>>;
  favorites_func?: Maybe<Count_Functions>;
  id: Scalars['ID']['output'];
  is_vetted?: Maybe<Scalars['Boolean']['output']>;
  membership_type?: Maybe<Catalog_Membership_Type>;
  mp_preferences?: Maybe<Array<Maybe<Attorney_Case_Mp_Preference>>>;
  mp_preferences_func?: Maybe<Count_Functions>;
  oauth_integrations?: Maybe<Array<Maybe<Attorney_Oauth_Integration>>>;
  oauth_integrations_func?: Maybe<Count_Functions>;
  profiles?: Maybe<Array<Maybe<Attorney_Profile>>>;
  profiles_func?: Maybe<Count_Functions>;
  stream_chat_keys?: Maybe<Array<Maybe<Attorney_Chat_Key>>>;
  stream_chat_keys_func?: Maybe<Count_Functions>;
  stripe_data?: Maybe<Array<Maybe<Attorney_Stripe>>>;
  stripe_data_func?: Maybe<Count_Functions>;
  user_id?: Maybe<Directus_Users>;
  waterfall_lists?: Maybe<Array<Maybe<Attorney_Waterfall_List>>>;
  waterfall_lists_func?: Maybe<Count_Functions>;
  waterfalls?: Maybe<Array<Maybe<Attorney_Waterfall>>>;
  waterfalls_func?: Maybe<Count_Functions>;
};


export type AttorneyCasesArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AttorneyFavoritesArgs = {
  filter?: InputMaybe<Attorney_Favorite_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AttorneyMembership_TypeArgs = {
  filter?: InputMaybe<Catalog_Membership_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AttorneyMp_PreferencesArgs = {
  filter?: InputMaybe<Attorney_Case_Mp_Preference_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AttorneyOauth_IntegrationsArgs = {
  filter?: InputMaybe<Attorney_Oauth_Integration_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AttorneyProfilesArgs = {
  filter?: InputMaybe<Attorney_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AttorneyStream_Chat_KeysArgs = {
  filter?: InputMaybe<Attorney_Chat_Key_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AttorneyStripe_DataArgs = {
  filter?: InputMaybe<Attorney_Stripe_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AttorneyUser_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AttorneyWaterfall_ListsArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type AttorneyWaterfallsArgs = {
  filter?: InputMaybe<Attorney_Waterfall_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Aggregated = {
  __typename?: 'attorney_aggregated';
  count?: Maybe<Attorney_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Aggregated_Count = {
  __typename?: 'attorney_aggregated_count';
  cases?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  favorites?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_vetted?: Maybe<Scalars['Int']['output']>;
  membership_type?: Maybe<Scalars['Int']['output']>;
  mp_preferences?: Maybe<Scalars['Int']['output']>;
  oauth_integrations?: Maybe<Scalars['Int']['output']>;
  profiles?: Maybe<Scalars['Int']['output']>;
  stream_chat_keys?: Maybe<Scalars['Int']['output']>;
  stripe_data?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  waterfall_lists?: Maybe<Scalars['Int']['output']>;
  waterfalls?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Case_Mp_Preference = {
  __typename?: 'attorney_case_mp_preference';
  attorney_id?: Maybe<Attorney>;
  case_id?: Maybe<Case>;
  case_mp_preference_id?: Maybe<Catalog_Case_Mp_Preference>;
  id: Scalars['ID']['output'];
};


export type Attorney_Case_Mp_PreferenceAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Case_Mp_PreferenceCase_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Case_Mp_PreferenceCase_Mp_Preference_IdArgs = {
  filter?: InputMaybe<Catalog_Case_Mp_Preference_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Case_Mp_Preference_Aggregated = {
  __typename?: 'attorney_case_mp_preference_aggregated';
  count?: Maybe<Attorney_Case_Mp_Preference_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Case_Mp_Preference_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Case_Mp_Preference_Aggregated_Count = {
  __typename?: 'attorney_case_mp_preference_aggregated_count';
  attorney_id?: Maybe<Scalars['Int']['output']>;
  case_id?: Maybe<Scalars['Int']['output']>;
  case_mp_preference_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Case_Mp_Preference_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Case_Mp_Preference_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Case_Mp_Preference_Filter>>>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  case_id?: InputMaybe<Case_Filter>;
  case_mp_preference_id?: InputMaybe<Catalog_Case_Mp_Preference_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
};

export type Attorney_Case_Mp_Preference_Mutated = {
  __typename?: 'attorney_case_mp_preference_mutated';
  data?: Maybe<Attorney_Case_Mp_Preference>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Chat_Key = {
  __typename?: 'attorney_chat_key';
  attorney_id?: Maybe<Attorney>;
  chat_token: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};


export type Attorney_Chat_KeyAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Chat_Key_Aggregated = {
  __typename?: 'attorney_chat_key_aggregated';
  count?: Maybe<Attorney_Chat_Key_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Chat_Key_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Chat_Key_Aggregated_Count = {
  __typename?: 'attorney_chat_key_aggregated_count';
  attorney_id?: Maybe<Scalars['Int']['output']>;
  chat_token?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Chat_Key_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Chat_Key_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Chat_Key_Filter>>>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  chat_token?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
};

export type Attorney_Chat_Key_Mutated = {
  __typename?: 'attorney_chat_key_mutated';
  data?: Maybe<Attorney_Chat_Key>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Favorite = {
  __typename?: 'attorney_favorite';
  attorney_id?: Maybe<Attorney>;
  favorite_attorney_id?: Maybe<Attorney>;
  id: Scalars['ID']['output'];
};


export type Attorney_FavoriteAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_FavoriteFavorite_Attorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Favorite_Aggregated = {
  __typename?: 'attorney_favorite_aggregated';
  count?: Maybe<Attorney_Favorite_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Favorite_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Favorite_Aggregated_Count = {
  __typename?: 'attorney_favorite_aggregated_count';
  attorney_id?: Maybe<Scalars['Int']['output']>;
  favorite_attorney_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Favorite_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Favorite_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Favorite_Filter>>>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  favorite_attorney_id?: InputMaybe<Attorney_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
};

export type Attorney_Favorite_Mutated = {
  __typename?: 'attorney_favorite_mutated';
  data?: Maybe<Attorney_Favorite>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Filter>>>;
  cases?: InputMaybe<Case_Filter>;
  cases_func?: InputMaybe<Count_Function_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  favorites?: InputMaybe<Attorney_Favorite_Filter>;
  favorites_func?: InputMaybe<Count_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  is_vetted?: InputMaybe<Boolean_Filter_Operators>;
  membership_type?: InputMaybe<Catalog_Membership_Type_Filter>;
  mp_preferences?: InputMaybe<Attorney_Case_Mp_Preference_Filter>;
  mp_preferences_func?: InputMaybe<Count_Function_Filter_Operators>;
  oauth_integrations?: InputMaybe<Attorney_Oauth_Integration_Filter>;
  oauth_integrations_func?: InputMaybe<Count_Function_Filter_Operators>;
  profiles?: InputMaybe<Attorney_Profile_Filter>;
  profiles_func?: InputMaybe<Count_Function_Filter_Operators>;
  stream_chat_keys?: InputMaybe<Attorney_Chat_Key_Filter>;
  stream_chat_keys_func?: InputMaybe<Count_Function_Filter_Operators>;
  stripe_data?: InputMaybe<Attorney_Stripe_Filter>;
  stripe_data_func?: InputMaybe<Count_Function_Filter_Operators>;
  user_id?: InputMaybe<Directus_Users_Filter>;
  waterfall_lists?: InputMaybe<Attorney_Waterfall_List_Filter>;
  waterfall_lists_func?: InputMaybe<Count_Function_Filter_Operators>;
  waterfalls?: InputMaybe<Attorney_Waterfall_Filter>;
  waterfalls_func?: InputMaybe<Count_Function_Filter_Operators>;
};

export type Attorney_Invite = {
  __typename?: 'attorney_invite';
  completed_ts?: Maybe<Scalars['Date']['output']>;
  completed_ts_func?: Maybe<Datetime_Functions>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  email: Scalars['String']['output'];
  /** Response from the SES send-account-invite-email call. NULL means the email was never sent. */
  email_service_response?: Maybe<Scalars['JSON']['output']>;
  email_service_response_func?: Maybe<Count_Functions>;
  id: Scalars['ID']['output'];
  invite_status_id?: Maybe<Catalog_Invite_Status>;
  inviting_attorney?: Maybe<Attorney>;
  sent_ts?: Maybe<Scalars['Date']['output']>;
  sent_ts_func?: Maybe<Datetime_Functions>;
  target_attorney_id?: Maybe<Attorney>;
  target_organization_id?: Maybe<Organization>;
  target_role_id?: Maybe<Directus_Roles>;
  token?: Maybe<Scalars['String']['output']>;
};


export type Attorney_InviteInvite_Status_IdArgs = {
  filter?: InputMaybe<Catalog_Invite_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_InviteInviting_AttorneyArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_InviteTarget_Attorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_InviteTarget_Organization_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_InviteTarget_Role_IdArgs = {
  filter?: InputMaybe<Directus_Roles_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Invite_Aggregated = {
  __typename?: 'attorney_invite_aggregated';
  count?: Maybe<Attorney_Invite_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Invite_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Invite_Aggregated_Count = {
  __typename?: 'attorney_invite_aggregated_count';
  completed_ts?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['Int']['output']>;
  /** Response from the SES send-account-invite-email call. NULL means the email was never sent. */
  email_service_response?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invite_status_id?: Maybe<Scalars['Int']['output']>;
  inviting_attorney?: Maybe<Scalars['Int']['output']>;
  sent_ts?: Maybe<Scalars['Int']['output']>;
  target_attorney_id?: Maybe<Scalars['Int']['output']>;
  target_organization_id?: Maybe<Scalars['Int']['output']>;
  target_role_id?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Invite_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Invite_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Invite_Filter>>>;
  completed_ts?: InputMaybe<Date_Filter_Operators>;
  completed_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  email?: InputMaybe<String_Filter_Operators>;
  email_service_response?: InputMaybe<String_Filter_Operators>;
  email_service_response_func?: InputMaybe<Count_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  invite_status_id?: InputMaybe<Catalog_Invite_Status_Filter>;
  inviting_attorney?: InputMaybe<Attorney_Filter>;
  sent_ts?: InputMaybe<Date_Filter_Operators>;
  sent_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  target_attorney_id?: InputMaybe<Attorney_Filter>;
  target_organization_id?: InputMaybe<Organization_Filter>;
  target_role_id?: InputMaybe<Directus_Roles_Filter>;
  token?: InputMaybe<String_Filter_Operators>;
};

export type Attorney_Invite_Link_Visit = {
  __typename?: 'attorney_invite_link_visit';
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  inviting_organization_id?: Maybe<Organization>;
  visitor_user_id?: Maybe<Directus_Users>;
};


export type Attorney_Invite_Link_VisitInviting_Organization_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Invite_Link_VisitVisitor_User_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Invite_Link_Visit_Aggregated = {
  __typename?: 'attorney_invite_link_visit_aggregated';
  count?: Maybe<Attorney_Invite_Link_Visit_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Invite_Link_Visit_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Invite_Link_Visit_Aggregated_Count = {
  __typename?: 'attorney_invite_link_visit_aggregated_count';
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  inviting_organization_id?: Maybe<Scalars['Int']['output']>;
  visitor_user_id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Invite_Link_Visit_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Invite_Link_Visit_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Invite_Link_Visit_Filter>>>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  inviting_organization_id?: InputMaybe<Organization_Filter>;
  visitor_user_id?: InputMaybe<Directus_Users_Filter>;
};

export type Attorney_Invite_Link_Visit_Mutated = {
  __typename?: 'attorney_invite_link_visit_mutated';
  data?: Maybe<Attorney_Invite_Link_Visit>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Invite_Mutated = {
  __typename?: 'attorney_invite_mutated';
  data?: Maybe<Attorney_Invite>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Mutated = {
  __typename?: 'attorney_mutated';
  data?: Maybe<Attorney>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Oauth_Integration = {
  __typename?: 'attorney_oauth_integration';
  attorney_id?: Maybe<Attorney>;
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  integration_id?: Maybe<Catalog_Oauth_Integration>;
};


export type Attorney_Oauth_IntegrationAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Oauth_IntegrationIntegration_IdArgs = {
  filter?: InputMaybe<Catalog_Oauth_Integration_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Oauth_Integration_Aggregated = {
  __typename?: 'attorney_oauth_integration_aggregated';
  count?: Maybe<Attorney_Oauth_Integration_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Oauth_Integration_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Oauth_Integration_Aggregated_Count = {
  __typename?: 'attorney_oauth_integration_aggregated_count';
  attorney_id?: Maybe<Scalars['Int']['output']>;
  code?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  integration_id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Oauth_Integration_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Oauth_Integration_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Oauth_Integration_Filter>>>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  code?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  integration_id?: InputMaybe<Catalog_Oauth_Integration_Filter>;
};

export type Attorney_Oauth_Integration_Mutated = {
  __typename?: 'attorney_oauth_integration_mutated';
  data?: Maybe<Attorney_Oauth_Integration>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Payment_Membership = {
  __typename?: 'attorney_payment_membership';
  attorney_id?: Maybe<Attorney>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  payment_status_id?: Maybe<Catalog_Payment_Status>;
  subscription_id: Scalars['String']['output'];
};


export type Attorney_Payment_MembershipAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Payment_MembershipPayment_Status_IdArgs = {
  filter?: InputMaybe<Catalog_Payment_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Payment_Membership_Aggregated = {
  __typename?: 'attorney_payment_membership_aggregated';
  count?: Maybe<Attorney_Payment_Membership_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Payment_Membership_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Payment_Membership_Aggregated_Count = {
  __typename?: 'attorney_payment_membership_aggregated_count';
  attorney_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  payment_status_id?: Maybe<Scalars['Int']['output']>;
  subscription_id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Payment_Membership_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Payment_Membership_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Payment_Membership_Filter>>>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  payment_status_id?: InputMaybe<Catalog_Payment_Status_Filter>;
  subscription_id?: InputMaybe<String_Filter_Operators>;
};

export type Attorney_Payment_Membership_Mutated = {
  __typename?: 'attorney_payment_membership_mutated';
  data?: Maybe<Attorney_Payment_Membership>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Profile = {
  __typename?: 'attorney_profile';
  affiliations?: Maybe<Array<Maybe<Attorney_Profile_Affiliation>>>;
  affiliations_func?: Maybe<Count_Functions>;
  attorney_id?: Maybe<Attorney>;
  awards?: Maybe<Array<Maybe<Attorney_Profile_Award>>>;
  awards_func?: Maybe<Count_Functions>;
  bio?: Maybe<Scalars['String']['output']>;
  case_management_softwares?: Maybe<Array<Maybe<Attorney_Profile_Case_Management_Software>>>;
  case_management_softwares_func?: Maybe<Count_Functions>;
  communication_preference?: Maybe<Array<Maybe<Attorney_Profile_Communication_Preference>>>;
  communication_preference_func?: Maybe<Count_Functions>;
  contacts?: Maybe<Array<Maybe<Attorney_Profile_Contact>>>;
  contacts_func?: Maybe<Count_Functions>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  education?: Maybe<Array<Maybe<Attorney_Profile_Education>>>;
  education_func?: Maybe<Count_Functions>;
  firms?: Maybe<Array<Maybe<Attorney_Profile_Firm>>>;
  firms_func?: Maybe<Count_Functions>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  languages?: Maybe<Array<Maybe<Attorney_Profile_Language>>>;
  languages_func?: Maybe<Count_Functions>;
  last_name?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Array<Maybe<Attorney_Profile_License>>>;
  licenses_func?: Maybe<Count_Functions>;
  notification_levels?: Maybe<Array<Maybe<Attorney_Profile_Notification_Level>>>;
  notification_levels_func?: Maybe<Count_Functions>;
  practice_areas?: Maybe<Array<Maybe<Attorney_Profile_Practice_Area>>>;
  practice_areas_func?: Maybe<Count_Functions>;
  referral_source?: Maybe<Scalars['String']['output']>;
  years_practice?: Maybe<Catalog_Years_Practice>;
};


export type Attorney_ProfileAffiliationsArgs = {
  filter?: InputMaybe<Attorney_Profile_Affiliation_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_ProfileAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_ProfileAwardsArgs = {
  filter?: InputMaybe<Attorney_Profile_Award_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_ProfileCase_Management_SoftwaresArgs = {
  filter?: InputMaybe<Attorney_Profile_Case_Management_Software_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_ProfileCommunication_PreferenceArgs = {
  filter?: InputMaybe<Attorney_Profile_Communication_Preference_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_ProfileContactsArgs = {
  filter?: InputMaybe<Attorney_Profile_Contact_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_ProfileEducationArgs = {
  filter?: InputMaybe<Attorney_Profile_Education_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_ProfileFirmsArgs = {
  filter?: InputMaybe<Attorney_Profile_Firm_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_ProfileLanguagesArgs = {
  filter?: InputMaybe<Attorney_Profile_Language_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_ProfileLicensesArgs = {
  filter?: InputMaybe<Attorney_Profile_License_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_ProfileNotification_LevelsArgs = {
  filter?: InputMaybe<Attorney_Profile_Notification_Level_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_ProfilePractice_AreasArgs = {
  filter?: InputMaybe<Attorney_Profile_Practice_Area_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_ProfileYears_PracticeArgs = {
  filter?: InputMaybe<Catalog_Years_Practice_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Profile_Affiliation = {
  __typename?: 'attorney_profile_affiliation';
  affiliation_id?: Maybe<Catalog_Affiliation>;
  attorney_profile_id?: Maybe<Attorney_Profile>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_at_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
};


export type Attorney_Profile_AffiliationAffiliation_IdArgs = {
  filter?: InputMaybe<Catalog_Affiliation_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_AffiliationAttorney_Profile_IdArgs = {
  filter?: InputMaybe<Attorney_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Profile_Affiliation_Aggregated = {
  __typename?: 'attorney_profile_affiliation_aggregated';
  count?: Maybe<Attorney_Profile_Affiliation_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Profile_Affiliation_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Profile_Affiliation_Aggregated_Count = {
  __typename?: 'attorney_profile_affiliation_aggregated_count';
  affiliation_id?: Maybe<Scalars['Int']['output']>;
  attorney_profile_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Profile_Affiliation_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Profile_Affiliation_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Profile_Affiliation_Filter>>>;
  affiliation_id?: InputMaybe<Catalog_Affiliation_Filter>;
  attorney_profile_id?: InputMaybe<Attorney_Profile_Filter>;
  created_at?: InputMaybe<Date_Filter_Operators>;
  created_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
};

export type Attorney_Profile_Affiliation_Mutated = {
  __typename?: 'attorney_profile_affiliation_mutated';
  data?: Maybe<Attorney_Profile_Affiliation>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Profile_Aggregated = {
  __typename?: 'attorney_profile_aggregated';
  count?: Maybe<Attorney_Profile_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Profile_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Profile_Aggregated_Count = {
  __typename?: 'attorney_profile_aggregated_count';
  affiliations?: Maybe<Scalars['Int']['output']>;
  attorney_id?: Maybe<Scalars['Int']['output']>;
  awards?: Maybe<Scalars['Int']['output']>;
  bio?: Maybe<Scalars['Int']['output']>;
  case_management_softwares?: Maybe<Scalars['Int']['output']>;
  communication_preference?: Maybe<Scalars['Int']['output']>;
  contacts?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  education?: Maybe<Scalars['Int']['output']>;
  firms?: Maybe<Scalars['Int']['output']>;
  first_name?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  languages?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['Int']['output']>;
  licenses?: Maybe<Scalars['Int']['output']>;
  notification_levels?: Maybe<Scalars['Int']['output']>;
  practice_areas?: Maybe<Scalars['Int']['output']>;
  referral_source?: Maybe<Scalars['Int']['output']>;
  years_practice?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Profile_Award = {
  __typename?: 'attorney_profile_award';
  attorney_profile_id?: Maybe<Attorney_Profile>;
  award_id?: Maybe<Catalog_Award>;
  id: Scalars['ID']['output'];
};


export type Attorney_Profile_AwardAttorney_Profile_IdArgs = {
  filter?: InputMaybe<Attorney_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_AwardAward_IdArgs = {
  filter?: InputMaybe<Catalog_Award_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Profile_Award_Aggregated = {
  __typename?: 'attorney_profile_award_aggregated';
  count?: Maybe<Attorney_Profile_Award_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Profile_Award_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Profile_Award_Aggregated_Count = {
  __typename?: 'attorney_profile_award_aggregated_count';
  attorney_profile_id?: Maybe<Scalars['Int']['output']>;
  award_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Profile_Award_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Profile_Award_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Profile_Award_Filter>>>;
  attorney_profile_id?: InputMaybe<Attorney_Profile_Filter>;
  award_id?: InputMaybe<Catalog_Award_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
};

export type Attorney_Profile_Award_Mutated = {
  __typename?: 'attorney_profile_award_mutated';
  data?: Maybe<Attorney_Profile_Award>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Profile_Case_Management_Software = {
  __typename?: 'attorney_profile_case_management_software';
  attorney_profile_id?: Maybe<Attorney_Profile>;
  case_management_software_id?: Maybe<Case_Management_Software>;
  id: Scalars['ID']['output'];
};


export type Attorney_Profile_Case_Management_SoftwareAttorney_Profile_IdArgs = {
  filter?: InputMaybe<Attorney_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_Case_Management_SoftwareCase_Management_Software_IdArgs = {
  filter?: InputMaybe<Case_Management_Software_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Profile_Case_Management_Software_Aggregated = {
  __typename?: 'attorney_profile_case_management_software_aggregated';
  count?: Maybe<Attorney_Profile_Case_Management_Software_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Profile_Case_Management_Software_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Profile_Case_Management_Software_Aggregated_Count = {
  __typename?: 'attorney_profile_case_management_software_aggregated_count';
  attorney_profile_id?: Maybe<Scalars['Int']['output']>;
  case_management_software_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Profile_Case_Management_Software_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Profile_Case_Management_Software_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Profile_Case_Management_Software_Filter>>>;
  attorney_profile_id?: InputMaybe<Attorney_Profile_Filter>;
  case_management_software_id?: InputMaybe<Case_Management_Software_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
};

export type Attorney_Profile_Case_Management_Software_Mutated = {
  __typename?: 'attorney_profile_case_management_software_mutated';
  data?: Maybe<Attorney_Profile_Case_Management_Software>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Profile_Communication_Preference = {
  __typename?: 'attorney_profile_communication_preference';
  attorney_profile_id?: Maybe<Attorney_Profile>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  is_email_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_notification_enabled: Scalars['Boolean']['output'];
  is_sms_enabled?: Maybe<Scalars['Boolean']['output']>;
  notification_level?: Maybe<Catalog_Communication_Preference>;
};


export type Attorney_Profile_Communication_PreferenceAttorney_Profile_IdArgs = {
  filter?: InputMaybe<Attorney_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_Communication_PreferenceNotification_LevelArgs = {
  filter?: InputMaybe<Catalog_Communication_Preference_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Profile_Communication_Preference_Aggregated = {
  __typename?: 'attorney_profile_communication_preference_aggregated';
  count?: Maybe<Attorney_Profile_Communication_Preference_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Profile_Communication_Preference_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Profile_Communication_Preference_Aggregated_Count = {
  __typename?: 'attorney_profile_communication_preference_aggregated_count';
  attorney_profile_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_email_enabled?: Maybe<Scalars['Int']['output']>;
  is_notification_enabled?: Maybe<Scalars['Int']['output']>;
  is_sms_enabled?: Maybe<Scalars['Int']['output']>;
  notification_level?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Profile_Communication_Preference_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Profile_Communication_Preference_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Profile_Communication_Preference_Filter>>>;
  attorney_profile_id?: InputMaybe<Attorney_Profile_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  is_email_enabled?: InputMaybe<Boolean_Filter_Operators>;
  is_notification_enabled?: InputMaybe<Boolean_Filter_Operators>;
  is_sms_enabled?: InputMaybe<Boolean_Filter_Operators>;
  notification_level?: InputMaybe<Catalog_Communication_Preference_Filter>;
};

export type Attorney_Profile_Communication_Preference_Mutated = {
  __typename?: 'attorney_profile_communication_preference_mutated';
  data?: Maybe<Attorney_Profile_Communication_Preference>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Profile_Contact = {
  __typename?: 'attorney_profile_contact';
  attorney_profile_id?: Maybe<Attorney_Profile>;
  id: Scalars['ID']['output'];
  type?: Maybe<Catalog_Contact_Type>;
  value: Scalars['String']['output'];
};


export type Attorney_Profile_ContactAttorney_Profile_IdArgs = {
  filter?: InputMaybe<Attorney_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_ContactTypeArgs = {
  filter?: InputMaybe<Catalog_Contact_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Profile_Contact_Aggregated = {
  __typename?: 'attorney_profile_contact_aggregated';
  count?: Maybe<Attorney_Profile_Contact_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Profile_Contact_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Profile_Contact_Aggregated_Count = {
  __typename?: 'attorney_profile_contact_aggregated_count';
  attorney_profile_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Profile_Contact_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Profile_Contact_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Profile_Contact_Filter>>>;
  attorney_profile_id?: InputMaybe<Attorney_Profile_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
  type?: InputMaybe<Catalog_Contact_Type_Filter>;
  value?: InputMaybe<String_Filter_Operators>;
};

export type Attorney_Profile_Contact_Mutated = {
  __typename?: 'attorney_profile_contact_mutated';
  data?: Maybe<Attorney_Profile_Contact>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Profile_Education = {
  __typename?: 'attorney_profile_education';
  attorney_profile_id?: Maybe<Attorney_Profile>;
  grade?: Maybe<Catalog_Education_Grade>;
  id: Scalars['ID']['output'];
  school_id?: Maybe<School>;
  year_end?: Maybe<Scalars['Int']['output']>;
  year_start?: Maybe<Scalars['Int']['output']>;
};


export type Attorney_Profile_EducationAttorney_Profile_IdArgs = {
  filter?: InputMaybe<Attorney_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_EducationGradeArgs = {
  filter?: InputMaybe<Catalog_Education_Grade_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_EducationSchool_IdArgs = {
  filter?: InputMaybe<School_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Profile_Education_Aggregated = {
  __typename?: 'attorney_profile_education_aggregated';
  avg?: Maybe<Attorney_Profile_Education_Aggregated_Fields>;
  avgDistinct?: Maybe<Attorney_Profile_Education_Aggregated_Fields>;
  count?: Maybe<Attorney_Profile_Education_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Profile_Education_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Attorney_Profile_Education_Aggregated_Fields>;
  min?: Maybe<Attorney_Profile_Education_Aggregated_Fields>;
  sum?: Maybe<Attorney_Profile_Education_Aggregated_Fields>;
  sumDistinct?: Maybe<Attorney_Profile_Education_Aggregated_Fields>;
};

export type Attorney_Profile_Education_Aggregated_Count = {
  __typename?: 'attorney_profile_education_aggregated_count';
  attorney_profile_id?: Maybe<Scalars['Int']['output']>;
  grade?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  school_id?: Maybe<Scalars['Int']['output']>;
  year_end?: Maybe<Scalars['Int']['output']>;
  year_start?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Profile_Education_Aggregated_Fields = {
  __typename?: 'attorney_profile_education_aggregated_fields';
  year_end?: Maybe<Scalars['Float']['output']>;
  year_start?: Maybe<Scalars['Float']['output']>;
};

export type Attorney_Profile_Education_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Profile_Education_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Profile_Education_Filter>>>;
  attorney_profile_id?: InputMaybe<Attorney_Profile_Filter>;
  grade?: InputMaybe<Catalog_Education_Grade_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
  school_id?: InputMaybe<School_Filter>;
  year_end?: InputMaybe<Number_Filter_Operators>;
  year_start?: InputMaybe<Number_Filter_Operators>;
};

export type Attorney_Profile_Education_Mutated = {
  __typename?: 'attorney_profile_education_mutated';
  data?: Maybe<Attorney_Profile_Education>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Profile_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Profile_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Profile_Filter>>>;
  affiliations?: InputMaybe<Attorney_Profile_Affiliation_Filter>;
  affiliations_func?: InputMaybe<Count_Function_Filter_Operators>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  awards?: InputMaybe<Attorney_Profile_Award_Filter>;
  awards_func?: InputMaybe<Count_Function_Filter_Operators>;
  bio?: InputMaybe<String_Filter_Operators>;
  case_management_softwares?: InputMaybe<Attorney_Profile_Case_Management_Software_Filter>;
  case_management_softwares_func?: InputMaybe<Count_Function_Filter_Operators>;
  communication_preference?: InputMaybe<Attorney_Profile_Communication_Preference_Filter>;
  communication_preference_func?: InputMaybe<Count_Function_Filter_Operators>;
  contacts?: InputMaybe<Attorney_Profile_Contact_Filter>;
  contacts_func?: InputMaybe<Count_Function_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  education?: InputMaybe<Attorney_Profile_Education_Filter>;
  education_func?: InputMaybe<Count_Function_Filter_Operators>;
  firms?: InputMaybe<Attorney_Profile_Firm_Filter>;
  firms_func?: InputMaybe<Count_Function_Filter_Operators>;
  first_name?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  languages?: InputMaybe<Attorney_Profile_Language_Filter>;
  languages_func?: InputMaybe<Count_Function_Filter_Operators>;
  last_name?: InputMaybe<String_Filter_Operators>;
  licenses?: InputMaybe<Attorney_Profile_License_Filter>;
  licenses_func?: InputMaybe<Count_Function_Filter_Operators>;
  notification_levels?: InputMaybe<Attorney_Profile_Notification_Level_Filter>;
  notification_levels_func?: InputMaybe<Count_Function_Filter_Operators>;
  practice_areas?: InputMaybe<Attorney_Profile_Practice_Area_Filter>;
  practice_areas_func?: InputMaybe<Count_Function_Filter_Operators>;
  referral_source?: InputMaybe<String_Filter_Operators>;
  years_practice?: InputMaybe<Catalog_Years_Practice_Filter>;
};

export type Attorney_Profile_Firm = {
  __typename?: 'attorney_profile_firm';
  address: Scalars['String']['output'];
  attorney_profile_id?: Maybe<Attorney_Profile>;
  city?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  relationship?: Maybe<Catalog_Firm_Relationship>;
  size?: Maybe<Catalog_Company_Size>;
  state?: Maybe<Catalog_Us_State>;
  zip?: Maybe<Scalars['Int']['output']>;
};


export type Attorney_Profile_FirmAttorney_Profile_IdArgs = {
  filter?: InputMaybe<Attorney_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_FirmRelationshipArgs = {
  filter?: InputMaybe<Catalog_Firm_Relationship_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_FirmSizeArgs = {
  filter?: InputMaybe<Catalog_Company_Size_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_FirmStateArgs = {
  filter?: InputMaybe<Catalog_Us_State_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Profile_Firm_Aggregated = {
  __typename?: 'attorney_profile_firm_aggregated';
  avg?: Maybe<Attorney_Profile_Firm_Aggregated_Fields>;
  avgDistinct?: Maybe<Attorney_Profile_Firm_Aggregated_Fields>;
  count?: Maybe<Attorney_Profile_Firm_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Profile_Firm_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Attorney_Profile_Firm_Aggregated_Fields>;
  min?: Maybe<Attorney_Profile_Firm_Aggregated_Fields>;
  sum?: Maybe<Attorney_Profile_Firm_Aggregated_Fields>;
  sumDistinct?: Maybe<Attorney_Profile_Firm_Aggregated_Fields>;
};

export type Attorney_Profile_Firm_Aggregated_Count = {
  __typename?: 'attorney_profile_firm_aggregated_count';
  address?: Maybe<Scalars['Int']['output']>;
  attorney_profile_id?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  relationship?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Profile_Firm_Aggregated_Fields = {
  __typename?: 'attorney_profile_firm_aggregated_fields';
  zip?: Maybe<Scalars['Float']['output']>;
};

export type Attorney_Profile_Firm_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Profile_Firm_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Profile_Firm_Filter>>>;
  address?: InputMaybe<String_Filter_Operators>;
  attorney_profile_id?: InputMaybe<Attorney_Profile_Filter>;
  city?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  relationship?: InputMaybe<Catalog_Firm_Relationship_Filter>;
  size?: InputMaybe<Catalog_Company_Size_Filter>;
  state?: InputMaybe<Catalog_Us_State_Filter>;
  zip?: InputMaybe<Number_Filter_Operators>;
};

export type Attorney_Profile_Firm_Mutated = {
  __typename?: 'attorney_profile_firm_mutated';
  data?: Maybe<Attorney_Profile_Firm>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Profile_Language = {
  __typename?: 'attorney_profile_language';
  attorney_profile_id?: Maybe<Attorney_Profile>;
  id: Scalars['ID']['output'];
  language_id?: Maybe<Catalog_Language>;
};


export type Attorney_Profile_LanguageAttorney_Profile_IdArgs = {
  filter?: InputMaybe<Attorney_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_LanguageLanguage_IdArgs = {
  filter?: InputMaybe<Catalog_Language_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Profile_Language_Aggregated = {
  __typename?: 'attorney_profile_language_aggregated';
  count?: Maybe<Attorney_Profile_Language_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Profile_Language_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Profile_Language_Aggregated_Count = {
  __typename?: 'attorney_profile_language_aggregated_count';
  attorney_profile_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language_id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Profile_Language_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Profile_Language_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Profile_Language_Filter>>>;
  attorney_profile_id?: InputMaybe<Attorney_Profile_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
  language_id?: InputMaybe<Catalog_Language_Filter>;
};

export type Attorney_Profile_Language_Mutated = {
  __typename?: 'attorney_profile_language_mutated';
  data?: Maybe<Attorney_Profile_Language>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Profile_License = {
  __typename?: 'attorney_profile_license';
  attorney_profile_id?: Maybe<Attorney_Profile>;
  bar_number: Scalars['String']['output'];
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  has_been_disciplined_by_bar: Scalars['Boolean']['output'];
  has_been_sued_by_malpractice: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insurances?: Maybe<Array<Maybe<Attorney_Profile_License_Insurance>>>;
  insurances_func?: Maybe<Count_Functions>;
  is_license_suspended: Scalars['Boolean']['output'];
  license_state?: Maybe<Catalog_Us_State>;
  status?: Maybe<Catalog_License_Status>;
  validated_ts?: Maybe<Scalars['Date']['output']>;
  validated_ts_func?: Maybe<Datetime_Functions>;
};


export type Attorney_Profile_LicenseAttorney_Profile_IdArgs = {
  filter?: InputMaybe<Attorney_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_LicenseInsurancesArgs = {
  filter?: InputMaybe<Attorney_Profile_License_Insurance_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_LicenseLicense_StateArgs = {
  filter?: InputMaybe<Catalog_Us_State_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_LicenseStatusArgs = {
  filter?: InputMaybe<Catalog_License_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Profile_License_Aggregated = {
  __typename?: 'attorney_profile_license_aggregated';
  count?: Maybe<Attorney_Profile_License_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Profile_License_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Profile_License_Aggregated_Count = {
  __typename?: 'attorney_profile_license_aggregated_count';
  attorney_profile_id?: Maybe<Scalars['Int']['output']>;
  bar_number?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  has_been_disciplined_by_bar?: Maybe<Scalars['Int']['output']>;
  has_been_sued_by_malpractice?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insurances?: Maybe<Scalars['Int']['output']>;
  is_license_suspended?: Maybe<Scalars['Int']['output']>;
  license_state?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  validated_ts?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Profile_License_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Profile_License_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Profile_License_Filter>>>;
  attorney_profile_id?: InputMaybe<Attorney_Profile_Filter>;
  bar_number?: InputMaybe<String_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  has_been_disciplined_by_bar?: InputMaybe<Boolean_Filter_Operators>;
  has_been_sued_by_malpractice?: InputMaybe<Boolean_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  insurances?: InputMaybe<Attorney_Profile_License_Insurance_Filter>;
  insurances_func?: InputMaybe<Count_Function_Filter_Operators>;
  is_license_suspended?: InputMaybe<Boolean_Filter_Operators>;
  license_state?: InputMaybe<Catalog_Us_State_Filter>;
  status?: InputMaybe<Catalog_License_Status_Filter>;
  validated_ts?: InputMaybe<Date_Filter_Operators>;
  validated_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
};

export type Attorney_Profile_License_Insurance = {
  __typename?: 'attorney_profile_license_insurance';
  attorney_profile_license_id?: Maybe<Attorney_Profile_License>;
  expiration_date?: Maybe<Scalars['Date']['output']>;
  expiration_date_func?: Maybe<Date_Functions>;
  id: Scalars['ID']['output'];
  insurance_coverage_id?: Maybe<Catalog_Malpractice_Insurance>;
};


export type Attorney_Profile_License_InsuranceAttorney_Profile_License_IdArgs = {
  filter?: InputMaybe<Attorney_Profile_License_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_License_InsuranceInsurance_Coverage_IdArgs = {
  filter?: InputMaybe<Catalog_Malpractice_Insurance_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Profile_License_Insurance_Aggregated = {
  __typename?: 'attorney_profile_license_insurance_aggregated';
  count?: Maybe<Attorney_Profile_License_Insurance_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Profile_License_Insurance_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Profile_License_Insurance_Aggregated_Count = {
  __typename?: 'attorney_profile_license_insurance_aggregated_count';
  attorney_profile_license_id?: Maybe<Scalars['Int']['output']>;
  expiration_date?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  insurance_coverage_id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Profile_License_Insurance_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Profile_License_Insurance_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Profile_License_Insurance_Filter>>>;
  attorney_profile_license_id?: InputMaybe<Attorney_Profile_License_Filter>;
  expiration_date?: InputMaybe<Date_Filter_Operators>;
  expiration_date_func?: InputMaybe<Date_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  insurance_coverage_id?: InputMaybe<Catalog_Malpractice_Insurance_Filter>;
};

export type Attorney_Profile_License_Insurance_Mutated = {
  __typename?: 'attorney_profile_license_insurance_mutated';
  data?: Maybe<Attorney_Profile_License_Insurance>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Profile_License_Mutated = {
  __typename?: 'attorney_profile_license_mutated';
  data?: Maybe<Attorney_Profile_License>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Profile_Mutated = {
  __typename?: 'attorney_profile_mutated';
  data?: Maybe<Attorney_Profile>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Profile_Notification_Level = {
  __typename?: 'attorney_profile_notification_level';
  attorney_profile_id?: Maybe<Attorney_Profile>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  notification_level?: Maybe<Catalog_Notification_Level>;
};


export type Attorney_Profile_Notification_LevelAttorney_Profile_IdArgs = {
  filter?: InputMaybe<Attorney_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_Notification_LevelNotification_LevelArgs = {
  filter?: InputMaybe<Catalog_Notification_Level_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Profile_Notification_Level_Aggregated = {
  __typename?: 'attorney_profile_notification_level_aggregated';
  count?: Maybe<Attorney_Profile_Notification_Level_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Profile_Notification_Level_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Profile_Notification_Level_Aggregated_Count = {
  __typename?: 'attorney_profile_notification_level_aggregated_count';
  attorney_profile_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  notification_level?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Profile_Notification_Level_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Profile_Notification_Level_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Profile_Notification_Level_Filter>>>;
  attorney_profile_id?: InputMaybe<Attorney_Profile_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  notification_level?: InputMaybe<Catalog_Notification_Level_Filter>;
};

export type Attorney_Profile_Notification_Level_Mutated = {
  __typename?: 'attorney_profile_notification_level_mutated';
  data?: Maybe<Attorney_Profile_Notification_Level>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Profile_Practice_Area = {
  __typename?: 'attorney_profile_practice_area';
  attorney_profile_id?: Maybe<Attorney_Profile>;
  id: Scalars['ID']['output'];
  practice_area_id?: Maybe<Catalog_Practice_Area>;
};


export type Attorney_Profile_Practice_AreaAttorney_Profile_IdArgs = {
  filter?: InputMaybe<Attorney_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Profile_Practice_AreaPractice_Area_IdArgs = {
  filter?: InputMaybe<Catalog_Practice_Area_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Profile_Practice_Area_Aggregated = {
  __typename?: 'attorney_profile_practice_area_aggregated';
  count?: Maybe<Attorney_Profile_Practice_Area_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Profile_Practice_Area_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Profile_Practice_Area_Aggregated_Count = {
  __typename?: 'attorney_profile_practice_area_aggregated_count';
  attorney_profile_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  practice_area_id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Profile_Practice_Area_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Profile_Practice_Area_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Profile_Practice_Area_Filter>>>;
  attorney_profile_id?: InputMaybe<Attorney_Profile_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
  practice_area_id?: InputMaybe<Catalog_Practice_Area_Filter>;
};

export type Attorney_Profile_Practice_Area_Mutated = {
  __typename?: 'attorney_profile_practice_area_mutated';
  data?: Maybe<Attorney_Profile_Practice_Area>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Stripe = {
  __typename?: 'attorney_stripe';
  attorney_id?: Maybe<Attorney>;
  id: Scalars['ID']['output'];
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
};


export type Attorney_StripeAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Stripe_Aggregated = {
  __typename?: 'attorney_stripe_aggregated';
  count?: Maybe<Attorney_Stripe_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Stripe_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Stripe_Aggregated_Count = {
  __typename?: 'attorney_stripe_aggregated_count';
  attorney_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  stripe_customer_id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Stripe_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Stripe_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Stripe_Filter>>>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
  stripe_customer_id?: InputMaybe<String_Filter_Operators>;
};

export type Attorney_Stripe_Mutated = {
  __typename?: 'attorney_stripe_mutated';
  data?: Maybe<Attorney_Stripe>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Waterfall = {
  __typename?: 'attorney_waterfall';
  alias?: Maybe<Scalars['String']['output']>;
  attorney_id?: Maybe<Attorney>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  current_item_id?: Maybe<Case_Purchase>;
  current_item_order?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  item_count?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<Case_Purchase>>>;
  items_func?: Maybe<Count_Functions>;
  status?: Maybe<Catalog_Waterfall_Status>;
};


export type Attorney_WaterfallAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_WaterfallCurrent_Item_IdArgs = {
  filter?: InputMaybe<Case_Purchase_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_WaterfallItemsArgs = {
  filter?: InputMaybe<Case_Purchase_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_WaterfallStatusArgs = {
  filter?: InputMaybe<Catalog_Waterfall_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Waterfall_Aggregated = {
  __typename?: 'attorney_waterfall_aggregated';
  avg?: Maybe<Attorney_Waterfall_Aggregated_Fields>;
  avgDistinct?: Maybe<Attorney_Waterfall_Aggregated_Fields>;
  count?: Maybe<Attorney_Waterfall_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Waterfall_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Attorney_Waterfall_Aggregated_Fields>;
  min?: Maybe<Attorney_Waterfall_Aggregated_Fields>;
  sum?: Maybe<Attorney_Waterfall_Aggregated_Fields>;
  sumDistinct?: Maybe<Attorney_Waterfall_Aggregated_Fields>;
};

export type Attorney_Waterfall_Aggregated_Count = {
  __typename?: 'attorney_waterfall_aggregated_count';
  alias?: Maybe<Scalars['Int']['output']>;
  attorney_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  current_item_id?: Maybe<Scalars['Int']['output']>;
  current_item_order?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item_count?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Waterfall_Aggregated_Fields = {
  __typename?: 'attorney_waterfall_aggregated_fields';
  current_item_order?: Maybe<Scalars['Float']['output']>;
  item_count?: Maybe<Scalars['Float']['output']>;
};

export type Attorney_Waterfall_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Waterfall_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Waterfall_Filter>>>;
  alias?: InputMaybe<String_Filter_Operators>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  current_item_id?: InputMaybe<Case_Purchase_Filter>;
  current_item_order?: InputMaybe<Number_Filter_Operators>;
  deleted?: InputMaybe<Boolean_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  item_count?: InputMaybe<Number_Filter_Operators>;
  items?: InputMaybe<Case_Purchase_Filter>;
  items_func?: InputMaybe<Count_Function_Filter_Operators>;
  status?: InputMaybe<Catalog_Waterfall_Status_Filter>;
};

export type Attorney_Waterfall_List = {
  __typename?: 'attorney_waterfall_list';
  attorney_id?: Maybe<Attorney>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  fee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  is_visible: Scalars['Boolean']['output'];
  items?: Maybe<Array<Maybe<Attorney_Waterfall_List_Item>>>;
  items_func?: Maybe<Count_Functions>;
  jurisdictions?: Maybe<Array<Maybe<Attorney_Waterfall_List_Jdx>>>;
  jurisdictions_func?: Maybe<Count_Functions>;
  lcms_enabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Organization>;
  practice_areas?: Maybe<Array<Maybe<Attorney_Waterfall_List_Pa>>>;
  practice_areas_func?: Maybe<Count_Functions>;
  priority_access_duration?: Maybe<Catalog_Waterfall_Duration>;
};


export type Attorney_Waterfall_ListAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Waterfall_ListItemsArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Item_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Waterfall_ListJurisdictionsArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Jdx_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Waterfall_ListOrganization_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Waterfall_ListPractice_AreasArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Pa_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Waterfall_ListPriority_Access_DurationArgs = {
  filter?: InputMaybe<Catalog_Waterfall_Duration_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Waterfall_List_Aggregated = {
  __typename?: 'attorney_waterfall_list_aggregated';
  avg?: Maybe<Attorney_Waterfall_List_Aggregated_Fields>;
  avgDistinct?: Maybe<Attorney_Waterfall_List_Aggregated_Fields>;
  count?: Maybe<Attorney_Waterfall_List_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Waterfall_List_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Attorney_Waterfall_List_Aggregated_Fields>;
  min?: Maybe<Attorney_Waterfall_List_Aggregated_Fields>;
  sum?: Maybe<Attorney_Waterfall_List_Aggregated_Fields>;
  sumDistinct?: Maybe<Attorney_Waterfall_List_Aggregated_Fields>;
};

export type Attorney_Waterfall_List_Aggregated_Count = {
  __typename?: 'attorney_waterfall_list_aggregated_count';
  attorney_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_visible?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Scalars['Int']['output']>;
  jurisdictions?: Maybe<Scalars['Int']['output']>;
  lcms_enabled?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  practice_areas?: Maybe<Scalars['Int']['output']>;
  priority_access_duration?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Waterfall_List_Aggregated_Fields = {
  __typename?: 'attorney_waterfall_list_aggregated_fields';
  fee?: Maybe<Scalars['Float']['output']>;
};

export type Attorney_Waterfall_List_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Waterfall_List_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Waterfall_List_Filter>>>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  fee?: InputMaybe<Number_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  is_visible?: InputMaybe<Boolean_Filter_Operators>;
  items?: InputMaybe<Attorney_Waterfall_List_Item_Filter>;
  items_func?: InputMaybe<Count_Function_Filter_Operators>;
  jurisdictions?: InputMaybe<Attorney_Waterfall_List_Jdx_Filter>;
  jurisdictions_func?: InputMaybe<Count_Function_Filter_Operators>;
  lcms_enabled?: InputMaybe<Boolean_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<Organization_Filter>;
  practice_areas?: InputMaybe<Attorney_Waterfall_List_Pa_Filter>;
  practice_areas_func?: InputMaybe<Count_Function_Filter_Operators>;
  priority_access_duration?: InputMaybe<Catalog_Waterfall_Duration_Filter>;
};

export type Attorney_Waterfall_List_Item = {
  __typename?: 'attorney_waterfall_list_item';
  attorney_id?: Maybe<Attorney>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  list_order?: Maybe<Scalars['Int']['output']>;
  waterfall_list_id?: Maybe<Attorney_Waterfall_List>;
};


export type Attorney_Waterfall_List_ItemAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Waterfall_List_ItemWaterfall_List_IdArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Waterfall_List_Item_Aggregated = {
  __typename?: 'attorney_waterfall_list_item_aggregated';
  avg?: Maybe<Attorney_Waterfall_List_Item_Aggregated_Fields>;
  avgDistinct?: Maybe<Attorney_Waterfall_List_Item_Aggregated_Fields>;
  count?: Maybe<Attorney_Waterfall_List_Item_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Waterfall_List_Item_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Attorney_Waterfall_List_Item_Aggregated_Fields>;
  min?: Maybe<Attorney_Waterfall_List_Item_Aggregated_Fields>;
  sum?: Maybe<Attorney_Waterfall_List_Item_Aggregated_Fields>;
  sumDistinct?: Maybe<Attorney_Waterfall_List_Item_Aggregated_Fields>;
};

export type Attorney_Waterfall_List_Item_Aggregated_Count = {
  __typename?: 'attorney_waterfall_list_item_aggregated_count';
  attorney_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  list_order?: Maybe<Scalars['Int']['output']>;
  waterfall_list_id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Waterfall_List_Item_Aggregated_Fields = {
  __typename?: 'attorney_waterfall_list_item_aggregated_fields';
  list_order?: Maybe<Scalars['Float']['output']>;
};

export type Attorney_Waterfall_List_Item_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Waterfall_List_Item_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Waterfall_List_Item_Filter>>>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  list_order?: InputMaybe<Number_Filter_Operators>;
  waterfall_list_id?: InputMaybe<Attorney_Waterfall_List_Filter>;
};

export type Attorney_Waterfall_List_Item_Mutated = {
  __typename?: 'attorney_waterfall_list_item_mutated';
  data?: Maybe<Attorney_Waterfall_List_Item>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Waterfall_List_Jdx = {
  __typename?: 'attorney_waterfall_list_jdx';
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  jdx_id?: Maybe<Catalog_Us_State>;
  waterfall_list_id?: Maybe<Attorney_Waterfall_List>;
};


export type Attorney_Waterfall_List_JdxJdx_IdArgs = {
  filter?: InputMaybe<Catalog_Us_State_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Waterfall_List_JdxWaterfall_List_IdArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Waterfall_List_Jdx_Aggregated = {
  __typename?: 'attorney_waterfall_list_jdx_aggregated';
  count?: Maybe<Attorney_Waterfall_List_Jdx_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Waterfall_List_Jdx_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Waterfall_List_Jdx_Aggregated_Count = {
  __typename?: 'attorney_waterfall_list_jdx_aggregated_count';
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  jdx_id?: Maybe<Scalars['Int']['output']>;
  waterfall_list_id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Waterfall_List_Jdx_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Waterfall_List_Jdx_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Waterfall_List_Jdx_Filter>>>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  jdx_id?: InputMaybe<Catalog_Us_State_Filter>;
  waterfall_list_id?: InputMaybe<Attorney_Waterfall_List_Filter>;
};

export type Attorney_Waterfall_List_Jdx_Mutated = {
  __typename?: 'attorney_waterfall_list_jdx_mutated';
  data?: Maybe<Attorney_Waterfall_List_Jdx>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Waterfall_List_Mutated = {
  __typename?: 'attorney_waterfall_list_mutated';
  data?: Maybe<Attorney_Waterfall_List>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Waterfall_List_Pa = {
  __typename?: 'attorney_waterfall_list_pa';
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  practice_area_id?: Maybe<Catalog_Practice_Area>;
  waterfall_list_id?: Maybe<Attorney_Waterfall_List>;
};


export type Attorney_Waterfall_List_PaPractice_Area_IdArgs = {
  filter?: InputMaybe<Catalog_Practice_Area_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Attorney_Waterfall_List_PaWaterfall_List_IdArgs = {
  filter?: InputMaybe<Attorney_Waterfall_List_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Attorney_Waterfall_List_Pa_Aggregated = {
  __typename?: 'attorney_waterfall_list_pa_aggregated';
  count?: Maybe<Attorney_Waterfall_List_Pa_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Attorney_Waterfall_List_Pa_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Attorney_Waterfall_List_Pa_Aggregated_Count = {
  __typename?: 'attorney_waterfall_list_pa_aggregated_count';
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  practice_area_id?: Maybe<Scalars['Int']['output']>;
  waterfall_list_id?: Maybe<Scalars['Int']['output']>;
};

export type Attorney_Waterfall_List_Pa_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Attorney_Waterfall_List_Pa_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Attorney_Waterfall_List_Pa_Filter>>>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  practice_area_id?: InputMaybe<Catalog_Practice_Area_Filter>;
  waterfall_list_id?: InputMaybe<Attorney_Waterfall_List_Filter>;
};

export type Attorney_Waterfall_List_Pa_Mutated = {
  __typename?: 'attorney_waterfall_list_pa_mutated';
  data?: Maybe<Attorney_Waterfall_List_Pa>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Attorney_Waterfall_Mutated = {
  __typename?: 'attorney_waterfall_mutated';
  data?: Maybe<Attorney_Waterfall>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Big_Int_Filter_Operators = {
  _between?: InputMaybe<Array<InputMaybe<Scalars['GraphQLBigInt']['input']>>>;
  _eq?: InputMaybe<Scalars['GraphQLBigInt']['input']>;
  _gt?: InputMaybe<Scalars['GraphQLBigInt']['input']>;
  _gte?: InputMaybe<Scalars['GraphQLBigInt']['input']>;
  _in?: InputMaybe<Array<InputMaybe<Scalars['GraphQLBigInt']['input']>>>;
  _lt?: InputMaybe<Scalars['GraphQLBigInt']['input']>;
  _lte?: InputMaybe<Scalars['GraphQLBigInt']['input']>;
  _nbetween?: InputMaybe<Array<InputMaybe<Scalars['GraphQLBigInt']['input']>>>;
  _neq?: InputMaybe<Scalars['GraphQLBigInt']['input']>;
  _nin?: InputMaybe<Array<InputMaybe<Scalars['GraphQLBigInt']['input']>>>;
  _nnull?: InputMaybe<Scalars['Boolean']['input']>;
  _null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Boolean_Filter_Operators = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nnull?: InputMaybe<Scalars['Boolean']['input']>;
  _null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Case = {
  __typename?: 'case';
  attorney_id?: Maybe<Attorney>;
  case_alias?: Maybe<Scalars['String']['output']>;
  case_number?: Maybe<Scalars['String']['output']>;
  case_source?: Maybe<Catalog_Case_Source>;
  case_status_update_scheduler_tasks?: Maybe<Array<Maybe<Case_Status_Update_Scheduler_Task>>>;
  case_status_update_scheduler_tasks_func?: Maybe<Count_Functions>;
  case_status_updates?: Maybe<Array<Maybe<Case_Status_Update>>>;
  case_status_updates_func?: Maybe<Count_Functions>;
  /** Midstream referral: referring firm currently represents this client; contact info withheld from the buyer until shared */
  client_currently_represented?: Maybe<Scalars['Boolean']['output']>;
  communities?: Maybe<Array<Maybe<Case_Affiliation>>>;
  communities_func?: Maybe<Count_Functions>;
  community_exclusive_expires_at?: Maybe<Scalars['Date']['output']>;
  community_exclusive_expires_at_func?: Maybe<Datetime_Functions>;
  created_by_user_id?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  data_room_filename?: Maybe<Scalars['String']['output']>;
  data_room_filesize?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  description_formatted?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  files?: Maybe<Array<Maybe<Case_File>>>;
  files_func?: Maybe<Count_Functions>;
  financing_source?: Maybe<Catalog_Financing_Source>;
  following_count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  incident_date?: Maybe<Scalars['Date']['output']>;
  incident_date_func?: Maybe<Date_Functions>;
  internal_case_number?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Catalog_Us_State>;
  lead_score?: Maybe<Array<Maybe<Case_Lead_Score>>>;
  lead_score_func?: Maybe<Count_Functions>;
  leads?: Maybe<Array<Maybe<Case_Lead>>>;
  leads_func?: Maybe<Count_Functions>;
  mp_visibility?: Maybe<Catalog_Case_Mp_Visibility>;
  name?: Maybe<Scalars['String']['output']>;
  ownerships?: Maybe<Array<Maybe<Case_Ownership>>>;
  ownerships_func?: Maybe<Count_Functions>;
  preferred_language?: Maybe<Catalog_Language>;
  process_stage?: Maybe<Catalog_Process_Stage>;
  proposal_due_date?: Maybe<Scalars['Date']['output']>;
  proposal_due_date_func?: Maybe<Date_Functions>;
  referral_id_lcms?: Maybe<Case_Management_Software>;
  reposted_from_case_id?: Maybe<Case>;
  status?: Maybe<Scalars['String']['output']>;
  status_ts?: Maybe<Scalars['Date']['output']>;
  status_ts_func?: Maybe<Datetime_Functions>;
  type?: Maybe<Catalog_Practice_Area>;
  user_mp_preferences?: Maybe<Array<Maybe<Attorney_Case_Mp_Preference>>>;
  user_mp_preferences_func?: Maybe<Count_Functions>;
  zip_code?: Maybe<Catalog_Zip_Code>;
};


export type CaseAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseCase_SourceArgs = {
  filter?: InputMaybe<Catalog_Case_Source_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseCase_Status_Update_Scheduler_TasksArgs = {
  filter?: InputMaybe<Case_Status_Update_Scheduler_Task_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseCase_Status_UpdatesArgs = {
  filter?: InputMaybe<Case_Status_Update_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseCommunitiesArgs = {
  filter?: InputMaybe<Case_Affiliation_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseFilesArgs = {
  filter?: InputMaybe<Case_File_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseFinancing_SourceArgs = {
  filter?: InputMaybe<Catalog_Financing_Source_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseJurisdictionArgs = {
  filter?: InputMaybe<Catalog_Us_State_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseLead_ScoreArgs = {
  filter?: InputMaybe<Case_Lead_Score_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseLeadsArgs = {
  filter?: InputMaybe<Case_Lead_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseMp_VisibilityArgs = {
  filter?: InputMaybe<Catalog_Case_Mp_Visibility_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseOwnershipsArgs = {
  filter?: InputMaybe<Case_Ownership_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CasePreferred_LanguageArgs = {
  filter?: InputMaybe<Catalog_Language_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseProcess_StageArgs = {
  filter?: InputMaybe<Catalog_Process_Stage_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseReferral_Id_LcmsArgs = {
  filter?: InputMaybe<Case_Management_Software_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseReposted_From_Case_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseTypeArgs = {
  filter?: InputMaybe<Catalog_Practice_Area_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseUser_Mp_PreferencesArgs = {
  filter?: InputMaybe<Attorney_Case_Mp_Preference_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CaseZip_CodeArgs = {
  filter?: InputMaybe<Catalog_Zip_Code_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_Affiliation = {
  __typename?: 'case_affiliation';
  affiliation_id?: Maybe<Catalog_Affiliation>;
  case_id?: Maybe<Case>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_at_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
};


export type Case_AffiliationAffiliation_IdArgs = {
  filter?: InputMaybe<Catalog_Affiliation_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_AffiliationCase_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_Affiliation_Aggregated = {
  __typename?: 'case_affiliation_aggregated';
  count?: Maybe<Case_Affiliation_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Affiliation_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Case_Affiliation_Aggregated_Count = {
  __typename?: 'case_affiliation_aggregated_count';
  affiliation_id?: Maybe<Scalars['Int']['output']>;
  case_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Case_Affiliation_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Affiliation_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Affiliation_Filter>>>;
  affiliation_id?: InputMaybe<Catalog_Affiliation_Filter>;
  case_id?: InputMaybe<Case_Filter>;
  created_at?: InputMaybe<Date_Filter_Operators>;
  created_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
};

export type Case_Affiliation_Mutated = {
  __typename?: 'case_affiliation_mutated';
  data?: Maybe<Case_Affiliation>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_Aggregated = {
  __typename?: 'case_aggregated';
  avg?: Maybe<Case_Aggregated_Fields>;
  avgDistinct?: Maybe<Case_Aggregated_Fields>;
  count?: Maybe<Case_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Case_Aggregated_Fields>;
  min?: Maybe<Case_Aggregated_Fields>;
  sum?: Maybe<Case_Aggregated_Fields>;
  sumDistinct?: Maybe<Case_Aggregated_Fields>;
};

export type Case_Aggregated_Count = {
  __typename?: 'case_aggregated_count';
  attorney_id?: Maybe<Scalars['Int']['output']>;
  case_alias?: Maybe<Scalars['Int']['output']>;
  case_number?: Maybe<Scalars['Int']['output']>;
  case_source?: Maybe<Scalars['Int']['output']>;
  case_status_update_scheduler_tasks?: Maybe<Scalars['Int']['output']>;
  case_status_updates?: Maybe<Scalars['Int']['output']>;
  /** Midstream referral: referring firm currently represents this client; contact info withheld from the buyer until shared */
  client_currently_represented?: Maybe<Scalars['Int']['output']>;
  communities?: Maybe<Scalars['Int']['output']>;
  community_exclusive_expires_at?: Maybe<Scalars['Int']['output']>;
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  data_room_filename?: Maybe<Scalars['Int']['output']>;
  data_room_filesize?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['Int']['output']>;
  description_formatted?: Maybe<Scalars['Int']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  files?: Maybe<Scalars['Int']['output']>;
  financing_source?: Maybe<Scalars['Int']['output']>;
  following_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  incident_date?: Maybe<Scalars['Int']['output']>;
  internal_case_number?: Maybe<Scalars['Int']['output']>;
  jurisdiction?: Maybe<Scalars['Int']['output']>;
  lead_score?: Maybe<Scalars['Int']['output']>;
  leads?: Maybe<Scalars['Int']['output']>;
  mp_visibility?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  ownerships?: Maybe<Scalars['Int']['output']>;
  preferred_language?: Maybe<Scalars['Int']['output']>;
  process_stage?: Maybe<Scalars['Int']['output']>;
  proposal_due_date?: Maybe<Scalars['Int']['output']>;
  referral_id_lcms?: Maybe<Scalars['Int']['output']>;
  /** ENG-1688: source case this case was reposted from */
  reposted_from_case_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  status_ts?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  user_mp_preferences?: Maybe<Scalars['Int']['output']>;
  zip_code?: Maybe<Scalars['Int']['output']>;
};

export type Case_Aggregated_Fields = {
  __typename?: 'case_aggregated_fields';
  data_room_filesize?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  following_count?: Maybe<Scalars['Float']['output']>;
};

export type Case_Fee_Overrides = {
  __typename?: 'case_fee_overrides';
  auto_charge_date?: Maybe<Scalars['Date']['output']>;
  auto_charge_date_func?: Maybe<Date_Functions>;
  auto_charge_days?: Maybe<Scalars['Int']['output']>;
  case_id?: Maybe<Case>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  expiration_date?: Maybe<Scalars['Date']['output']>;
  expiration_date_func?: Maybe<Date_Functions>;
  expiration_days?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  match_fee?: Maybe<Scalars['Float']['output']>;
};


export type Case_Fee_OverridesCase_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_Fee_Overrides_Aggregated = {
  __typename?: 'case_fee_overrides_aggregated';
  avg?: Maybe<Case_Fee_Overrides_Aggregated_Fields>;
  avgDistinct?: Maybe<Case_Fee_Overrides_Aggregated_Fields>;
  count?: Maybe<Case_Fee_Overrides_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Fee_Overrides_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Case_Fee_Overrides_Aggregated_Fields>;
  min?: Maybe<Case_Fee_Overrides_Aggregated_Fields>;
  sum?: Maybe<Case_Fee_Overrides_Aggregated_Fields>;
  sumDistinct?: Maybe<Case_Fee_Overrides_Aggregated_Fields>;
};

export type Case_Fee_Overrides_Aggregated_Count = {
  __typename?: 'case_fee_overrides_aggregated_count';
  auto_charge_date?: Maybe<Scalars['Int']['output']>;
  auto_charge_days?: Maybe<Scalars['Int']['output']>;
  case_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  expiration_date?: Maybe<Scalars['Int']['output']>;
  expiration_days?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  match_fee?: Maybe<Scalars['Int']['output']>;
};

export type Case_Fee_Overrides_Aggregated_Fields = {
  __typename?: 'case_fee_overrides_aggregated_fields';
  auto_charge_days?: Maybe<Scalars['Float']['output']>;
  expiration_days?: Maybe<Scalars['Float']['output']>;
  match_fee?: Maybe<Scalars['Float']['output']>;
};

export type Case_Fee_Overrides_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Fee_Overrides_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Fee_Overrides_Filter>>>;
  auto_charge_date?: InputMaybe<Date_Filter_Operators>;
  auto_charge_date_func?: InputMaybe<Date_Function_Filter_Operators>;
  auto_charge_days?: InputMaybe<Number_Filter_Operators>;
  case_id?: InputMaybe<Case_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  expiration_date?: InputMaybe<Date_Filter_Operators>;
  expiration_date_func?: InputMaybe<Date_Function_Filter_Operators>;
  expiration_days?: InputMaybe<Number_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  match_fee?: InputMaybe<Number_Filter_Operators>;
};

export type Case_Fee_Overrides_Mutated = {
  __typename?: 'case_fee_overrides_mutated';
  data?: Maybe<Case_Fee_Overrides>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_File = {
  __typename?: 'case_file';
  alias?: Maybe<Scalars['String']['output']>;
  case_file_type?: Maybe<Catalog_Case_File_Type>;
  case_id?: Maybe<Case>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  file_id?: Maybe<Directus_Files>;
  id: Scalars['ID']['output'];
};


export type Case_FileCase_File_TypeArgs = {
  filter?: InputMaybe<Catalog_Case_File_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_FileCase_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_FileFile_IdArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_File_Aggregated = {
  __typename?: 'case_file_aggregated';
  count?: Maybe<Case_File_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_File_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Case_File_Aggregated_Count = {
  __typename?: 'case_file_aggregated_count';
  alias?: Maybe<Scalars['Int']['output']>;
  case_file_type?: Maybe<Scalars['Int']['output']>;
  case_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Int']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Case_File_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_File_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_File_Filter>>>;
  alias?: InputMaybe<String_Filter_Operators>;
  case_file_type?: InputMaybe<Catalog_Case_File_Type_Filter>;
  case_id?: InputMaybe<Case_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  deleted?: InputMaybe<Boolean_Filter_Operators>;
  file_id?: InputMaybe<Directus_Files_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
};

export type Case_File_Mutated = {
  __typename?: 'case_file_mutated';
  data?: Maybe<Case_File>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Filter>>>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  case_alias?: InputMaybe<String_Filter_Operators>;
  case_number?: InputMaybe<String_Filter_Operators>;
  case_source?: InputMaybe<Catalog_Case_Source_Filter>;
  case_status_update_scheduler_tasks?: InputMaybe<Case_Status_Update_Scheduler_Task_Filter>;
  case_status_update_scheduler_tasks_func?: InputMaybe<Count_Function_Filter_Operators>;
  case_status_updates?: InputMaybe<Case_Status_Update_Filter>;
  case_status_updates_func?: InputMaybe<Count_Function_Filter_Operators>;
  client_currently_represented?: InputMaybe<Boolean_Filter_Operators>;
  communities?: InputMaybe<Case_Affiliation_Filter>;
  communities_func?: InputMaybe<Count_Function_Filter_Operators>;
  community_exclusive_expires_at?: InputMaybe<Date_Filter_Operators>;
  community_exclusive_expires_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  created_by_user_id?: InputMaybe<String_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  data_room_filename?: InputMaybe<String_Filter_Operators>;
  data_room_filesize?: InputMaybe<Number_Filter_Operators>;
  deleted?: InputMaybe<Boolean_Filter_Operators>;
  description?: InputMaybe<String_Filter_Operators>;
  description_formatted?: InputMaybe<String_Filter_Operators>;
  fee?: InputMaybe<Number_Filter_Operators>;
  files?: InputMaybe<Case_File_Filter>;
  files_func?: InputMaybe<Count_Function_Filter_Operators>;
  financing_source?: InputMaybe<Catalog_Financing_Source_Filter>;
  following_count?: InputMaybe<Number_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  incident_date?: InputMaybe<Date_Filter_Operators>;
  incident_date_func?: InputMaybe<Date_Function_Filter_Operators>;
  internal_case_number?: InputMaybe<String_Filter_Operators>;
  jurisdiction?: InputMaybe<Catalog_Us_State_Filter>;
  lead_score?: InputMaybe<Case_Lead_Score_Filter>;
  lead_score_func?: InputMaybe<Count_Function_Filter_Operators>;
  leads?: InputMaybe<Case_Lead_Filter>;
  leads_func?: InputMaybe<Count_Function_Filter_Operators>;
  mp_visibility?: InputMaybe<Catalog_Case_Mp_Visibility_Filter>;
  name?: InputMaybe<String_Filter_Operators>;
  ownerships?: InputMaybe<Case_Ownership_Filter>;
  ownerships_func?: InputMaybe<Count_Function_Filter_Operators>;
  preferred_language?: InputMaybe<Catalog_Language_Filter>;
  process_stage?: InputMaybe<Catalog_Process_Stage_Filter>;
  proposal_due_date?: InputMaybe<Date_Filter_Operators>;
  proposal_due_date_func?: InputMaybe<Date_Function_Filter_Operators>;
  referral_id_lcms?: InputMaybe<Case_Management_Software_Filter>;
  reposted_from_case_id?: InputMaybe<Case_Filter>;
  status?: InputMaybe<String_Filter_Operators>;
  status_ts?: InputMaybe<Date_Filter_Operators>;
  status_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  type?: InputMaybe<Catalog_Practice_Area_Filter>;
  user_mp_preferences?: InputMaybe<Attorney_Case_Mp_Preference_Filter>;
  user_mp_preferences_func?: InputMaybe<Count_Function_Filter_Operators>;
  zip_code?: InputMaybe<Catalog_Zip_Code_Filter>;
};

export type Case_Lead = {
  __typename?: 'case_lead';
  case_id?: Maybe<Case>;
  contacts?: Maybe<Array<Maybe<Case_Lead_Contact>>>;
  contacts_func?: Maybe<Count_Functions>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
};


export type Case_LeadCase_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_LeadContactsArgs = {
  filter?: InputMaybe<Case_Lead_Contact_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_Lead_Aggregated = {
  __typename?: 'case_lead_aggregated';
  count?: Maybe<Case_Lead_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Lead_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Case_Lead_Aggregated_Count = {
  __typename?: 'case_lead_aggregated_count';
  case_id?: Maybe<Scalars['Int']['output']>;
  contacts?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Int']['output']>;
  first_name?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['Int']['output']>;
};

export type Case_Lead_Contact = {
  __typename?: 'case_lead_contact';
  case_lead_id?: Maybe<Case_Lead>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  type?: Maybe<Catalog_Contact_Type>;
  value: Scalars['String']['output'];
};


export type Case_Lead_ContactCase_Lead_IdArgs = {
  filter?: InputMaybe<Case_Lead_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Lead_ContactTypeArgs = {
  filter?: InputMaybe<Catalog_Contact_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_Lead_Contact_Aggregated = {
  __typename?: 'case_lead_contact_aggregated';
  count?: Maybe<Case_Lead_Contact_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Lead_Contact_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Case_Lead_Contact_Aggregated_Count = {
  __typename?: 'case_lead_contact_aggregated_count';
  case_lead_id?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type Case_Lead_Contact_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Lead_Contact_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Lead_Contact_Filter>>>;
  case_lead_id?: InputMaybe<Case_Lead_Filter>;
  deleted?: InputMaybe<Boolean_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  type?: InputMaybe<Catalog_Contact_Type_Filter>;
  value?: InputMaybe<String_Filter_Operators>;
};

export type Case_Lead_Contact_Mutated = {
  __typename?: 'case_lead_contact_mutated';
  data?: Maybe<Case_Lead_Contact>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_Lead_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Lead_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Lead_Filter>>>;
  case_id?: InputMaybe<Case_Filter>;
  contacts?: InputMaybe<Case_Lead_Contact_Filter>;
  contacts_func?: InputMaybe<Count_Function_Filter_Operators>;
  deleted?: InputMaybe<Boolean_Filter_Operators>;
  first_name?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  last_name?: InputMaybe<String_Filter_Operators>;
};

export type Case_Lead_Mutated = {
  __typename?: 'case_lead_mutated';
  data?: Maybe<Case_Lead>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_Lead_Score = {
  __typename?: 'case_lead_score';
  case_id?: Maybe<Case>;
  confidence: Scalars['Float']['output'];
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  market_fit: Scalars['String']['output'];
  quality_score: Scalars['Int']['output'];
  suggestions?: Maybe<Scalars['JSON']['output']>;
  suggestions_func?: Maybe<Count_Functions>;
};


export type Case_Lead_ScoreCase_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_Lead_Score_Aggregated = {
  __typename?: 'case_lead_score_aggregated';
  avg?: Maybe<Case_Lead_Score_Aggregated_Fields>;
  avgDistinct?: Maybe<Case_Lead_Score_Aggregated_Fields>;
  count?: Maybe<Case_Lead_Score_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Lead_Score_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Case_Lead_Score_Aggregated_Fields>;
  min?: Maybe<Case_Lead_Score_Aggregated_Fields>;
  sum?: Maybe<Case_Lead_Score_Aggregated_Fields>;
  sumDistinct?: Maybe<Case_Lead_Score_Aggregated_Fields>;
};

export type Case_Lead_Score_Aggregated_Count = {
  __typename?: 'case_lead_score_aggregated_count';
  case_id?: Maybe<Scalars['Int']['output']>;
  confidence?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  market_fit?: Maybe<Scalars['Int']['output']>;
  quality_score?: Maybe<Scalars['Int']['output']>;
  suggestions?: Maybe<Scalars['Int']['output']>;
};

export type Case_Lead_Score_Aggregated_Fields = {
  __typename?: 'case_lead_score_aggregated_fields';
  confidence?: Maybe<Scalars['Float']['output']>;
  quality_score?: Maybe<Scalars['Float']['output']>;
};

export type Case_Lead_Score_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Lead_Score_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Lead_Score_Filter>>>;
  case_id?: InputMaybe<Case_Filter>;
  confidence?: InputMaybe<Number_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  market_fit?: InputMaybe<String_Filter_Operators>;
  quality_score?: InputMaybe<Number_Filter_Operators>;
  suggestions?: InputMaybe<String_Filter_Operators>;
  suggestions_func?: InputMaybe<Count_Function_Filter_Operators>;
};

export type Case_Lead_Score_Mutated = {
  __typename?: 'case_lead_score_mutated';
  data?: Maybe<Case_Lead_Score>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_Management_Software = {
  __typename?: 'case_management_software';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Case_Management_Software_Aggregated = {
  __typename?: 'case_management_software_aggregated';
  count?: Maybe<Case_Management_Software_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Management_Software_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Case_Management_Software_Aggregated_Count = {
  __typename?: 'case_management_software_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Case_Management_Software_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Management_Software_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Management_Software_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Case_Management_Software_Mutated = {
  __typename?: 'case_management_software_mutated';
  data?: Maybe<Case_Management_Software>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_Mutated = {
  __typename?: 'case_mutated';
  data?: Maybe<Case>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_Ownership = {
  __typename?: 'case_ownership';
  case_id?: Maybe<Case>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  user_id?: Maybe<Directus_Users>;
};


export type Case_OwnershipCase_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_OwnershipUser_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_Ownership_Aggregated = {
  __typename?: 'case_ownership_aggregated';
  count?: Maybe<Case_Ownership_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Ownership_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Case_Ownership_Aggregated_Count = {
  __typename?: 'case_ownership_aggregated_count';
  case_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type Case_Ownership_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Ownership_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Ownership_Filter>>>;
  case_id?: InputMaybe<Case_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  user_id?: InputMaybe<Directus_Users_Filter>;
};

export type Case_Ownership_Mutated = {
  __typename?: 'case_ownership_mutated';
  data?: Maybe<Case_Ownership>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_Purchase = {
  __typename?: 'case_purchase';
  active_ts?: Maybe<Scalars['Date']['output']>;
  active_ts_func?: Maybe<Datetime_Functions>;
  activity?: Maybe<Array<Maybe<Case_Purchase_Activity>>>;
  activity_func?: Maybe<Count_Functions>;
  case_id?: Maybe<Case>;
  contact_shared_by?: Maybe<Directus_Users>;
  /** When client contact info was shared with the buyer */
  contact_shared_ts?: Maybe<Scalars['Date']['output']>;
  contact_shared_ts_func?: Maybe<Datetime_Functions>;
  created_by?: Maybe<Attorney>;
  created_by_user_id?: Maybe<Directus_Users>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  fee_agreement_status?: Maybe<Catalog_Fee_Agreement_Status>;
  fee_agreement_status_ts?: Maybe<Scalars['Date']['output']>;
  fee_agreement_status_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  in_progress_by?: Maybe<Directus_Users>;
  in_progress_ts?: Maybe<Scalars['Date']['output']>;
  in_progress_ts_func?: Maybe<Datetime_Functions>;
  is_in_progress?: Maybe<Scalars['Boolean']['output']>;
  ownerships?: Maybe<Array<Maybe<Case_Purchase_Ownership>>>;
  ownerships_func?: Maybe<Count_Functions>;
  payments?: Maybe<Array<Maybe<Case_Purchase_Payment>>>;
  payments_func?: Maybe<Count_Functions>;
  prospect_attorney_id?: Maybe<Attorney>;
  sign_request?: Maybe<Array<Maybe<Case_Purchase_Sign_Request>>>;
  sign_request_func?: Maybe<Count_Functions>;
  status?: Maybe<Catalog_Case_Purchase_Status>;
  status_ts?: Maybe<Scalars['Date']['output']>;
  status_ts_func?: Maybe<Datetime_Functions>;
  time_unit?: Maybe<Catalog_Time_Unit>;
  timed_access_limit?: Maybe<Scalars['Int']['output']>;
  waterfall_id?: Maybe<Attorney_Waterfall>;
  waterfall_order?: Maybe<Scalars['Int']['output']>;
};


export type Case_PurchaseActivityArgs = {
  filter?: InputMaybe<Case_Purchase_Activity_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_PurchaseCase_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_PurchaseContact_Shared_ByArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_PurchaseCreated_ByArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_PurchaseCreated_By_User_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_PurchaseFee_Agreement_StatusArgs = {
  filter?: InputMaybe<Catalog_Fee_Agreement_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_PurchaseIn_Progress_ByArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_PurchaseOwnershipsArgs = {
  filter?: InputMaybe<Case_Purchase_Ownership_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_PurchasePaymentsArgs = {
  filter?: InputMaybe<Case_Purchase_Payment_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_PurchaseProspect_Attorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_PurchaseSign_RequestArgs = {
  filter?: InputMaybe<Case_Purchase_Sign_Request_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_PurchaseStatusArgs = {
  filter?: InputMaybe<Catalog_Case_Purchase_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_PurchaseTime_UnitArgs = {
  filter?: InputMaybe<Catalog_Time_Unit_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_PurchaseWaterfall_IdArgs = {
  filter?: InputMaybe<Attorney_Waterfall_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_Purchase_Activity = {
  __typename?: 'case_purchase_activity';
  activity_entry_status?: Maybe<Catalog_Case_Purchase_Status>;
  case_purchase_id?: Maybe<Case_Purchase>;
  created_by?: Maybe<Attorney>;
  created_by_user_id?: Maybe<Directus_Users>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  decline_reason_id?: Maybe<Catalog_Case_Purchase_Decline_Reason>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  fee: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  origin_id?: Maybe<Catalog_Activity_Origin>;
  unmatch_reason_id?: Maybe<Catalog_Case_Purchase_Unmatch_Reason>;
};


export type Case_Purchase_ActivityActivity_Entry_StatusArgs = {
  filter?: InputMaybe<Catalog_Case_Purchase_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Purchase_ActivityCase_Purchase_IdArgs = {
  filter?: InputMaybe<Case_Purchase_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Purchase_ActivityCreated_ByArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Purchase_ActivityCreated_By_User_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Purchase_ActivityDecline_Reason_IdArgs = {
  filter?: InputMaybe<Catalog_Case_Purchase_Decline_Reason_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Purchase_ActivityOrigin_IdArgs = {
  filter?: InputMaybe<Catalog_Activity_Origin_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Purchase_ActivityUnmatch_Reason_IdArgs = {
  filter?: InputMaybe<Catalog_Case_Purchase_Unmatch_Reason_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_Purchase_Activity_Aggregated = {
  __typename?: 'case_purchase_activity_aggregated';
  avg?: Maybe<Case_Purchase_Activity_Aggregated_Fields>;
  avgDistinct?: Maybe<Case_Purchase_Activity_Aggregated_Fields>;
  count?: Maybe<Case_Purchase_Activity_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Purchase_Activity_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Case_Purchase_Activity_Aggregated_Fields>;
  min?: Maybe<Case_Purchase_Activity_Aggregated_Fields>;
  sum?: Maybe<Case_Purchase_Activity_Aggregated_Fields>;
  sumDistinct?: Maybe<Case_Purchase_Activity_Aggregated_Fields>;
};

export type Case_Purchase_Activity_Aggregated_Count = {
  __typename?: 'case_purchase_activity_aggregated_count';
  activity_entry_status?: Maybe<Scalars['Int']['output']>;
  case_purchase_id?: Maybe<Scalars['Int']['output']>;
  created_by?: Maybe<Scalars['Int']['output']>;
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  decline_reason_id?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Int']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['Int']['output']>;
  origin_id?: Maybe<Scalars['Int']['output']>;
  /** ENG-2122: set only on Unmatched activities. */
  unmatch_reason_id?: Maybe<Scalars['Int']['output']>;
};

export type Case_Purchase_Activity_Aggregated_Fields = {
  __typename?: 'case_purchase_activity_aggregated_fields';
  fee?: Maybe<Scalars['Float']['output']>;
};

export type Case_Purchase_Activity_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Purchase_Activity_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Purchase_Activity_Filter>>>;
  activity_entry_status?: InputMaybe<Catalog_Case_Purchase_Status_Filter>;
  case_purchase_id?: InputMaybe<Case_Purchase_Filter>;
  created_by?: InputMaybe<Attorney_Filter>;
  created_by_user_id?: InputMaybe<Directus_Users_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  decline_reason_id?: InputMaybe<Catalog_Case_Purchase_Decline_Reason_Filter>;
  deleted?: InputMaybe<Boolean_Filter_Operators>;
  fee?: InputMaybe<Number_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  message?: InputMaybe<String_Filter_Operators>;
  origin_id?: InputMaybe<Catalog_Activity_Origin_Filter>;
  unmatch_reason_id?: InputMaybe<Catalog_Case_Purchase_Unmatch_Reason_Filter>;
};

export type Case_Purchase_Activity_Mutated = {
  __typename?: 'case_purchase_activity_mutated';
  data?: Maybe<Case_Purchase_Activity>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_Purchase_Aggregated = {
  __typename?: 'case_purchase_aggregated';
  avg?: Maybe<Case_Purchase_Aggregated_Fields>;
  avgDistinct?: Maybe<Case_Purchase_Aggregated_Fields>;
  count?: Maybe<Case_Purchase_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Purchase_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Case_Purchase_Aggregated_Fields>;
  min?: Maybe<Case_Purchase_Aggregated_Fields>;
  sum?: Maybe<Case_Purchase_Aggregated_Fields>;
  sumDistinct?: Maybe<Case_Purchase_Aggregated_Fields>;
};

export type Case_Purchase_Aggregated_Count = {
  __typename?: 'case_purchase_aggregated_count';
  active_ts?: Maybe<Scalars['Int']['output']>;
  activity?: Maybe<Scalars['Int']['output']>;
  case_id?: Maybe<Scalars['Int']['output']>;
  /** User who shared client contact info */
  contact_shared_by?: Maybe<Scalars['Int']['output']>;
  /** When client contact info was shared with the buyer */
  contact_shared_ts?: Maybe<Scalars['Int']['output']>;
  created_by?: Maybe<Scalars['Int']['output']>;
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Int']['output']>;
  fee_agreement_status?: Maybe<Scalars['Int']['output']>;
  fee_agreement_status_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  in_progress_by?: Maybe<Scalars['Int']['output']>;
  in_progress_ts?: Maybe<Scalars['Int']['output']>;
  is_in_progress?: Maybe<Scalars['Int']['output']>;
  ownerships?: Maybe<Scalars['Int']['output']>;
  payments?: Maybe<Scalars['Int']['output']>;
  prospect_attorney_id?: Maybe<Scalars['Int']['output']>;
  sign_request?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  status_ts?: Maybe<Scalars['Int']['output']>;
  time_unit?: Maybe<Scalars['Int']['output']>;
  timed_access_limit?: Maybe<Scalars['Int']['output']>;
  waterfall_id?: Maybe<Scalars['Int']['output']>;
  waterfall_order?: Maybe<Scalars['Int']['output']>;
};

export type Case_Purchase_Aggregated_Fields = {
  __typename?: 'case_purchase_aggregated_fields';
  timed_access_limit?: Maybe<Scalars['Float']['output']>;
  waterfall_order?: Maybe<Scalars['Float']['output']>;
};

export type Case_Purchase_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Purchase_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Purchase_Filter>>>;
  active_ts?: InputMaybe<Date_Filter_Operators>;
  active_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  activity?: InputMaybe<Case_Purchase_Activity_Filter>;
  activity_func?: InputMaybe<Count_Function_Filter_Operators>;
  case_id?: InputMaybe<Case_Filter>;
  contact_shared_by?: InputMaybe<Directus_Users_Filter>;
  contact_shared_ts?: InputMaybe<Date_Filter_Operators>;
  contact_shared_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  created_by?: InputMaybe<Attorney_Filter>;
  created_by_user_id?: InputMaybe<Directus_Users_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  deleted?: InputMaybe<Boolean_Filter_Operators>;
  fee_agreement_status?: InputMaybe<Catalog_Fee_Agreement_Status_Filter>;
  fee_agreement_status_ts?: InputMaybe<Date_Filter_Operators>;
  fee_agreement_status_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  in_progress_by?: InputMaybe<Directus_Users_Filter>;
  in_progress_ts?: InputMaybe<Date_Filter_Operators>;
  in_progress_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  is_in_progress?: InputMaybe<Boolean_Filter_Operators>;
  ownerships?: InputMaybe<Case_Purchase_Ownership_Filter>;
  ownerships_func?: InputMaybe<Count_Function_Filter_Operators>;
  payments?: InputMaybe<Case_Purchase_Payment_Filter>;
  payments_func?: InputMaybe<Count_Function_Filter_Operators>;
  prospect_attorney_id?: InputMaybe<Attorney_Filter>;
  sign_request?: InputMaybe<Case_Purchase_Sign_Request_Filter>;
  sign_request_func?: InputMaybe<Count_Function_Filter_Operators>;
  status?: InputMaybe<Catalog_Case_Purchase_Status_Filter>;
  status_ts?: InputMaybe<Date_Filter_Operators>;
  status_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  time_unit?: InputMaybe<Catalog_Time_Unit_Filter>;
  timed_access_limit?: InputMaybe<Number_Filter_Operators>;
  waterfall_id?: InputMaybe<Attorney_Waterfall_Filter>;
  waterfall_order?: InputMaybe<Number_Filter_Operators>;
};

export type Case_Purchase_Mutated = {
  __typename?: 'case_purchase_mutated';
  data?: Maybe<Case_Purchase>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_Purchase_Ownership = {
  __typename?: 'case_purchase_ownership';
  case_purchase_id?: Maybe<Case_Purchase>;
  id: Scalars['ID']['output'];
  user_id?: Maybe<Directus_Users>;
};


export type Case_Purchase_OwnershipCase_Purchase_IdArgs = {
  filter?: InputMaybe<Case_Purchase_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Purchase_OwnershipUser_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_Purchase_Ownership_Aggregated = {
  __typename?: 'case_purchase_ownership_aggregated';
  count?: Maybe<Case_Purchase_Ownership_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Purchase_Ownership_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Case_Purchase_Ownership_Aggregated_Count = {
  __typename?: 'case_purchase_ownership_aggregated_count';
  case_purchase_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type Case_Purchase_Ownership_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Purchase_Ownership_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Purchase_Ownership_Filter>>>;
  case_purchase_id?: InputMaybe<Case_Purchase_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
  user_id?: InputMaybe<Directus_Users_Filter>;
};

export type Case_Purchase_Ownership_Mutated = {
  __typename?: 'case_purchase_ownership_mutated';
  data?: Maybe<Case_Purchase_Ownership>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_Purchase_Payment = {
  __typename?: 'case_purchase_payment';
  amount: Scalars['Float']['output'];
  amount_audit?: Maybe<Scalars['JSON']['output']>;
  amount_audit_func?: Maybe<Count_Functions>;
  attorney_id?: Maybe<Attorney>;
  case_purchase_id?: Maybe<Case_Purchase>;
  created_by_user_id?: Maybe<Directus_Users>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  payment_intent?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  payment_status_id?: Maybe<Catalog_Payment_Status>;
  stripe_invoice_id?: Maybe<Scalars['String']['output']>;
};


export type Case_Purchase_PaymentAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Purchase_PaymentCase_Purchase_IdArgs = {
  filter?: InputMaybe<Case_Purchase_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Purchase_PaymentCreated_By_User_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Purchase_PaymentPayment_Status_IdArgs = {
  filter?: InputMaybe<Catalog_Payment_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_Purchase_Payment_Aggregated = {
  __typename?: 'case_purchase_payment_aggregated';
  avg?: Maybe<Case_Purchase_Payment_Aggregated_Fields>;
  avgDistinct?: Maybe<Case_Purchase_Payment_Aggregated_Fields>;
  count?: Maybe<Case_Purchase_Payment_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Purchase_Payment_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Case_Purchase_Payment_Aggregated_Fields>;
  min?: Maybe<Case_Purchase_Payment_Aggregated_Fields>;
  sum?: Maybe<Case_Purchase_Payment_Aggregated_Fields>;
  sumDistinct?: Maybe<Case_Purchase_Payment_Aggregated_Fields>;
};

export type Case_Purchase_Payment_Aggregated_Count = {
  __typename?: 'case_purchase_payment_aggregated_count';
  amount?: Maybe<Scalars['Int']['output']>;
  amount_audit?: Maybe<Scalars['Int']['output']>;
  attorney_id?: Maybe<Scalars['Int']['output']>;
  case_purchase_id?: Maybe<Scalars['Int']['output']>;
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  hosted_invoice_url?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  payment_intent?: Maybe<Scalars['Int']['output']>;
  payment_method?: Maybe<Scalars['Int']['output']>;
  payment_status_id?: Maybe<Scalars['Int']['output']>;
  stripe_invoice_id?: Maybe<Scalars['Int']['output']>;
};

export type Case_Purchase_Payment_Aggregated_Fields = {
  __typename?: 'case_purchase_payment_aggregated_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type Case_Purchase_Payment_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Purchase_Payment_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Purchase_Payment_Filter>>>;
  amount?: InputMaybe<Number_Filter_Operators>;
  amount_audit?: InputMaybe<String_Filter_Operators>;
  amount_audit_func?: InputMaybe<Count_Function_Filter_Operators>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  case_purchase_id?: InputMaybe<Case_Purchase_Filter>;
  created_by_user_id?: InputMaybe<Directus_Users_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  hosted_invoice_url?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  payment_intent?: InputMaybe<String_Filter_Operators>;
  payment_method?: InputMaybe<String_Filter_Operators>;
  payment_status_id?: InputMaybe<Catalog_Payment_Status_Filter>;
  stripe_invoice_id?: InputMaybe<String_Filter_Operators>;
};

export type Case_Purchase_Payment_Mutated = {
  __typename?: 'case_purchase_payment_mutated';
  data?: Maybe<Case_Purchase_Payment>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_Purchase_Sign_Request = {
  __typename?: 'case_purchase_sign_request';
  case_purchase_id?: Maybe<Case_Purchase>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  sign_request_id: Scalars['String']['output'];
  sign_request_status_id?: Maybe<Catalog_Sign_Request_Status>;
  url_file?: Maybe<Scalars['String']['output']>;
  url_final_copy?: Maybe<Scalars['String']['output']>;
  url_request?: Maybe<Scalars['String']['output']>;
};


export type Case_Purchase_Sign_RequestCase_Purchase_IdArgs = {
  filter?: InputMaybe<Case_Purchase_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Purchase_Sign_RequestSign_Request_Status_IdArgs = {
  filter?: InputMaybe<Catalog_Sign_Request_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_Purchase_Sign_Request_Aggregated = {
  __typename?: 'case_purchase_sign_request_aggregated';
  count?: Maybe<Case_Purchase_Sign_Request_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Purchase_Sign_Request_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Case_Purchase_Sign_Request_Aggregated_Count = {
  __typename?: 'case_purchase_sign_request_aggregated_count';
  case_purchase_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  sign_request_id?: Maybe<Scalars['Int']['output']>;
  sign_request_status_id?: Maybe<Scalars['Int']['output']>;
  url_file?: Maybe<Scalars['Int']['output']>;
  url_final_copy?: Maybe<Scalars['Int']['output']>;
  url_request?: Maybe<Scalars['Int']['output']>;
};

export type Case_Purchase_Sign_Request_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Purchase_Sign_Request_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Purchase_Sign_Request_Filter>>>;
  case_purchase_id?: InputMaybe<Case_Purchase_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  sign_request_id?: InputMaybe<String_Filter_Operators>;
  sign_request_status_id?: InputMaybe<Catalog_Sign_Request_Status_Filter>;
  url_file?: InputMaybe<String_Filter_Operators>;
  url_final_copy?: InputMaybe<String_Filter_Operators>;
  url_request?: InputMaybe<String_Filter_Operators>;
};

export type Case_Purchase_Sign_Request_Mutated = {
  __typename?: 'case_purchase_sign_request_mutated';
  data?: Maybe<Case_Purchase_Sign_Request>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_Status_Update = {
  __typename?: 'case_status_update';
  actual_settlement_value?: Maybe<Scalars['Float']['output']>;
  case_id?: Maybe<Case>;
  comments?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Directus_Users>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  estimated_settlement_value?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  matter_stage?: Maybe<Catalog_Case_Status_Update_Matter_Stage>;
  matter_status?: Maybe<Catalog_Case_Status_Update_Matter_Status>;
};


export type Case_Status_UpdateCase_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Status_UpdateCreated_ByArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Status_UpdateMatter_StageArgs = {
  filter?: InputMaybe<Catalog_Case_Status_Update_Matter_Stage_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Case_Status_UpdateMatter_StatusArgs = {
  filter?: InputMaybe<Catalog_Case_Status_Update_Matter_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_Status_Update_Aggregated = {
  __typename?: 'case_status_update_aggregated';
  avg?: Maybe<Case_Status_Update_Aggregated_Fields>;
  avgDistinct?: Maybe<Case_Status_Update_Aggregated_Fields>;
  count?: Maybe<Case_Status_Update_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Status_Update_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Case_Status_Update_Aggregated_Fields>;
  min?: Maybe<Case_Status_Update_Aggregated_Fields>;
  sum?: Maybe<Case_Status_Update_Aggregated_Fields>;
  sumDistinct?: Maybe<Case_Status_Update_Aggregated_Fields>;
};

export type Case_Status_Update_Aggregated_Count = {
  __typename?: 'case_status_update_aggregated_count';
  actual_settlement_value?: Maybe<Scalars['Int']['output']>;
  case_id?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  created_by?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  estimated_settlement_value?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  matter_stage?: Maybe<Scalars['Int']['output']>;
  matter_status?: Maybe<Scalars['Int']['output']>;
};

export type Case_Status_Update_Aggregated_Fields = {
  __typename?: 'case_status_update_aggregated_fields';
  actual_settlement_value?: Maybe<Scalars['Float']['output']>;
  estimated_settlement_value?: Maybe<Scalars['Float']['output']>;
};

export type Case_Status_Update_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Status_Update_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Status_Update_Filter>>>;
  actual_settlement_value?: InputMaybe<Number_Filter_Operators>;
  case_id?: InputMaybe<Case_Filter>;
  comments?: InputMaybe<String_Filter_Operators>;
  created_by?: InputMaybe<Directus_Users_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  estimated_settlement_value?: InputMaybe<Number_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  matter_stage?: InputMaybe<Catalog_Case_Status_Update_Matter_Stage_Filter>;
  matter_status?: InputMaybe<Catalog_Case_Status_Update_Matter_Status_Filter>;
};

export type Case_Status_Update_Mutated = {
  __typename?: 'case_status_update_mutated';
  data?: Maybe<Case_Status_Update>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Case_Status_Update_Scheduler_Task = {
  __typename?: 'case_status_update_scheduler_task';
  case_id?: Maybe<Case>;
  comment?: Maybe<Scalars['String']['output']>;
  completed: Scalars['Boolean']['output'];
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
};


export type Case_Status_Update_Scheduler_TaskCase_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Case_Status_Update_Scheduler_Task_Aggregated = {
  __typename?: 'case_status_update_scheduler_task_aggregated';
  count?: Maybe<Case_Status_Update_Scheduler_Task_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Case_Status_Update_Scheduler_Task_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Case_Status_Update_Scheduler_Task_Aggregated_Count = {
  __typename?: 'case_status_update_scheduler_task_aggregated_count';
  case_id?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['Int']['output']>;
  completed?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Case_Status_Update_Scheduler_Task_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Case_Status_Update_Scheduler_Task_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Case_Status_Update_Scheduler_Task_Filter>>>;
  case_id?: InputMaybe<Case_Filter>;
  comment?: InputMaybe<String_Filter_Operators>;
  completed?: InputMaybe<Boolean_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
};

export type Case_Status_Update_Scheduler_Task_Mutated = {
  __typename?: 'case_status_update_scheduler_task_mutated';
  data?: Maybe<Case_Status_Update_Scheduler_Task>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Access_Request_Status = {
  __typename?: 'catalog_access_request_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Access_Request_Status_Aggregated = {
  __typename?: 'catalog_access_request_status_aggregated';
  count?: Maybe<Catalog_Access_Request_Status_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Access_Request_Status_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Access_Request_Status_Aggregated_Count = {
  __typename?: 'catalog_access_request_status_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Access_Request_Status_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Access_Request_Status_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Access_Request_Status_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Access_Request_Status_Mutated = {
  __typename?: 'catalog_access_request_status_mutated';
  data?: Maybe<Catalog_Access_Request_Status>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Account_Type = {
  __typename?: 'catalog_account_type';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Account_Type_Aggregated = {
  __typename?: 'catalog_account_type_aggregated';
  count?: Maybe<Catalog_Account_Type_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Account_Type_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Account_Type_Aggregated_Count = {
  __typename?: 'catalog_account_type_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Account_Type_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Account_Type_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Account_Type_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Account_Type_Mutated = {
  __typename?: 'catalog_account_type_mutated';
  data?: Maybe<Catalog_Account_Type>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Activity_Origin = {
  __typename?: 'catalog_activity_origin';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Catalog_Activity_Origin_Aggregated = {
  __typename?: 'catalog_activity_origin_aggregated';
  count?: Maybe<Catalog_Activity_Origin_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Activity_Origin_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Activity_Origin_Aggregated_Count = {
  __typename?: 'catalog_activity_origin_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Activity_Origin_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Activity_Origin_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Activity_Origin_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Activity_Origin_Mutated = {
  __typename?: 'catalog_activity_origin_mutated';
  data?: Maybe<Catalog_Activity_Origin>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Affiliation = {
  __typename?: 'catalog_affiliation';
  badge_image_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_hidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Affiliation_Aggregated = {
  __typename?: 'catalog_affiliation_aggregated';
  avg?: Maybe<Catalog_Affiliation_Aggregated_Fields>;
  avgDistinct?: Maybe<Catalog_Affiliation_Aggregated_Fields>;
  count?: Maybe<Catalog_Affiliation_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Affiliation_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Catalog_Affiliation_Aggregated_Fields>;
  min?: Maybe<Catalog_Affiliation_Aggregated_Fields>;
  sum?: Maybe<Catalog_Affiliation_Aggregated_Fields>;
  sumDistinct?: Maybe<Catalog_Affiliation_Aggregated_Fields>;
};

export type Catalog_Affiliation_Aggregated_Count = {
  __typename?: 'catalog_affiliation_aggregated_count';
  badge_image_url?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_hidden?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Affiliation_Aggregated_Fields = {
  __typename?: 'catalog_affiliation_aggregated_fields';
  priority?: Maybe<Scalars['Float']['output']>;
};

export type Catalog_Affiliation_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Affiliation_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Affiliation_Filter>>>;
  badge_image_url?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  is_hidden?: InputMaybe<Boolean_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  priority?: InputMaybe<Number_Filter_Operators>;
};

export type Catalog_Affiliation_Mutated = {
  __typename?: 'catalog_affiliation_mutated';
  data?: Maybe<Catalog_Affiliation>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Award = {
  __typename?: 'catalog_award';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Award_Aggregated = {
  __typename?: 'catalog_award_aggregated';
  count?: Maybe<Catalog_Award_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Award_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Award_Aggregated_Count = {
  __typename?: 'catalog_award_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Award_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Award_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Award_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Award_Mutated = {
  __typename?: 'catalog_award_mutated';
  data?: Maybe<Catalog_Award>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Case_Alert = {
  __typename?: 'catalog_case_alert';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  position: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type Catalog_Case_Alert_Aggregated = {
  __typename?: 'catalog_case_alert_aggregated';
  count?: Maybe<Catalog_Case_Alert_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Case_Alert_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Case_Alert_Aggregated_Count = {
  __typename?: 'catalog_case_alert_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Case_Alert_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Case_Alert_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Case_Alert_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  message?: InputMaybe<String_Filter_Operators>;
  position?: InputMaybe<String_Filter_Operators>;
  subtitle?: InputMaybe<String_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
  type?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Case_Alert_Mutated = {
  __typename?: 'catalog_case_alert_mutated';
  data?: Maybe<Catalog_Case_Alert>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Case_File_Type = {
  __typename?: 'catalog_case_file_type';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Case_File_Type_Aggregated = {
  __typename?: 'catalog_case_file_type_aggregated';
  count?: Maybe<Catalog_Case_File_Type_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Case_File_Type_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Case_File_Type_Aggregated_Count = {
  __typename?: 'catalog_case_file_type_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Case_File_Type_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Case_File_Type_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Case_File_Type_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Case_File_Type_Mutated = {
  __typename?: 'catalog_case_file_type_mutated';
  data?: Maybe<Catalog_Case_File_Type>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Case_Mp_Preference = {
  __typename?: 'catalog_case_mp_preference';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Case_Mp_Preference_Aggregated = {
  __typename?: 'catalog_case_mp_preference_aggregated';
  count?: Maybe<Catalog_Case_Mp_Preference_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Case_Mp_Preference_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Case_Mp_Preference_Aggregated_Count = {
  __typename?: 'catalog_case_mp_preference_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Case_Mp_Preference_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Case_Mp_Preference_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Case_Mp_Preference_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Case_Mp_Preference_Mutated = {
  __typename?: 'catalog_case_mp_preference_mutated';
  data?: Maybe<Catalog_Case_Mp_Preference>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Case_Mp_Visibility = {
  __typename?: 'catalog_case_mp_visibility';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Case_Mp_Visibility_Aggregated = {
  __typename?: 'catalog_case_mp_visibility_aggregated';
  count?: Maybe<Catalog_Case_Mp_Visibility_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Case_Mp_Visibility_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Case_Mp_Visibility_Aggregated_Count = {
  __typename?: 'catalog_case_mp_visibility_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Case_Mp_Visibility_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Case_Mp_Visibility_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Case_Mp_Visibility_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Case_Mp_Visibility_Mutated = {
  __typename?: 'catalog_case_mp_visibility_mutated';
  data?: Maybe<Catalog_Case_Mp_Visibility>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Case_Purchase_Decline_Reason = {
  __typename?: 'catalog_case_purchase_decline_reason';
  id: Scalars['ID']['output'];
  is_case_relistable?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type Catalog_Case_Purchase_Decline_Reason_Aggregated = {
  __typename?: 'catalog_case_purchase_decline_reason_aggregated';
  count?: Maybe<Catalog_Case_Purchase_Decline_Reason_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Case_Purchase_Decline_Reason_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Case_Purchase_Decline_Reason_Aggregated_Count = {
  __typename?: 'catalog_case_purchase_decline_reason_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  is_case_relistable?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Case_Purchase_Decline_Reason_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Case_Purchase_Decline_Reason_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Case_Purchase_Decline_Reason_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  is_case_relistable?: InputMaybe<Boolean_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Case_Purchase_Decline_Reason_Mutated = {
  __typename?: 'catalog_case_purchase_decline_reason_mutated';
  data?: Maybe<Catalog_Case_Purchase_Decline_Reason>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Case_Purchase_Status = {
  __typename?: 'catalog_case_purchase_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Case_Purchase_Status_Aggregated = {
  __typename?: 'catalog_case_purchase_status_aggregated';
  count?: Maybe<Catalog_Case_Purchase_Status_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Case_Purchase_Status_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Case_Purchase_Status_Aggregated_Count = {
  __typename?: 'catalog_case_purchase_status_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Case_Purchase_Status_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Case_Purchase_Status_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Case_Purchase_Status_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Case_Purchase_Status_Mutated = {
  __typename?: 'catalog_case_purchase_status_mutated';
  data?: Maybe<Catalog_Case_Purchase_Status>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Case_Purchase_Unmatch_Reason = {
  __typename?: 'catalog_case_purchase_unmatch_reason';
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  /** Copy shown in the Unmatch & Repost modal. */
  label: Scalars['String']['output'];
  /** Stable key used in code and Segment (unmatch_reason_key). Do not change once in use. */
  name: Scalars['String']['output'];
  /** When true the seller must type a free-text reason (stored in case_purchase_activity.message). */
  requires_text: Scalars['Boolean']['output'];
  /** Display order in the modal (ascending). */
  sort_order: Scalars['Int']['output'];
};

export type Catalog_Case_Purchase_Unmatch_Reason_Aggregated = {
  __typename?: 'catalog_case_purchase_unmatch_reason_aggregated';
  avg?: Maybe<Catalog_Case_Purchase_Unmatch_Reason_Aggregated_Fields>;
  avgDistinct?: Maybe<Catalog_Case_Purchase_Unmatch_Reason_Aggregated_Fields>;
  count?: Maybe<Catalog_Case_Purchase_Unmatch_Reason_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Case_Purchase_Unmatch_Reason_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Catalog_Case_Purchase_Unmatch_Reason_Aggregated_Fields>;
  min?: Maybe<Catalog_Case_Purchase_Unmatch_Reason_Aggregated_Fields>;
  sum?: Maybe<Catalog_Case_Purchase_Unmatch_Reason_Aggregated_Fields>;
  sumDistinct?: Maybe<Catalog_Case_Purchase_Unmatch_Reason_Aggregated_Fields>;
};

export type Catalog_Case_Purchase_Unmatch_Reason_Aggregated_Count = {
  __typename?: 'catalog_case_purchase_unmatch_reason_aggregated_count';
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Copy shown in the Unmatch & Repost modal. */
  label?: Maybe<Scalars['Int']['output']>;
  /** Stable key used in code and Segment (unmatch_reason_key). Do not change once in use. */
  name?: Maybe<Scalars['Int']['output']>;
  /** When true the seller must type a free-text reason (stored in case_purchase_activity.message). */
  requires_text?: Maybe<Scalars['Int']['output']>;
  /** Display order in the modal (ascending). */
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Case_Purchase_Unmatch_Reason_Aggregated_Fields = {
  __typename?: 'catalog_case_purchase_unmatch_reason_aggregated_fields';
  /** Display order in the modal (ascending). */
  sort_order?: Maybe<Scalars['Float']['output']>;
};

export type Catalog_Case_Purchase_Unmatch_Reason_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Case_Purchase_Unmatch_Reason_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Case_Purchase_Unmatch_Reason_Filter>>>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  label?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  requires_text?: InputMaybe<Boolean_Filter_Operators>;
  sort_order?: InputMaybe<Number_Filter_Operators>;
};

export type Catalog_Case_Purchase_Unmatch_Reason_Mutated = {
  __typename?: 'catalog_case_purchase_unmatch_reason_mutated';
  data?: Maybe<Catalog_Case_Purchase_Unmatch_Reason>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Case_Source = {
  __typename?: 'catalog_case_source';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Catalog_Case_Source_Aggregated = {
  __typename?: 'catalog_case_source_aggregated';
  count?: Maybe<Catalog_Case_Source_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Case_Source_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Case_Source_Aggregated_Count = {
  __typename?: 'catalog_case_source_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Case_Source_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Case_Source_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Case_Source_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Case_Source_Mutated = {
  __typename?: 'catalog_case_source_mutated';
  data?: Maybe<Catalog_Case_Source>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Case_Status_Update_Matter_Stage = {
  __typename?: 'catalog_case_status_update_matter_stage';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Case_Status_Update_Matter_Stage_Aggregated = {
  __typename?: 'catalog_case_status_update_matter_stage_aggregated';
  avg?: Maybe<Catalog_Case_Status_Update_Matter_Stage_Aggregated_Fields>;
  avgDistinct?: Maybe<Catalog_Case_Status_Update_Matter_Stage_Aggregated_Fields>;
  count?: Maybe<Catalog_Case_Status_Update_Matter_Stage_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Case_Status_Update_Matter_Stage_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Catalog_Case_Status_Update_Matter_Stage_Aggregated_Fields>;
  min?: Maybe<Catalog_Case_Status_Update_Matter_Stage_Aggregated_Fields>;
  sum?: Maybe<Catalog_Case_Status_Update_Matter_Stage_Aggregated_Fields>;
  sumDistinct?: Maybe<Catalog_Case_Status_Update_Matter_Stage_Aggregated_Fields>;
};

export type Catalog_Case_Status_Update_Matter_Stage_Aggregated_Count = {
  __typename?: 'catalog_case_status_update_matter_stage_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Case_Status_Update_Matter_Stage_Aggregated_Fields = {
  __typename?: 'catalog_case_status_update_matter_stage_aggregated_fields';
  sort_order?: Maybe<Scalars['Float']['output']>;
};

export type Catalog_Case_Status_Update_Matter_Stage_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Case_Status_Update_Matter_Stage_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Case_Status_Update_Matter_Stage_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  sort_order?: InputMaybe<Number_Filter_Operators>;
};

export type Catalog_Case_Status_Update_Matter_Stage_Mutated = {
  __typename?: 'catalog_case_status_update_matter_stage_mutated';
  data?: Maybe<Catalog_Case_Status_Update_Matter_Stage>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Case_Status_Update_Matter_Status = {
  __typename?: 'catalog_case_status_update_matter_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Case_Status_Update_Matter_Status_Aggregated = {
  __typename?: 'catalog_case_status_update_matter_status_aggregated';
  avg?: Maybe<Catalog_Case_Status_Update_Matter_Status_Aggregated_Fields>;
  avgDistinct?: Maybe<Catalog_Case_Status_Update_Matter_Status_Aggregated_Fields>;
  count?: Maybe<Catalog_Case_Status_Update_Matter_Status_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Case_Status_Update_Matter_Status_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Catalog_Case_Status_Update_Matter_Status_Aggregated_Fields>;
  min?: Maybe<Catalog_Case_Status_Update_Matter_Status_Aggregated_Fields>;
  sum?: Maybe<Catalog_Case_Status_Update_Matter_Status_Aggregated_Fields>;
  sumDistinct?: Maybe<Catalog_Case_Status_Update_Matter_Status_Aggregated_Fields>;
};

export type Catalog_Case_Status_Update_Matter_Status_Aggregated_Count = {
  __typename?: 'catalog_case_status_update_matter_status_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Case_Status_Update_Matter_Status_Aggregated_Fields = {
  __typename?: 'catalog_case_status_update_matter_status_aggregated_fields';
  sort_order?: Maybe<Scalars['Float']['output']>;
};

export type Catalog_Case_Status_Update_Matter_Status_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Case_Status_Update_Matter_Status_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Case_Status_Update_Matter_Status_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  sort_order?: InputMaybe<Number_Filter_Operators>;
};

export type Catalog_Case_Status_Update_Matter_Status_Mutated = {
  __typename?: 'catalog_case_status_update_matter_status_mutated';
  data?: Maybe<Catalog_Case_Status_Update_Matter_Status>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Communication_Preference = {
  __typename?: 'catalog_communication_preference';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Catalog_Communication_Preference_Aggregated = {
  __typename?: 'catalog_communication_preference_aggregated';
  count?: Maybe<Catalog_Communication_Preference_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Communication_Preference_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Communication_Preference_Aggregated_Count = {
  __typename?: 'catalog_communication_preference_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Communication_Preference_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Communication_Preference_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Communication_Preference_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Communication_Preference_Mutated = {
  __typename?: 'catalog_communication_preference_mutated';
  data?: Maybe<Catalog_Communication_Preference>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Community_Expiration_Duration = {
  __typename?: 'catalog_community_expiration_duration';
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Community_Expiration_Duration_Aggregated = {
  __typename?: 'catalog_community_expiration_duration_aggregated';
  avg?: Maybe<Catalog_Community_Expiration_Duration_Aggregated_Fields>;
  avgDistinct?: Maybe<Catalog_Community_Expiration_Duration_Aggregated_Fields>;
  count?: Maybe<Catalog_Community_Expiration_Duration_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Community_Expiration_Duration_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Catalog_Community_Expiration_Duration_Aggregated_Fields>;
  min?: Maybe<Catalog_Community_Expiration_Duration_Aggregated_Fields>;
  sum?: Maybe<Catalog_Community_Expiration_Duration_Aggregated_Fields>;
  sumDistinct?: Maybe<Catalog_Community_Expiration_Duration_Aggregated_Fields>;
};

export type Catalog_Community_Expiration_Duration_Aggregated_Count = {
  __typename?: 'catalog_community_expiration_duration_aggregated_count';
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Community_Expiration_Duration_Aggregated_Fields = {
  __typename?: 'catalog_community_expiration_duration_aggregated_fields';
  duration?: Maybe<Scalars['Float']['output']>;
};

export type Catalog_Community_Expiration_Duration_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Community_Expiration_Duration_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Community_Expiration_Duration_Filter>>>;
  duration?: InputMaybe<Number_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Community_Expiration_Duration_Mutated = {
  __typename?: 'catalog_community_expiration_duration_mutated';
  data?: Maybe<Catalog_Community_Expiration_Duration>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Company_Size = {
  __typename?: 'catalog_company_size';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Company_Size_Aggregated = {
  __typename?: 'catalog_company_size_aggregated';
  avg?: Maybe<Catalog_Company_Size_Aggregated_Fields>;
  avgDistinct?: Maybe<Catalog_Company_Size_Aggregated_Fields>;
  count?: Maybe<Catalog_Company_Size_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Company_Size_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Catalog_Company_Size_Aggregated_Fields>;
  min?: Maybe<Catalog_Company_Size_Aggregated_Fields>;
  sum?: Maybe<Catalog_Company_Size_Aggregated_Fields>;
  sumDistinct?: Maybe<Catalog_Company_Size_Aggregated_Fields>;
};

export type Catalog_Company_Size_Aggregated_Count = {
  __typename?: 'catalog_company_size_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Company_Size_Aggregated_Fields = {
  __typename?: 'catalog_company_size_aggregated_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

export type Catalog_Company_Size_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Company_Size_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Company_Size_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  order?: InputMaybe<Number_Filter_Operators>;
};

export type Catalog_Company_Size_Mutated = {
  __typename?: 'catalog_company_size_mutated';
  data?: Maybe<Catalog_Company_Size>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Contact_Type = {
  __typename?: 'catalog_contact_type';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Contact_Type_Aggregated = {
  __typename?: 'catalog_contact_type_aggregated';
  count?: Maybe<Catalog_Contact_Type_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Contact_Type_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Contact_Type_Aggregated_Count = {
  __typename?: 'catalog_contact_type_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Contact_Type_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Contact_Type_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Contact_Type_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Contact_Type_Mutated = {
  __typename?: 'catalog_contact_type_mutated';
  data?: Maybe<Catalog_Contact_Type>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Credit_Price_Type = {
  __typename?: 'catalog_credit_price_type';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Catalog_Credit_Price_Type_Aggregated = {
  __typename?: 'catalog_credit_price_type_aggregated';
  count?: Maybe<Catalog_Credit_Price_Type_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Credit_Price_Type_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Credit_Price_Type_Aggregated_Count = {
  __typename?: 'catalog_credit_price_type_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Credit_Price_Type_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Credit_Price_Type_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Credit_Price_Type_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Credit_Price_Type_Mutated = {
  __typename?: 'catalog_credit_price_type_mutated';
  data?: Maybe<Catalog_Credit_Price_Type>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Credit_Status = {
  __typename?: 'catalog_credit_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Credit_Status_Aggregated = {
  __typename?: 'catalog_credit_status_aggregated';
  count?: Maybe<Catalog_Credit_Status_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Credit_Status_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Credit_Status_Aggregated_Count = {
  __typename?: 'catalog_credit_status_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Credit_Status_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Credit_Status_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Credit_Status_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Credit_Status_Mutated = {
  __typename?: 'catalog_credit_status_mutated';
  data?: Maybe<Catalog_Credit_Status>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Education_Grade = {
  __typename?: 'catalog_education_grade';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Education_Grade_Aggregated = {
  __typename?: 'catalog_education_grade_aggregated';
  count?: Maybe<Catalog_Education_Grade_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Education_Grade_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Education_Grade_Aggregated_Count = {
  __typename?: 'catalog_education_grade_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Education_Grade_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Education_Grade_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Education_Grade_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Education_Grade_Mutated = {
  __typename?: 'catalog_education_grade_mutated';
  data?: Maybe<Catalog_Education_Grade>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Exempt_Email_Domain = {
  __typename?: 'catalog_exempt_email_domain';
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  domain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Catalog_Exempt_Email_Domain_Aggregated = {
  __typename?: 'catalog_exempt_email_domain_aggregated';
  count?: Maybe<Catalog_Exempt_Email_Domain_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Exempt_Email_Domain_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Exempt_Email_Domain_Aggregated_Count = {
  __typename?: 'catalog_exempt_email_domain_aggregated_count';
  created_ts?: Maybe<Scalars['Int']['output']>;
  domain?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Exempt_Email_Domain_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Exempt_Email_Domain_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Exempt_Email_Domain_Filter>>>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  domain?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Exempt_Email_Domain_Mutated = {
  __typename?: 'catalog_exempt_email_domain_mutated';
  data?: Maybe<Catalog_Exempt_Email_Domain>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Fee = {
  __typename?: 'catalog_fee';
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price_type?: Maybe<Catalog_Credit_Price_Type>;
  stripe_price_id: Scalars['String']['output'];
};


export type Catalog_FeePrice_TypeArgs = {
  filter?: InputMaybe<Catalog_Credit_Price_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Catalog_Fee_Aggregated = {
  __typename?: 'catalog_fee_aggregated';
  avg?: Maybe<Catalog_Fee_Aggregated_Fields>;
  avgDistinct?: Maybe<Catalog_Fee_Aggregated_Fields>;
  count?: Maybe<Catalog_Fee_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Fee_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Catalog_Fee_Aggregated_Fields>;
  min?: Maybe<Catalog_Fee_Aggregated_Fields>;
  sum?: Maybe<Catalog_Fee_Aggregated_Fields>;
  sumDistinct?: Maybe<Catalog_Fee_Aggregated_Fields>;
};

export type Catalog_Fee_Aggregated_Count = {
  __typename?: 'catalog_fee_aggregated_count';
  amount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  price_type?: Maybe<Scalars['Int']['output']>;
  stripe_price_id?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Fee_Aggregated_Fields = {
  __typename?: 'catalog_fee_aggregated_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type Catalog_Fee_Agreement_Status = {
  __typename?: 'catalog_fee_agreement_status';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Catalog_Fee_Agreement_Status_Aggregated = {
  __typename?: 'catalog_fee_agreement_status_aggregated';
  count?: Maybe<Catalog_Fee_Agreement_Status_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Fee_Agreement_Status_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Fee_Agreement_Status_Aggregated_Count = {
  __typename?: 'catalog_fee_agreement_status_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Fee_Agreement_Status_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Fee_Agreement_Status_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Fee_Agreement_Status_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Fee_Agreement_Status_Mutated = {
  __typename?: 'catalog_fee_agreement_status_mutated';
  data?: Maybe<Catalog_Fee_Agreement_Status>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Fee_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Fee_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Fee_Filter>>>;
  amount?: InputMaybe<Number_Filter_Operators>;
  description?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  price_type?: InputMaybe<Catalog_Credit_Price_Type_Filter>;
  stripe_price_id?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Fee_Mutated = {
  __typename?: 'catalog_fee_mutated';
  data?: Maybe<Catalog_Fee>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Financing_Source = {
  __typename?: 'catalog_financing_source';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Financing_Source_Aggregated = {
  __typename?: 'catalog_financing_source_aggregated';
  count?: Maybe<Catalog_Financing_Source_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Financing_Source_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Financing_Source_Aggregated_Count = {
  __typename?: 'catalog_financing_source_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Financing_Source_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Financing_Source_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Financing_Source_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Financing_Source_Mutated = {
  __typename?: 'catalog_financing_source_mutated';
  data?: Maybe<Catalog_Financing_Source>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Firm_Relationship = {
  __typename?: 'catalog_firm_relationship';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Firm_Relationship_Aggregated = {
  __typename?: 'catalog_firm_relationship_aggregated';
  avg?: Maybe<Catalog_Firm_Relationship_Aggregated_Fields>;
  avgDistinct?: Maybe<Catalog_Firm_Relationship_Aggregated_Fields>;
  count?: Maybe<Catalog_Firm_Relationship_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Firm_Relationship_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Catalog_Firm_Relationship_Aggregated_Fields>;
  min?: Maybe<Catalog_Firm_Relationship_Aggregated_Fields>;
  sum?: Maybe<Catalog_Firm_Relationship_Aggregated_Fields>;
  sumDistinct?: Maybe<Catalog_Firm_Relationship_Aggregated_Fields>;
};

export type Catalog_Firm_Relationship_Aggregated_Count = {
  __typename?: 'catalog_firm_relationship_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Firm_Relationship_Aggregated_Fields = {
  __typename?: 'catalog_firm_relationship_aggregated_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

export type Catalog_Firm_Relationship_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Firm_Relationship_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Firm_Relationship_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  order?: InputMaybe<Number_Filter_Operators>;
};

export type Catalog_Firm_Relationship_Mutated = {
  __typename?: 'catalog_firm_relationship_mutated';
  data?: Maybe<Catalog_Firm_Relationship>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Invite_Status = {
  __typename?: 'catalog_invite_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Invite_Status_Aggregated = {
  __typename?: 'catalog_invite_status_aggregated';
  count?: Maybe<Catalog_Invite_Status_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Invite_Status_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Invite_Status_Aggregated_Count = {
  __typename?: 'catalog_invite_status_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Invite_Status_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Invite_Status_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Invite_Status_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Invite_Status_Mutated = {
  __typename?: 'catalog_invite_status_mutated';
  data?: Maybe<Catalog_Invite_Status>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Language = {
  __typename?: 'catalog_language';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Language_Aggregated = {
  __typename?: 'catalog_language_aggregated';
  count?: Maybe<Catalog_Language_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Language_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Language_Aggregated_Count = {
  __typename?: 'catalog_language_aggregated_count';
  code?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Language_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Language_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Language_Filter>>>;
  code?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Language_Mutated = {
  __typename?: 'catalog_language_mutated';
  data?: Maybe<Catalog_Language>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_License_Status = {
  __typename?: 'catalog_license_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_License_Status_Aggregated = {
  __typename?: 'catalog_license_status_aggregated';
  count?: Maybe<Catalog_License_Status_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_License_Status_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_License_Status_Aggregated_Count = {
  __typename?: 'catalog_license_status_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_License_Status_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_License_Status_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_License_Status_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_License_Status_Mutated = {
  __typename?: 'catalog_license_status_mutated';
  data?: Maybe<Catalog_License_Status>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Malpractice_Insurance = {
  __typename?: 'catalog_malpractice_insurance';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Malpractice_Insurance_Aggregated = {
  __typename?: 'catalog_malpractice_insurance_aggregated';
  avg?: Maybe<Catalog_Malpractice_Insurance_Aggregated_Fields>;
  avgDistinct?: Maybe<Catalog_Malpractice_Insurance_Aggregated_Fields>;
  count?: Maybe<Catalog_Malpractice_Insurance_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Malpractice_Insurance_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Catalog_Malpractice_Insurance_Aggregated_Fields>;
  min?: Maybe<Catalog_Malpractice_Insurance_Aggregated_Fields>;
  sum?: Maybe<Catalog_Malpractice_Insurance_Aggregated_Fields>;
  sumDistinct?: Maybe<Catalog_Malpractice_Insurance_Aggregated_Fields>;
};

export type Catalog_Malpractice_Insurance_Aggregated_Count = {
  __typename?: 'catalog_malpractice_insurance_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Malpractice_Insurance_Aggregated_Fields = {
  __typename?: 'catalog_malpractice_insurance_aggregated_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

export type Catalog_Malpractice_Insurance_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Malpractice_Insurance_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Malpractice_Insurance_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  order?: InputMaybe<Number_Filter_Operators>;
};

export type Catalog_Malpractice_Insurance_Mutated = {
  __typename?: 'catalog_malpractice_insurance_mutated';
  data?: Maybe<Catalog_Malpractice_Insurance>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Membership_Type = {
  __typename?: 'catalog_membership_type';
  id: Scalars['ID']['output'];
  is_default?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Membership_Type_Aggregated = {
  __typename?: 'catalog_membership_type_aggregated';
  count?: Maybe<Catalog_Membership_Type_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Membership_Type_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Membership_Type_Aggregated_Count = {
  __typename?: 'catalog_membership_type_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  is_default?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Membership_Type_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Membership_Type_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Membership_Type_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  is_default?: InputMaybe<Boolean_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Membership_Type_Mutated = {
  __typename?: 'catalog_membership_type_mutated';
  data?: Maybe<Catalog_Membership_Type>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Notification_Level = {
  __typename?: 'catalog_notification_level';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Notification_Level_Aggregated = {
  __typename?: 'catalog_notification_level_aggregated';
  avg?: Maybe<Catalog_Notification_Level_Aggregated_Fields>;
  avgDistinct?: Maybe<Catalog_Notification_Level_Aggregated_Fields>;
  count?: Maybe<Catalog_Notification_Level_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Notification_Level_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Catalog_Notification_Level_Aggregated_Fields>;
  min?: Maybe<Catalog_Notification_Level_Aggregated_Fields>;
  sum?: Maybe<Catalog_Notification_Level_Aggregated_Fields>;
  sumDistinct?: Maybe<Catalog_Notification_Level_Aggregated_Fields>;
};

export type Catalog_Notification_Level_Aggregated_Count = {
  __typename?: 'catalog_notification_level_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Notification_Level_Aggregated_Fields = {
  __typename?: 'catalog_notification_level_aggregated_fields';
  sort_order?: Maybe<Scalars['Float']['output']>;
};

export type Catalog_Notification_Level_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Notification_Level_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Notification_Level_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  sort_order?: InputMaybe<Number_Filter_Operators>;
};

export type Catalog_Notification_Level_Mutated = {
  __typename?: 'catalog_notification_level_mutated';
  data?: Maybe<Catalog_Notification_Level>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Oauth_Integration = {
  __typename?: 'catalog_oauth_integration';
  connect_url_envar: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Catalog_Oauth_Integration_Aggregated = {
  __typename?: 'catalog_oauth_integration_aggregated';
  count?: Maybe<Catalog_Oauth_Integration_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Oauth_Integration_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Oauth_Integration_Aggregated_Count = {
  __typename?: 'catalog_oauth_integration_aggregated_count';
  connect_url_envar?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Oauth_Integration_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Oauth_Integration_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Oauth_Integration_Filter>>>;
  connect_url_envar?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Oauth_Integration_Mutated = {
  __typename?: 'catalog_oauth_integration_mutated';
  data?: Maybe<Catalog_Oauth_Integration>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Payment_Method = {
  __typename?: 'catalog_payment_method';
  id: Scalars['ID']['output'];
  is_default?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Payment_Method_Aggregated = {
  __typename?: 'catalog_payment_method_aggregated';
  count?: Maybe<Catalog_Payment_Method_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Payment_Method_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Payment_Method_Aggregated_Count = {
  __typename?: 'catalog_payment_method_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  is_default?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Payment_Method_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Payment_Method_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Payment_Method_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  is_default?: InputMaybe<Boolean_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Payment_Method_Mutated = {
  __typename?: 'catalog_payment_method_mutated';
  data?: Maybe<Catalog_Payment_Method>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Payment_Status = {
  __typename?: 'catalog_payment_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Payment_Status_Aggregated = {
  __typename?: 'catalog_payment_status_aggregated';
  count?: Maybe<Catalog_Payment_Status_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Payment_Status_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Payment_Status_Aggregated_Count = {
  __typename?: 'catalog_payment_status_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Payment_Status_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Payment_Status_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Payment_Status_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Payment_Status_Mutated = {
  __typename?: 'catalog_payment_status_mutated';
  data?: Maybe<Catalog_Payment_Status>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Practice_Area = {
  __typename?: 'catalog_practice_area';
  id: Scalars['ID']['output'];
  is_default?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  practice_area_bundle?: Maybe<Catalog_Practice_Area_Bundle>;
};


export type Catalog_Practice_AreaPractice_Area_BundleArgs = {
  filter?: InputMaybe<Catalog_Practice_Area_Bundle_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Catalog_Practice_Area_Aggregated = {
  __typename?: 'catalog_practice_area_aggregated';
  count?: Maybe<Catalog_Practice_Area_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Practice_Area_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Practice_Area_Aggregated_Count = {
  __typename?: 'catalog_practice_area_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  is_default?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  practice_area_bundle?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Practice_Area_Bundle = {
  __typename?: 'catalog_practice_area_bundle';
  bundle_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Catalog_Practice_Area_Bundle_Aggregated = {
  __typename?: 'catalog_practice_area_bundle_aggregated';
  count?: Maybe<Catalog_Practice_Area_Bundle_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Practice_Area_Bundle_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Practice_Area_Bundle_Aggregated_Count = {
  __typename?: 'catalog_practice_area_bundle_aggregated_count';
  bundle_name?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Practice_Area_Bundle_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Practice_Area_Bundle_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Practice_Area_Bundle_Filter>>>;
  bundle_name?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Practice_Area_Bundle_Mutated = {
  __typename?: 'catalog_practice_area_bundle_mutated';
  data?: Maybe<Catalog_Practice_Area_Bundle>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Practice_Area_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Practice_Area_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Practice_Area_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  is_default?: InputMaybe<Boolean_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  practice_area_bundle?: InputMaybe<Catalog_Practice_Area_Bundle_Filter>;
};

export type Catalog_Practice_Area_Mutated = {
  __typename?: 'catalog_practice_area_mutated';
  data?: Maybe<Catalog_Practice_Area>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Process_Stage = {
  __typename?: 'catalog_process_stage';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Process_Stage_Aggregated = {
  __typename?: 'catalog_process_stage_aggregated';
  avg?: Maybe<Catalog_Process_Stage_Aggregated_Fields>;
  avgDistinct?: Maybe<Catalog_Process_Stage_Aggregated_Fields>;
  count?: Maybe<Catalog_Process_Stage_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Process_Stage_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Catalog_Process_Stage_Aggregated_Fields>;
  min?: Maybe<Catalog_Process_Stage_Aggregated_Fields>;
  sum?: Maybe<Catalog_Process_Stage_Aggregated_Fields>;
  sumDistinct?: Maybe<Catalog_Process_Stage_Aggregated_Fields>;
};

export type Catalog_Process_Stage_Aggregated_Count = {
  __typename?: 'catalog_process_stage_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Process_Stage_Aggregated_Fields = {
  __typename?: 'catalog_process_stage_aggregated_fields';
  sort_order?: Maybe<Scalars['Float']['output']>;
};

export type Catalog_Process_Stage_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Process_Stage_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Process_Stage_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  sort_order?: InputMaybe<Number_Filter_Operators>;
};

export type Catalog_Process_Stage_Mutated = {
  __typename?: 'catalog_process_stage_mutated';
  data?: Maybe<Catalog_Process_Stage>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Referral_Network_List_Item_Status = {
  __typename?: 'catalog_referral_network_list_item_status';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Catalog_Referral_Network_List_Item_Status_Aggregated = {
  __typename?: 'catalog_referral_network_list_item_status_aggregated';
  count?: Maybe<Catalog_Referral_Network_List_Item_Status_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Referral_Network_List_Item_Status_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Referral_Network_List_Item_Status_Aggregated_Count = {
  __typename?: 'catalog_referral_network_list_item_status_aggregated_count';
  description?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Referral_Network_List_Item_Status_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Referral_Network_List_Item_Status_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Referral_Network_List_Item_Status_Filter>>>;
  description?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Referral_Network_List_Item_Status_Mutated = {
  __typename?: 'catalog_referral_network_list_item_status_mutated';
  data?: Maybe<Catalog_Referral_Network_List_Item_Status>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Referral_Network_List_Status = {
  __typename?: 'catalog_referral_network_list_status';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Catalog_Referral_Network_List_Status_Aggregated = {
  __typename?: 'catalog_referral_network_list_status_aggregated';
  count?: Maybe<Catalog_Referral_Network_List_Status_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Referral_Network_List_Status_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Referral_Network_List_Status_Aggregated_Count = {
  __typename?: 'catalog_referral_network_list_status_aggregated_count';
  description?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Referral_Network_List_Status_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Referral_Network_List_Status_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Referral_Network_List_Status_Filter>>>;
  description?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Referral_Network_List_Status_Mutated = {
  __typename?: 'catalog_referral_network_list_status_mutated';
  data?: Maybe<Catalog_Referral_Network_List_Status>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Referral_Network_Type = {
  __typename?: 'catalog_referral_network_type';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Catalog_Referral_Network_Type_Aggregated = {
  __typename?: 'catalog_referral_network_type_aggregated';
  count?: Maybe<Catalog_Referral_Network_Type_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Referral_Network_Type_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Referral_Network_Type_Aggregated_Count = {
  __typename?: 'catalog_referral_network_type_aggregated_count';
  description?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Referral_Network_Type_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Referral_Network_Type_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Referral_Network_Type_Filter>>>;
  description?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Referral_Network_Type_Mutated = {
  __typename?: 'catalog_referral_network_type_mutated';
  data?: Maybe<Catalog_Referral_Network_Type>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Role_Invite = {
  __typename?: 'catalog_role_invite';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Directus_Roles>;
};


export type Catalog_Role_InviteRole_IdArgs = {
  filter?: InputMaybe<Directus_Roles_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Catalog_Role_Invite_Aggregated = {
  __typename?: 'catalog_role_invite_aggregated';
  count?: Maybe<Catalog_Role_Invite_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Role_Invite_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Role_Invite_Aggregated_Count = {
  __typename?: 'catalog_role_invite_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  role_id?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Role_Invite_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Role_Invite_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Role_Invite_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  role_id?: InputMaybe<Directus_Roles_Filter>;
};

export type Catalog_Role_Invite_Mutated = {
  __typename?: 'catalog_role_invite_mutated';
  data?: Maybe<Catalog_Role_Invite>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Sign_Request_Status = {
  __typename?: 'catalog_sign_request_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Sign_Request_Status_Aggregated = {
  __typename?: 'catalog_sign_request_status_aggregated';
  count?: Maybe<Catalog_Sign_Request_Status_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Sign_Request_Status_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Sign_Request_Status_Aggregated_Count = {
  __typename?: 'catalog_sign_request_status_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Sign_Request_Status_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Sign_Request_Status_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Sign_Request_Status_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Sign_Request_Status_Mutated = {
  __typename?: 'catalog_sign_request_status_mutated';
  data?: Maybe<Catalog_Sign_Request_Status>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Time_Unit = {
  __typename?: 'catalog_time_unit';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Time_Unit_Aggregated = {
  __typename?: 'catalog_time_unit_aggregated';
  count?: Maybe<Catalog_Time_Unit_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Time_Unit_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Time_Unit_Aggregated_Count = {
  __typename?: 'catalog_time_unit_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Time_Unit_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Time_Unit_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Time_Unit_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Time_Unit_Mutated = {
  __typename?: 'catalog_time_unit_mutated';
  data?: Maybe<Catalog_Time_Unit>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Us_State = {
  __typename?: 'catalog_us_state';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Us_State_Aggregated = {
  __typename?: 'catalog_us_state_aggregated';
  count?: Maybe<Catalog_Us_State_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Us_State_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Us_State_Aggregated_Count = {
  __typename?: 'catalog_us_state_aggregated_count';
  code?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Us_State_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Us_State_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Us_State_Filter>>>;
  code?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Us_State_Mutated = {
  __typename?: 'catalog_us_state_mutated';
  data?: Maybe<Catalog_Us_State>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Waterfall_Duration = {
  __typename?: 'catalog_waterfall_duration';
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Waterfall_Duration_Aggregated = {
  __typename?: 'catalog_waterfall_duration_aggregated';
  avg?: Maybe<Catalog_Waterfall_Duration_Aggregated_Fields>;
  avgDistinct?: Maybe<Catalog_Waterfall_Duration_Aggregated_Fields>;
  count?: Maybe<Catalog_Waterfall_Duration_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Waterfall_Duration_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Catalog_Waterfall_Duration_Aggregated_Fields>;
  min?: Maybe<Catalog_Waterfall_Duration_Aggregated_Fields>;
  sum?: Maybe<Catalog_Waterfall_Duration_Aggregated_Fields>;
  sumDistinct?: Maybe<Catalog_Waterfall_Duration_Aggregated_Fields>;
};

export type Catalog_Waterfall_Duration_Aggregated_Count = {
  __typename?: 'catalog_waterfall_duration_aggregated_count';
  duration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Waterfall_Duration_Aggregated_Fields = {
  __typename?: 'catalog_waterfall_duration_aggregated_fields';
  duration?: Maybe<Scalars['Float']['output']>;
};

export type Catalog_Waterfall_Duration_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Waterfall_Duration_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Waterfall_Duration_Filter>>>;
  duration?: InputMaybe<Number_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Waterfall_Duration_Mutated = {
  __typename?: 'catalog_waterfall_duration_mutated';
  data?: Maybe<Catalog_Waterfall_Duration>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Waterfall_Status = {
  __typename?: 'catalog_waterfall_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Catalog_Waterfall_Status_Aggregated = {
  __typename?: 'catalog_waterfall_status_aggregated';
  count?: Maybe<Catalog_Waterfall_Status_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Waterfall_Status_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Catalog_Waterfall_Status_Aggregated_Count = {
  __typename?: 'catalog_waterfall_status_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Waterfall_Status_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Waterfall_Status_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Waterfall_Status_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Waterfall_Status_Mutated = {
  __typename?: 'catalog_waterfall_status_mutated';
  data?: Maybe<Catalog_Waterfall_Status>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Years_Practice = {
  __typename?: 'catalog_years_practice';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Years_Practice_Aggregated = {
  __typename?: 'catalog_years_practice_aggregated';
  avg?: Maybe<Catalog_Years_Practice_Aggregated_Fields>;
  avgDistinct?: Maybe<Catalog_Years_Practice_Aggregated_Fields>;
  count?: Maybe<Catalog_Years_Practice_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Years_Practice_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Catalog_Years_Practice_Aggregated_Fields>;
  min?: Maybe<Catalog_Years_Practice_Aggregated_Fields>;
  sum?: Maybe<Catalog_Years_Practice_Aggregated_Fields>;
  sumDistinct?: Maybe<Catalog_Years_Practice_Aggregated_Fields>;
};

export type Catalog_Years_Practice_Aggregated_Count = {
  __typename?: 'catalog_years_practice_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Years_Practice_Aggregated_Fields = {
  __typename?: 'catalog_years_practice_aggregated_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

export type Catalog_Years_Practice_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Years_Practice_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Years_Practice_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  order?: InputMaybe<Number_Filter_Operators>;
};

export type Catalog_Years_Practice_Mutated = {
  __typename?: 'catalog_years_practice_mutated';
  data?: Maybe<Catalog_Years_Practice>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Catalog_Zip_Code = {
  __typename?: 'catalog_zip_code';
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_at_func?: Maybe<Datetime_Functions>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  updated_at_func?: Maybe<Datetime_Functions>;
  zip_code: Scalars['ID']['output'];
};

export type Catalog_Zip_Code_Aggregated = {
  __typename?: 'catalog_zip_code_aggregated';
  avg?: Maybe<Catalog_Zip_Code_Aggregated_Fields>;
  avgDistinct?: Maybe<Catalog_Zip_Code_Aggregated_Fields>;
  count?: Maybe<Catalog_Zip_Code_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Catalog_Zip_Code_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Catalog_Zip_Code_Aggregated_Fields>;
  min?: Maybe<Catalog_Zip_Code_Aggregated_Fields>;
  sum?: Maybe<Catalog_Zip_Code_Aggregated_Fields>;
  sumDistinct?: Maybe<Catalog_Zip_Code_Aggregated_Fields>;
};

export type Catalog_Zip_Code_Aggregated_Count = {
  __typename?: 'catalog_zip_code_aggregated_count';
  city?: Maybe<Scalars['Int']['output']>;
  county?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['Int']['output']>;
  latitude?: Maybe<Scalars['Int']['output']>;
  longitude?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['Int']['output']>;
  timezone?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['Int']['output']>;
  zip_code?: Maybe<Scalars['Int']['output']>;
};

export type Catalog_Zip_Code_Aggregated_Fields = {
  __typename?: 'catalog_zip_code_aggregated_fields';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type Catalog_Zip_Code_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Catalog_Zip_Code_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Catalog_Zip_Code_Filter>>>;
  city?: InputMaybe<String_Filter_Operators>;
  county?: InputMaybe<String_Filter_Operators>;
  created_at?: InputMaybe<Date_Filter_Operators>;
  created_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  latitude?: InputMaybe<Number_Filter_Operators>;
  longitude?: InputMaybe<Number_Filter_Operators>;
  state?: InputMaybe<String_Filter_Operators>;
  timezone?: InputMaybe<String_Filter_Operators>;
  updated_at?: InputMaybe<Date_Filter_Operators>;
  updated_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  zip_code?: InputMaybe<String_Filter_Operators>;
};

export type Catalog_Zip_Code_Mutated = {
  __typename?: 'catalog_zip_code_mutated';
  data?: Maybe<Catalog_Zip_Code>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Config_Lcms_Leaddocket = {
  __typename?: 'config_lcms_leaddocket';
  api_key: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  instance_url: Scalars['String']['output'];
  intake_form_url: Scalars['String']['output'];
  organization_id?: Maybe<Organization>;
};


export type Config_Lcms_LeaddocketOrganization_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Config_Lcms_Leaddocket_Aggregated = {
  __typename?: 'config_lcms_leaddocket_aggregated';
  count?: Maybe<Config_Lcms_Leaddocket_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Config_Lcms_Leaddocket_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Config_Lcms_Leaddocket_Aggregated_Count = {
  __typename?: 'config_lcms_leaddocket_aggregated_count';
  api_key?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  instance_url?: Maybe<Scalars['Int']['output']>;
  intake_form_url?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

export type Config_Lcms_Leaddocket_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Config_Lcms_Leaddocket_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Config_Lcms_Leaddocket_Filter>>>;
  api_key?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  instance_url?: InputMaybe<String_Filter_Operators>;
  intake_form_url?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<Organization_Filter>;
};

export type Config_Lcms_Leaddocket_Mutated = {
  __typename?: 'config_lcms_leaddocket_mutated';
  data?: Maybe<Config_Lcms_Leaddocket>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Count_Function_Filter_Operators = {
  count?: InputMaybe<Number_Filter_Operators>;
};

export type Count_Functions = {
  __typename?: 'count_functions';
  count?: Maybe<Scalars['Int']['output']>;
};

export type Create_Attorney_Case_Mp_Preference_Input = {
  attorney_id?: InputMaybe<Scalars['String']['input']>;
  case_id?: InputMaybe<Scalars['String']['input']>;
  case_mp_preference_id?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Attorney_Favorite_Input = {
  attorney_id?: InputMaybe<Scalars['String']['input']>;
  favorite_attorney_id?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Attorney_Invite_Input = {
  email: Scalars['String']['input'];
  invite_status_id?: InputMaybe<Scalars['String']['input']>;
  target_attorney_id?: InputMaybe<Scalars['String']['input']>;
  target_organization_id?: InputMaybe<Scalars['String']['input']>;
  target_role_id?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Attorney_Oauth_Integration_Input = {
  attorney_id: Scalars['String']['input'];
  code: Scalars['String']['input'];
  integration_id: Scalars['String']['input'];
};

export type Create_Attorney_Profile_Award_Input = {
  attorney_profile_id?: InputMaybe<Scalars['String']['input']>;
  award_id?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Attorney_Profile_Case_Management_Software_Input = {
  attorney_profile_id?: InputMaybe<Scalars['String']['input']>;
  case_management_software_id?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Attorney_Profile_Communication_Preference_Input = {
  attorney_profile_id?: InputMaybe<Scalars['String']['input']>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_email_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_notification_enabled: Scalars['Boolean']['input'];
  is_sms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  notification_level?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Attorney_Profile_Contact_Input = {
  attorney_profile_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type Create_Attorney_Profile_Education_Input = {
  attorney_profile_id?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  school_id?: InputMaybe<Create_School_Input>;
  year_end?: InputMaybe<Scalars['Int']['input']>;
  year_start?: InputMaybe<Scalars['Int']['input']>;
};

export type Create_Attorney_Profile_Firm_Input = {
  address: Scalars['String']['input'];
  attorney_profile_id?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  relationship?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['Int']['input']>;
};

export type Create_Attorney_Profile_Language_Input = {
  attorney_profile_id?: InputMaybe<Scalars['String']['input']>;
  language_id?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Attorney_Profile_License_Input = {
  attorney_profile_id?: InputMaybe<Scalars['String']['input']>;
  bar_number: Scalars['String']['input'];
  has_been_disciplined_by_bar: Scalars['Boolean']['input'];
  has_been_sued_by_malpractice: Scalars['Boolean']['input'];
  insurances?: InputMaybe<Array<InputMaybe<Create_Attorney_Profile_License_Insurance_Input>>>;
  is_license_suspended: Scalars['Boolean']['input'];
  license_state?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Attorney_Profile_License_Insurance_Input = {
  attorney_profile_license_id?: InputMaybe<Create_Attorney_Profile_License_Input>;
  expiration_date?: InputMaybe<Scalars['Date']['input']>;
  insurance_coverage_id: Scalars['String']['input'];
};

export type Create_Attorney_Profile_Notification_Level_Input = {
  attorney_profile_id: Scalars['String']['input'];
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notification_level?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Attorney_Profile_Practice_Area_Input = {
  attorney_profile_id?: InputMaybe<Scalars['String']['input']>;
  practice_area_id?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Attorney_Stripe_Input = {
  attorney_id?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_id?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Attorney_Waterfall_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  attorney_id?: InputMaybe<Scalars['String']['input']>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  current_item_id?: InputMaybe<Create_Case_Purchase_Input>;
  current_item_order?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  item_count?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Array<InputMaybe<Create_Case_Purchase_Input>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Attorney_Waterfall_List_Input = {
  attorney_id?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  is_visible: Scalars['Boolean']['input'];
  items?: InputMaybe<Array<InputMaybe<Create_Attorney_Waterfall_List_Item_Input>>>;
  jurisdictions?: InputMaybe<Array<InputMaybe<Create_Attorney_Waterfall_List_Jdx_Input>>>;
  lcms_enabled: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
  practice_areas?: InputMaybe<Array<InputMaybe<Create_Attorney_Waterfall_List_Pa_Input>>>;
  priority_access_duration?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Attorney_Waterfall_List_Item_Input = {
  attorney_id: Scalars['String']['input'];
  list_order?: InputMaybe<Scalars['Int']['input']>;
  waterfall_list_id?: InputMaybe<Create_Attorney_Waterfall_List_Input>;
};

export type Create_Attorney_Waterfall_List_Jdx_Input = {
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jdx_id: Scalars['String']['input'];
  waterfall_list_id?: InputMaybe<Create_Attorney_Waterfall_List_Input>;
};

export type Create_Attorney_Waterfall_List_Pa_Input = {
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  practice_area_id: Scalars['String']['input'];
  waterfall_list_id?: InputMaybe<Create_Attorney_Waterfall_List_Input>;
};

export type Create_Case_Affiliation_Input = {
  affiliation_id: Scalars['String']['input'];
  case_id?: InputMaybe<Create_Case_Input>;
  created_at?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Create_Case_Fee_Overrides_Input = {
  auto_charge_date?: InputMaybe<Scalars['Date']['input']>;
  auto_charge_days?: InputMaybe<Scalars['Int']['input']>;
  case_id?: InputMaybe<Create_Case_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  expiration_date?: InputMaybe<Scalars['Date']['input']>;
  expiration_days?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  match_fee?: InputMaybe<Scalars['Float']['input']>;
};

export type Create_Case_File_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  case_file_type?: InputMaybe<Scalars['String']['input']>;
  case_id?: InputMaybe<Create_Case_Input>;
  file_id?: InputMaybe<Create_Directus_Files_Input>;
};

export type Create_Case_Input = {
  attorney_id?: InputMaybe<Scalars['String']['input']>;
  case_alias?: InputMaybe<Scalars['String']['input']>;
  case_number?: InputMaybe<Scalars['String']['input']>;
  case_source?: InputMaybe<Scalars['String']['input']>;
  /** Midstream referral: referring firm currently represents this client; contact info withheld from the buyer until shared */
  client_currently_represented?: InputMaybe<Scalars['Boolean']['input']>;
  communities?: InputMaybe<Array<InputMaybe<Create_Case_Affiliation_Input>>>;
  community_exclusive_expires_at?: InputMaybe<Scalars['Date']['input']>;
  created_by_user_id?: InputMaybe<Scalars['String']['input']>;
  data_room_filename?: InputMaybe<Scalars['String']['input']>;
  data_room_filesize?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_formatted?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Array<InputMaybe<Create_Case_File_Input>>>;
  financing_source?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  incident_date?: InputMaybe<Scalars['Date']['input']>;
  internal_case_number?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  leads?: InputMaybe<Array<InputMaybe<Create_Case_Lead_Input>>>;
  mp_visibility?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerships?: InputMaybe<Array<InputMaybe<Create_Case_Ownership_Input>>>;
  preferred_language?: InputMaybe<Scalars['String']['input']>;
  process_stage?: InputMaybe<Scalars['String']['input']>;
  proposal_due_date?: InputMaybe<Scalars['Date']['input']>;
  referral_id_lcms?: InputMaybe<Scalars['String']['input']>;
  reposted_from_case_id?: InputMaybe<Create_Case_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Case_Lead_Contact_Input = {
  case_lead_id?: InputMaybe<Create_Case_Lead_Input>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type Create_Case_Lead_Input = {
  case_id?: InputMaybe<Create_Case_Input>;
  contacts?: InputMaybe<Array<InputMaybe<Create_Case_Lead_Contact_Input>>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Case_Ownership_Input = {
  case_id?: InputMaybe<Create_Case_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Create_Directus_Users_Input>;
};

export type Create_Case_Purchase_Activity_Input = {
  activity_entry_status?: InputMaybe<Scalars['String']['input']>;
  case_purchase_id?: InputMaybe<Create_Case_Purchase_Input>;
  created_by: Scalars['String']['input'];
  created_by_user_id?: InputMaybe<Create_Directus_Users_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  decline_reason_id?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  fee: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  origin_id?: InputMaybe<Scalars['String']['input']>;
  /** ENG-2122: set only on Unmatched activities. */
  unmatch_reason_id?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Case_Purchase_Input = {
  active_ts?: InputMaybe<Scalars['Date']['input']>;
  activity?: InputMaybe<Array<InputMaybe<Create_Case_Purchase_Activity_Input>>>;
  case_id?: InputMaybe<Create_Case_Input>;
  contact_shared_by?: InputMaybe<Create_Directus_Users_Input>;
  /** When client contact info was shared with the buyer */
  contact_shared_ts?: InputMaybe<Scalars['Date']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  created_by_user_id?: InputMaybe<Create_Directus_Users_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  fee_agreement_status?: InputMaybe<Scalars['String']['input']>;
  fee_agreement_status_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  in_progress_by?: InputMaybe<Create_Directus_Users_Input>;
  in_progress_ts?: InputMaybe<Scalars['Date']['input']>;
  is_in_progress?: InputMaybe<Scalars['Boolean']['input']>;
  ownerships?: InputMaybe<Array<InputMaybe<Create_Case_Purchase_Ownership_Input>>>;
  payments?: InputMaybe<Array<InputMaybe<Create_Case_Purchase_Payment_Input>>>;
  prospect_attorney_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_ts?: InputMaybe<Scalars['Date']['input']>;
  time_unit?: InputMaybe<Scalars['String']['input']>;
  timed_access_limit?: InputMaybe<Scalars['Int']['input']>;
  waterfall_id?: InputMaybe<Create_Attorney_Waterfall_Input>;
  waterfall_order?: InputMaybe<Scalars['Int']['input']>;
};

export type Create_Case_Purchase_Ownership_Input = {
  case_purchase_id?: InputMaybe<Create_Case_Purchase_Input>;
  id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Create_Directus_Users_Input>;
};

export type Create_Case_Purchase_Payment_Input = {
  amount: Scalars['Float']['input'];
  amount_audit?: InputMaybe<Scalars['JSON']['input']>;
  attorney_id?: InputMaybe<Scalars['String']['input']>;
  case_purchase_id?: InputMaybe<Create_Case_Purchase_Input>;
  created_by_user_id?: InputMaybe<Create_Directus_Users_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  hosted_invoice_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<Scalars['String']['input']>;
  payment_status_id?: InputMaybe<Scalars['String']['input']>;
  stripe_invoice_id?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Case_Status_Update_Input = {
  actual_settlement_value?: InputMaybe<Scalars['Float']['input']>;
  case_id: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Create_Directus_Users_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  estimated_settlement_value?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  matter_stage: Scalars['String']['input'];
  matter_status: Scalars['String']['input'];
};

export type Create_Case_Status_Update_Scheduler_Task_Input = {
  case_id?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  completed: Scalars['Boolean']['input'];
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Create_Config_Lcms_Leaddocket_Input = {
  api_key: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  instance_url: Scalars['String']['input'];
  intake_form_url: Scalars['String']['input'];
  organization_id?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Directus_Files_Input = {
  charset?: InputMaybe<Scalars['String']['input']>;
  created_on?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  embed?: InputMaybe<Scalars['String']['input']>;
  filename_disk?: InputMaybe<Scalars['String']['input']>;
  filename_download: Scalars['String']['input'];
  filesize?: InputMaybe<Scalars['GraphQLBigInt']['input']>;
  focal_point_x?: InputMaybe<Scalars['Int']['input']>;
  focal_point_y?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Create_Directus_Folders_Input>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  modified_by?: InputMaybe<Create_Directus_Users_Input>;
  modified_on?: InputMaybe<Scalars['Date']['input']>;
  storage: Scalars['String']['input'];
  tags?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tus_data?: InputMaybe<Scalars['JSON']['input']>;
  tus_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uploaded_by?: InputMaybe<Create_Directus_Users_Input>;
  uploaded_on?: InputMaybe<Scalars['Date']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type Create_Directus_Folders_Input = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  parent?: InputMaybe<Create_Directus_Folders_Input>;
};

export type Create_Directus_Users_Input = {
  appearance?: InputMaybe<Scalars['String']['input']>;
  auth_data?: InputMaybe<Scalars['JSON']['input']>;
  avatar?: InputMaybe<Create_Directus_Files_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_notifications?: InputMaybe<Scalars['Boolean']['input']>;
  external_identifier?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_access?: InputMaybe<Scalars['Date']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_page?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  own_cases?: InputMaybe<Array<InputMaybe<Create_Case_Ownership_Input>>>;
  password?: InputMaybe<Scalars['Hash']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['JSON']['input']>;
  tfa_secret?: InputMaybe<Scalars['Hash']['input']>;
  theme_dark?: InputMaybe<Scalars['String']['input']>;
  theme_dark_overrides?: InputMaybe<Scalars['JSON']['input']>;
  theme_light?: InputMaybe<Scalars['String']['input']>;
  theme_light_overrides?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['Hash']['input']>;
};

export type Create_Filter_Redundant_Input = {
  /** Dimension: affiliation name or *. */
  affiliations_id?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: community name or *. */
  communities_id?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: firm name or *. */
  created_by_firm_id?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: created by user name or *. */
  created_by_user_id?: InputMaybe<Scalars['String']['input']>;
  /** FK to saved_filters. */
  filter_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Dimension: market_fit or *. */
  market_fit?: InputMaybe<Scalars['String']['input']>;
  /** Email of user for saved_filters.on_behalf_of. */
  on_behalf_of_email?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: practice area or *. */
  practice_area_id?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: process stage or *. */
  process_stage_id?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: state name or *. */
  us_state_id?: InputMaybe<Scalars['String']['input']>;
  /** Email of saved_filters.user_id. */
  user_email?: InputMaybe<Scalars['String']['input']>;
  /** Organization id of filter owner from organization_user. */
  user_organization_id?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: zip code or *. */
  zip_code?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: city zip or *. */
  zip_code_city_zip_code?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: "County, ST" or *. */
  zip_code_county?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Lcms_Case_Mapping_Input = {
  case_id?: InputMaybe<Scalars['ID']['input']>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  lcms_case_id?: InputMaybe<Scalars['String']['input']>;
  lcms_id?: InputMaybe<Scalars['String']['input']>;
  lcms_lead_id?: InputMaybe<Scalars['String']['input']>;
  lcms_opportunity_id?: InputMaybe<Scalars['String']['input']>;
  updated_ts?: InputMaybe<Scalars['Date']['input']>;
};

export type Create_Lcms_Health_Check_Input = {
  health_check_timestamp: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  lcms_config_id?: InputMaybe<Scalars['String']['input']>;
  lcms_health: Scalars['Boolean']['input'];
  lcms_health_http_status_code: Scalars['Int']['input'];
  org_id?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Network_User_Invite_Input = {
  completed_ts?: InputMaybe<Scalars['Date']['input']>;
  completed_user_id?: InputMaybe<Create_Directus_Users_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  last_name: Scalars['String']['input'];
  send_ts?: InputMaybe<Scalars['Date']['input']>;
  sender_user_id?: InputMaybe<Create_Directus_Users_Input>;
};

export type Create_Organization_Block_Input = {
  blocked_org_id?: InputMaybe<Scalars['String']['input']>;
  blocking_org_id?: InputMaybe<Scalars['String']['input']>;
  created_by_user_id?: InputMaybe<Create_Directus_Users_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Create_Organization_Connected_Lcms_Input = {
  case_management_software_id?: InputMaybe<Scalars['String']['input']>;
  config_id?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Create_Directus_Users_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organization_id?: InputMaybe<Scalars['String']['input']>;
};

export type Create_Organization_Referral_Settings_Input = {
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  default_referral_fee?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organization_id: Scalars['String']['input'];
  referral_text?: InputMaybe<Scalars['String']['input']>;
  updated_ts?: InputMaybe<Scalars['Date']['input']>;
};

export type Create_Practice_Attorney_Mapping_Input = {
  attorney_id: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  jurisdiction_id?: InputMaybe<Scalars['String']['input']>;
  organization_id: Scalars['String']['input'];
  practice_area_id?: InputMaybe<Scalars['String']['input']>;
};

export type Create_School_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Create_User_File_Access_Request_Input = {
  attorney_id?: InputMaybe<Scalars['String']['input']>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_granted?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  requested_by_user_id?: InputMaybe<Create_Directus_Users_Input>;
  requested_case_id?: InputMaybe<Create_Case_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type Date_Filter_Operators = {
  _between?: InputMaybe<Array<InputMaybe<Scalars['GraphQLStringOrFloat']['input']>>>;
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _nbetween?: InputMaybe<Array<InputMaybe<Scalars['GraphQLStringOrFloat']['input']>>>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _nnull?: InputMaybe<Scalars['Boolean']['input']>;
  _null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Date_Function_Filter_Operators = {
  day?: InputMaybe<Number_Filter_Operators>;
  month?: InputMaybe<Number_Filter_Operators>;
  week?: InputMaybe<Number_Filter_Operators>;
  weekday?: InputMaybe<Number_Filter_Operators>;
  year?: InputMaybe<Number_Filter_Operators>;
};

export type Date_Functions = {
  __typename?: 'date_functions';
  day?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
  weekday?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type Datetime_Function_Filter_Operators = {
  day?: InputMaybe<Number_Filter_Operators>;
  hour?: InputMaybe<Number_Filter_Operators>;
  minute?: InputMaybe<Number_Filter_Operators>;
  month?: InputMaybe<Number_Filter_Operators>;
  second?: InputMaybe<Number_Filter_Operators>;
  week?: InputMaybe<Number_Filter_Operators>;
  weekday?: InputMaybe<Number_Filter_Operators>;
  year?: InputMaybe<Number_Filter_Operators>;
};

export type Datetime_Functions = {
  __typename?: 'datetime_functions';
  day?: Maybe<Scalars['Int']['output']>;
  hour?: Maybe<Scalars['Int']['output']>;
  minute?: Maybe<Scalars['Int']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  second?: Maybe<Scalars['Int']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
  weekday?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type Delete_Many = {
  __typename?: 'delete_many';
  ids: Array<Maybe<Scalars['ID']['output']>>;
};

export type Delete_One = {
  __typename?: 'delete_one';
  id: Scalars['ID']['output'];
};

export type Directus_Dashboards = {
  __typename?: 'directus_dashboards';
  color?: Maybe<Scalars['String']['output']>;
  date_created?: Maybe<Scalars['Date']['output']>;
  date_created_func?: Maybe<Datetime_Functions>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  panels?: Maybe<Array<Maybe<Directus_Panels>>>;
  panels_func?: Maybe<Count_Functions>;
  user_created?: Maybe<Directus_Users>;
};


export type Directus_DashboardsPanelsArgs = {
  filter?: InputMaybe<Directus_Panels_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Directus_DashboardsUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Directus_Dashboards_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Directus_Dashboards_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Directus_Dashboards_Filter>>>;
  color?: InputMaybe<String_Filter_Operators>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  icon?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  note?: InputMaybe<String_Filter_Operators>;
  panels?: InputMaybe<Directus_Panels_Filter>;
  panels_func?: InputMaybe<Count_Function_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
};

export type Directus_Dashboards_Mutated = {
  __typename?: 'directus_dashboards_mutated';
  data?: Maybe<Directus_Dashboards>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Directus_Files = {
  __typename?: 'directus_files';
  allowed_users?: Maybe<Array<Maybe<User_Allowed_File>>>;
  allowed_users_func?: Maybe<Count_Functions>;
  charset?: Maybe<Scalars['String']['output']>;
  created_on?: Maybe<Scalars['Date']['output']>;
  created_on_func?: Maybe<Datetime_Functions>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  embed?: Maybe<Scalars['String']['output']>;
  filename_disk?: Maybe<Scalars['String']['output']>;
  filename_download: Scalars['String']['output'];
  filesize?: Maybe<Scalars['GraphQLBigInt']['output']>;
  focal_point_x?: Maybe<Scalars['Int']['output']>;
  focal_point_y?: Maybe<Scalars['Int']['output']>;
  folder?: Maybe<Directus_Folders>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  metadata_func?: Maybe<Count_Functions>;
  modified_by?: Maybe<Directus_Users>;
  modified_on?: Maybe<Scalars['Date']['output']>;
  modified_on_func?: Maybe<Datetime_Functions>;
  storage: Scalars['String']['output'];
  tags?: Maybe<Scalars['JSON']['output']>;
  tags_func?: Maybe<Count_Functions>;
  title?: Maybe<Scalars['String']['output']>;
  tus_data?: Maybe<Scalars['JSON']['output']>;
  tus_data_func?: Maybe<Count_Functions>;
  tus_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uploaded_by?: Maybe<Directus_Users>;
  uploaded_on?: Maybe<Scalars['Date']['output']>;
  uploaded_on_func?: Maybe<Datetime_Functions>;
  width?: Maybe<Scalars['Int']['output']>;
};


export type Directus_FilesAllowed_UsersArgs = {
  filter?: InputMaybe<User_Allowed_File_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Directus_FilesFolderArgs = {
  filter?: InputMaybe<Directus_Folders_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Directus_FilesModified_ByArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Directus_FilesUploaded_ByArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Directus_Files_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Directus_Files_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Directus_Files_Filter>>>;
  allowed_users?: InputMaybe<User_Allowed_File_Filter>;
  allowed_users_func?: InputMaybe<Count_Function_Filter_Operators>;
  charset?: InputMaybe<String_Filter_Operators>;
  created_on?: InputMaybe<Date_Filter_Operators>;
  created_on_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  description?: InputMaybe<String_Filter_Operators>;
  duration?: InputMaybe<Number_Filter_Operators>;
  embed?: InputMaybe<String_Filter_Operators>;
  filename_disk?: InputMaybe<String_Filter_Operators>;
  filename_download?: InputMaybe<String_Filter_Operators>;
  filesize?: InputMaybe<Big_Int_Filter_Operators>;
  focal_point_x?: InputMaybe<Number_Filter_Operators>;
  focal_point_y?: InputMaybe<Number_Filter_Operators>;
  folder?: InputMaybe<Directus_Folders_Filter>;
  height?: InputMaybe<Number_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  location?: InputMaybe<String_Filter_Operators>;
  metadata?: InputMaybe<String_Filter_Operators>;
  metadata_func?: InputMaybe<Count_Function_Filter_Operators>;
  modified_by?: InputMaybe<Directus_Users_Filter>;
  modified_on?: InputMaybe<Date_Filter_Operators>;
  modified_on_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  storage?: InputMaybe<String_Filter_Operators>;
  tags?: InputMaybe<String_Filter_Operators>;
  tags_func?: InputMaybe<Count_Function_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
  tus_data?: InputMaybe<String_Filter_Operators>;
  tus_data_func?: InputMaybe<Count_Function_Filter_Operators>;
  tus_id?: InputMaybe<String_Filter_Operators>;
  type?: InputMaybe<String_Filter_Operators>;
  uploaded_by?: InputMaybe<Directus_Users_Filter>;
  uploaded_on?: InputMaybe<Date_Filter_Operators>;
  uploaded_on_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  width?: InputMaybe<Number_Filter_Operators>;
};

export type Directus_Files_Mutated = {
  __typename?: 'directus_files_mutated';
  data?: Maybe<Directus_Files>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Directus_Flows = {
  __typename?: 'directus_flows';
  color?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Scalars['JSON']['output']>;
  options_func?: Maybe<Count_Functions>;
  trigger?: Maybe<Scalars['String']['output']>;
};

export type Directus_Flows_Mutated = {
  __typename?: 'directus_flows_mutated';
  data?: Maybe<Directus_Flows>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Directus_Folders = {
  __typename?: 'directus_folders';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Directus_Folders>;
};


export type Directus_FoldersParentArgs = {
  filter?: InputMaybe<Directus_Folders_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Directus_Folders_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Directus_Folders_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Directus_Folders_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  parent?: InputMaybe<Directus_Folders_Filter>;
};

export type Directus_Folders_Mutated = {
  __typename?: 'directus_folders_mutated';
  data?: Maybe<Directus_Folders>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Directus_Panels = {
  __typename?: 'directus_panels';
  color?: Maybe<Scalars['String']['output']>;
  dashboard?: Maybe<Directus_Dashboards>;
  date_created?: Maybe<Scalars['Date']['output']>;
  date_created_func?: Maybe<Datetime_Functions>;
  height: Scalars['Int']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Scalars['JSON']['output']>;
  options_func?: Maybe<Count_Functions>;
  position_x: Scalars['Int']['output'];
  position_y: Scalars['Int']['output'];
  show_header: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  user_created?: Maybe<Directus_Users>;
  width: Scalars['Int']['output'];
};


export type Directus_PanelsDashboardArgs = {
  filter?: InputMaybe<Directus_Dashboards_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Directus_PanelsUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Directus_Panels_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Directus_Panels_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Directus_Panels_Filter>>>;
  color?: InputMaybe<String_Filter_Operators>;
  dashboard?: InputMaybe<Directus_Dashboards_Filter>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  height?: InputMaybe<Number_Filter_Operators>;
  icon?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  note?: InputMaybe<String_Filter_Operators>;
  options?: InputMaybe<String_Filter_Operators>;
  options_func?: InputMaybe<Count_Function_Filter_Operators>;
  position_x?: InputMaybe<Number_Filter_Operators>;
  position_y?: InputMaybe<Number_Filter_Operators>;
  show_header?: InputMaybe<Boolean_Filter_Operators>;
  type?: InputMaybe<String_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  width?: InputMaybe<Number_Filter_Operators>;
};

export type Directus_Panels_Mutated = {
  __typename?: 'directus_panels_mutated';
  data?: Maybe<Directus_Panels>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Directus_Roles = {
  __typename?: 'directus_roles';
  admin_access: Scalars['Boolean']['output'];
  app_access?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enforce_tfa: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ip_access?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  users?: Maybe<Array<Maybe<Directus_Users>>>;
  users_func?: Maybe<Count_Functions>;
};


export type Directus_RolesUsersArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Directus_Roles_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Directus_Roles_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Directus_Roles_Filter>>>;
  admin_access?: InputMaybe<Boolean_Filter_Operators>;
  app_access?: InputMaybe<Boolean_Filter_Operators>;
  description?: InputMaybe<String_Filter_Operators>;
  enforce_tfa?: InputMaybe<Boolean_Filter_Operators>;
  icon?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  ip_access?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  users?: InputMaybe<Directus_Users_Filter>;
  users_func?: InputMaybe<Count_Function_Filter_Operators>;
};

export type Directus_Roles_Mutated = {
  __typename?: 'directus_roles_mutated';
  data?: Maybe<Directus_Roles>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Directus_Shares = {
  __typename?: 'directus_shares';
  collection: Scalars['String']['output'];
  date_created?: Maybe<Scalars['Date']['output']>;
  date_created_func?: Maybe<Datetime_Functions>;
  /** $t:shared_leave_blank_for_unlimited */
  date_end?: Maybe<Scalars['Date']['output']>;
  date_end_func?: Maybe<Datetime_Functions>;
  /** $t:shared_leave_blank_for_unlimited */
  date_start?: Maybe<Scalars['Date']['output']>;
  date_start_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  item: Scalars['String']['output'];
  /** $t:shared_leave_blank_for_unlimited */
  max_uses?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** $t:shared_leave_blank_for_passwordless_access */
  password?: Maybe<Scalars['Hash']['output']>;
  role?: Maybe<Directus_Roles>;
  times_used?: Maybe<Scalars['Int']['output']>;
  user_created?: Maybe<Directus_Users>;
};


export type Directus_SharesRoleArgs = {
  filter?: InputMaybe<Directus_Roles_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Directus_SharesUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Directus_Shares_Mutated = {
  __typename?: 'directus_shares_mutated';
  data?: Maybe<Directus_Shares>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Directus_Users = {
  __typename?: 'directus_users';
  account_type?: Maybe<Array<Maybe<User_Account_Type>>>;
  account_type_func?: Maybe<Count_Functions>;
  allowed_files?: Maybe<Array<Maybe<User_Allowed_File>>>;
  allowed_files_func?: Maybe<Count_Functions>;
  appearance?: Maybe<Scalars['String']['output']>;
  attorneys?: Maybe<Array<Maybe<Attorney>>>;
  attorneys_func?: Maybe<Count_Functions>;
  auth_data?: Maybe<Scalars['JSON']['output']>;
  auth_data_func?: Maybe<Count_Functions>;
  avatar?: Maybe<Directus_Files>;
  created_organization?: Maybe<Array<Maybe<Organization>>>;
  created_organization_func?: Maybe<Count_Functions>;
  current_organization?: Maybe<Array<Maybe<Organization_User>>>;
  current_organization_func?: Maybe<Count_Functions>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_notifications?: Maybe<Scalars['Boolean']['output']>;
  external_identifier?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  last_access?: Maybe<Scalars['Date']['output']>;
  last_access_func?: Maybe<Datetime_Functions>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_page?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  own_cases?: Maybe<Array<Maybe<Case_Ownership>>>;
  own_cases_func?: Maybe<Count_Functions>;
  password?: Maybe<Scalars['Hash']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Directus_Roles>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['JSON']['output']>;
  tags_func?: Maybe<Count_Functions>;
  tfa_secret?: Maybe<Scalars['Hash']['output']>;
  theme_dark?: Maybe<Scalars['String']['output']>;
  theme_dark_overrides?: Maybe<Scalars['JSON']['output']>;
  theme_dark_overrides_func?: Maybe<Count_Functions>;
  theme_light?: Maybe<Scalars['String']['output']>;
  theme_light_overrides?: Maybe<Scalars['JSON']['output']>;
  theme_light_overrides_func?: Maybe<Count_Functions>;
  title?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['Hash']['output']>;
};


export type Directus_UsersAccount_TypeArgs = {
  filter?: InputMaybe<User_Account_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Directus_UsersAllowed_FilesArgs = {
  filter?: InputMaybe<User_Allowed_File_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Directus_UsersAttorneysArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Directus_UsersAvatarArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Directus_UsersCreated_OrganizationArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Directus_UsersCurrent_OrganizationArgs = {
  filter?: InputMaybe<Organization_User_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Directus_UsersOwn_CasesArgs = {
  filter?: InputMaybe<Case_Ownership_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Directus_UsersRoleArgs = {
  filter?: InputMaybe<Directus_Roles_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Directus_Users_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Directus_Users_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Directus_Users_Filter>>>;
  account_type?: InputMaybe<User_Account_Type_Filter>;
  account_type_func?: InputMaybe<Count_Function_Filter_Operators>;
  allowed_files?: InputMaybe<User_Allowed_File_Filter>;
  allowed_files_func?: InputMaybe<Count_Function_Filter_Operators>;
  appearance?: InputMaybe<String_Filter_Operators>;
  attorneys?: InputMaybe<Attorney_Filter>;
  attorneys_func?: InputMaybe<Count_Function_Filter_Operators>;
  auth_data?: InputMaybe<String_Filter_Operators>;
  auth_data_func?: InputMaybe<Count_Function_Filter_Operators>;
  avatar?: InputMaybe<Directus_Files_Filter>;
  created_organization?: InputMaybe<Organization_Filter>;
  created_organization_func?: InputMaybe<Count_Function_Filter_Operators>;
  current_organization?: InputMaybe<Organization_User_Filter>;
  current_organization_func?: InputMaybe<Count_Function_Filter_Operators>;
  description?: InputMaybe<String_Filter_Operators>;
  email?: InputMaybe<String_Filter_Operators>;
  email_notifications?: InputMaybe<Boolean_Filter_Operators>;
  external_identifier?: InputMaybe<String_Filter_Operators>;
  first_name?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  language?: InputMaybe<String_Filter_Operators>;
  last_access?: InputMaybe<Date_Filter_Operators>;
  last_access_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  last_name?: InputMaybe<String_Filter_Operators>;
  last_page?: InputMaybe<String_Filter_Operators>;
  location?: InputMaybe<String_Filter_Operators>;
  own_cases?: InputMaybe<Case_Ownership_Filter>;
  own_cases_func?: InputMaybe<Count_Function_Filter_Operators>;
  password?: InputMaybe<Hash_Filter_Operators>;
  provider?: InputMaybe<String_Filter_Operators>;
  role?: InputMaybe<Directus_Roles_Filter>;
  status?: InputMaybe<String_Filter_Operators>;
  tags?: InputMaybe<String_Filter_Operators>;
  tags_func?: InputMaybe<Count_Function_Filter_Operators>;
  tfa_secret?: InputMaybe<Hash_Filter_Operators>;
  theme_dark?: InputMaybe<String_Filter_Operators>;
  theme_dark_overrides?: InputMaybe<String_Filter_Operators>;
  theme_dark_overrides_func?: InputMaybe<Count_Function_Filter_Operators>;
  theme_light?: InputMaybe<String_Filter_Operators>;
  theme_light_overrides?: InputMaybe<String_Filter_Operators>;
  theme_light_overrides_func?: InputMaybe<Count_Function_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
  token?: InputMaybe<Hash_Filter_Operators>;
};

export type Directus_Users_Mutated = {
  __typename?: 'directus_users_mutated';
  data?: Maybe<Directus_Users>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Dismissed_Invite_Suggestions = {
  __typename?: 'dismissed_invite_suggestions';
  attorney_id?: Maybe<Attorney>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  dismissed_by_user_id?: Maybe<Directus_Users>;
  id: Scalars['ID']['output'];
  organization_id?: Maybe<Organization>;
};


export type Dismissed_Invite_SuggestionsAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Dismissed_Invite_SuggestionsDismissed_By_User_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Dismissed_Invite_SuggestionsOrganization_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Dismissed_Invite_Suggestions_Aggregated = {
  __typename?: 'dismissed_invite_suggestions_aggregated';
  count?: Maybe<Dismissed_Invite_Suggestions_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Dismissed_Invite_Suggestions_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Dismissed_Invite_Suggestions_Aggregated_Count = {
  __typename?: 'dismissed_invite_suggestions_aggregated_count';
  attorney_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  dismissed_by_user_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

export type Dismissed_Invite_Suggestions_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Dismissed_Invite_Suggestions_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Dismissed_Invite_Suggestions_Filter>>>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  dismissed_by_user_id?: InputMaybe<Directus_Users_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<Organization_Filter>;
};

export type Dismissed_Invite_Suggestions_Mutated = {
  __typename?: 'dismissed_invite_suggestions_mutated';
  data?: Maybe<Dismissed_Invite_Suggestions>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Fct_Affiliation_Members = {
  __typename?: 'fct_affiliation_members';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  affiliation?: Maybe<Scalars['String']['output']>;
  affiliation_id?: Maybe<Scalars['String']['output']>;
  attorney_id?: Maybe<Scalars['String']['output']>;
  bar_license_number?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  member_id: Scalars['ID']['output'];
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  phone_number?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type Fct_Affiliation_Members_Aggregated = {
  __typename?: 'fct_affiliation_members_aggregated';
  count?: Maybe<Fct_Affiliation_Members_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Fct_Affiliation_Members_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Fct_Affiliation_Members_Aggregated_Count = {
  __typename?: 'fct_affiliation_members_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  affiliation?: Maybe<Scalars['Int']['output']>;
  affiliation_id?: Maybe<Scalars['Int']['output']>;
  attorney_id?: Maybe<Scalars['Int']['output']>;
  bar_license_number?: Maybe<Scalars['Int']['output']>;
  email_address?: Maybe<Scalars['Int']['output']>;
  first_name?: Maybe<Scalars['Int']['output']>;
  jurisdiction?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['Int']['output']>;
  member_id?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  phone_number?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type Fct_Affiliation_Members_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Fct_Affiliation_Members_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Fct_Affiliation_Members_Filter>>>;
  affiliation?: InputMaybe<String_Filter_Operators>;
  affiliation_id?: InputMaybe<String_Filter_Operators>;
  attorney_id?: InputMaybe<String_Filter_Operators>;
  bar_license_number?: InputMaybe<String_Filter_Operators>;
  email_address?: InputMaybe<String_Filter_Operators>;
  first_name?: InputMaybe<String_Filter_Operators>;
  jurisdiction?: InputMaybe<String_Filter_Operators>;
  last_name?: InputMaybe<String_Filter_Operators>;
  member_id?: InputMaybe<String_Filter_Operators>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  phone_number?: InputMaybe<String_Filter_Operators>;
  user_id?: InputMaybe<String_Filter_Operators>;
};

export type Fct_Affiliation_Members_Mutated = {
  __typename?: 'fct_affiliation_members_mutated';
  data?: Maybe<Fct_Affiliation_Members>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Filter_Daily_Digest_Pending = {
  __typename?: 'filter_daily_digest_pending';
  /** Matched case ID */
  case_id?: Maybe<Scalars['String']['output']>;
  /** Jurisdiction name */
  case_jurisdiction?: Maybe<Scalars['String']['output']>;
  /** Direct link to case */
  case_link: Scalars['String']['output'];
  /** Case name snapshot */
  case_name: Scalars['String']['output'];
  /** Practice area name */
  case_type?: Maybe<Scalars['String']['output']>;
  /** When the pending row was created */
  created_at?: Maybe<Scalars['Date']['output']>;
  created_at_func?: Maybe<Datetime_Functions>;
  /** Asking fee */
  fee?: Maybe<Scalars['Int']['output']>;
  filter_id?: Maybe<Saved_Filters>;
  /** Filter name at time of match */
  filter_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** On-behalf-of email */
  on_behalf_of_email?: Maybe<Scalars['String']['output']>;
  /** Seller organization ID */
  organization_id?: Maybe<Scalars['String']['output']>;
  /** Seller organization name */
  organization_name?: Maybe<Scalars['String']['output']>;
  /** Seller first name */
  seller_first_name?: Maybe<Scalars['String']['output']>;
  /** Seller last name */
  seller_last_name?: Maybe<Scalars['String']['output']>;
  /** When the digest was sent (NULL = pending) */
  sent_at?: Maybe<Scalars['Date']['output']>;
  sent_at_func?: Maybe<Datetime_Functions>;
  /** Recipient email */
  user_email: Scalars['String']['output'];
};


export type Filter_Daily_Digest_PendingFilter_IdArgs = {
  filter?: InputMaybe<Saved_Filters_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Filter_Daily_Digest_Pending_Aggregated = {
  __typename?: 'filter_daily_digest_pending_aggregated';
  avg?: Maybe<Filter_Daily_Digest_Pending_Aggregated_Fields>;
  avgDistinct?: Maybe<Filter_Daily_Digest_Pending_Aggregated_Fields>;
  count?: Maybe<Filter_Daily_Digest_Pending_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Filter_Daily_Digest_Pending_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Filter_Daily_Digest_Pending_Aggregated_Fields>;
  min?: Maybe<Filter_Daily_Digest_Pending_Aggregated_Fields>;
  sum?: Maybe<Filter_Daily_Digest_Pending_Aggregated_Fields>;
  sumDistinct?: Maybe<Filter_Daily_Digest_Pending_Aggregated_Fields>;
};

export type Filter_Daily_Digest_Pending_Aggregated_Count = {
  __typename?: 'filter_daily_digest_pending_aggregated_count';
  /** Matched case ID */
  case_id?: Maybe<Scalars['Int']['output']>;
  /** Jurisdiction name */
  case_jurisdiction?: Maybe<Scalars['Int']['output']>;
  /** Direct link to case */
  case_link?: Maybe<Scalars['Int']['output']>;
  /** Case name snapshot */
  case_name?: Maybe<Scalars['Int']['output']>;
  /** Practice area name */
  case_type?: Maybe<Scalars['Int']['output']>;
  /** When the pending row was created */
  created_at?: Maybe<Scalars['Int']['output']>;
  /** Asking fee */
  fee?: Maybe<Scalars['Int']['output']>;
  /** FK to saved_filters */
  filter_id?: Maybe<Scalars['Int']['output']>;
  /** Filter name at time of match */
  filter_name?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** On-behalf-of email */
  on_behalf_of_email?: Maybe<Scalars['Int']['output']>;
  /** Seller organization ID */
  organization_id?: Maybe<Scalars['Int']['output']>;
  /** Seller organization name */
  organization_name?: Maybe<Scalars['Int']['output']>;
  /** Seller first name */
  seller_first_name?: Maybe<Scalars['Int']['output']>;
  /** Seller last name */
  seller_last_name?: Maybe<Scalars['Int']['output']>;
  /** When the digest was sent (NULL = pending) */
  sent_at?: Maybe<Scalars['Int']['output']>;
  /** Recipient email */
  user_email?: Maybe<Scalars['Int']['output']>;
};

export type Filter_Daily_Digest_Pending_Aggregated_Fields = {
  __typename?: 'filter_daily_digest_pending_aggregated_fields';
  /** Asking fee */
  fee?: Maybe<Scalars['Float']['output']>;
};

export type Filter_Daily_Digest_Pending_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Filter_Daily_Digest_Pending_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Filter_Daily_Digest_Pending_Filter>>>;
  case_id?: InputMaybe<String_Filter_Operators>;
  case_jurisdiction?: InputMaybe<String_Filter_Operators>;
  case_link?: InputMaybe<String_Filter_Operators>;
  case_name?: InputMaybe<String_Filter_Operators>;
  case_type?: InputMaybe<String_Filter_Operators>;
  created_at?: InputMaybe<Date_Filter_Operators>;
  created_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  fee?: InputMaybe<Number_Filter_Operators>;
  filter_id?: InputMaybe<Saved_Filters_Filter>;
  filter_name?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  on_behalf_of_email?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<String_Filter_Operators>;
  organization_name?: InputMaybe<String_Filter_Operators>;
  seller_first_name?: InputMaybe<String_Filter_Operators>;
  seller_last_name?: InputMaybe<String_Filter_Operators>;
  sent_at?: InputMaybe<Date_Filter_Operators>;
  sent_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  user_email?: InputMaybe<String_Filter_Operators>;
};

export type Filter_Daily_Digest_Pending_Mutated = {
  __typename?: 'filter_daily_digest_pending_mutated';
  data?: Maybe<Filter_Daily_Digest_Pending>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Filter_Redundant = {
  __typename?: 'filter_redundant';
  /** Dimension: affiliation name or *. */
  affiliations_id?: Maybe<Scalars['String']['output']>;
  /** Dimension: community name or *. */
  communities_id?: Maybe<Scalars['String']['output']>;
  /** Dimension: firm name or *. */
  created_by_firm_id?: Maybe<Scalars['String']['output']>;
  /** Dimension: created by user name or *. */
  created_by_user_id?: Maybe<Scalars['String']['output']>;
  filter_id?: Maybe<Saved_Filters>;
  id: Scalars['ID']['output'];
  /** Dimension: market_fit or *. */
  market_fit?: Maybe<Scalars['String']['output']>;
  /** Email of user for saved_filters.on_behalf_of. */
  on_behalf_of_email?: Maybe<Scalars['String']['output']>;
  /** Dimension: practice area or *. */
  practice_area_id?: Maybe<Scalars['String']['output']>;
  /** Dimension: process stage or *. */
  process_stage_id?: Maybe<Scalars['String']['output']>;
  /** Dimension: state name or *. */
  us_state_id?: Maybe<Scalars['String']['output']>;
  /** Email of saved_filters.user_id. */
  user_email?: Maybe<Scalars['String']['output']>;
  /** Organization id of filter owner from organization_user. */
  user_organization_id?: Maybe<Scalars['String']['output']>;
  /** Dimension: zip code or *. */
  zip_code?: Maybe<Scalars['String']['output']>;
  /** Dimension: city zip or *. */
  zip_code_city_zip_code?: Maybe<Scalars['String']['output']>;
  /** Dimension: "County, ST" or *. */
  zip_code_county?: Maybe<Scalars['String']['output']>;
};


export type Filter_RedundantFilter_IdArgs = {
  filter?: InputMaybe<Saved_Filters_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Filter_Redundant_Aggregated = {
  __typename?: 'filter_redundant_aggregated';
  count?: Maybe<Filter_Redundant_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Filter_Redundant_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Filter_Redundant_Aggregated_Count = {
  __typename?: 'filter_redundant_aggregated_count';
  /** Dimension: affiliation name or *. */
  affiliations_id?: Maybe<Scalars['Int']['output']>;
  /** Dimension: community name or *. */
  communities_id?: Maybe<Scalars['Int']['output']>;
  /** Dimension: firm name or *. */
  created_by_firm_id?: Maybe<Scalars['Int']['output']>;
  /** Dimension: created by user name or *. */
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  /** FK to saved_filters. */
  filter_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Dimension: market_fit or *. */
  market_fit?: Maybe<Scalars['Int']['output']>;
  /** Email of user for saved_filters.on_behalf_of. */
  on_behalf_of_email?: Maybe<Scalars['Int']['output']>;
  /** Dimension: practice area or *. */
  practice_area_id?: Maybe<Scalars['Int']['output']>;
  /** Dimension: process stage or *. */
  process_stage_id?: Maybe<Scalars['Int']['output']>;
  /** Dimension: state name or *. */
  us_state_id?: Maybe<Scalars['Int']['output']>;
  /** Email of saved_filters.user_id. */
  user_email?: Maybe<Scalars['Int']['output']>;
  /** Organization id of filter owner from organization_user. */
  user_organization_id?: Maybe<Scalars['Int']['output']>;
  /** Dimension: zip code or *. */
  zip_code?: Maybe<Scalars['Int']['output']>;
  /** Dimension: city zip or *. */
  zip_code_city_zip_code?: Maybe<Scalars['Int']['output']>;
  /** Dimension: "County, ST" or *. */
  zip_code_county?: Maybe<Scalars['Int']['output']>;
};

export type Filter_Redundant_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Filter_Redundant_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Filter_Redundant_Filter>>>;
  affiliations_id?: InputMaybe<String_Filter_Operators>;
  communities_id?: InputMaybe<String_Filter_Operators>;
  created_by_firm_id?: InputMaybe<String_Filter_Operators>;
  created_by_user_id?: InputMaybe<String_Filter_Operators>;
  filter_id?: InputMaybe<Saved_Filters_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
  market_fit?: InputMaybe<String_Filter_Operators>;
  on_behalf_of_email?: InputMaybe<String_Filter_Operators>;
  practice_area_id?: InputMaybe<String_Filter_Operators>;
  process_stage_id?: InputMaybe<String_Filter_Operators>;
  us_state_id?: InputMaybe<String_Filter_Operators>;
  user_email?: InputMaybe<String_Filter_Operators>;
  user_organization_id?: InputMaybe<String_Filter_Operators>;
  zip_code?: InputMaybe<String_Filter_Operators>;
  zip_code_city_zip_code?: InputMaybe<String_Filter_Operators>;
  zip_code_county?: InputMaybe<String_Filter_Operators>;
};

export type Filter_Redundant_Mutated = {
  __typename?: 'filter_redundant_mutated';
  data?: Maybe<Filter_Redundant>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Hash_Filter_Operators = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
  _nempty?: InputMaybe<Scalars['Boolean']['input']>;
  _nnull?: InputMaybe<Scalars['Boolean']['input']>;
  _null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Invitation_Discount = {
  __typename?: 'invitation_discount';
  amount: Scalars['Float']['output'];
  apply_to_invitation?: Maybe<Scalars['Boolean']['output']>;
  apply_to_waterfall?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  end_date?: Maybe<Scalars['Date']['output']>;
  end_date_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  organization_id?: Maybe<Organization>;
  start_date?: Maybe<Scalars['Date']['output']>;
  start_date_func?: Maybe<Datetime_Functions>;
};


export type Invitation_DiscountOrganization_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Invitation_Discount_Aggregated = {
  __typename?: 'invitation_discount_aggregated';
  avg?: Maybe<Invitation_Discount_Aggregated_Fields>;
  avgDistinct?: Maybe<Invitation_Discount_Aggregated_Fields>;
  count?: Maybe<Invitation_Discount_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Invitation_Discount_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Invitation_Discount_Aggregated_Fields>;
  min?: Maybe<Invitation_Discount_Aggregated_Fields>;
  sum?: Maybe<Invitation_Discount_Aggregated_Fields>;
  sumDistinct?: Maybe<Invitation_Discount_Aggregated_Fields>;
};

export type Invitation_Discount_Aggregated_Count = {
  __typename?: 'invitation_discount_aggregated_count';
  amount?: Maybe<Scalars['Int']['output']>;
  apply_to_invitation?: Maybe<Scalars['Int']['output']>;
  apply_to_waterfall?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['Int']['output']>;
};

export type Invitation_Discount_Aggregated_Fields = {
  __typename?: 'invitation_discount_aggregated_fields';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type Invitation_Discount_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Invitation_Discount_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Invitation_Discount_Filter>>>;
  amount?: InputMaybe<Number_Filter_Operators>;
  apply_to_invitation?: InputMaybe<Boolean_Filter_Operators>;
  apply_to_waterfall?: InputMaybe<Boolean_Filter_Operators>;
  description?: InputMaybe<String_Filter_Operators>;
  end_date?: InputMaybe<Date_Filter_Operators>;
  end_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<Organization_Filter>;
  start_date?: InputMaybe<Date_Filter_Operators>;
  start_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
};

export type Invitation_Discount_Mutated = {
  __typename?: 'invitation_discount_mutated';
  data?: Maybe<Invitation_Discount>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Lcms_Case_Mapping = {
  __typename?: 'lcms_case_mapping';
  case_id: Scalars['ID']['output'];
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  lcms_case_id?: Maybe<Scalars['String']['output']>;
  lcms_id?: Maybe<Case_Management_Software>;
  lcms_lead_id?: Maybe<Scalars['String']['output']>;
  lcms_opportunity_id?: Maybe<Scalars['String']['output']>;
  updated_ts?: Maybe<Scalars['Date']['output']>;
  updated_ts_func?: Maybe<Time_Functions>;
};


export type Lcms_Case_MappingLcms_IdArgs = {
  filter?: InputMaybe<Case_Management_Software_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Lcms_Case_Mapping_Aggregated = {
  __typename?: 'lcms_case_mapping_aggregated';
  count?: Maybe<Lcms_Case_Mapping_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Lcms_Case_Mapping_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Lcms_Case_Mapping_Aggregated_Count = {
  __typename?: 'lcms_case_mapping_aggregated_count';
  case_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  lcms_case_id?: Maybe<Scalars['Int']['output']>;
  lcms_id?: Maybe<Scalars['Int']['output']>;
  lcms_lead_id?: Maybe<Scalars['Int']['output']>;
  lcms_opportunity_id?: Maybe<Scalars['Int']['output']>;
  updated_ts?: Maybe<Scalars['Int']['output']>;
};

export type Lcms_Case_Mapping_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Lcms_Case_Mapping_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Lcms_Case_Mapping_Filter>>>;
  case_id?: InputMaybe<String_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  lcms_case_id?: InputMaybe<String_Filter_Operators>;
  lcms_id?: InputMaybe<Case_Management_Software_Filter>;
  lcms_lead_id?: InputMaybe<String_Filter_Operators>;
  lcms_opportunity_id?: InputMaybe<String_Filter_Operators>;
  updated_ts?: InputMaybe<Date_Filter_Operators>;
  updated_ts_func?: InputMaybe<Time_Function_Filter_Operators>;
};

export type Lcms_Case_Mapping_Mutated = {
  __typename?: 'lcms_case_mapping_mutated';
  data?: Maybe<Lcms_Case_Mapping>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Lcms_Health_Check = {
  __typename?: 'lcms_health_check';
  health_check_timestamp: Scalars['Date']['output'];
  health_check_timestamp_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  lcms_config_id?: Maybe<Scalars['String']['output']>;
  lcms_health: Scalars['Boolean']['output'];
  lcms_health_http_status_code: Scalars['Int']['output'];
  org_id?: Maybe<Organization>;
};


export type Lcms_Health_CheckOrg_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Lcms_Health_Check_Aggregated = {
  __typename?: 'lcms_health_check_aggregated';
  avg?: Maybe<Lcms_Health_Check_Aggregated_Fields>;
  avgDistinct?: Maybe<Lcms_Health_Check_Aggregated_Fields>;
  count?: Maybe<Lcms_Health_Check_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Lcms_Health_Check_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Lcms_Health_Check_Aggregated_Fields>;
  min?: Maybe<Lcms_Health_Check_Aggregated_Fields>;
  sum?: Maybe<Lcms_Health_Check_Aggregated_Fields>;
  sumDistinct?: Maybe<Lcms_Health_Check_Aggregated_Fields>;
};

export type Lcms_Health_Check_Aggregated_Count = {
  __typename?: 'lcms_health_check_aggregated_count';
  health_check_timestamp?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lcms_config_id?: Maybe<Scalars['Int']['output']>;
  lcms_health?: Maybe<Scalars['Int']['output']>;
  lcms_health_http_status_code?: Maybe<Scalars['Int']['output']>;
  org_id?: Maybe<Scalars['Int']['output']>;
};

export type Lcms_Health_Check_Aggregated_Fields = {
  __typename?: 'lcms_health_check_aggregated_fields';
  lcms_health_http_status_code?: Maybe<Scalars['Float']['output']>;
};

export type Lcms_Health_Check_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Lcms_Health_Check_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Lcms_Health_Check_Filter>>>;
  health_check_timestamp?: InputMaybe<Date_Filter_Operators>;
  health_check_timestamp_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  lcms_config_id?: InputMaybe<String_Filter_Operators>;
  lcms_health?: InputMaybe<Boolean_Filter_Operators>;
  lcms_health_http_status_code?: InputMaybe<Number_Filter_Operators>;
  org_id?: InputMaybe<Organization_Filter>;
};

export type Lcms_Health_Check_Mutated = {
  __typename?: 'lcms_health_check_mutated';
  data?: Maybe<Lcms_Health_Check>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Master_Attorney = {
  __typename?: 'master_attorney';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  affiliations?: Maybe<Scalars['String']['output']>;
  attorney_id: Scalars['ID']['output'];
  calendar_id?: Maybe<Scalars['String']['output']>;
  case_management_software?: Maybe<Scalars['String']['output']>;
  connected_case_management_software?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  education_law_school?: Maybe<Scalars['String']['output']>;
  education_undergraduate_school?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  has_profile_photo?: Maybe<Scalars['Boolean']['output']>;
  is_vetted?: Maybe<Scalars['Boolean']['output']>;
  jurisdictions?: Maybe<Scalars['String']['output']>;
  klaviyo_profile_id?: Maybe<Scalars['String']['output']>;
  languages_spoken?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  membership_type?: Maybe<Scalars['String']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  notification_level?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  practice_areas?: Maybe<Scalars['String']['output']>;
  primary_license_bar_number?: Maybe<Scalars['String']['output']>;
  primary_license_state?: Maybe<Scalars['String']['output']>;
  referral_source?: Maybe<Scalars['String']['output']>;
  role_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  years_practice?: Maybe<Scalars['String']['output']>;
};

export type Master_Attorney_Aggregated = {
  __typename?: 'master_attorney_aggregated';
  count?: Maybe<Master_Attorney_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Master_Attorney_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Master_Attorney_Aggregated_Count = {
  __typename?: 'master_attorney_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  affiliations?: Maybe<Scalars['Int']['output']>;
  attorney_id?: Maybe<Scalars['Int']['output']>;
  calendar_id?: Maybe<Scalars['Int']['output']>;
  case_management_software?: Maybe<Scalars['Int']['output']>;
  connected_case_management_software?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  education_law_school?: Maybe<Scalars['Int']['output']>;
  education_undergraduate_school?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['Int']['output']>;
  first_name?: Maybe<Scalars['Int']['output']>;
  full_name?: Maybe<Scalars['Int']['output']>;
  has_profile_photo?: Maybe<Scalars['Int']['output']>;
  is_vetted?: Maybe<Scalars['Int']['output']>;
  jurisdictions?: Maybe<Scalars['Int']['output']>;
  klaviyo_profile_id?: Maybe<Scalars['Int']['output']>;
  languages_spoken?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['Int']['output']>;
  membership_type?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  notification_level?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  organization_name?: Maybe<Scalars['Int']['output']>;
  phone_number?: Maybe<Scalars['Int']['output']>;
  practice_areas?: Maybe<Scalars['Int']['output']>;
  primary_license_bar_number?: Maybe<Scalars['Int']['output']>;
  primary_license_state?: Maybe<Scalars['Int']['output']>;
  referral_source?: Maybe<Scalars['Int']['output']>;
  role_name?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  years_practice?: Maybe<Scalars['Int']['output']>;
};

export type Master_Attorney_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Master_Attorney_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Master_Attorney_Filter>>>;
  affiliations?: InputMaybe<String_Filter_Operators>;
  attorney_id?: InputMaybe<String_Filter_Operators>;
  calendar_id?: InputMaybe<String_Filter_Operators>;
  case_management_software?: InputMaybe<String_Filter_Operators>;
  connected_case_management_software?: InputMaybe<String_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  education_law_school?: InputMaybe<String_Filter_Operators>;
  education_undergraduate_school?: InputMaybe<String_Filter_Operators>;
  email?: InputMaybe<String_Filter_Operators>;
  first_name?: InputMaybe<String_Filter_Operators>;
  full_name?: InputMaybe<String_Filter_Operators>;
  has_profile_photo?: InputMaybe<Boolean_Filter_Operators>;
  is_vetted?: InputMaybe<Boolean_Filter_Operators>;
  jurisdictions?: InputMaybe<String_Filter_Operators>;
  klaviyo_profile_id?: InputMaybe<String_Filter_Operators>;
  languages_spoken?: InputMaybe<String_Filter_Operators>;
  last_name?: InputMaybe<String_Filter_Operators>;
  membership_type?: InputMaybe<String_Filter_Operators>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  notification_level?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<String_Filter_Operators>;
  organization_name?: InputMaybe<String_Filter_Operators>;
  phone_number?: InputMaybe<String_Filter_Operators>;
  practice_areas?: InputMaybe<String_Filter_Operators>;
  primary_license_bar_number?: InputMaybe<String_Filter_Operators>;
  primary_license_state?: InputMaybe<String_Filter_Operators>;
  referral_source?: InputMaybe<String_Filter_Operators>;
  role_name?: InputMaybe<String_Filter_Operators>;
  user_id?: InputMaybe<String_Filter_Operators>;
  years_practice?: InputMaybe<String_Filter_Operators>;
};

export type Master_Attorney_Mutated = {
  __typename?: 'master_attorney_mutated';
  data?: Maybe<Master_Attorney>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Master_Case = {
  __typename?: 'master_case';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  attorney_id?: Maybe<Scalars['String']['output']>;
  attorney_name?: Maybe<Scalars['String']['output']>;
  calendar_id?: Maybe<Scalars['String']['output']>;
  case_id: Scalars['ID']['output'];
  case_type?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  description?: Maybe<Scalars['String']['output']>;
  desired_fee_perc?: Maybe<Scalars['Float']['output']>;
  financing_source?: Maybe<Scalars['String']['output']>;
  internal_case_number?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  lcms_case_id?: Maybe<Scalars['String']['output']>;
  lcms_name?: Maybe<Scalars['String']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  name?: Maybe<Scalars['String']['output']>;
  num_negotiations?: Maybe<Scalars['Float']['output']>;
  num_watchers?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  practice_area?: Maybe<Scalars['String']['output']>;
  preferred_language?: Maybe<Scalars['String']['output']>;
  process_stage?: Maybe<Scalars['String']['output']>;
  reporting_status?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_ts?: Maybe<Scalars['Date']['output']>;
  status_ts_func?: Maybe<Datetime_Functions>;
};

export type Master_Case_Aggregated = {
  __typename?: 'master_case_aggregated';
  avg?: Maybe<Master_Case_Aggregated_Fields>;
  avgDistinct?: Maybe<Master_Case_Aggregated_Fields>;
  count?: Maybe<Master_Case_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Master_Case_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Master_Case_Aggregated_Fields>;
  min?: Maybe<Master_Case_Aggregated_Fields>;
  sum?: Maybe<Master_Case_Aggregated_Fields>;
  sumDistinct?: Maybe<Master_Case_Aggregated_Fields>;
};

export type Master_Case_Aggregated_Count = {
  __typename?: 'master_case_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  attorney_id?: Maybe<Scalars['Int']['output']>;
  attorney_name?: Maybe<Scalars['Int']['output']>;
  calendar_id?: Maybe<Scalars['Int']['output']>;
  case_id?: Maybe<Scalars['Int']['output']>;
  case_type?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['Int']['output']>;
  desired_fee_perc?: Maybe<Scalars['Int']['output']>;
  financing_source?: Maybe<Scalars['Int']['output']>;
  internal_case_number?: Maybe<Scalars['Int']['output']>;
  is_deleted?: Maybe<Scalars['Int']['output']>;
  jurisdiction?: Maybe<Scalars['Int']['output']>;
  lcms_case_id?: Maybe<Scalars['Int']['output']>;
  lcms_name?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  num_negotiations?: Maybe<Scalars['Int']['output']>;
  num_watchers?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  organization_name?: Maybe<Scalars['Int']['output']>;
  practice_area?: Maybe<Scalars['Int']['output']>;
  preferred_language?: Maybe<Scalars['Int']['output']>;
  process_stage?: Maybe<Scalars['Int']['output']>;
  reporting_status?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  status_ts?: Maybe<Scalars['Int']['output']>;
};

export type Master_Case_Aggregated_Fields = {
  __typename?: 'master_case_aggregated_fields';
  desired_fee_perc?: Maybe<Scalars['Float']['output']>;
  num_negotiations?: Maybe<Scalars['Float']['output']>;
  num_watchers?: Maybe<Scalars['Float']['output']>;
};

export type Master_Case_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Master_Case_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Master_Case_Filter>>>;
  attorney_id?: InputMaybe<String_Filter_Operators>;
  attorney_name?: InputMaybe<String_Filter_Operators>;
  calendar_id?: InputMaybe<String_Filter_Operators>;
  case_id?: InputMaybe<String_Filter_Operators>;
  case_type?: InputMaybe<String_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  description?: InputMaybe<String_Filter_Operators>;
  desired_fee_perc?: InputMaybe<Number_Filter_Operators>;
  financing_source?: InputMaybe<String_Filter_Operators>;
  internal_case_number?: InputMaybe<String_Filter_Operators>;
  is_deleted?: InputMaybe<Boolean_Filter_Operators>;
  jurisdiction?: InputMaybe<String_Filter_Operators>;
  lcms_case_id?: InputMaybe<String_Filter_Operators>;
  lcms_name?: InputMaybe<String_Filter_Operators>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  num_negotiations?: InputMaybe<Number_Filter_Operators>;
  num_watchers?: InputMaybe<Number_Filter_Operators>;
  organization_id?: InputMaybe<String_Filter_Operators>;
  organization_name?: InputMaybe<String_Filter_Operators>;
  practice_area?: InputMaybe<String_Filter_Operators>;
  preferred_language?: InputMaybe<String_Filter_Operators>;
  process_stage?: InputMaybe<String_Filter_Operators>;
  reporting_status?: InputMaybe<String_Filter_Operators>;
  status?: InputMaybe<String_Filter_Operators>;
  status_ts?: InputMaybe<Date_Filter_Operators>;
  status_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
};

export type Master_Case_Mutated = {
  __typename?: 'master_case_mutated';
  data?: Maybe<Master_Case>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Master_Organization = {
  __typename?: 'master_organization';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  address_city?: Maybe<Scalars['String']['output']>;
  address_state?: Maybe<Scalars['String']['output']>;
  address_street?: Maybe<Scalars['String']['output']>;
  calendar_id?: Maybe<Scalars['String']['output']>;
  connected_case_management_software?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  description?: Maybe<Scalars['String']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id: Scalars['ID']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type Master_Organization_Aggregated = {
  __typename?: 'master_organization_aggregated';
  count?: Maybe<Master_Organization_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Master_Organization_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Master_Organization_Aggregated_Count = {
  __typename?: 'master_organization_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  address_city?: Maybe<Scalars['Int']['output']>;
  address_state?: Maybe<Scalars['Int']['output']>;
  address_street?: Maybe<Scalars['Int']['output']>;
  calendar_id?: Maybe<Scalars['Int']['output']>;
  connected_case_management_software?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  website?: Maybe<Scalars['Int']['output']>;
};

export type Master_Organization_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Master_Organization_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Master_Organization_Filter>>>;
  address_city?: InputMaybe<String_Filter_Operators>;
  address_state?: InputMaybe<String_Filter_Operators>;
  address_street?: InputMaybe<String_Filter_Operators>;
  calendar_id?: InputMaybe<String_Filter_Operators>;
  connected_case_management_software?: InputMaybe<String_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  description?: InputMaybe<String_Filter_Operators>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<String_Filter_Operators>;
  website?: InputMaybe<String_Filter_Operators>;
};

export type Master_Organization_Mutated = {
  __typename?: 'master_organization_mutated';
  data?: Maybe<Master_Organization>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Master_Referral = {
  __typename?: 'master_referral';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  calendar_id?: Maybe<Scalars['String']['output']>;
  calendar_id_auto_charge?: Maybe<Scalars['String']['output']>;
  calendar_id_expiration?: Maybe<Scalars['String']['output']>;
  calendar_id_match_fee_expected_collection_date?: Maybe<Scalars['String']['output']>;
  calendar_id_match_fee_paid_on?: Maybe<Scalars['String']['output']>;
  calendar_id_matched?: Maybe<Scalars['String']['output']>;
  calendar_id_signed?: Maybe<Scalars['String']['output']>;
  calendar_id_status_update?: Maybe<Scalars['String']['output']>;
  case_created_ts?: Maybe<Scalars['Date']['output']>;
  case_created_ts_func?: Maybe<Datetime_Functions>;
  case_id?: Maybe<Scalars['String']['output']>;
  case_name?: Maybe<Scalars['String']['output']>;
  case_status?: Maybe<Scalars['String']['output']>;
  case_status_ts?: Maybe<Scalars['Date']['output']>;
  case_status_ts_func?: Maybe<Datetime_Functions>;
  case_status_update_comments?: Maybe<Scalars['String']['output']>;
  case_status_update_created_ts?: Maybe<Scalars['Date']['output']>;
  case_status_update_created_ts_func?: Maybe<Datetime_Functions>;
  case_status_update_matter_stage?: Maybe<Scalars['String']['output']>;
  case_status_update_matter_status?: Maybe<Scalars['String']['output']>;
  case_type?: Maybe<Scalars['String']['output']>;
  contact_first_name?: Maybe<Scalars['String']['output']>;
  contact_last_name?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  days_until_match_fee_collection?: Maybe<Scalars['Float']['output']>;
  fee_percentage?: Maybe<Scalars['Float']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  match_date?: Maybe<Scalars['Date']['output']>;
  match_date_func?: Maybe<Datetime_Functions>;
  match_fee_amount_expected?: Maybe<Scalars['Float']['output']>;
  match_fee_amount_paid?: Maybe<Scalars['Float']['output']>;
  match_fee_expected_amount?: Maybe<Scalars['Float']['output']>;
  match_fee_expected_collection_date?: Maybe<Scalars['Date']['output']>;
  match_fee_expected_collection_date_func?: Maybe<Date_Functions>;
  match_fee_paid_on?: Maybe<Scalars['Date']['output']>;
  match_fee_paid_on_func?: Maybe<Datetime_Functions>;
  match_fee_payment_method?: Maybe<Scalars['String']['output']>;
  match_fee_payment_status?: Maybe<Scalars['String']['output']>;
  match_fee_payment_type?: Maybe<Scalars['String']['output']>;
  matched_date_ts?: Maybe<Scalars['Date']['output']>;
  matched_date_ts_func?: Maybe<Datetime_Functions>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  practice_area?: Maybe<Scalars['String']['output']>;
  prospect_attorney_id?: Maybe<Scalars['String']['output']>;
  prospect_attorney_name?: Maybe<Scalars['String']['output']>;
  prospect_membership_type?: Maybe<Scalars['String']['output']>;
  prospect_organization_id?: Maybe<Scalars['String']['output']>;
  prospect_organization_name?: Maybe<Scalars['String']['output']>;
  referral_id: Scalars['ID']['output'];
  referring_attorney_id?: Maybe<Scalars['String']['output']>;
  referring_attorney_name?: Maybe<Scalars['String']['output']>;
  referring_membership_type?: Maybe<Scalars['String']['output']>;
  referring_organization_id?: Maybe<Scalars['String']['output']>;
  referring_organization_name?: Maybe<Scalars['String']['output']>;
  signed_date_ts?: Maybe<Scalars['Date']['output']>;
  signed_date_ts_func?: Maybe<Datetime_Functions>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type Master_Referral_Aggregated = {
  __typename?: 'master_referral_aggregated';
  avg?: Maybe<Master_Referral_Aggregated_Fields>;
  avgDistinct?: Maybe<Master_Referral_Aggregated_Fields>;
  count?: Maybe<Master_Referral_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Master_Referral_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Master_Referral_Aggregated_Fields>;
  min?: Maybe<Master_Referral_Aggregated_Fields>;
  sum?: Maybe<Master_Referral_Aggregated_Fields>;
  sumDistinct?: Maybe<Master_Referral_Aggregated_Fields>;
};

export type Master_Referral_Aggregated_Count = {
  __typename?: 'master_referral_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  calendar_id?: Maybe<Scalars['Int']['output']>;
  calendar_id_auto_charge?: Maybe<Scalars['Int']['output']>;
  calendar_id_expiration?: Maybe<Scalars['Int']['output']>;
  calendar_id_match_fee_expected_collection_date?: Maybe<Scalars['Int']['output']>;
  calendar_id_match_fee_paid_on?: Maybe<Scalars['Int']['output']>;
  calendar_id_matched?: Maybe<Scalars['Int']['output']>;
  calendar_id_signed?: Maybe<Scalars['Int']['output']>;
  calendar_id_status_update?: Maybe<Scalars['Int']['output']>;
  case_created_ts?: Maybe<Scalars['Int']['output']>;
  case_id?: Maybe<Scalars['Int']['output']>;
  case_name?: Maybe<Scalars['Int']['output']>;
  case_status?: Maybe<Scalars['Int']['output']>;
  case_status_ts?: Maybe<Scalars['Int']['output']>;
  case_status_update_comments?: Maybe<Scalars['Int']['output']>;
  case_status_update_created_ts?: Maybe<Scalars['Int']['output']>;
  case_status_update_matter_stage?: Maybe<Scalars['Int']['output']>;
  case_status_update_matter_status?: Maybe<Scalars['Int']['output']>;
  case_type?: Maybe<Scalars['Int']['output']>;
  contact_first_name?: Maybe<Scalars['Int']['output']>;
  contact_last_name?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  days_until_match_fee_collection?: Maybe<Scalars['Int']['output']>;
  fee_percentage?: Maybe<Scalars['Int']['output']>;
  jurisdiction?: Maybe<Scalars['Int']['output']>;
  match_date?: Maybe<Scalars['Int']['output']>;
  match_fee_amount_expected?: Maybe<Scalars['Int']['output']>;
  match_fee_amount_paid?: Maybe<Scalars['Int']['output']>;
  match_fee_expected_amount?: Maybe<Scalars['Int']['output']>;
  match_fee_expected_collection_date?: Maybe<Scalars['Int']['output']>;
  match_fee_paid_on?: Maybe<Scalars['Int']['output']>;
  match_fee_payment_method?: Maybe<Scalars['Int']['output']>;
  match_fee_payment_status?: Maybe<Scalars['Int']['output']>;
  match_fee_payment_type?: Maybe<Scalars['Int']['output']>;
  matched_date_ts?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  practice_area?: Maybe<Scalars['Int']['output']>;
  prospect_attorney_id?: Maybe<Scalars['Int']['output']>;
  prospect_attorney_name?: Maybe<Scalars['Int']['output']>;
  prospect_membership_type?: Maybe<Scalars['Int']['output']>;
  prospect_organization_id?: Maybe<Scalars['Int']['output']>;
  prospect_organization_name?: Maybe<Scalars['Int']['output']>;
  referral_id?: Maybe<Scalars['Int']['output']>;
  referring_attorney_id?: Maybe<Scalars['Int']['output']>;
  referring_attorney_name?: Maybe<Scalars['Int']['output']>;
  referring_membership_type?: Maybe<Scalars['Int']['output']>;
  referring_organization_id?: Maybe<Scalars['Int']['output']>;
  referring_organization_name?: Maybe<Scalars['Int']['output']>;
  signed_date_ts?: Maybe<Scalars['Int']['output']>;
  zip_code?: Maybe<Scalars['Int']['output']>;
};

export type Master_Referral_Aggregated_Fields = {
  __typename?: 'master_referral_aggregated_fields';
  days_until_match_fee_collection?: Maybe<Scalars['Float']['output']>;
  fee_percentage?: Maybe<Scalars['Float']['output']>;
  match_fee_amount_expected?: Maybe<Scalars['Float']['output']>;
  match_fee_amount_paid?: Maybe<Scalars['Float']['output']>;
  match_fee_expected_amount?: Maybe<Scalars['Float']['output']>;
};

export type Master_Referral_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Master_Referral_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Master_Referral_Filter>>>;
  calendar_id?: InputMaybe<String_Filter_Operators>;
  calendar_id_auto_charge?: InputMaybe<String_Filter_Operators>;
  calendar_id_expiration?: InputMaybe<String_Filter_Operators>;
  calendar_id_match_fee_expected_collection_date?: InputMaybe<String_Filter_Operators>;
  calendar_id_match_fee_paid_on?: InputMaybe<String_Filter_Operators>;
  calendar_id_matched?: InputMaybe<String_Filter_Operators>;
  calendar_id_signed?: InputMaybe<String_Filter_Operators>;
  calendar_id_status_update?: InputMaybe<String_Filter_Operators>;
  case_created_ts?: InputMaybe<Date_Filter_Operators>;
  case_created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  case_id?: InputMaybe<String_Filter_Operators>;
  case_name?: InputMaybe<String_Filter_Operators>;
  case_status?: InputMaybe<String_Filter_Operators>;
  case_status_ts?: InputMaybe<Date_Filter_Operators>;
  case_status_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  case_status_update_comments?: InputMaybe<String_Filter_Operators>;
  case_status_update_created_ts?: InputMaybe<Date_Filter_Operators>;
  case_status_update_created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  case_status_update_matter_stage?: InputMaybe<String_Filter_Operators>;
  case_status_update_matter_status?: InputMaybe<String_Filter_Operators>;
  case_type?: InputMaybe<String_Filter_Operators>;
  contact_first_name?: InputMaybe<String_Filter_Operators>;
  contact_last_name?: InputMaybe<String_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  days_until_match_fee_collection?: InputMaybe<Number_Filter_Operators>;
  fee_percentage?: InputMaybe<Number_Filter_Operators>;
  jurisdiction?: InputMaybe<String_Filter_Operators>;
  match_date?: InputMaybe<Date_Filter_Operators>;
  match_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  match_fee_amount_expected?: InputMaybe<Number_Filter_Operators>;
  match_fee_amount_paid?: InputMaybe<Number_Filter_Operators>;
  match_fee_expected_amount?: InputMaybe<Number_Filter_Operators>;
  match_fee_expected_collection_date?: InputMaybe<Date_Filter_Operators>;
  match_fee_expected_collection_date_func?: InputMaybe<Date_Function_Filter_Operators>;
  match_fee_paid_on?: InputMaybe<Date_Filter_Operators>;
  match_fee_paid_on_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  match_fee_payment_method?: InputMaybe<String_Filter_Operators>;
  match_fee_payment_status?: InputMaybe<String_Filter_Operators>;
  match_fee_payment_type?: InputMaybe<String_Filter_Operators>;
  matched_date_ts?: InputMaybe<Date_Filter_Operators>;
  matched_date_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  practice_area?: InputMaybe<String_Filter_Operators>;
  prospect_attorney_id?: InputMaybe<String_Filter_Operators>;
  prospect_attorney_name?: InputMaybe<String_Filter_Operators>;
  prospect_membership_type?: InputMaybe<String_Filter_Operators>;
  prospect_organization_id?: InputMaybe<String_Filter_Operators>;
  prospect_organization_name?: InputMaybe<String_Filter_Operators>;
  referral_id?: InputMaybe<String_Filter_Operators>;
  referring_attorney_id?: InputMaybe<String_Filter_Operators>;
  referring_attorney_name?: InputMaybe<String_Filter_Operators>;
  referring_membership_type?: InputMaybe<String_Filter_Operators>;
  referring_organization_id?: InputMaybe<String_Filter_Operators>;
  referring_organization_name?: InputMaybe<String_Filter_Operators>;
  signed_date_ts?: InputMaybe<Date_Filter_Operators>;
  signed_date_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  zip_code?: InputMaybe<String_Filter_Operators>;
};

export type Master_Referral_Mutated = {
  __typename?: 'master_referral_mutated';
  data?: Maybe<Master_Referral>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Network_User_Invite = {
  __typename?: 'network_user_invite';
  completed_ts?: Maybe<Scalars['Date']['output']>;
  completed_ts_func?: Maybe<Datetime_Functions>;
  completed_user_id?: Maybe<Directus_Users>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last_name: Scalars['String']['output'];
  send_ts?: Maybe<Scalars['Date']['output']>;
  send_ts_func?: Maybe<Datetime_Functions>;
  sender_user_id?: Maybe<Directus_Users>;
};


export type Network_User_InviteCompleted_User_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Network_User_InviteSender_User_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Network_User_Invite_Aggregated = {
  __typename?: 'network_user_invite_aggregated';
  count?: Maybe<Network_User_Invite_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Network_User_Invite_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Network_User_Invite_Aggregated_Count = {
  __typename?: 'network_user_invite_aggregated_count';
  completed_ts?: Maybe<Scalars['Int']['output']>;
  completed_user_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['Int']['output']>;
  first_name?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['Int']['output']>;
  send_ts?: Maybe<Scalars['Int']['output']>;
  sender_user_id?: Maybe<Scalars['Int']['output']>;
};

export type Network_User_Invite_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Network_User_Invite_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Network_User_Invite_Filter>>>;
  completed_ts?: InputMaybe<Date_Filter_Operators>;
  completed_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  completed_user_id?: InputMaybe<Directus_Users_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  email?: InputMaybe<String_Filter_Operators>;
  first_name?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  last_name?: InputMaybe<String_Filter_Operators>;
  send_ts?: InputMaybe<Date_Filter_Operators>;
  send_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  sender_user_id?: InputMaybe<Directus_Users_Filter>;
};

export type Network_User_Invite_Mutated = {
  __typename?: 'network_user_invite_mutated';
  data?: Maybe<Network_User_Invite>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Notification = {
  __typename?: 'notification';
  /** Notification content/message */
  content: Scalars['String']['output'];
  /** When the notification was created */
  created_at?: Maybe<Scalars['Date']['output']>;
  created_at_func?: Maybe<Datetime_Functions>;
  /** When the notification expires */
  expires_at?: Maybe<Scalars['Date']['output']>;
  expires_at_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  /** Additional metadata for the notification */
  metadata?: Maybe<Scalars['JSON']['output']>;
  metadata_func?: Maybe<Count_Functions>;
  /** When the notification was read */
  read_at?: Maybe<Scalars['Date']['output']>;
  read_at_func?: Maybe<Datetime_Functions>;
  /** Notification status */
  status?: Maybe<Scalars['String']['output']>;
  /** Notification title */
  title: Scalars['String']['output'];
  /** Type of notification */
  type: Scalars['String']['output'];
  /** When the notification was last updated */
  updated_at?: Maybe<Scalars['Date']['output']>;
  updated_at_func?: Maybe<Datetime_Functions>;
  user_id?: Maybe<Directus_Users>;
};


export type NotificationUser_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Notification_Aggregated = {
  __typename?: 'notification_aggregated';
  count?: Maybe<Notification_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Notification_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Notification_Aggregated_Count = {
  __typename?: 'notification_aggregated_count';
  /** Notification content/message */
  content?: Maybe<Scalars['Int']['output']>;
  /** When the notification was created */
  created_at?: Maybe<Scalars['Int']['output']>;
  /** When the notification expires */
  expires_at?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Additional metadata for the notification */
  metadata?: Maybe<Scalars['Int']['output']>;
  /** When the notification was read */
  read_at?: Maybe<Scalars['Int']['output']>;
  /** Notification status */
  status?: Maybe<Scalars['Int']['output']>;
  /** Notification title */
  title?: Maybe<Scalars['Int']['output']>;
  /** Type of notification */
  type?: Maybe<Scalars['Int']['output']>;
  /** When the notification was last updated */
  updated_at?: Maybe<Scalars['Int']['output']>;
  /** User who will receive this notification */
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type Notification_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Notification_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Notification_Filter>>>;
  content?: InputMaybe<String_Filter_Operators>;
  created_at?: InputMaybe<Date_Filter_Operators>;
  created_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  expires_at?: InputMaybe<Date_Filter_Operators>;
  expires_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  metadata?: InputMaybe<String_Filter_Operators>;
  metadata_func?: InputMaybe<Count_Function_Filter_Operators>;
  read_at?: InputMaybe<Date_Filter_Operators>;
  read_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  status?: InputMaybe<String_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
  type?: InputMaybe<String_Filter_Operators>;
  updated_at?: InputMaybe<Date_Filter_Operators>;
  updated_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  user_id?: InputMaybe<Directus_Users_Filter>;
};

export type Notification_Mutated = {
  __typename?: 'notification_mutated';
  data?: Maybe<Notification>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Number_Filter_Operators = {
  _between?: InputMaybe<Array<InputMaybe<Scalars['GraphQLStringOrFloat']['input']>>>;
  _eq?: InputMaybe<Scalars['GraphQLStringOrFloat']['input']>;
  _gt?: InputMaybe<Scalars['GraphQLStringOrFloat']['input']>;
  _gte?: InputMaybe<Scalars['GraphQLStringOrFloat']['input']>;
  _in?: InputMaybe<Array<InputMaybe<Scalars['GraphQLStringOrFloat']['input']>>>;
  _lt?: InputMaybe<Scalars['GraphQLStringOrFloat']['input']>;
  _lte?: InputMaybe<Scalars['GraphQLStringOrFloat']['input']>;
  _nbetween?: InputMaybe<Array<InputMaybe<Scalars['GraphQLStringOrFloat']['input']>>>;
  _neq?: InputMaybe<Scalars['GraphQLStringOrFloat']['input']>;
  _nin?: InputMaybe<Array<InputMaybe<Scalars['GraphQLStringOrFloat']['input']>>>;
  _nnull?: InputMaybe<Scalars['Boolean']['input']>;
  _null?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Organization = {
  __typename?: 'organization';
  allow_attorney_wf_list?: Maybe<Scalars['Boolean']['output']>;
  /** Exit-survey reason captured on self-service Premium cancellation. */
  cancellation_reason?: Maybe<Scalars['String']['output']>;
  /** Free-text detail when cancellation_reason = other. */
  cancellation_reason_other?: Maybe<Scalars['String']['output']>;
  /** When the firm confirmed self-service cancellation. */
  cancellation_requested_at?: Maybe<Scalars['Date']['output']>;
  cancellation_requested_at_func?: Maybe<Datetime_Functions>;
  created_by_user_id?: Maybe<Directus_Users>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  credits?: Maybe<Scalars['Int']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
  /** End of billing cycle when Basic takes effect. */
  downgrade_effective_at?: Maybe<Scalars['Date']['output']>;
  downgrade_effective_at_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  lcms_waterfall_default_duration?: Maybe<Catalog_Waterfall_Duration>;
  lcms_waterfall_mapping_enabled?: Maybe<Scalars['Boolean']['output']>;
  organization_discount?: Maybe<Array<Maybe<Organization_Discount>>>;
  organization_discount_func?: Maybe<Count_Functions>;
  partner_source?: Maybe<Scalars['String']['output']>;
  /** Stripe-driven payment health for the firm. 'failed' set on invoice.payment_failed; cleared on invoice.paid. Audit trail lives in attorney_share.firm_payment_failure. */
  payment_status?: Maybe<Scalars['String']['output']>;
  practice_attorney_mapping?: Maybe<Array<Maybe<Practice_Attorney_Mapping>>>;
  practice_attorney_mapping_func?: Maybe<Count_Functions>;
  profiles?: Maybe<Array<Maybe<Organization_Profile>>>;
  profiles_func?: Maybe<Count_Functions>;
  referral_network?: Maybe<Array<Maybe<Referral_Network>>>;
  referral_network_func?: Maybe<Count_Functions>;
  /** Derived firm-facing subscription status. Read-only — written by the subscriptions service, not editable in Directus. */
  subscription_status?: Maybe<Scalars['String']['output']>;
  /** Set when the firm's one-time partner trial (e.g. Supio 30-day Premium) is granted. While set, no further trial is granted at subscribe. Clear this field to deliberately re-grant a trial. */
  trial_used_at?: Maybe<Scalars['Date']['output']>;
  trial_used_at_func?: Maybe<Datetime_Functions>;
  users?: Maybe<Array<Maybe<Organization_User>>>;
  users_func?: Maybe<Count_Functions>;
};


export type OrganizationCreated_By_User_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type OrganizationLcms_Waterfall_Default_DurationArgs = {
  filter?: InputMaybe<Catalog_Waterfall_Duration_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type OrganizationOrganization_DiscountArgs = {
  filter?: InputMaybe<Organization_Discount_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type OrganizationPractice_Attorney_MappingArgs = {
  filter?: InputMaybe<Practice_Attorney_Mapping_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type OrganizationProfilesArgs = {
  filter?: InputMaybe<Organization_Profile_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type OrganizationReferral_NetworkArgs = {
  filter?: InputMaybe<Referral_Network_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type OrganizationUsersArgs = {
  filter?: InputMaybe<Organization_User_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Organization_Aggregated = {
  __typename?: 'organization_aggregated';
  avg?: Maybe<Organization_Aggregated_Fields>;
  avgDistinct?: Maybe<Organization_Aggregated_Fields>;
  count?: Maybe<Organization_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Organization_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Organization_Aggregated_Fields>;
  min?: Maybe<Organization_Aggregated_Fields>;
  sum?: Maybe<Organization_Aggregated_Fields>;
  sumDistinct?: Maybe<Organization_Aggregated_Fields>;
};

export type Organization_Aggregated_Count = {
  __typename?: 'organization_aggregated_count';
  allow_attorney_wf_list?: Maybe<Scalars['Int']['output']>;
  /** Exit-survey reason captured on self-service Premium cancellation. */
  cancellation_reason?: Maybe<Scalars['Int']['output']>;
  /** Free-text detail when cancellation_reason = other. */
  cancellation_reason_other?: Maybe<Scalars['Int']['output']>;
  /** When the firm confirmed self-service cancellation. */
  cancellation_requested_at?: Maybe<Scalars['Int']['output']>;
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  credits?: Maybe<Scalars['Int']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  /** End of billing cycle when Basic takes effect. */
  downgrade_effective_at?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lcms_waterfall_default_duration?: Maybe<Scalars['Int']['output']>;
  lcms_waterfall_mapping_enabled?: Maybe<Scalars['Int']['output']>;
  organization_discount?: Maybe<Scalars['Int']['output']>;
  partner_source?: Maybe<Scalars['Int']['output']>;
  /** Stripe-driven payment health for the firm. 'failed' set on invoice.payment_failed; cleared on invoice.paid. Audit trail lives in attorney_share.firm_payment_failure. */
  payment_status?: Maybe<Scalars['Int']['output']>;
  practice_attorney_mapping?: Maybe<Scalars['Int']['output']>;
  profiles?: Maybe<Scalars['Int']['output']>;
  referral_network?: Maybe<Scalars['Int']['output']>;
  /** Derived firm-facing subscription status. Read-only — written by the subscriptions service, not editable in Directus. */
  subscription_status?: Maybe<Scalars['Int']['output']>;
  /** Set when the firm's one-time partner trial (e.g. Supio 30-day Premium) is granted. While set, no further trial is granted at subscribe. Clear this field to deliberately re-grant a trial. */
  trial_used_at?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Scalars['Int']['output']>;
};

export type Organization_Aggregated_Fields = {
  __typename?: 'organization_aggregated_fields';
  credits?: Maybe<Scalars['Float']['output']>;
};

export type Organization_Block = {
  __typename?: 'organization_block';
  blocked_org_id?: Maybe<Organization>;
  blocking_org_id?: Maybe<Organization>;
  created_by_user_id?: Maybe<Directus_Users>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
};


export type Organization_BlockBlocked_Org_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Organization_BlockBlocking_Org_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Organization_BlockCreated_By_User_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Organization_Block_Aggregated = {
  __typename?: 'organization_block_aggregated';
  count?: Maybe<Organization_Block_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Organization_Block_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Organization_Block_Aggregated_Count = {
  __typename?: 'organization_block_aggregated_count';
  blocked_org_id?: Maybe<Scalars['Int']['output']>;
  blocking_org_id?: Maybe<Scalars['Int']['output']>;
  created_by_user_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Organization_Block_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Organization_Block_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Organization_Block_Filter>>>;
  blocked_org_id?: InputMaybe<Organization_Filter>;
  blocking_org_id?: InputMaybe<Organization_Filter>;
  created_by_user_id?: InputMaybe<Directus_Users_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
};

export type Organization_Block_Mutated = {
  __typename?: 'organization_block_mutated';
  data?: Maybe<Organization_Block>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Organization_Connected_Lcms = {
  __typename?: 'organization_connected_lcms';
  case_management_software_id?: Maybe<Case_Management_Software>;
  config_id?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Directus_Users>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  organization_id?: Maybe<Organization>;
};


export type Organization_Connected_LcmsCase_Management_Software_IdArgs = {
  filter?: InputMaybe<Case_Management_Software_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Organization_Connected_LcmsCreated_ByArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Organization_Connected_LcmsOrganization_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Organization_Connected_Lcms_Aggregated = {
  __typename?: 'organization_connected_lcms_aggregated';
  count?: Maybe<Organization_Connected_Lcms_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Organization_Connected_Lcms_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Organization_Connected_Lcms_Aggregated_Count = {
  __typename?: 'organization_connected_lcms_aggregated_count';
  case_management_software_id?: Maybe<Scalars['Int']['output']>;
  config_id?: Maybe<Scalars['Int']['output']>;
  created_by?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
};

export type Organization_Connected_Lcms_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Organization_Connected_Lcms_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Organization_Connected_Lcms_Filter>>>;
  case_management_software_id?: InputMaybe<Case_Management_Software_Filter>;
  config_id?: InputMaybe<String_Filter_Operators>;
  created_by?: InputMaybe<Directus_Users_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<Organization_Filter>;
};

export type Organization_Connected_Lcms_Mutated = {
  __typename?: 'organization_connected_lcms_mutated';
  data?: Maybe<Organization_Connected_Lcms>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Organization_Discount = {
  __typename?: 'organization_discount';
  comment: Scalars['String']['output'];
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  discount_id: Scalars['String']['output'];
  expiration_date?: Maybe<Scalars['Date']['output']>;
  expiration_date_func?: Maybe<Date_Functions>;
  id: Scalars['ID']['output'];
  organization_id?: Maybe<Organization>;
  start_date?: Maybe<Scalars['Date']['output']>;
  start_date_func?: Maybe<Date_Functions>;
};


export type Organization_DiscountOrganization_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Organization_Discount_Aggregated = {
  __typename?: 'organization_discount_aggregated';
  count?: Maybe<Organization_Discount_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Organization_Discount_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Organization_Discount_Aggregated_Count = {
  __typename?: 'organization_discount_aggregated_count';
  comment?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  discount_id?: Maybe<Scalars['Int']['output']>;
  expiration_date?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['Int']['output']>;
};

export type Organization_Discount_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Organization_Discount_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Organization_Discount_Filter>>>;
  comment?: InputMaybe<String_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  discount_id?: InputMaybe<String_Filter_Operators>;
  expiration_date?: InputMaybe<Date_Filter_Operators>;
  expiration_date_func?: InputMaybe<Date_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<Organization_Filter>;
  start_date?: InputMaybe<Date_Filter_Operators>;
  start_date_func?: InputMaybe<Date_Function_Filter_Operators>;
};

export type Organization_Discount_Mutated = {
  __typename?: 'organization_discount_mutated';
  data?: Maybe<Organization_Discount>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Organization_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Organization_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Organization_Filter>>>;
  allow_attorney_wf_list?: InputMaybe<Boolean_Filter_Operators>;
  cancellation_reason?: InputMaybe<String_Filter_Operators>;
  cancellation_reason_other?: InputMaybe<String_Filter_Operators>;
  cancellation_requested_at?: InputMaybe<Date_Filter_Operators>;
  cancellation_requested_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  created_by_user_id?: InputMaybe<Directus_Users_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  credits?: InputMaybe<Number_Filter_Operators>;
  customer_id?: InputMaybe<String_Filter_Operators>;
  downgrade_effective_at?: InputMaybe<Date_Filter_Operators>;
  downgrade_effective_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  lcms_waterfall_default_duration?: InputMaybe<Catalog_Waterfall_Duration_Filter>;
  lcms_waterfall_mapping_enabled?: InputMaybe<Boolean_Filter_Operators>;
  organization_discount?: InputMaybe<Organization_Discount_Filter>;
  organization_discount_func?: InputMaybe<Count_Function_Filter_Operators>;
  partner_source?: InputMaybe<String_Filter_Operators>;
  payment_status?: InputMaybe<String_Filter_Operators>;
  practice_attorney_mapping?: InputMaybe<Practice_Attorney_Mapping_Filter>;
  practice_attorney_mapping_func?: InputMaybe<Count_Function_Filter_Operators>;
  profiles?: InputMaybe<Organization_Profile_Filter>;
  profiles_func?: InputMaybe<Count_Function_Filter_Operators>;
  referral_network?: InputMaybe<Referral_Network_Filter>;
  referral_network_func?: InputMaybe<Count_Function_Filter_Operators>;
  subscription_status?: InputMaybe<String_Filter_Operators>;
  trial_used_at?: InputMaybe<Date_Filter_Operators>;
  trial_used_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  users?: InputMaybe<Organization_User_Filter>;
  users_func?: InputMaybe<Count_Function_Filter_Operators>;
};

export type Organization_Mutated = {
  __typename?: 'organization_mutated';
  data?: Maybe<Organization>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Organization_Profile = {
  __typename?: 'organization_profile';
  address?: Maybe<Scalars['String']['output']>;
  case_management_software?: Maybe<Scalars['String']['output']>;
  case_notification_level?: Maybe<Catalog_Notification_Level>;
  city?: Maybe<Scalars['String']['output']>;
  company_size?: Maybe<Scalars['String']['output']>;
  /** ENG-1998: Shared Inbox Address (firm contact email), lowercased */
  contact_email?: Maybe<Scalars['String']['output']>;
  /** ENG-1998: server-maintained, set once when the firm first sets a contact email */
  contact_email_set_ts?: Maybe<Scalars['Date']['output']>;
  contact_email_set_ts_func?: Maybe<Datetime_Functions>;
  /** ENG-1998: show the firm contact email on cases */
  contact_email_show_on_cases?: Maybe<Scalars['Boolean']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  description?: Maybe<Scalars['String']['output']>;
  /** Domain part from the E-mail of an Organization's initial user */
  email_domain?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  main_goal?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Organization>;
  state?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};


export type Organization_ProfileCase_Notification_LevelArgs = {
  filter?: InputMaybe<Catalog_Notification_Level_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Organization_ProfileOrganization_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Organization_Profile_Aggregated = {
  __typename?: 'organization_profile_aggregated';
  count?: Maybe<Organization_Profile_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Organization_Profile_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Organization_Profile_Aggregated_Count = {
  __typename?: 'organization_profile_aggregated_count';
  address?: Maybe<Scalars['Int']['output']>;
  case_management_software?: Maybe<Scalars['Int']['output']>;
  /** ENG-1998: firm-wide case notification level; NULL reads as Essential */
  case_notification_level?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['Int']['output']>;
  company_size?: Maybe<Scalars['Int']['output']>;
  /** ENG-1998: Shared Inbox Address (firm contact email), lowercased */
  contact_email?: Maybe<Scalars['Int']['output']>;
  /** ENG-1998: server-maintained, set once when the firm first sets a contact email */
  contact_email_set_ts?: Maybe<Scalars['Int']['output']>;
  /** ENG-1998: show the firm contact email on cases */
  contact_email_show_on_cases?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['Int']['output']>;
  /** Domain part from the E-mail of an Organization's initial user */
  email_domain?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  main_goal?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['Int']['output']>;
  website_url?: Maybe<Scalars['Int']['output']>;
  zipcode?: Maybe<Scalars['Int']['output']>;
};

export type Organization_Profile_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Organization_Profile_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Organization_Profile_Filter>>>;
  address?: InputMaybe<String_Filter_Operators>;
  case_management_software?: InputMaybe<String_Filter_Operators>;
  case_notification_level?: InputMaybe<Catalog_Notification_Level_Filter>;
  city?: InputMaybe<String_Filter_Operators>;
  company_size?: InputMaybe<String_Filter_Operators>;
  contact_email?: InputMaybe<String_Filter_Operators>;
  contact_email_set_ts?: InputMaybe<Date_Filter_Operators>;
  contact_email_set_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  contact_email_show_on_cases?: InputMaybe<Boolean_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  description?: InputMaybe<String_Filter_Operators>;
  email_domain?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  main_goal?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<Organization_Filter>;
  state?: InputMaybe<String_Filter_Operators>;
  website_url?: InputMaybe<String_Filter_Operators>;
  zipcode?: InputMaybe<String_Filter_Operators>;
};

export type Organization_Profile_Mutated = {
  __typename?: 'organization_profile_mutated';
  data?: Maybe<Organization_Profile>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Organization_Referral_Settings = {
  __typename?: 'organization_referral_settings';
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  default_referral_fee?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  organization_id?: Maybe<Organization>;
  referral_text?: Maybe<Scalars['String']['output']>;
  updated_ts?: Maybe<Scalars['Date']['output']>;
  updated_ts_func?: Maybe<Datetime_Functions>;
};


export type Organization_Referral_SettingsOrganization_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Organization_Referral_Settings_Aggregated = {
  __typename?: 'organization_referral_settings_aggregated';
  avg?: Maybe<Organization_Referral_Settings_Aggregated_Fields>;
  avgDistinct?: Maybe<Organization_Referral_Settings_Aggregated_Fields>;
  count?: Maybe<Organization_Referral_Settings_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Organization_Referral_Settings_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Organization_Referral_Settings_Aggregated_Fields>;
  min?: Maybe<Organization_Referral_Settings_Aggregated_Fields>;
  sum?: Maybe<Organization_Referral_Settings_Aggregated_Fields>;
  sumDistinct?: Maybe<Organization_Referral_Settings_Aggregated_Fields>;
};

export type Organization_Referral_Settings_Aggregated_Count = {
  __typename?: 'organization_referral_settings_aggregated_count';
  created_ts?: Maybe<Scalars['Int']['output']>;
  default_referral_fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  referral_text?: Maybe<Scalars['Int']['output']>;
  updated_ts?: Maybe<Scalars['Int']['output']>;
};

export type Organization_Referral_Settings_Aggregated_Fields = {
  __typename?: 'organization_referral_settings_aggregated_fields';
  default_referral_fee?: Maybe<Scalars['Float']['output']>;
};

export type Organization_Referral_Settings_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Organization_Referral_Settings_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Organization_Referral_Settings_Filter>>>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  default_referral_fee?: InputMaybe<Number_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<Organization_Filter>;
  referral_text?: InputMaybe<String_Filter_Operators>;
  updated_ts?: InputMaybe<Date_Filter_Operators>;
  updated_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
};

export type Organization_Referral_Settings_Mutated = {
  __typename?: 'organization_referral_settings_mutated';
  data?: Maybe<Organization_Referral_Settings>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Organization_User = {
  __typename?: 'organization_user';
  can_create_wf_lists?: Maybe<Scalars['Boolean']['output']>;
  /** ENG-1998: member also receives a copy of case notifications at the account email */
  case_notification_copy?: Maybe<Scalars['Boolean']['output']>;
  delegated_organization_user_id?: Maybe<Organization_User>;
  id: Scalars['ID']['output'];
  organization_id?: Maybe<Organization>;
  position_bio?: Maybe<Scalars['String']['output']>;
  position_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Directus_Users>;
};


export type Organization_UserDelegated_Organization_User_IdArgs = {
  filter?: InputMaybe<Organization_User_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Organization_UserOrganization_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Organization_UserUser_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Organization_User_Aggregated = {
  __typename?: 'organization_user_aggregated';
  count?: Maybe<Organization_User_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Organization_User_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Organization_User_Aggregated_Count = {
  __typename?: 'organization_user_aggregated_count';
  can_create_wf_lists?: Maybe<Scalars['Int']['output']>;
  /** ENG-1998: member also receives a copy of case notifications at the account email */
  case_notification_copy?: Maybe<Scalars['Int']['output']>;
  delegated_organization_user_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  position_bio?: Maybe<Scalars['Int']['output']>;
  position_name?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type Organization_User_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Organization_User_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Organization_User_Filter>>>;
  can_create_wf_lists?: InputMaybe<Boolean_Filter_Operators>;
  case_notification_copy?: InputMaybe<Boolean_Filter_Operators>;
  delegated_organization_user_id?: InputMaybe<Organization_User_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<Organization_Filter>;
  position_bio?: InputMaybe<String_Filter_Operators>;
  position_name?: InputMaybe<String_Filter_Operators>;
  user_id?: InputMaybe<Directus_Users_Filter>;
};

export type Organization_User_Mutated = {
  __typename?: 'organization_user_mutated';
  data?: Maybe<Organization_User>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Practice_Area_Overrides = {
  __typename?: 'practice_area_overrides';
  auto_charge_days?: Maybe<Scalars['Int']['output']>;
  expiration_days?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  match_fee?: Maybe<Scalars['Float']['output']>;
  practice_area_id?: Maybe<Catalog_Practice_Area>;
  process_stage_id?: Maybe<Catalog_Process_Stage>;
};


export type Practice_Area_OverridesPractice_Area_IdArgs = {
  filter?: InputMaybe<Catalog_Practice_Area_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Practice_Area_OverridesProcess_Stage_IdArgs = {
  filter?: InputMaybe<Catalog_Process_Stage_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Practice_Area_Overrides_Aggregated = {
  __typename?: 'practice_area_overrides_aggregated';
  avg?: Maybe<Practice_Area_Overrides_Aggregated_Fields>;
  avgDistinct?: Maybe<Practice_Area_Overrides_Aggregated_Fields>;
  count?: Maybe<Practice_Area_Overrides_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Practice_Area_Overrides_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Practice_Area_Overrides_Aggregated_Fields>;
  min?: Maybe<Practice_Area_Overrides_Aggregated_Fields>;
  sum?: Maybe<Practice_Area_Overrides_Aggregated_Fields>;
  sumDistinct?: Maybe<Practice_Area_Overrides_Aggregated_Fields>;
};

export type Practice_Area_Overrides_Aggregated_Count = {
  __typename?: 'practice_area_overrides_aggregated_count';
  auto_charge_days?: Maybe<Scalars['Int']['output']>;
  expiration_days?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  match_fee?: Maybe<Scalars['Int']['output']>;
  practice_area_id?: Maybe<Scalars['Int']['output']>;
  process_stage_id?: Maybe<Scalars['Int']['output']>;
};

export type Practice_Area_Overrides_Aggregated_Fields = {
  __typename?: 'practice_area_overrides_aggregated_fields';
  auto_charge_days?: Maybe<Scalars['Float']['output']>;
  expiration_days?: Maybe<Scalars['Float']['output']>;
  match_fee?: Maybe<Scalars['Float']['output']>;
};

export type Practice_Area_Overrides_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Practice_Area_Overrides_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Practice_Area_Overrides_Filter>>>;
  auto_charge_days?: InputMaybe<Number_Filter_Operators>;
  expiration_days?: InputMaybe<Number_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  match_fee?: InputMaybe<Number_Filter_Operators>;
  practice_area_id?: InputMaybe<Catalog_Practice_Area_Filter>;
  process_stage_id?: InputMaybe<Catalog_Process_Stage_Filter>;
};

export type Practice_Area_Overrides_Mutated = {
  __typename?: 'practice_area_overrides_mutated';
  data?: Maybe<Practice_Area_Overrides>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Practice_Attorney_Mapping = {
  __typename?: 'practice_attorney_mapping';
  attorney_id?: Maybe<Attorney>;
  id: Scalars['ID']['output'];
  jurisdiction_id?: Maybe<Catalog_Us_State>;
  organization_id?: Maybe<Organization>;
  practice_area_id?: Maybe<Catalog_Practice_Area>;
};


export type Practice_Attorney_MappingAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Practice_Attorney_MappingJurisdiction_IdArgs = {
  filter?: InputMaybe<Catalog_Us_State_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Practice_Attorney_MappingOrganization_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Practice_Attorney_MappingPractice_Area_IdArgs = {
  filter?: InputMaybe<Catalog_Practice_Area_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Practice_Attorney_Mapping_Aggregated = {
  __typename?: 'practice_attorney_mapping_aggregated';
  count?: Maybe<Practice_Attorney_Mapping_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Practice_Attorney_Mapping_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Practice_Attorney_Mapping_Aggregated_Count = {
  __typename?: 'practice_attorney_mapping_aggregated_count';
  attorney_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  jurisdiction_id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  practice_area_id?: Maybe<Scalars['Int']['output']>;
};

export type Practice_Attorney_Mapping_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Practice_Attorney_Mapping_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Practice_Attorney_Mapping_Filter>>>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
  jurisdiction_id?: InputMaybe<Catalog_Us_State_Filter>;
  organization_id?: InputMaybe<Organization_Filter>;
  practice_area_id?: InputMaybe<Catalog_Practice_Area_Filter>;
};

export type Practice_Attorney_Mapping_Mutated = {
  __typename?: 'practice_attorney_mapping_mutated';
  data?: Maybe<Practice_Attorney_Mapping>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Referral_Network = {
  __typename?: 'referral_network';
  attorneys_per_round?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  marketplace_fallback_rounds?: Maybe<Scalars['Int']['output']>;
  maximum_attorneys?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Organization>;
  time_per_attorney?: Maybe<Scalars['Int']['output']>;
  time_per_round?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Catalog_Referral_Network_Type>;
  updated_ts?: Maybe<Scalars['Date']['output']>;
  updated_ts_func?: Maybe<Datetime_Functions>;
};


export type Referral_NetworkOrganization_IdArgs = {
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Referral_NetworkTypeArgs = {
  filter?: InputMaybe<Catalog_Referral_Network_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Referral_Network_Aggregated = {
  __typename?: 'referral_network_aggregated';
  avg?: Maybe<Referral_Network_Aggregated_Fields>;
  avgDistinct?: Maybe<Referral_Network_Aggregated_Fields>;
  count?: Maybe<Referral_Network_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Referral_Network_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Referral_Network_Aggregated_Fields>;
  min?: Maybe<Referral_Network_Aggregated_Fields>;
  sum?: Maybe<Referral_Network_Aggregated_Fields>;
  sumDistinct?: Maybe<Referral_Network_Aggregated_Fields>;
};

export type Referral_Network_Aggregated_Count = {
  __typename?: 'referral_network_aggregated_count';
  attorneys_per_round?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_active?: Maybe<Scalars['Int']['output']>;
  marketplace_fallback_rounds?: Maybe<Scalars['Int']['output']>;
  maximum_attorneys?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  time_per_attorney?: Maybe<Scalars['Int']['output']>;
  time_per_round?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  updated_ts?: Maybe<Scalars['Int']['output']>;
};

export type Referral_Network_Aggregated_Fields = {
  __typename?: 'referral_network_aggregated_fields';
  attorneys_per_round?: Maybe<Scalars['Float']['output']>;
  marketplace_fallback_rounds?: Maybe<Scalars['Float']['output']>;
  maximum_attorneys?: Maybe<Scalars['Float']['output']>;
  time_per_attorney?: Maybe<Scalars['Float']['output']>;
  time_per_round?: Maybe<Scalars['Float']['output']>;
};

export type Referral_Network_Broadcast_Audit = {
  __typename?: 'referral_network_broadcast_audit';
  accepted_by_attorney_id?: Maybe<Scalars['String']['output']>;
  accepted_in_round?: Maybe<Scalars['Int']['output']>;
  attorneys_per_round: Scalars['Int']['output'];
  case_id?: Maybe<Case>;
  case_owner_attorney_id: Scalars['String']['output'];
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  ended_at?: Maybe<Scalars['Date']['output']>;
  ended_at_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  jurisdiction_id?: Maybe<Scalars['String']['output']>;
  list_id?: Maybe<Referral_Network_List>;
  marketplace_fallback_rounds: Scalars['Int']['output'];
  network_id?: Maybe<Referral_Network>;
  organization_id: Scalars['String']['output'];
  outcome?: Maybe<Scalars['String']['output']>;
  practice_area_id?: Maybe<Scalars['String']['output']>;
  started_at?: Maybe<Scalars['Date']['output']>;
  started_at_func?: Maybe<Datetime_Functions>;
  time_per_round: Scalars['Int']['output'];
  total_attorneys_invited: Scalars['Int']['output'];
  total_rounds_executed?: Maybe<Scalars['Int']['output']>;
  updated_ts?: Maybe<Scalars['Date']['output']>;
  updated_ts_func?: Maybe<Datetime_Functions>;
};


export type Referral_Network_Broadcast_AuditCase_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Referral_Network_Broadcast_AuditList_IdArgs = {
  filter?: InputMaybe<Referral_Network_List_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Referral_Network_Broadcast_AuditNetwork_IdArgs = {
  filter?: InputMaybe<Referral_Network_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Referral_Network_Broadcast_Audit_Aggregated = {
  __typename?: 'referral_network_broadcast_audit_aggregated';
  avg?: Maybe<Referral_Network_Broadcast_Audit_Aggregated_Fields>;
  avgDistinct?: Maybe<Referral_Network_Broadcast_Audit_Aggregated_Fields>;
  count?: Maybe<Referral_Network_Broadcast_Audit_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Referral_Network_Broadcast_Audit_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Referral_Network_Broadcast_Audit_Aggregated_Fields>;
  min?: Maybe<Referral_Network_Broadcast_Audit_Aggregated_Fields>;
  sum?: Maybe<Referral_Network_Broadcast_Audit_Aggregated_Fields>;
  sumDistinct?: Maybe<Referral_Network_Broadcast_Audit_Aggregated_Fields>;
};

export type Referral_Network_Broadcast_Audit_Aggregated_Count = {
  __typename?: 'referral_network_broadcast_audit_aggregated_count';
  accepted_by_attorney_id?: Maybe<Scalars['Int']['output']>;
  accepted_in_round?: Maybe<Scalars['Int']['output']>;
  attorneys_per_round?: Maybe<Scalars['Int']['output']>;
  case_id?: Maybe<Scalars['Int']['output']>;
  case_owner_attorney_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  ended_at?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  jurisdiction_id?: Maybe<Scalars['Int']['output']>;
  list_id?: Maybe<Scalars['Int']['output']>;
  marketplace_fallback_rounds?: Maybe<Scalars['Int']['output']>;
  network_id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  outcome?: Maybe<Scalars['Int']['output']>;
  practice_area_id?: Maybe<Scalars['Int']['output']>;
  started_at?: Maybe<Scalars['Int']['output']>;
  time_per_round?: Maybe<Scalars['Int']['output']>;
  total_attorneys_invited?: Maybe<Scalars['Int']['output']>;
  total_rounds_executed?: Maybe<Scalars['Int']['output']>;
  updated_ts?: Maybe<Scalars['Int']['output']>;
};

export type Referral_Network_Broadcast_Audit_Aggregated_Fields = {
  __typename?: 'referral_network_broadcast_audit_aggregated_fields';
  accepted_in_round?: Maybe<Scalars['Float']['output']>;
  attorneys_per_round?: Maybe<Scalars['Float']['output']>;
  marketplace_fallback_rounds?: Maybe<Scalars['Float']['output']>;
  time_per_round?: Maybe<Scalars['Float']['output']>;
  total_attorneys_invited?: Maybe<Scalars['Float']['output']>;
  total_rounds_executed?: Maybe<Scalars['Float']['output']>;
};

export type Referral_Network_Broadcast_Audit_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Referral_Network_Broadcast_Audit_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Referral_Network_Broadcast_Audit_Filter>>>;
  accepted_by_attorney_id?: InputMaybe<String_Filter_Operators>;
  accepted_in_round?: InputMaybe<Number_Filter_Operators>;
  attorneys_per_round?: InputMaybe<Number_Filter_Operators>;
  case_id?: InputMaybe<Case_Filter>;
  case_owner_attorney_id?: InputMaybe<String_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  ended_at?: InputMaybe<Date_Filter_Operators>;
  ended_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  jurisdiction_id?: InputMaybe<String_Filter_Operators>;
  list_id?: InputMaybe<Referral_Network_List_Filter>;
  marketplace_fallback_rounds?: InputMaybe<Number_Filter_Operators>;
  network_id?: InputMaybe<Referral_Network_Filter>;
  organization_id?: InputMaybe<String_Filter_Operators>;
  outcome?: InputMaybe<String_Filter_Operators>;
  practice_area_id?: InputMaybe<String_Filter_Operators>;
  started_at?: InputMaybe<Date_Filter_Operators>;
  started_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  time_per_round?: InputMaybe<Number_Filter_Operators>;
  total_attorneys_invited?: InputMaybe<Number_Filter_Operators>;
  total_rounds_executed?: InputMaybe<Number_Filter_Operators>;
  updated_ts?: InputMaybe<Date_Filter_Operators>;
  updated_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
};

export type Referral_Network_Broadcast_Audit_Mutated = {
  __typename?: 'referral_network_broadcast_audit_mutated';
  data?: Maybe<Referral_Network_Broadcast_Audit>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Referral_Network_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Referral_Network_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Referral_Network_Filter>>>;
  attorneys_per_round?: InputMaybe<Number_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  is_active?: InputMaybe<Boolean_Filter_Operators>;
  marketplace_fallback_rounds?: InputMaybe<Number_Filter_Operators>;
  maximum_attorneys?: InputMaybe<Number_Filter_Operators>;
  organization_id?: InputMaybe<Organization_Filter>;
  time_per_attorney?: InputMaybe<Number_Filter_Operators>;
  time_per_round?: InputMaybe<Number_Filter_Operators>;
  type?: InputMaybe<Catalog_Referral_Network_Type_Filter>;
  updated_ts?: InputMaybe<Date_Filter_Operators>;
  updated_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
};

export type Referral_Network_List = {
  __typename?: 'referral_network_list';
  case_id?: Maybe<Case>;
  completed_at?: Maybe<Scalars['Date']['output']>;
  completed_at_func?: Maybe<Datetime_Functions>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  network_id?: Maybe<Referral_Network>;
  status?: Maybe<Catalog_Referral_Network_List_Status>;
};


export type Referral_Network_ListCase_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Referral_Network_ListNetwork_IdArgs = {
  filter?: InputMaybe<Referral_Network_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Referral_Network_ListStatusArgs = {
  filter?: InputMaybe<Catalog_Referral_Network_List_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Referral_Network_List_Aggregated = {
  __typename?: 'referral_network_list_aggregated';
  count?: Maybe<Referral_Network_List_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Referral_Network_List_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Referral_Network_List_Aggregated_Count = {
  __typename?: 'referral_network_list_aggregated_count';
  case_id?: Maybe<Scalars['Int']['output']>;
  completed_at?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  network_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type Referral_Network_List_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Referral_Network_List_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Referral_Network_List_Filter>>>;
  case_id?: InputMaybe<Case_Filter>;
  completed_at?: InputMaybe<Date_Filter_Operators>;
  completed_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  network_id?: InputMaybe<Referral_Network_Filter>;
  status?: InputMaybe<Catalog_Referral_Network_List_Status_Filter>;
};

export type Referral_Network_List_Item = {
  __typename?: 'referral_network_list_item';
  attorney_id?: Maybe<Attorney>;
  case_purchase_id?: Maybe<Case_Purchase>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  expires_at?: Maybe<Scalars['Date']['output']>;
  expires_at_func?: Maybe<Datetime_Functions>;
  fee_percentage: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  list_id?: Maybe<Referral_Network_List>;
  notified_at?: Maybe<Scalars['Date']['output']>;
  notified_at_func?: Maybe<Datetime_Functions>;
  previous_item?: Maybe<Referral_Network_List_Item>;
  responded_at?: Maybe<Scalars['Date']['output']>;
  responded_at_func?: Maybe<Datetime_Functions>;
  /** Broadcast round number (NULL for waterfall items) */
  round_number?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Catalog_Referral_Network_List_Item_Status>;
};


export type Referral_Network_List_ItemAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Referral_Network_List_ItemCase_Purchase_IdArgs = {
  filter?: InputMaybe<Case_Purchase_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Referral_Network_List_ItemList_IdArgs = {
  filter?: InputMaybe<Referral_Network_List_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Referral_Network_List_ItemPrevious_ItemArgs = {
  filter?: InputMaybe<Referral_Network_List_Item_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Referral_Network_List_ItemStatusArgs = {
  filter?: InputMaybe<Catalog_Referral_Network_List_Item_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Referral_Network_List_Item_Aggregated = {
  __typename?: 'referral_network_list_item_aggregated';
  avg?: Maybe<Referral_Network_List_Item_Aggregated_Fields>;
  avgDistinct?: Maybe<Referral_Network_List_Item_Aggregated_Fields>;
  count?: Maybe<Referral_Network_List_Item_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Referral_Network_List_Item_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Referral_Network_List_Item_Aggregated_Fields>;
  min?: Maybe<Referral_Network_List_Item_Aggregated_Fields>;
  sum?: Maybe<Referral_Network_List_Item_Aggregated_Fields>;
  sumDistinct?: Maybe<Referral_Network_List_Item_Aggregated_Fields>;
};

export type Referral_Network_List_Item_Aggregated_Count = {
  __typename?: 'referral_network_list_item_aggregated_count';
  attorney_id?: Maybe<Scalars['Int']['output']>;
  case_purchase_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['Int']['output']>;
  fee_percentage?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  list_id?: Maybe<Scalars['Int']['output']>;
  notified_at?: Maybe<Scalars['Int']['output']>;
  previous_item?: Maybe<Scalars['Int']['output']>;
  responded_at?: Maybe<Scalars['Int']['output']>;
  /** Broadcast round number (NULL for waterfall items) */
  round_number?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type Referral_Network_List_Item_Aggregated_Fields = {
  __typename?: 'referral_network_list_item_aggregated_fields';
  fee_percentage?: Maybe<Scalars['Float']['output']>;
  /** Broadcast round number (NULL for waterfall items) */
  round_number?: Maybe<Scalars['Float']['output']>;
};

export type Referral_Network_List_Item_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Referral_Network_List_Item_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Referral_Network_List_Item_Filter>>>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  case_purchase_id?: InputMaybe<Case_Purchase_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  expires_at?: InputMaybe<Date_Filter_Operators>;
  expires_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  fee_percentage?: InputMaybe<Number_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  list_id?: InputMaybe<Referral_Network_List_Filter>;
  notified_at?: InputMaybe<Date_Filter_Operators>;
  notified_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  previous_item?: InputMaybe<Referral_Network_List_Item_Filter>;
  responded_at?: InputMaybe<Date_Filter_Operators>;
  responded_at_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  round_number?: InputMaybe<Number_Filter_Operators>;
  status?: InputMaybe<Catalog_Referral_Network_List_Item_Status_Filter>;
};

export type Referral_Network_List_Item_Mutated = {
  __typename?: 'referral_network_list_item_mutated';
  data?: Maybe<Referral_Network_List_Item>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Referral_Network_List_Mutated = {
  __typename?: 'referral_network_list_mutated';
  data?: Maybe<Referral_Network_List>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Referral_Network_Member = {
  __typename?: 'referral_network_member';
  added_ts?: Maybe<Scalars['Date']['output']>;
  added_ts_func?: Maybe<Datetime_Functions>;
  attorney_id?: Maybe<Attorney>;
  deleted_ts?: Maybe<Scalars['Date']['output']>;
  deleted_ts_func?: Maybe<Datetime_Functions>;
  fee_percentage: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  jurisdictions?: Maybe<Array<Maybe<Referral_Network_Member_Jurisdiction>>>;
  jurisdictions_func?: Maybe<Count_Functions>;
  last_assignation_ts?: Maybe<Scalars['Date']['output']>;
  last_assignation_ts_func?: Maybe<Datetime_Functions>;
  network_id?: Maybe<Referral_Network>;
};


export type Referral_Network_MemberAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Referral_Network_MemberJurisdictionsArgs = {
  filter?: InputMaybe<Referral_Network_Member_Jurisdiction_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Referral_Network_MemberNetwork_IdArgs = {
  filter?: InputMaybe<Referral_Network_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Referral_Network_Member_Aggregated = {
  __typename?: 'referral_network_member_aggregated';
  avg?: Maybe<Referral_Network_Member_Aggregated_Fields>;
  avgDistinct?: Maybe<Referral_Network_Member_Aggregated_Fields>;
  count?: Maybe<Referral_Network_Member_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Referral_Network_Member_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Referral_Network_Member_Aggregated_Fields>;
  min?: Maybe<Referral_Network_Member_Aggregated_Fields>;
  sum?: Maybe<Referral_Network_Member_Aggregated_Fields>;
  sumDistinct?: Maybe<Referral_Network_Member_Aggregated_Fields>;
};

export type Referral_Network_Member_Aggregated_Count = {
  __typename?: 'referral_network_member_aggregated_count';
  added_ts?: Maybe<Scalars['Int']['output']>;
  attorney_id?: Maybe<Scalars['Int']['output']>;
  deleted_ts?: Maybe<Scalars['Int']['output']>;
  fee_percentage?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_active?: Maybe<Scalars['Int']['output']>;
  /** Allowed routing jurisdictions (empty = all licensed) */
  jurisdictions?: Maybe<Scalars['Int']['output']>;
  last_assignation_ts?: Maybe<Scalars['Int']['output']>;
  network_id?: Maybe<Scalars['Int']['output']>;
};

export type Referral_Network_Member_Aggregated_Fields = {
  __typename?: 'referral_network_member_aggregated_fields';
  fee_percentage?: Maybe<Scalars['Float']['output']>;
};

export type Referral_Network_Member_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Referral_Network_Member_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Referral_Network_Member_Filter>>>;
  added_ts?: InputMaybe<Date_Filter_Operators>;
  added_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  deleted_ts?: InputMaybe<Date_Filter_Operators>;
  deleted_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  fee_percentage?: InputMaybe<Number_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  is_active?: InputMaybe<Boolean_Filter_Operators>;
  jurisdictions?: InputMaybe<Referral_Network_Member_Jurisdiction_Filter>;
  jurisdictions_func?: InputMaybe<Count_Function_Filter_Operators>;
  last_assignation_ts?: InputMaybe<Date_Filter_Operators>;
  last_assignation_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  network_id?: InputMaybe<Referral_Network_Filter>;
};

export type Referral_Network_Member_Jurisdiction = {
  __typename?: 'referral_network_member_jurisdiction';
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  jurisdiction_id?: Maybe<Catalog_Us_State>;
  member_id?: Maybe<Referral_Network_Member>;
};


export type Referral_Network_Member_JurisdictionJurisdiction_IdArgs = {
  filter?: InputMaybe<Catalog_Us_State_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Referral_Network_Member_JurisdictionMember_IdArgs = {
  filter?: InputMaybe<Referral_Network_Member_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Referral_Network_Member_Jurisdiction_Aggregated = {
  __typename?: 'referral_network_member_jurisdiction_aggregated';
  count?: Maybe<Referral_Network_Member_Jurisdiction_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Referral_Network_Member_Jurisdiction_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Referral_Network_Member_Jurisdiction_Aggregated_Count = {
  __typename?: 'referral_network_member_jurisdiction_aggregated_count';
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  jurisdiction_id?: Maybe<Scalars['Int']['output']>;
  member_id?: Maybe<Scalars['Int']['output']>;
};

export type Referral_Network_Member_Jurisdiction_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Referral_Network_Member_Jurisdiction_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Referral_Network_Member_Jurisdiction_Filter>>>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  jurisdiction_id?: InputMaybe<Catalog_Us_State_Filter>;
  member_id?: InputMaybe<Referral_Network_Member_Filter>;
};

export type Referral_Network_Member_Jurisdiction_Mutated = {
  __typename?: 'referral_network_member_jurisdiction_mutated';
  data?: Maybe<Referral_Network_Member_Jurisdiction>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Referral_Network_Member_Mutated = {
  __typename?: 'referral_network_member_mutated';
  data?: Maybe<Referral_Network_Member>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Referral_Network_Mutated = {
  __typename?: 'referral_network_mutated';
  data?: Maybe<Referral_Network>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Saved_Filters = {
  __typename?: 'saved_filters';
  /** Automatically create proposals for matching cases */
  auto_proposal: Scalars['Boolean']['output'];
  /** When the filter was created */
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  /** Enable email notifications for this filter */
  email_notifications: Scalars['Boolean']['output'];
  /** Filter criteria stored as JSON */
  filters?: Maybe<Scalars['JSON']['output']>;
  filters_func?: Maybe<Count_Functions>;
  /** Filter criteria with IDs (UUIDs) instead of names/codes. Same structure as filters column but with ID values. */
  filters_ids?: Maybe<Scalars['JSON']['output']>;
  filters_ids_func?: Maybe<Count_Functions>;
  id: Scalars['ID']['output'];
  /** Maximum referral fee percentage (0-100) */
  maximum_referral_fee?: Maybe<Scalars['Int']['output']>;
  /** Name of the saved filter */
  name: Scalars['String']['output'];
  /** Email notification frequency: never, instant, or daily digest */
  notification_frequency?: Maybe<Scalars['String']['output']>;
  on_behalf_of?: Maybe<Attorney>;
  /** Enable SMS notifications for this filter */
  sms_notifications: Scalars['Boolean']['output'];
  /** When the filter was last updated */
  updated_ts?: Maybe<Scalars['Date']['output']>;
  updated_ts_func?: Maybe<Datetime_Functions>;
  user_id?: Maybe<Directus_Users>;
};


export type Saved_FiltersOn_Behalf_OfArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Saved_FiltersUser_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Saved_Filters_Aggregated = {
  __typename?: 'saved_filters_aggregated';
  avg?: Maybe<Saved_Filters_Aggregated_Fields>;
  avgDistinct?: Maybe<Saved_Filters_Aggregated_Fields>;
  count?: Maybe<Saved_Filters_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Saved_Filters_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Saved_Filters_Aggregated_Fields>;
  min?: Maybe<Saved_Filters_Aggregated_Fields>;
  sum?: Maybe<Saved_Filters_Aggregated_Fields>;
  sumDistinct?: Maybe<Saved_Filters_Aggregated_Fields>;
};

export type Saved_Filters_Aggregated_Count = {
  __typename?: 'saved_filters_aggregated_count';
  /** Automatically create proposals for matching cases */
  auto_proposal?: Maybe<Scalars['Int']['output']>;
  /** When the filter was created */
  created_ts?: Maybe<Scalars['Int']['output']>;
  /** Enable email notifications for this filter */
  email_notifications?: Maybe<Scalars['Int']['output']>;
  /** Filter criteria stored as JSON */
  filters?: Maybe<Scalars['Int']['output']>;
  /** Filter criteria with IDs (UUIDs) instead of names/codes. Same structure as filters column but with ID values. */
  filters_ids?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum referral fee percentage (0-100) */
  maximum_referral_fee?: Maybe<Scalars['Int']['output']>;
  /** Name of the saved filter */
  name?: Maybe<Scalars['Int']['output']>;
  /** Email notification frequency: never, instant, or daily digest */
  notification_frequency?: Maybe<Scalars['Int']['output']>;
  /** Attorney ID for filters created on behalf of another user */
  on_behalf_of?: Maybe<Scalars['Int']['output']>;
  /** Enable SMS notifications for this filter */
  sms_notifications?: Maybe<Scalars['Int']['output']>;
  /** When the filter was last updated */
  updated_ts?: Maybe<Scalars['Int']['output']>;
  /** User who owns this filter */
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type Saved_Filters_Aggregated_Fields = {
  __typename?: 'saved_filters_aggregated_fields';
  /** Maximum referral fee percentage (0-100) */
  maximum_referral_fee?: Maybe<Scalars['Float']['output']>;
};

export type Saved_Filters_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Saved_Filters_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Saved_Filters_Filter>>>;
  auto_proposal?: InputMaybe<Boolean_Filter_Operators>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  email_notifications?: InputMaybe<Boolean_Filter_Operators>;
  filters?: InputMaybe<String_Filter_Operators>;
  filters_func?: InputMaybe<Count_Function_Filter_Operators>;
  filters_ids?: InputMaybe<String_Filter_Operators>;
  filters_ids_func?: InputMaybe<Count_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  maximum_referral_fee?: InputMaybe<Number_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  notification_frequency?: InputMaybe<String_Filter_Operators>;
  on_behalf_of?: InputMaybe<Attorney_Filter>;
  sms_notifications?: InputMaybe<Boolean_Filter_Operators>;
  updated_ts?: InputMaybe<Date_Filter_Operators>;
  updated_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  user_id?: InputMaybe<Directus_Users_Filter>;
};

export type Saved_Filters_Mutated = {
  __typename?: 'saved_filters_mutated';
  data?: Maybe<Saved_Filters>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type School = {
  __typename?: 'school';
  id: Scalars['ID']['output'];
  is_law_school?: Maybe<Scalars['Boolean']['output']>;
  is_undergrad_school?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type School_Aggregated = {
  __typename?: 'school_aggregated';
  count?: Maybe<School_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<School_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type School_Aggregated_Count = {
  __typename?: 'school_aggregated_count';
  id?: Maybe<Scalars['Int']['output']>;
  is_law_school?: Maybe<Scalars['Int']['output']>;
  is_undergrad_school?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['Int']['output']>;
};

export type School_Filter = {
  _and?: InputMaybe<Array<InputMaybe<School_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<School_Filter>>>;
  id?: InputMaybe<String_Filter_Operators>;
  is_law_school?: InputMaybe<Boolean_Filter_Operators>;
  is_undergrad_school?: InputMaybe<Boolean_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type School_Mutated = {
  __typename?: 'school_mutated';
  data?: Maybe<School>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type String_Filter_Operators = {
  _contains?: InputMaybe<Scalars['String']['input']>;
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
  _ends_with?: InputMaybe<Scalars['String']['input']>;
  _eq?: InputMaybe<Scalars['String']['input']>;
  _icontains?: InputMaybe<Scalars['String']['input']>;
  _iends_with?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _istarts_with?: InputMaybe<Scalars['String']['input']>;
  _ncontains?: InputMaybe<Scalars['String']['input']>;
  _nempty?: InputMaybe<Scalars['Boolean']['input']>;
  _nends_with?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _niends_with?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  _nistarts_with?: InputMaybe<Scalars['String']['input']>;
  _nnull?: InputMaybe<Scalars['Boolean']['input']>;
  _nstarts_with?: InputMaybe<Scalars['String']['input']>;
  _null?: InputMaybe<Scalars['Boolean']['input']>;
  _starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type Sum_Analytics_Attorney_Metrics = {
  __typename?: 'sum_analytics_attorney_metrics';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  attorney_id: Scalars['ID']['output'];
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  invites_received_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Float']['output']>;
  matches_as_referee_count?: Maybe<Scalars['Float']['output']>;
  matches_as_referee_percentage?: Maybe<Scalars['Float']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  posted_cases_count?: Maybe<Scalars['Float']['output']>;
  proposals_sent_count?: Maybe<Scalars['Float']['output']>;
  signed_as_referee_count?: Maybe<Scalars['Float']['output']>;
  signed_as_referee_percentage?: Maybe<Scalars['Float']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Attorney_Metrics_Aggregated = {
  __typename?: 'sum_analytics_attorney_metrics_aggregated';
  avg?: Maybe<Sum_Analytics_Attorney_Metrics_Aggregated_Fields>;
  avgDistinct?: Maybe<Sum_Analytics_Attorney_Metrics_Aggregated_Fields>;
  count?: Maybe<Sum_Analytics_Attorney_Metrics_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Sum_Analytics_Attorney_Metrics_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Sum_Analytics_Attorney_Metrics_Aggregated_Fields>;
  min?: Maybe<Sum_Analytics_Attorney_Metrics_Aggregated_Fields>;
  sum?: Maybe<Sum_Analytics_Attorney_Metrics_Aggregated_Fields>;
  sumDistinct?: Maybe<Sum_Analytics_Attorney_Metrics_Aggregated_Fields>;
};

export type Sum_Analytics_Attorney_Metrics_Aggregated_Count = {
  __typename?: 'sum_analytics_attorney_metrics_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  attorney_id?: Maybe<Scalars['Int']['output']>;
  avg_referring_fees?: Maybe<Scalars['Int']['output']>;
  invites_received_count?: Maybe<Scalars['Int']['output']>;
  matched_cases_count?: Maybe<Scalars['Int']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Int']['output']>;
  matches_as_referee_count?: Maybe<Scalars['Int']['output']>;
  matches_as_referee_percentage?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  posted_cases_count?: Maybe<Scalars['Int']['output']>;
  proposals_sent_count?: Maybe<Scalars['Int']['output']>;
  signed_as_referee_count?: Maybe<Scalars['Int']['output']>;
  signed_as_referee_percentage?: Maybe<Scalars['Int']['output']>;
  signed_cases_count?: Maybe<Scalars['Int']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Int']['output']>;
};

export type Sum_Analytics_Attorney_Metrics_Aggregated_Fields = {
  __typename?: 'sum_analytics_attorney_metrics_aggregated_fields';
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  invites_received_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Float']['output']>;
  matches_as_referee_count?: Maybe<Scalars['Float']['output']>;
  matches_as_referee_percentage?: Maybe<Scalars['Float']['output']>;
  posted_cases_count?: Maybe<Scalars['Float']['output']>;
  proposals_sent_count?: Maybe<Scalars['Float']['output']>;
  signed_as_referee_count?: Maybe<Scalars['Float']['output']>;
  signed_as_referee_percentage?: Maybe<Scalars['Float']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Attorney_Metrics_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Sum_Analytics_Attorney_Metrics_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Sum_Analytics_Attorney_Metrics_Filter>>>;
  attorney_id?: InputMaybe<String_Filter_Operators>;
  avg_referring_fees?: InputMaybe<Number_Filter_Operators>;
  invites_received_count?: InputMaybe<Number_Filter_Operators>;
  matched_cases_count?: InputMaybe<Number_Filter_Operators>;
  matched_cases_percentage?: InputMaybe<Number_Filter_Operators>;
  matches_as_referee_count?: InputMaybe<Number_Filter_Operators>;
  matches_as_referee_percentage?: InputMaybe<Number_Filter_Operators>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  posted_cases_count?: InputMaybe<Number_Filter_Operators>;
  proposals_sent_count?: InputMaybe<Number_Filter_Operators>;
  signed_as_referee_count?: InputMaybe<Number_Filter_Operators>;
  signed_as_referee_percentage?: InputMaybe<Number_Filter_Operators>;
  signed_cases_count?: InputMaybe<Number_Filter_Operators>;
  signed_cases_percentage?: InputMaybe<Number_Filter_Operators>;
};

export type Sum_Analytics_Attorney_Metrics_Mutated = {
  __typename?: 'sum_analytics_attorney_metrics_mutated';
  data?: Maybe<Sum_Analytics_Attorney_Metrics>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Sum_Analytics_Freshness = {
  __typename?: 'sum_analytics_freshness';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  last_successful_run?: Maybe<Scalars['Date']['output']>;
  last_successful_run_func?: Maybe<Datetime_Functions>;
  next_scheduled_run?: Maybe<Scalars['Date']['output']>;
  next_scheduled_run_func?: Maybe<Datetime_Functions>;
  run_id: Scalars['ID']['output'];
};

export type Sum_Analytics_Freshness_Aggregated = {
  __typename?: 'sum_analytics_freshness_aggregated';
  count?: Maybe<Sum_Analytics_Freshness_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Sum_Analytics_Freshness_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type Sum_Analytics_Freshness_Aggregated_Count = {
  __typename?: 'sum_analytics_freshness_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  last_successful_run?: Maybe<Scalars['Int']['output']>;
  next_scheduled_run?: Maybe<Scalars['Int']['output']>;
  run_id?: Maybe<Scalars['Int']['output']>;
};

export type Sum_Analytics_Freshness_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Sum_Analytics_Freshness_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Sum_Analytics_Freshness_Filter>>>;
  last_successful_run?: InputMaybe<Date_Filter_Operators>;
  last_successful_run_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  next_scheduled_run?: InputMaybe<Date_Filter_Operators>;
  next_scheduled_run_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  run_id?: InputMaybe<String_Filter_Operators>;
};

export type Sum_Analytics_Freshness_Mutated = {
  __typename?: 'sum_analytics_freshness_mutated';
  data?: Maybe<Sum_Analytics_Freshness>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Sum_Analytics_Org_Metrics = {
  __typename?: 'sum_analytics_org_metrics';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  invites_received_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Float']['output']>;
  matches_as_referee_count?: Maybe<Scalars['Float']['output']>;
  matches_as_referee_percentage?: Maybe<Scalars['Float']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  organization_id: Scalars['ID']['output'];
  posted_cases_count?: Maybe<Scalars['Float']['output']>;
  proposals_sent_count?: Maybe<Scalars['Float']['output']>;
  signed_as_referee_count?: Maybe<Scalars['Float']['output']>;
  signed_as_referee_percentage?: Maybe<Scalars['Float']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Org_Metrics_Aggregated = {
  __typename?: 'sum_analytics_org_metrics_aggregated';
  avg?: Maybe<Sum_Analytics_Org_Metrics_Aggregated_Fields>;
  avgDistinct?: Maybe<Sum_Analytics_Org_Metrics_Aggregated_Fields>;
  count?: Maybe<Sum_Analytics_Org_Metrics_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Sum_Analytics_Org_Metrics_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Sum_Analytics_Org_Metrics_Aggregated_Fields>;
  min?: Maybe<Sum_Analytics_Org_Metrics_Aggregated_Fields>;
  sum?: Maybe<Sum_Analytics_Org_Metrics_Aggregated_Fields>;
  sumDistinct?: Maybe<Sum_Analytics_Org_Metrics_Aggregated_Fields>;
};

export type Sum_Analytics_Org_Metrics_Aggregated_Count = {
  __typename?: 'sum_analytics_org_metrics_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  avg_referring_fees?: Maybe<Scalars['Int']['output']>;
  invites_received_count?: Maybe<Scalars['Int']['output']>;
  matched_cases_count?: Maybe<Scalars['Int']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Int']['output']>;
  matches_as_referee_count?: Maybe<Scalars['Int']['output']>;
  matches_as_referee_percentage?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  posted_cases_count?: Maybe<Scalars['Int']['output']>;
  proposals_sent_count?: Maybe<Scalars['Int']['output']>;
  signed_as_referee_count?: Maybe<Scalars['Int']['output']>;
  signed_as_referee_percentage?: Maybe<Scalars['Int']['output']>;
  signed_cases_count?: Maybe<Scalars['Int']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Int']['output']>;
};

export type Sum_Analytics_Org_Metrics_Aggregated_Fields = {
  __typename?: 'sum_analytics_org_metrics_aggregated_fields';
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  invites_received_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Float']['output']>;
  matches_as_referee_count?: Maybe<Scalars['Float']['output']>;
  matches_as_referee_percentage?: Maybe<Scalars['Float']['output']>;
  posted_cases_count?: Maybe<Scalars['Float']['output']>;
  proposals_sent_count?: Maybe<Scalars['Float']['output']>;
  signed_as_referee_count?: Maybe<Scalars['Float']['output']>;
  signed_as_referee_percentage?: Maybe<Scalars['Float']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Org_Metrics_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Sum_Analytics_Org_Metrics_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Sum_Analytics_Org_Metrics_Filter>>>;
  avg_referring_fees?: InputMaybe<Number_Filter_Operators>;
  invites_received_count?: InputMaybe<Number_Filter_Operators>;
  matched_cases_count?: InputMaybe<Number_Filter_Operators>;
  matched_cases_percentage?: InputMaybe<Number_Filter_Operators>;
  matches_as_referee_count?: InputMaybe<Number_Filter_Operators>;
  matches_as_referee_percentage?: InputMaybe<Number_Filter_Operators>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  organization_id?: InputMaybe<String_Filter_Operators>;
  posted_cases_count?: InputMaybe<Number_Filter_Operators>;
  proposals_sent_count?: InputMaybe<Number_Filter_Operators>;
  signed_as_referee_count?: InputMaybe<Number_Filter_Operators>;
  signed_as_referee_percentage?: InputMaybe<Number_Filter_Operators>;
  signed_cases_count?: InputMaybe<Number_Filter_Operators>;
  signed_cases_percentage?: InputMaybe<Number_Filter_Operators>;
};

export type Sum_Analytics_Org_Metrics_Mutated = {
  __typename?: 'sum_analytics_org_metrics_mutated';
  data?: Maybe<Sum_Analytics_Org_Metrics>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Sum_Analytics_Org_Practice_Areas_Buyer = {
  __typename?: 'sum_analytics_org_practice_areas_buyer';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Float']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  metric_id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  practice_area?: Maybe<Scalars['String']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
  signed_matched_ratio?: Maybe<Scalars['Float']['output']>;
  total_cases_count?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Org_Practice_Areas_Buyer_Aggregated = {
  __typename?: 'sum_analytics_org_practice_areas_buyer_aggregated';
  avg?: Maybe<Sum_Analytics_Org_Practice_Areas_Buyer_Aggregated_Fields>;
  avgDistinct?: Maybe<Sum_Analytics_Org_Practice_Areas_Buyer_Aggregated_Fields>;
  count?: Maybe<Sum_Analytics_Org_Practice_Areas_Buyer_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Sum_Analytics_Org_Practice_Areas_Buyer_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Sum_Analytics_Org_Practice_Areas_Buyer_Aggregated_Fields>;
  min?: Maybe<Sum_Analytics_Org_Practice_Areas_Buyer_Aggregated_Fields>;
  sum?: Maybe<Sum_Analytics_Org_Practice_Areas_Buyer_Aggregated_Fields>;
  sumDistinct?: Maybe<Sum_Analytics_Org_Practice_Areas_Buyer_Aggregated_Fields>;
};

export type Sum_Analytics_Org_Practice_Areas_Buyer_Aggregated_Count = {
  __typename?: 'sum_analytics_org_practice_areas_buyer_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  avg_referring_fees?: Maybe<Scalars['Int']['output']>;
  matched_cases_count?: Maybe<Scalars['Int']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  metric_id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  practice_area?: Maybe<Scalars['Int']['output']>;
  signed_cases_count?: Maybe<Scalars['Int']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Int']['output']>;
  signed_matched_ratio?: Maybe<Scalars['Int']['output']>;
  total_cases_count?: Maybe<Scalars['Int']['output']>;
};

export type Sum_Analytics_Org_Practice_Areas_Buyer_Aggregated_Fields = {
  __typename?: 'sum_analytics_org_practice_areas_buyer_aggregated_fields';
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Float']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
  signed_matched_ratio?: Maybe<Scalars['Float']['output']>;
  total_cases_count?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Org_Practice_Areas_Buyer_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Sum_Analytics_Org_Practice_Areas_Buyer_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Sum_Analytics_Org_Practice_Areas_Buyer_Filter>>>;
  avg_referring_fees?: InputMaybe<Number_Filter_Operators>;
  matched_cases_count?: InputMaybe<Number_Filter_Operators>;
  matched_cases_percentage?: InputMaybe<Number_Filter_Operators>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  metric_id?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<String_Filter_Operators>;
  practice_area?: InputMaybe<String_Filter_Operators>;
  signed_cases_count?: InputMaybe<Number_Filter_Operators>;
  signed_cases_percentage?: InputMaybe<Number_Filter_Operators>;
  signed_matched_ratio?: InputMaybe<Number_Filter_Operators>;
  total_cases_count?: InputMaybe<Number_Filter_Operators>;
};

export type Sum_Analytics_Org_Practice_Areas_Buyer_Mutated = {
  __typename?: 'sum_analytics_org_practice_areas_buyer_mutated';
  data?: Maybe<Sum_Analytics_Org_Practice_Areas_Buyer>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Sum_Analytics_Org_Practice_Areas_Seller = {
  __typename?: 'sum_analytics_org_practice_areas_seller';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Float']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  metric_id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  practice_area?: Maybe<Scalars['String']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
  signed_matched_ratio?: Maybe<Scalars['Float']['output']>;
  total_cases_count?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Org_Practice_Areas_Seller_Aggregated = {
  __typename?: 'sum_analytics_org_practice_areas_seller_aggregated';
  avg?: Maybe<Sum_Analytics_Org_Practice_Areas_Seller_Aggregated_Fields>;
  avgDistinct?: Maybe<Sum_Analytics_Org_Practice_Areas_Seller_Aggregated_Fields>;
  count?: Maybe<Sum_Analytics_Org_Practice_Areas_Seller_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Sum_Analytics_Org_Practice_Areas_Seller_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Sum_Analytics_Org_Practice_Areas_Seller_Aggregated_Fields>;
  min?: Maybe<Sum_Analytics_Org_Practice_Areas_Seller_Aggregated_Fields>;
  sum?: Maybe<Sum_Analytics_Org_Practice_Areas_Seller_Aggregated_Fields>;
  sumDistinct?: Maybe<Sum_Analytics_Org_Practice_Areas_Seller_Aggregated_Fields>;
};

export type Sum_Analytics_Org_Practice_Areas_Seller_Aggregated_Count = {
  __typename?: 'sum_analytics_org_practice_areas_seller_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  avg_referring_fees?: Maybe<Scalars['Int']['output']>;
  matched_cases_count?: Maybe<Scalars['Int']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  metric_id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  practice_area?: Maybe<Scalars['Int']['output']>;
  signed_cases_count?: Maybe<Scalars['Int']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Int']['output']>;
  signed_matched_ratio?: Maybe<Scalars['Int']['output']>;
  total_cases_count?: Maybe<Scalars['Int']['output']>;
};

export type Sum_Analytics_Org_Practice_Areas_Seller_Aggregated_Fields = {
  __typename?: 'sum_analytics_org_practice_areas_seller_aggregated_fields';
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Float']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
  signed_matched_ratio?: Maybe<Scalars['Float']['output']>;
  total_cases_count?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Org_Practice_Areas_Seller_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Sum_Analytics_Org_Practice_Areas_Seller_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Sum_Analytics_Org_Practice_Areas_Seller_Filter>>>;
  avg_referring_fees?: InputMaybe<Number_Filter_Operators>;
  matched_cases_count?: InputMaybe<Number_Filter_Operators>;
  matched_cases_percentage?: InputMaybe<Number_Filter_Operators>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  metric_id?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<String_Filter_Operators>;
  practice_area?: InputMaybe<String_Filter_Operators>;
  signed_cases_count?: InputMaybe<Number_Filter_Operators>;
  signed_cases_percentage?: InputMaybe<Number_Filter_Operators>;
  signed_matched_ratio?: InputMaybe<Number_Filter_Operators>;
  total_cases_count?: InputMaybe<Number_Filter_Operators>;
};

export type Sum_Analytics_Org_Practice_Areas_Seller_Mutated = {
  __typename?: 'sum_analytics_org_practice_areas_seller_mutated';
  data?: Maybe<Sum_Analytics_Org_Practice_Areas_Seller>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Sum_Analytics_Org_Top_Attorneys_Buyer = {
  __typename?: 'sum_analytics_org_top_attorneys_buyer';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  attorney_id?: Maybe<Scalars['String']['output']>;
  attorney_name?: Maybe<Scalars['String']['output']>;
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  metric_id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  referring_organization_id?: Maybe<Scalars['String']['output']>;
  referring_organization_name?: Maybe<Scalars['String']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Org_Top_Attorneys_Buyer_Aggregated = {
  __typename?: 'sum_analytics_org_top_attorneys_buyer_aggregated';
  avg?: Maybe<Sum_Analytics_Org_Top_Attorneys_Buyer_Aggregated_Fields>;
  avgDistinct?: Maybe<Sum_Analytics_Org_Top_Attorneys_Buyer_Aggregated_Fields>;
  count?: Maybe<Sum_Analytics_Org_Top_Attorneys_Buyer_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Sum_Analytics_Org_Top_Attorneys_Buyer_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Sum_Analytics_Org_Top_Attorneys_Buyer_Aggregated_Fields>;
  min?: Maybe<Sum_Analytics_Org_Top_Attorneys_Buyer_Aggregated_Fields>;
  sum?: Maybe<Sum_Analytics_Org_Top_Attorneys_Buyer_Aggregated_Fields>;
  sumDistinct?: Maybe<Sum_Analytics_Org_Top_Attorneys_Buyer_Aggregated_Fields>;
};

export type Sum_Analytics_Org_Top_Attorneys_Buyer_Aggregated_Count = {
  __typename?: 'sum_analytics_org_top_attorneys_buyer_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  attorney_id?: Maybe<Scalars['Int']['output']>;
  attorney_name?: Maybe<Scalars['Int']['output']>;
  avg_referring_fees?: Maybe<Scalars['Int']['output']>;
  matched_cases_count?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  metric_id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  organization_name?: Maybe<Scalars['Int']['output']>;
  referring_organization_id?: Maybe<Scalars['Int']['output']>;
  referring_organization_name?: Maybe<Scalars['Int']['output']>;
  signed_cases_count?: Maybe<Scalars['Int']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Int']['output']>;
};

export type Sum_Analytics_Org_Top_Attorneys_Buyer_Aggregated_Fields = {
  __typename?: 'sum_analytics_org_top_attorneys_buyer_aggregated_fields';
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Org_Top_Attorneys_Buyer_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Sum_Analytics_Org_Top_Attorneys_Buyer_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Sum_Analytics_Org_Top_Attorneys_Buyer_Filter>>>;
  attorney_id?: InputMaybe<String_Filter_Operators>;
  attorney_name?: InputMaybe<String_Filter_Operators>;
  avg_referring_fees?: InputMaybe<Number_Filter_Operators>;
  matched_cases_count?: InputMaybe<Number_Filter_Operators>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  metric_id?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<String_Filter_Operators>;
  organization_name?: InputMaybe<String_Filter_Operators>;
  referring_organization_id?: InputMaybe<String_Filter_Operators>;
  referring_organization_name?: InputMaybe<String_Filter_Operators>;
  signed_cases_count?: InputMaybe<Number_Filter_Operators>;
  signed_cases_percentage?: InputMaybe<Number_Filter_Operators>;
};

export type Sum_Analytics_Org_Top_Attorneys_Buyer_Mutated = {
  __typename?: 'sum_analytics_org_top_attorneys_buyer_mutated';
  data?: Maybe<Sum_Analytics_Org_Top_Attorneys_Buyer>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Sum_Analytics_Org_Top_Attorneys_Seller = {
  __typename?: 'sum_analytics_org_top_attorneys_seller';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  attorney_id?: Maybe<Scalars['String']['output']>;
  attorney_name?: Maybe<Scalars['String']['output']>;
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  metric_id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  referee_organization_id?: Maybe<Scalars['String']['output']>;
  referee_organization_name?: Maybe<Scalars['String']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Org_Top_Attorneys_Seller_Aggregated = {
  __typename?: 'sum_analytics_org_top_attorneys_seller_aggregated';
  avg?: Maybe<Sum_Analytics_Org_Top_Attorneys_Seller_Aggregated_Fields>;
  avgDistinct?: Maybe<Sum_Analytics_Org_Top_Attorneys_Seller_Aggregated_Fields>;
  count?: Maybe<Sum_Analytics_Org_Top_Attorneys_Seller_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Sum_Analytics_Org_Top_Attorneys_Seller_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Sum_Analytics_Org_Top_Attorneys_Seller_Aggregated_Fields>;
  min?: Maybe<Sum_Analytics_Org_Top_Attorneys_Seller_Aggregated_Fields>;
  sum?: Maybe<Sum_Analytics_Org_Top_Attorneys_Seller_Aggregated_Fields>;
  sumDistinct?: Maybe<Sum_Analytics_Org_Top_Attorneys_Seller_Aggregated_Fields>;
};

export type Sum_Analytics_Org_Top_Attorneys_Seller_Aggregated_Count = {
  __typename?: 'sum_analytics_org_top_attorneys_seller_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  attorney_id?: Maybe<Scalars['Int']['output']>;
  attorney_name?: Maybe<Scalars['Int']['output']>;
  avg_referring_fees?: Maybe<Scalars['Int']['output']>;
  matched_cases_count?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  metric_id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  organization_name?: Maybe<Scalars['Int']['output']>;
  referee_organization_id?: Maybe<Scalars['Int']['output']>;
  referee_organization_name?: Maybe<Scalars['Int']['output']>;
  signed_cases_count?: Maybe<Scalars['Int']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Int']['output']>;
};

export type Sum_Analytics_Org_Top_Attorneys_Seller_Aggregated_Fields = {
  __typename?: 'sum_analytics_org_top_attorneys_seller_aggregated_fields';
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Org_Top_Attorneys_Seller_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Sum_Analytics_Org_Top_Attorneys_Seller_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Sum_Analytics_Org_Top_Attorneys_Seller_Filter>>>;
  attorney_id?: InputMaybe<String_Filter_Operators>;
  attorney_name?: InputMaybe<String_Filter_Operators>;
  avg_referring_fees?: InputMaybe<Number_Filter_Operators>;
  matched_cases_count?: InputMaybe<Number_Filter_Operators>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  metric_id?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<String_Filter_Operators>;
  organization_name?: InputMaybe<String_Filter_Operators>;
  referee_organization_id?: InputMaybe<String_Filter_Operators>;
  referee_organization_name?: InputMaybe<String_Filter_Operators>;
  signed_cases_count?: InputMaybe<Number_Filter_Operators>;
  signed_cases_percentage?: InputMaybe<Number_Filter_Operators>;
};

export type Sum_Analytics_Org_Top_Attorneys_Seller_Mutated = {
  __typename?: 'sum_analytics_org_top_attorneys_seller_mutated';
  data?: Maybe<Sum_Analytics_Org_Top_Attorneys_Seller>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Sum_Analytics_Top_Attorneys = {
  __typename?: 'sum_analytics_top_attorneys';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  attorney_id?: Maybe<Scalars['String']['output']>;
  attorney_name?: Maybe<Scalars['String']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  metric_id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  referee_count?: Maybe<Scalars['Float']['output']>;
  referring_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Top_Attorneys_Aggregated = {
  __typename?: 'sum_analytics_top_attorneys_aggregated';
  avg?: Maybe<Sum_Analytics_Top_Attorneys_Aggregated_Fields>;
  avgDistinct?: Maybe<Sum_Analytics_Top_Attorneys_Aggregated_Fields>;
  count?: Maybe<Sum_Analytics_Top_Attorneys_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Sum_Analytics_Top_Attorneys_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Sum_Analytics_Top_Attorneys_Aggregated_Fields>;
  min?: Maybe<Sum_Analytics_Top_Attorneys_Aggregated_Fields>;
  sum?: Maybe<Sum_Analytics_Top_Attorneys_Aggregated_Fields>;
  sumDistinct?: Maybe<Sum_Analytics_Top_Attorneys_Aggregated_Fields>;
};

export type Sum_Analytics_Top_Attorneys_Aggregated_Count = {
  __typename?: 'sum_analytics_top_attorneys_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  attorney_id?: Maybe<Scalars['Int']['output']>;
  attorney_name?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  metric_id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  referee_count?: Maybe<Scalars['Int']['output']>;
  referring_count?: Maybe<Scalars['Int']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type Sum_Analytics_Top_Attorneys_Aggregated_Fields = {
  __typename?: 'sum_analytics_top_attorneys_aggregated_fields';
  referee_count?: Maybe<Scalars['Float']['output']>;
  referring_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Top_Attorneys_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Sum_Analytics_Top_Attorneys_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Sum_Analytics_Top_Attorneys_Filter>>>;
  attorney_id?: InputMaybe<String_Filter_Operators>;
  attorney_name?: InputMaybe<String_Filter_Operators>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  metric_id?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<String_Filter_Operators>;
  referee_count?: InputMaybe<Number_Filter_Operators>;
  referring_count?: InputMaybe<Number_Filter_Operators>;
  total_count?: InputMaybe<Number_Filter_Operators>;
};

export type Sum_Analytics_Top_Attorneys_Mutated = {
  __typename?: 'sum_analytics_top_attorneys_mutated';
  data?: Maybe<Sum_Analytics_Top_Attorneys>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Sum_Analytics_Top_Practice_Areas = {
  __typename?: 'sum_analytics_top_practice_areas';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  metric_id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  practice_area?: Maybe<Scalars['String']['output']>;
  referee_count?: Maybe<Scalars['Float']['output']>;
  referring_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Top_Practice_Areas_Aggregated = {
  __typename?: 'sum_analytics_top_practice_areas_aggregated';
  avg?: Maybe<Sum_Analytics_Top_Practice_Areas_Aggregated_Fields>;
  avgDistinct?: Maybe<Sum_Analytics_Top_Practice_Areas_Aggregated_Fields>;
  count?: Maybe<Sum_Analytics_Top_Practice_Areas_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Sum_Analytics_Top_Practice_Areas_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Sum_Analytics_Top_Practice_Areas_Aggregated_Fields>;
  min?: Maybe<Sum_Analytics_Top_Practice_Areas_Aggregated_Fields>;
  sum?: Maybe<Sum_Analytics_Top_Practice_Areas_Aggregated_Fields>;
  sumDistinct?: Maybe<Sum_Analytics_Top_Practice_Areas_Aggregated_Fields>;
};

export type Sum_Analytics_Top_Practice_Areas_Aggregated_Count = {
  __typename?: 'sum_analytics_top_practice_areas_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  metric_id?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['Int']['output']>;
  practice_area?: Maybe<Scalars['Int']['output']>;
  referee_count?: Maybe<Scalars['Int']['output']>;
  referring_count?: Maybe<Scalars['Int']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type Sum_Analytics_Top_Practice_Areas_Aggregated_Fields = {
  __typename?: 'sum_analytics_top_practice_areas_aggregated_fields';
  referee_count?: Maybe<Scalars['Float']['output']>;
  referring_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Analytics_Top_Practice_Areas_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Sum_Analytics_Top_Practice_Areas_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Sum_Analytics_Top_Practice_Areas_Filter>>>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  metric_id?: InputMaybe<String_Filter_Operators>;
  organization_id?: InputMaybe<String_Filter_Operators>;
  practice_area?: InputMaybe<String_Filter_Operators>;
  referee_count?: InputMaybe<Number_Filter_Operators>;
  referring_count?: InputMaybe<Number_Filter_Operators>;
  total_count?: InputMaybe<Number_Filter_Operators>;
};

export type Sum_Analytics_Top_Practice_Areas_Mutated = {
  __typename?: 'sum_analytics_top_practice_areas_mutated';
  data?: Maybe<Sum_Analytics_Top_Practice_Areas>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Sum_Ratings_Attorney_Buyer = {
  __typename?: 'sum_ratings_attorney_buyer';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  attorney_id: Scalars['ID']['output'];
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  num_case_status_updates_completed?: Maybe<Scalars['Float']['output']>;
  num_case_status_updates_requested?: Maybe<Scalars['Float']['output']>;
  num_matches?: Maybe<Scalars['Float']['output']>;
  num_signed?: Maybe<Scalars['Float']['output']>;
  percent_case_status_updates_completed?: Maybe<Scalars['String']['output']>;
  percent_signed?: Maybe<Scalars['String']['output']>;
  responsiveness_label?: Maybe<Scalars['String']['output']>;
};

export type Sum_Ratings_Attorney_Buyer_Aggregated = {
  __typename?: 'sum_ratings_attorney_buyer_aggregated';
  avg?: Maybe<Sum_Ratings_Attorney_Buyer_Aggregated_Fields>;
  avgDistinct?: Maybe<Sum_Ratings_Attorney_Buyer_Aggregated_Fields>;
  count?: Maybe<Sum_Ratings_Attorney_Buyer_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Sum_Ratings_Attorney_Buyer_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Sum_Ratings_Attorney_Buyer_Aggregated_Fields>;
  min?: Maybe<Sum_Ratings_Attorney_Buyer_Aggregated_Fields>;
  sum?: Maybe<Sum_Ratings_Attorney_Buyer_Aggregated_Fields>;
  sumDistinct?: Maybe<Sum_Ratings_Attorney_Buyer_Aggregated_Fields>;
};

export type Sum_Ratings_Attorney_Buyer_Aggregated_Count = {
  __typename?: 'sum_ratings_attorney_buyer_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  attorney_id?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  num_case_status_updates_completed?: Maybe<Scalars['Int']['output']>;
  num_case_status_updates_requested?: Maybe<Scalars['Int']['output']>;
  num_matches?: Maybe<Scalars['Int']['output']>;
  num_signed?: Maybe<Scalars['Int']['output']>;
  percent_case_status_updates_completed?: Maybe<Scalars['Int']['output']>;
  percent_signed?: Maybe<Scalars['Int']['output']>;
  responsiveness_label?: Maybe<Scalars['Int']['output']>;
};

export type Sum_Ratings_Attorney_Buyer_Aggregated_Fields = {
  __typename?: 'sum_ratings_attorney_buyer_aggregated_fields';
  num_case_status_updates_completed?: Maybe<Scalars['Float']['output']>;
  num_case_status_updates_requested?: Maybe<Scalars['Float']['output']>;
  num_matches?: Maybe<Scalars['Float']['output']>;
  num_signed?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Ratings_Attorney_Buyer_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Sum_Ratings_Attorney_Buyer_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Sum_Ratings_Attorney_Buyer_Filter>>>;
  attorney_id?: InputMaybe<String_Filter_Operators>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  num_case_status_updates_completed?: InputMaybe<Number_Filter_Operators>;
  num_case_status_updates_requested?: InputMaybe<Number_Filter_Operators>;
  num_matches?: InputMaybe<Number_Filter_Operators>;
  num_signed?: InputMaybe<Number_Filter_Operators>;
  percent_case_status_updates_completed?: InputMaybe<String_Filter_Operators>;
  percent_signed?: InputMaybe<String_Filter_Operators>;
  responsiveness_label?: InputMaybe<String_Filter_Operators>;
};

export type Sum_Ratings_Attorney_Buyer_Mutated = {
  __typename?: 'sum_ratings_attorney_buyer_mutated';
  data?: Maybe<Sum_Ratings_Attorney_Buyer>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Sum_Ratings_Attorney_Seller = {
  __typename?: 'sum_ratings_attorney_seller';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  attorney_id: Scalars['ID']['output'];
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  num_matches?: Maybe<Scalars['Float']['output']>;
  num_referrals?: Maybe<Scalars['Float']['output']>;
  num_signed?: Maybe<Scalars['Float']['output']>;
  percent_matched?: Maybe<Scalars['String']['output']>;
  percent_signed?: Maybe<Scalars['String']['output']>;
  responsiveness_label?: Maybe<Scalars['String']['output']>;
};

export type Sum_Ratings_Attorney_Seller_Aggregated = {
  __typename?: 'sum_ratings_attorney_seller_aggregated';
  avg?: Maybe<Sum_Ratings_Attorney_Seller_Aggregated_Fields>;
  avgDistinct?: Maybe<Sum_Ratings_Attorney_Seller_Aggregated_Fields>;
  count?: Maybe<Sum_Ratings_Attorney_Seller_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<Sum_Ratings_Attorney_Seller_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
  max?: Maybe<Sum_Ratings_Attorney_Seller_Aggregated_Fields>;
  min?: Maybe<Sum_Ratings_Attorney_Seller_Aggregated_Fields>;
  sum?: Maybe<Sum_Ratings_Attorney_Seller_Aggregated_Fields>;
  sumDistinct?: Maybe<Sum_Ratings_Attorney_Seller_Aggregated_Fields>;
};

export type Sum_Ratings_Attorney_Seller_Aggregated_Count = {
  __typename?: 'sum_ratings_attorney_seller_aggregated_count';
  _fivetran_deleted?: Maybe<Scalars['Int']['output']>;
  _fivetran_synced?: Maybe<Scalars['Int']['output']>;
  attorney_id?: Maybe<Scalars['Int']['output']>;
  meta_load_date?: Maybe<Scalars['Int']['output']>;
  num_matches?: Maybe<Scalars['Int']['output']>;
  num_referrals?: Maybe<Scalars['Int']['output']>;
  num_signed?: Maybe<Scalars['Int']['output']>;
  percent_matched?: Maybe<Scalars['Int']['output']>;
  percent_signed?: Maybe<Scalars['Int']['output']>;
  responsiveness_label?: Maybe<Scalars['Int']['output']>;
};

export type Sum_Ratings_Attorney_Seller_Aggregated_Fields = {
  __typename?: 'sum_ratings_attorney_seller_aggregated_fields';
  num_matches?: Maybe<Scalars['Float']['output']>;
  num_referrals?: Maybe<Scalars['Float']['output']>;
  num_signed?: Maybe<Scalars['Float']['output']>;
};

export type Sum_Ratings_Attorney_Seller_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Sum_Ratings_Attorney_Seller_Filter>>>;
  _fivetran_deleted?: InputMaybe<Boolean_Filter_Operators>;
  _fivetran_synced?: InputMaybe<Date_Filter_Operators>;
  _fivetran_synced_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  _or?: InputMaybe<Array<InputMaybe<Sum_Ratings_Attorney_Seller_Filter>>>;
  attorney_id?: InputMaybe<String_Filter_Operators>;
  meta_load_date?: InputMaybe<Date_Filter_Operators>;
  meta_load_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  num_matches?: InputMaybe<Number_Filter_Operators>;
  num_referrals?: InputMaybe<Number_Filter_Operators>;
  num_signed?: InputMaybe<Number_Filter_Operators>;
  percent_matched?: InputMaybe<String_Filter_Operators>;
  percent_signed?: InputMaybe<String_Filter_Operators>;
  responsiveness_label?: InputMaybe<String_Filter_Operators>;
};

export type Sum_Ratings_Attorney_Seller_Mutated = {
  __typename?: 'sum_ratings_attorney_seller_mutated';
  data?: Maybe<Sum_Ratings_Attorney_Seller>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Time_Function_Filter_Operators = {
  hour?: InputMaybe<Number_Filter_Operators>;
  minute?: InputMaybe<Number_Filter_Operators>;
  second?: InputMaybe<Number_Filter_Operators>;
};

export type Time_Functions = {
  __typename?: 'time_functions';
  hour?: Maybe<Scalars['Int']['output']>;
  minute?: Maybe<Scalars['Int']['output']>;
  second?: Maybe<Scalars['Int']['output']>;
};

export type Update_Attorney_Invite_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invite_status_id?: InputMaybe<Scalars['String']['input']>;
  target_attorney_id?: InputMaybe<Scalars['String']['input']>;
  target_role_id?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Attorney_Oauth_Integration_Input = {
  attorney_id?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  integration_id?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Attorney_Profile_Award_Input = {
  attorney_profile_id?: InputMaybe<Update_Attorney_Profile_Input>;
  award_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Update_Attorney_Profile_Case_Management_Software_Input = {
  attorney_profile_id?: InputMaybe<Update_Attorney_Profile_Input>;
  case_management_software_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Update_Attorney_Profile_Communication_Preference_Input = {
  attorney_profile_id?: InputMaybe<Update_Attorney_Profile_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_email_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_notification_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_sms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  notification_level?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Attorney_Profile_Contact_Input = {
  attorney_profile_id?: InputMaybe<Update_Attorney_Profile_Input>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Attorney_Profile_Education_Input = {
  attorney_profile_id?: InputMaybe<Update_Attorney_Profile_Input>;
  grade?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  school_id?: InputMaybe<Scalars['String']['input']>;
  year_end?: InputMaybe<Scalars['Int']['input']>;
  year_start?: InputMaybe<Scalars['Int']['input']>;
};

export type Update_Attorney_Profile_Firm_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  attorney_profile_id?: InputMaybe<Update_Attorney_Profile_Input>;
  city?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['Int']['input']>;
};

export type Update_Attorney_Profile_Input = {
  attorney_id?: InputMaybe<Scalars['String']['input']>;
  awards?: InputMaybe<Array<InputMaybe<Update_Attorney_Profile_Award_Input>>>;
  bio?: InputMaybe<Scalars['String']['input']>;
  case_management_softwares?: InputMaybe<Array<InputMaybe<Update_Attorney_Profile_Case_Management_Software_Input>>>;
  communication_preference?: InputMaybe<Array<InputMaybe<Update_Attorney_Profile_Communication_Preference_Input>>>;
  contacts?: InputMaybe<Array<InputMaybe<Update_Attorney_Profile_Contact_Input>>>;
  education?: InputMaybe<Array<InputMaybe<Update_Attorney_Profile_Education_Input>>>;
  firms?: InputMaybe<Array<InputMaybe<Update_Attorney_Profile_Firm_Input>>>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languages?: InputMaybe<Array<InputMaybe<Update_Attorney_Profile_Language_Input>>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  licenses?: InputMaybe<Array<InputMaybe<Update_Attorney_Profile_License_Input>>>;
  practice_areas?: InputMaybe<Array<InputMaybe<Update_Attorney_Profile_Practice_Area_Input>>>;
  referral_source?: InputMaybe<Scalars['String']['input']>;
  years_practice?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Attorney_Profile_Language_Input = {
  attorney_profile_id?: InputMaybe<Update_Attorney_Profile_Input>;
  id?: InputMaybe<Scalars['ID']['input']>;
  language_id?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Attorney_Profile_License_Input = {
  attorney_profile_id?: InputMaybe<Update_Attorney_Profile_Input>;
  bar_number?: InputMaybe<Scalars['String']['input']>;
  has_been_disciplined_by_bar?: InputMaybe<Scalars['Boolean']['input']>;
  has_been_sued_by_malpractice?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  insurances?: InputMaybe<Array<InputMaybe<Update_Attorney_Profile_License_Insurance_Input>>>;
  is_license_suspended?: InputMaybe<Scalars['Boolean']['input']>;
  license_state?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Attorney_Profile_License_Insurance_Input = {
  attorney_profile_license_id?: InputMaybe<Update_Attorney_Profile_License_Input>;
  expiration_date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  insurance_coverage_id?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Attorney_Profile_Notification_Level_Input = {
  attorney_profile_id?: InputMaybe<Scalars['String']['input']>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notification_level?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Attorney_Profile_Practice_Area_Input = {
  attorney_profile_id?: InputMaybe<Update_Attorney_Profile_Input>;
  id?: InputMaybe<Scalars['ID']['input']>;
  practice_area_id?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Attorney_Waterfall_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  attorney_id?: InputMaybe<Scalars['String']['input']>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  current_item_id?: InputMaybe<Update_Case_Purchase_Input>;
  current_item_order?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  item_count?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Array<InputMaybe<Update_Case_Purchase_Input>>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Attorney_Waterfall_List_Input = {
  fee?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<Update_Attorney_Waterfall_List_Item_Input>>>;
  jurisdictions?: InputMaybe<Array<InputMaybe<Update_Attorney_Waterfall_List_Jdx_Input>>>;
  lcms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Update_Organization_Input>;
  practice_areas?: InputMaybe<Array<InputMaybe<Update_Attorney_Waterfall_List_Pa_Input>>>;
  priority_access_duration?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Attorney_Waterfall_List_Item_Input = {
  attorney_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  list_order?: InputMaybe<Scalars['Int']['input']>;
  waterfall_list_id?: InputMaybe<Update_Attorney_Waterfall_List_Input>;
};

export type Update_Attorney_Waterfall_List_Jdx_Input = {
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jdx_id?: InputMaybe<Scalars['String']['input']>;
  waterfall_list_id?: InputMaybe<Update_Attorney_Waterfall_List_Input>;
};

export type Update_Attorney_Waterfall_List_Pa_Input = {
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  practice_area_id?: InputMaybe<Scalars['String']['input']>;
  waterfall_list_id?: InputMaybe<Update_Attorney_Waterfall_List_Input>;
};

export type Update_Case_Affiliation_Input = {
  affiliation_id?: InputMaybe<Scalars['String']['input']>;
  case_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Update_Case_Fee_Overrides_Input = {
  auto_charge_date?: InputMaybe<Scalars['Date']['input']>;
  auto_charge_days?: InputMaybe<Scalars['Int']['input']>;
  case_id?: InputMaybe<Update_Case_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  expiration_date?: InputMaybe<Scalars['Date']['input']>;
  expiration_days?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  match_fee?: InputMaybe<Scalars['Float']['input']>;
};

export type Update_Case_File_Input = {
  alias?: InputMaybe<Scalars['String']['input']>;
  case_file_type?: InputMaybe<Scalars['String']['input']>;
  case_id?: InputMaybe<Update_Case_Input>;
  file_id?: InputMaybe<Update_Directus_Files_Input>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Update_Case_Input = {
  case_alias?: InputMaybe<Scalars['String']['input']>;
  case_number?: InputMaybe<Scalars['String']['input']>;
  case_source?: InputMaybe<Scalars['String']['input']>;
  /** Midstream referral: referring firm currently represents this client; contact info withheld from the buyer until shared */
  client_currently_represented?: InputMaybe<Scalars['Boolean']['input']>;
  data_room_filename?: InputMaybe<Scalars['String']['input']>;
  data_room_filesize?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_formatted?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Array<InputMaybe<Update_Case_File_Input>>>;
  financing_source?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  incident_date?: InputMaybe<Scalars['Date']['input']>;
  internal_case_number?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  leads?: InputMaybe<Array<InputMaybe<Update_Case_Lead_Input>>>;
  mp_visibility?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferred_language?: InputMaybe<Scalars['String']['input']>;
  process_stage?: InputMaybe<Scalars['String']['input']>;
  proposal_due_date?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Case_Lead_Contact_Input = {
  case_lead_id?: InputMaybe<Update_Case_Lead_Input>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Case_Lead_Input = {
  case_id?: InputMaybe<Update_Case_Input>;
  contacts?: InputMaybe<Array<InputMaybe<Update_Case_Lead_Contact_Input>>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Case_Ownership_Input = {
  case_id?: InputMaybe<Scalars['String']['input']>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Case_Purchase_Input = {
  active_ts?: InputMaybe<Scalars['Date']['input']>;
  case_id?: InputMaybe<Update_Case_Input>;
  contact_shared_by?: InputMaybe<Update_Directus_Users_Input>;
  /** When client contact info was shared with the buyer */
  contact_shared_ts?: InputMaybe<Scalars['Date']['input']>;
  created_by?: InputMaybe<Scalars['String']['input']>;
  created_by_user_id?: InputMaybe<Update_Directus_Users_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  fee_agreement_status?: InputMaybe<Scalars['String']['input']>;
  fee_agreement_status_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  in_progress_by?: InputMaybe<Update_Directus_Users_Input>;
  in_progress_ts?: InputMaybe<Scalars['Date']['input']>;
  is_in_progress?: InputMaybe<Scalars['Boolean']['input']>;
  ownerships?: InputMaybe<Array<InputMaybe<Update_Case_Purchase_Ownership_Input>>>;
  prospect_attorney_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_ts?: InputMaybe<Scalars['Date']['input']>;
  time_unit?: InputMaybe<Scalars['String']['input']>;
  timed_access_limit?: InputMaybe<Scalars['Int']['input']>;
  waterfall_id?: InputMaybe<Update_Attorney_Waterfall_Input>;
  waterfall_order?: InputMaybe<Scalars['Int']['input']>;
};

export type Update_Case_Purchase_Ownership_Input = {
  case_purchase_id?: InputMaybe<Update_Case_Purchase_Input>;
  id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Update_Directus_Users_Input>;
};

export type Update_Case_Status_Update_Scheduler_Task_Input = {
  case_id?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Update_Config_Lcms_Leaddocket_Input = {
  api_key?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instance_url?: InputMaybe<Scalars['String']['input']>;
  intake_form_url?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Update_Organization_Input>;
};

export type Update_Directus_Files_Input = {
  charset?: InputMaybe<Scalars['String']['input']>;
  created_on?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  embed?: InputMaybe<Scalars['String']['input']>;
  filename_disk?: InputMaybe<Scalars['String']['input']>;
  filename_download?: InputMaybe<Scalars['String']['input']>;
  filesize?: InputMaybe<Scalars['GraphQLBigInt']['input']>;
  focal_point_x?: InputMaybe<Scalars['Int']['input']>;
  focal_point_y?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Update_Directus_Folders_Input>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  modified_by?: InputMaybe<Update_Directus_Users_Input>;
  modified_on?: InputMaybe<Scalars['Date']['input']>;
  storage?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tus_data?: InputMaybe<Scalars['JSON']['input']>;
  tus_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uploaded_by?: InputMaybe<Update_Directus_Users_Input>;
  uploaded_on?: InputMaybe<Scalars['Date']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type Update_Directus_Folders_Input = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Update_Directus_Folders_Input>;
};

export type Update_Directus_Users_Input = {
  avatar?: InputMaybe<Update_Directus_Files_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['Hash']['input']>;
  tfa_secret?: InputMaybe<Scalars['Hash']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['Hash']['input']>;
};

export type Update_Filter_Redundant_Input = {
  /** Dimension: affiliation name or *. */
  affiliations_id?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: community name or *. */
  communities_id?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: firm name or *. */
  created_by_firm_id?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: created by user name or *. */
  created_by_user_id?: InputMaybe<Scalars['String']['input']>;
  /** FK to saved_filters. */
  filter_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Dimension: market_fit or *. */
  market_fit?: InputMaybe<Scalars['String']['input']>;
  /** Email of user for saved_filters.on_behalf_of. */
  on_behalf_of_email?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: practice area or *. */
  practice_area_id?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: process stage or *. */
  process_stage_id?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: state name or *. */
  us_state_id?: InputMaybe<Scalars['String']['input']>;
  /** Email of saved_filters.user_id. */
  user_email?: InputMaybe<Scalars['String']['input']>;
  /** Organization id of filter owner from organization_user. */
  user_organization_id?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: zip code or *. */
  zip_code?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: city zip or *. */
  zip_code_city_zip_code?: InputMaybe<Scalars['String']['input']>;
  /** Dimension: "County, ST" or *. */
  zip_code_county?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Lcms_Case_Mapping_Input = {
  case_id?: InputMaybe<Scalars['ID']['input']>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  lcms_case_id?: InputMaybe<Scalars['String']['input']>;
  lcms_id?: InputMaybe<Scalars['String']['input']>;
  lcms_lead_id?: InputMaybe<Scalars['String']['input']>;
  lcms_opportunity_id?: InputMaybe<Scalars['String']['input']>;
  updated_ts?: InputMaybe<Scalars['Date']['input']>;
};

export type Update_Network_User_Invite_Input = {
  completed_ts?: InputMaybe<Scalars['Date']['input']>;
  completed_user_id?: InputMaybe<Update_Directus_Users_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  send_ts?: InputMaybe<Scalars['Date']['input']>;
  sender_user_id?: InputMaybe<Update_Directus_Users_Input>;
};

export type Update_Organization_Block_Input = {
  blocked_org_id?: InputMaybe<Update_Organization_Input>;
  blocking_org_id?: InputMaybe<Update_Organization_Input>;
  created_by_user_id?: InputMaybe<Update_Directus_Users_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Update_Organization_Connected_Lcms_Input = {
  case_management_software_id?: InputMaybe<Scalars['String']['input']>;
  config_id?: InputMaybe<Scalars['String']['input']>;
  created_by?: InputMaybe<Update_Directus_Users_Input>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organization_id?: InputMaybe<Update_Organization_Input>;
};

export type Update_Organization_Input = {
  allow_attorney_wf_list?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exit-survey reason captured on self-service Premium cancellation. */
  cancellation_reason?: InputMaybe<Scalars['String']['input']>;
  /** Free-text detail when cancellation_reason = other. */
  cancellation_reason_other?: InputMaybe<Scalars['String']['input']>;
  /** When the firm confirmed self-service cancellation. */
  cancellation_requested_at?: InputMaybe<Scalars['Date']['input']>;
  created_by_user_id?: InputMaybe<Scalars['String']['input']>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  credits?: InputMaybe<Scalars['Int']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  /** End of billing cycle when Basic takes effect. */
  downgrade_effective_at?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lcms_waterfall_default_duration?: InputMaybe<Scalars['String']['input']>;
  lcms_waterfall_mapping_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  partner_source?: InputMaybe<Scalars['String']['input']>;
  /** Stripe-driven payment health for the firm. 'failed' set on invoice.payment_failed; cleared on invoice.paid. Audit trail lives in attorney_share.firm_payment_failure. */
  payment_status?: InputMaybe<Scalars['String']['input']>;
  practice_attorney_mapping?: InputMaybe<Array<InputMaybe<Update_Practice_Attorney_Mapping_Input>>>;
  profiles?: InputMaybe<Array<InputMaybe<Update_Organization_Profile_Input>>>;
  /** Derived firm-facing subscription status. Read-only — written by the subscriptions service, not editable in Directus. */
  subscription_status?: InputMaybe<Scalars['String']['input']>;
  /** Set when the firm's one-time partner trial (e.g. Supio 30-day Premium) is granted. While set, no further trial is granted at subscribe. Clear this field to deliberately re-grant a trial. */
  trial_used_at?: InputMaybe<Scalars['Date']['input']>;
  users?: InputMaybe<Array<InputMaybe<Update_Organization_User_Input>>>;
};

export type Update_Organization_Profile_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  case_management_software?: InputMaybe<Scalars['String']['input']>;
  /** ENG-1998: firm-wide case notification level; NULL reads as Essential */
  case_notification_level?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company_size?: InputMaybe<Scalars['String']['input']>;
  /** ENG-1998: Shared Inbox Address (firm contact email), lowercased */
  contact_email?: InputMaybe<Scalars['String']['input']>;
  /** ENG-1998: server-maintained, set once when the firm first sets a contact email */
  contact_email_set_ts?: InputMaybe<Scalars['Date']['input']>;
  /** ENG-1998: show the firm contact email on cases */
  contact_email_show_on_cases?: InputMaybe<Scalars['Boolean']['input']>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Domain part from the E-mail of an Organization's initial user */
  email_domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  main_goal?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Update_Organization_Input>;
  state?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Organization_Referral_Settings_Input = {
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  default_referral_fee?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organization_id?: InputMaybe<Update_Organization_Input>;
  referral_text?: InputMaybe<Scalars['String']['input']>;
  updated_ts?: InputMaybe<Scalars['Date']['input']>;
};

export type Update_Organization_User_Input = {
  can_create_wf_lists?: InputMaybe<Scalars['Boolean']['input']>;
  /** ENG-1998: member also receives a copy of case notifications at the account email */
  case_notification_copy?: InputMaybe<Scalars['Boolean']['input']>;
  delegated_organization_user_id?: InputMaybe<Update_Organization_User_Input>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organization_id?: InputMaybe<Update_Organization_Input>;
  position_bio?: InputMaybe<Scalars['String']['input']>;
  position_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type Update_Practice_Attorney_Mapping_Input = {
  attorney_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jurisdiction_id?: InputMaybe<Scalars['String']['input']>;
  organization_id?: InputMaybe<Update_Organization_Input>;
  practice_area_id?: InputMaybe<Scalars['String']['input']>;
};

export type Update_User_File_Access_Request_Input = {
  attorney_id?: InputMaybe<Scalars['String']['input']>;
  created_ts?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_granted?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  requested_by_user_id?: InputMaybe<Update_Directus_Users_Input>;
  requested_case_id?: InputMaybe<Update_Case_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type User_Account_Type = {
  __typename?: 'user_account_type';
  account_type_id?: Maybe<Catalog_Account_Type>;
  id: Scalars['ID']['output'];
  user_id?: Maybe<Directus_Users>;
};


export type User_Account_TypeAccount_Type_IdArgs = {
  filter?: InputMaybe<Catalog_Account_Type_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type User_Account_TypeUser_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type User_Account_Type_Aggregated = {
  __typename?: 'user_account_type_aggregated';
  count?: Maybe<User_Account_Type_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<User_Account_Type_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type User_Account_Type_Aggregated_Count = {
  __typename?: 'user_account_type_aggregated_count';
  account_type_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type User_Account_Type_Filter = {
  _and?: InputMaybe<Array<InputMaybe<User_Account_Type_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<User_Account_Type_Filter>>>;
  account_type_id?: InputMaybe<Catalog_Account_Type_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
  user_id?: InputMaybe<Directus_Users_Filter>;
};

export type User_Account_Type_Mutated = {
  __typename?: 'user_account_type_mutated';
  data?: Maybe<User_Account_Type>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type User_Allowed_File = {
  __typename?: 'user_allowed_file';
  case_id?: Maybe<Case>;
  file_id?: Maybe<Directus_Files>;
  id: Scalars['ID']['output'];
  user_id?: Maybe<Directus_Users>;
};


export type User_Allowed_FileCase_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type User_Allowed_FileFile_IdArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type User_Allowed_FileUser_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type User_Allowed_File_Aggregated = {
  __typename?: 'user_allowed_file_aggregated';
  count?: Maybe<User_Allowed_File_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<User_Allowed_File_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type User_Allowed_File_Aggregated_Count = {
  __typename?: 'user_allowed_file_aggregated_count';
  case_id?: Maybe<Scalars['Int']['output']>;
  file_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type User_Allowed_File_Filter = {
  _and?: InputMaybe<Array<InputMaybe<User_Allowed_File_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<User_Allowed_File_Filter>>>;
  case_id?: InputMaybe<Case_Filter>;
  file_id?: InputMaybe<Directus_Files_Filter>;
  id?: InputMaybe<String_Filter_Operators>;
  user_id?: InputMaybe<Directus_Users_Filter>;
};

export type User_Allowed_File_Mutated = {
  __typename?: 'user_allowed_file_mutated';
  data?: Maybe<User_Allowed_File>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type User_Email_Validation = {
  __typename?: 'user_email_validation';
  email: Scalars['String']['output'];
  target_organization_id: Scalars['String']['output'];
  target_role_id?: Maybe<Directus_Roles>;
  user_id?: Maybe<Directus_Users>;
  validation_ts?: Maybe<Scalars['Date']['output']>;
  validation_ts_func?: Maybe<Datetime_Functions>;
};


export type User_Email_ValidationTarget_Role_IdArgs = {
  filter?: InputMaybe<Directus_Roles_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type User_Email_ValidationUser_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type User_Email_Validation_Aggregated = {
  __typename?: 'user_email_validation_aggregated';
  count?: Maybe<User_Email_Validation_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<User_Email_Validation_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type User_Email_Validation_Aggregated_Count = {
  __typename?: 'user_email_validation_aggregated_count';
  email?: Maybe<Scalars['Int']['output']>;
  target_organization_id?: Maybe<Scalars['Int']['output']>;
  target_role_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  validation_ts?: Maybe<Scalars['Int']['output']>;
};

export type User_Email_Validation_Filter = {
  _and?: InputMaybe<Array<InputMaybe<User_Email_Validation_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<User_Email_Validation_Filter>>>;
  email?: InputMaybe<String_Filter_Operators>;
  target_organization_id?: InputMaybe<String_Filter_Operators>;
  target_role_id?: InputMaybe<Directus_Roles_Filter>;
  user_id?: InputMaybe<Directus_Users_Filter>;
  validation_ts?: InputMaybe<Date_Filter_Operators>;
  validation_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
};

export type User_Email_Validation_Mutated = {
  __typename?: 'user_email_validation_mutated';
  data?: Maybe<User_Email_Validation>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type User_File_Access_Request = {
  __typename?: 'user_file_access_request';
  attorney_id?: Maybe<Attorney>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  is_granted?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  requested_by_user_id?: Maybe<Directus_Users>;
  requested_case_id?: Maybe<Case>;
  status?: Maybe<Catalog_Access_Request_Status>;
};


export type User_File_Access_RequestAttorney_IdArgs = {
  filter?: InputMaybe<Attorney_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type User_File_Access_RequestRequested_By_User_IdArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type User_File_Access_RequestRequested_Case_IdArgs = {
  filter?: InputMaybe<Case_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type User_File_Access_RequestStatusArgs = {
  filter?: InputMaybe<Catalog_Access_Request_Status_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type User_File_Access_Request_Aggregated = {
  __typename?: 'user_file_access_request_aggregated';
  count?: Maybe<User_File_Access_Request_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']['output']>;
  countDistinct?: Maybe<User_File_Access_Request_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']['output']>;
};

export type User_File_Access_Request_Aggregated_Count = {
  __typename?: 'user_file_access_request_aggregated_count';
  attorney_id?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_granted?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['Int']['output']>;
  requested_by_user_id?: Maybe<Scalars['Int']['output']>;
  requested_case_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type User_File_Access_Request_Filter = {
  _and?: InputMaybe<Array<InputMaybe<User_File_Access_Request_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<User_File_Access_Request_Filter>>>;
  attorney_id?: InputMaybe<Attorney_Filter>;
  created_ts?: InputMaybe<Date_Filter_Operators>;
  created_ts_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  is_granted?: InputMaybe<Boolean_Filter_Operators>;
  message?: InputMaybe<String_Filter_Operators>;
  requested_by_user_id?: InputMaybe<Directus_Users_Filter>;
  requested_case_id?: InputMaybe<Case_Filter>;
  status?: InputMaybe<Catalog_Access_Request_Status_Filter>;
};

export type User_File_Access_Request_Mutated = {
  __typename?: 'user_file_access_request_mutated';
  data?: Maybe<User_File_Access_Request>;
  event?: Maybe<EventEnum>;
  key: Scalars['ID']['output'];
};

export type Version_Affiliation_Discount = {
  __typename?: 'version_affiliation_discount';
  affiliation_id?: Maybe<Scalars['JSON']['output']>;
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  end_date?: Maybe<Scalars['Date']['output']>;
  end_date_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  start_date?: Maybe<Scalars['Date']['output']>;
  start_date_func?: Maybe<Datetime_Functions>;
};

export type Version_Attorney = {
  __typename?: 'version_attorney';
  cases?: Maybe<Scalars['JSON']['output']>;
  cases_func?: Maybe<Count_Functions>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  favorites?: Maybe<Scalars['JSON']['output']>;
  favorites_func?: Maybe<Count_Functions>;
  id: Scalars['ID']['output'];
  is_vetted?: Maybe<Scalars['Boolean']['output']>;
  membership_type?: Maybe<Scalars['JSON']['output']>;
  mp_preferences?: Maybe<Scalars['JSON']['output']>;
  mp_preferences_func?: Maybe<Count_Functions>;
  oauth_integrations?: Maybe<Scalars['JSON']['output']>;
  oauth_integrations_func?: Maybe<Count_Functions>;
  profiles?: Maybe<Scalars['JSON']['output']>;
  profiles_func?: Maybe<Count_Functions>;
  stream_chat_keys?: Maybe<Scalars['JSON']['output']>;
  stream_chat_keys_func?: Maybe<Count_Functions>;
  stripe_data?: Maybe<Scalars['JSON']['output']>;
  stripe_data_func?: Maybe<Count_Functions>;
  user_id?: Maybe<Scalars['JSON']['output']>;
  waterfall_lists?: Maybe<Scalars['JSON']['output']>;
  waterfall_lists_func?: Maybe<Count_Functions>;
  waterfalls?: Maybe<Scalars['JSON']['output']>;
  waterfalls_func?: Maybe<Count_Functions>;
};

export type Version_Attorney_Case_Mp_Preference = {
  __typename?: 'version_attorney_case_mp_preference';
  attorney_id?: Maybe<Scalars['String']['output']>;
  case_id?: Maybe<Scalars['String']['output']>;
  case_mp_preference_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Chat_Key = {
  __typename?: 'version_attorney_chat_key';
  attorney_id?: Maybe<Scalars['JSON']['output']>;
  chat_token: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Version_Attorney_Favorite = {
  __typename?: 'version_attorney_favorite';
  attorney_id?: Maybe<Scalars['String']['output']>;
  favorite_attorney_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Invite = {
  __typename?: 'version_attorney_invite';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invite_status_id?: Maybe<Scalars['String']['output']>;
  target_attorney_id?: Maybe<Scalars['String']['output']>;
  target_role_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Invite_Link_Visit = {
  __typename?: 'version_attorney_invite_link_visit';
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  inviting_organization_id?: Maybe<Scalars['JSON']['output']>;
  visitor_user_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Attorney_Oauth_Integration = {
  __typename?: 'version_attorney_oauth_integration';
  attorney_id?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  integration_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Payment_Membership = {
  __typename?: 'version_attorney_payment_membership';
  attorney_id?: Maybe<Scalars['JSON']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  payment_status_id?: Maybe<Scalars['JSON']['output']>;
  subscription_id: Scalars['String']['output'];
};

export type Version_Attorney_Profile = {
  __typename?: 'version_attorney_profile';
  attorney_id?: Maybe<Scalars['String']['output']>;
  awards?: Maybe<Scalars['JSON']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  case_management_softwares?: Maybe<Scalars['JSON']['output']>;
  communication_preference?: Maybe<Scalars['JSON']['output']>;
  contacts?: Maybe<Scalars['JSON']['output']>;
  education?: Maybe<Scalars['JSON']['output']>;
  firms?: Maybe<Scalars['JSON']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  languages?: Maybe<Scalars['JSON']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Scalars['JSON']['output']>;
  practice_areas?: Maybe<Scalars['JSON']['output']>;
  referral_source?: Maybe<Scalars['String']['output']>;
  years_practice?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Profile_Affiliation = {
  __typename?: 'version_attorney_profile_affiliation';
  affiliation_id?: Maybe<Scalars['JSON']['output']>;
  attorney_profile_id?: Maybe<Scalars['JSON']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_at_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
};

export type Version_Attorney_Profile_Award = {
  __typename?: 'version_attorney_profile_award';
  attorney_profile_id?: Maybe<Scalars['JSON']['output']>;
  award_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Version_Attorney_Profile_Case_Management_Software = {
  __typename?: 'version_attorney_profile_case_management_software';
  attorney_profile_id?: Maybe<Scalars['JSON']['output']>;
  case_management_software_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Version_Attorney_Profile_Communication_Preference = {
  __typename?: 'version_attorney_profile_communication_preference';
  attorney_profile_id?: Maybe<Scalars['JSON']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_email_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_notification_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_sms_enabled?: Maybe<Scalars['Boolean']['output']>;
  notification_level?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Profile_Contact = {
  __typename?: 'version_attorney_profile_contact';
  attorney_profile_id?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Profile_Education = {
  __typename?: 'version_attorney_profile_education';
  attorney_profile_id?: Maybe<Scalars['JSON']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  school_id?: Maybe<Scalars['String']['output']>;
  year_end?: Maybe<Scalars['Int']['output']>;
  year_start?: Maybe<Scalars['Int']['output']>;
};

export type Version_Attorney_Profile_Firm = {
  __typename?: 'version_attorney_profile_firm';
  address?: Maybe<Scalars['String']['output']>;
  attorney_profile_id?: Maybe<Scalars['JSON']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['Int']['output']>;
};

export type Version_Attorney_Profile_Language = {
  __typename?: 'version_attorney_profile_language';
  attorney_profile_id?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  language_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Profile_License = {
  __typename?: 'version_attorney_profile_license';
  attorney_profile_id?: Maybe<Scalars['JSON']['output']>;
  bar_number?: Maybe<Scalars['String']['output']>;
  has_been_disciplined_by_bar?: Maybe<Scalars['Boolean']['output']>;
  has_been_sued_by_malpractice?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insurances?: Maybe<Scalars['JSON']['output']>;
  is_license_suspended?: Maybe<Scalars['Boolean']['output']>;
  license_state?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Profile_License_Insurance = {
  __typename?: 'version_attorney_profile_license_insurance';
  attorney_profile_license_id?: Maybe<Scalars['JSON']['output']>;
  expiration_date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insurance_coverage_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Profile_Notification_Level = {
  __typename?: 'version_attorney_profile_notification_level';
  attorney_profile_id?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  notification_level?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Profile_Practice_Area = {
  __typename?: 'version_attorney_profile_practice_area';
  attorney_profile_id?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  practice_area_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Stripe = {
  __typename?: 'version_attorney_stripe';
  attorney_id?: Maybe<Scalars['String']['output']>;
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Waterfall = {
  __typename?: 'version_attorney_waterfall';
  alias?: Maybe<Scalars['String']['output']>;
  attorney_id?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  current_item_id?: Maybe<Scalars['JSON']['output']>;
  current_item_order?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  item_count?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Waterfall_List = {
  __typename?: 'version_attorney_waterfall_list';
  fee?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_visible?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Scalars['JSON']['output']>;
  jurisdictions?: Maybe<Scalars['JSON']['output']>;
  lcms_enabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['JSON']['output']>;
  practice_areas?: Maybe<Scalars['JSON']['output']>;
  priority_access_duration?: Maybe<Scalars['String']['output']>;
};

export type Version_Attorney_Waterfall_List_Item = {
  __typename?: 'version_attorney_waterfall_list_item';
  attorney_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  list_order?: Maybe<Scalars['Int']['output']>;
  waterfall_list_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Attorney_Waterfall_List_Jdx = {
  __typename?: 'version_attorney_waterfall_list_jdx';
  created_ts?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  jdx_id?: Maybe<Scalars['String']['output']>;
  waterfall_list_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Attorney_Waterfall_List_Pa = {
  __typename?: 'version_attorney_waterfall_list_pa';
  created_ts?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  practice_area_id?: Maybe<Scalars['String']['output']>;
  waterfall_list_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Case = {
  __typename?: 'version_case';
  case_alias?: Maybe<Scalars['String']['output']>;
  case_number?: Maybe<Scalars['String']['output']>;
  case_source?: Maybe<Scalars['String']['output']>;
  /** Midstream referral: referring firm currently represents this client; contact info withheld from the buyer until shared */
  client_currently_represented?: Maybe<Scalars['Boolean']['output']>;
  data_room_filename?: Maybe<Scalars['String']['output']>;
  data_room_filesize?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  description_formatted?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  files?: Maybe<Scalars['JSON']['output']>;
  financing_source?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incident_date?: Maybe<Scalars['Date']['output']>;
  internal_case_number?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  leads?: Maybe<Scalars['JSON']['output']>;
  mp_visibility?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  preferred_language?: Maybe<Scalars['String']['output']>;
  process_stage?: Maybe<Scalars['String']['output']>;
  proposal_due_date?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type Version_Case_Affiliation = {
  __typename?: 'version_case_affiliation';
  affiliation_id?: Maybe<Scalars['String']['output']>;
  case_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Version_Case_Fee_Overrides = {
  __typename?: 'version_case_fee_overrides';
  auto_charge_date?: Maybe<Scalars['Date']['output']>;
  auto_charge_days?: Maybe<Scalars['Int']['output']>;
  case_id?: Maybe<Scalars['JSON']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  expiration_date?: Maybe<Scalars['Date']['output']>;
  expiration_days?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  match_fee?: Maybe<Scalars['Float']['output']>;
};

export type Version_Case_File = {
  __typename?: 'version_case_file';
  alias?: Maybe<Scalars['String']['output']>;
  case_file_type?: Maybe<Scalars['String']['output']>;
  case_id?: Maybe<Scalars['JSON']['output']>;
  file_id?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Version_Case_Lead = {
  __typename?: 'version_case_lead';
  case_id?: Maybe<Scalars['JSON']['output']>;
  contacts?: Maybe<Scalars['JSON']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
};

export type Version_Case_Lead_Contact = {
  __typename?: 'version_case_lead_contact';
  case_lead_id?: Maybe<Scalars['JSON']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Version_Case_Lead_Score = {
  __typename?: 'version_case_lead_score';
  case_id?: Maybe<Scalars['JSON']['output']>;
  confidence: Scalars['Float']['output'];
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  market_fit: Scalars['String']['output'];
  quality_score: Scalars['Int']['output'];
  suggestions?: Maybe<Scalars['JSON']['output']>;
  suggestions_func?: Maybe<Count_Functions>;
};

export type Version_Case_Management_Software = {
  __typename?: 'version_case_management_software';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Case_Ownership = {
  __typename?: 'version_case_ownership';
  case_id?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Case_Purchase = {
  __typename?: 'version_case_purchase';
  active_ts?: Maybe<Scalars['Date']['output']>;
  case_id?: Maybe<Scalars['JSON']['output']>;
  contact_shared_by?: Maybe<Scalars['JSON']['output']>;
  /** When client contact info was shared with the buyer */
  contact_shared_ts?: Maybe<Scalars['Date']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  created_by_user_id?: Maybe<Scalars['JSON']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  fee_agreement_status?: Maybe<Scalars['String']['output']>;
  fee_agreement_status_ts?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  in_progress_by?: Maybe<Scalars['JSON']['output']>;
  in_progress_ts?: Maybe<Scalars['Date']['output']>;
  is_in_progress?: Maybe<Scalars['Boolean']['output']>;
  ownerships?: Maybe<Scalars['JSON']['output']>;
  prospect_attorney_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_ts?: Maybe<Scalars['Date']['output']>;
  time_unit?: Maybe<Scalars['String']['output']>;
  timed_access_limit?: Maybe<Scalars['Int']['output']>;
  waterfall_id?: Maybe<Scalars['JSON']['output']>;
  waterfall_order?: Maybe<Scalars['Int']['output']>;
};

export type Version_Case_Purchase_Activity = {
  __typename?: 'version_case_purchase_activity';
  activity_entry_status?: Maybe<Scalars['String']['output']>;
  case_purchase_id?: Maybe<Scalars['JSON']['output']>;
  created_by: Scalars['String']['output'];
  created_by_user_id?: Maybe<Scalars['JSON']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  decline_reason_id?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  fee: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  origin_id?: Maybe<Scalars['String']['output']>;
  /** ENG-2122: set only on Unmatched activities. */
  unmatch_reason_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Case_Purchase_Ownership = {
  __typename?: 'version_case_purchase_ownership';
  case_purchase_id?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  user_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Case_Purchase_Payment = {
  __typename?: 'version_case_purchase_payment';
  amount: Scalars['Float']['output'];
  amount_audit?: Maybe<Scalars['JSON']['output']>;
  attorney_id?: Maybe<Scalars['String']['output']>;
  case_purchase_id?: Maybe<Scalars['JSON']['output']>;
  created_by_user_id?: Maybe<Scalars['JSON']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  payment_intent?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  payment_status_id?: Maybe<Scalars['String']['output']>;
  stripe_invoice_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Case_Purchase_Sign_Request = {
  __typename?: 'version_case_purchase_sign_request';
  case_purchase_id?: Maybe<Scalars['JSON']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  sign_request_id: Scalars['String']['output'];
  sign_request_status_id?: Maybe<Scalars['JSON']['output']>;
  url_file?: Maybe<Scalars['String']['output']>;
  url_final_copy?: Maybe<Scalars['String']['output']>;
  url_request?: Maybe<Scalars['String']['output']>;
};

export type Version_Case_Status_Update = {
  __typename?: 'version_case_status_update';
  actual_settlement_value?: Maybe<Scalars['Float']['output']>;
  case_id: Scalars['String']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['JSON']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  estimated_settlement_value?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  matter_stage: Scalars['String']['output'];
  matter_status: Scalars['String']['output'];
};

export type Version_Case_Status_Update_Scheduler_Task = {
  __typename?: 'version_case_status_update_scheduler_task';
  case_id?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Version_Catalog_Access_Request_Status = {
  __typename?: 'version_catalog_access_request_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Account_Type = {
  __typename?: 'version_catalog_account_type';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Activity_Origin = {
  __typename?: 'version_catalog_activity_origin';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Version_Catalog_Affiliation = {
  __typename?: 'version_catalog_affiliation';
  badge_image_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_hidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
};

export type Version_Catalog_Award = {
  __typename?: 'version_catalog_award';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Case_Alert = {
  __typename?: 'version_catalog_case_alert';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  position: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type Version_Catalog_Case_File_Type = {
  __typename?: 'version_catalog_case_file_type';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Case_Mp_Preference = {
  __typename?: 'version_catalog_case_mp_preference';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Case_Mp_Visibility = {
  __typename?: 'version_catalog_case_mp_visibility';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Case_Purchase_Decline_Reason = {
  __typename?: 'version_catalog_case_purchase_decline_reason';
  id: Scalars['ID']['output'];
  is_case_relistable?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type Version_Catalog_Case_Purchase_Status = {
  __typename?: 'version_catalog_case_purchase_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Case_Purchase_Unmatch_Reason = {
  __typename?: 'version_catalog_case_purchase_unmatch_reason';
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  /** Copy shown in the Unmatch & Repost modal. */
  label: Scalars['String']['output'];
  /** Stable key used in code and Segment (unmatch_reason_key). Do not change once in use. */
  name: Scalars['String']['output'];
  /** When true the seller must type a free-text reason (stored in case_purchase_activity.message). */
  requires_text: Scalars['Boolean']['output'];
  /** Display order in the modal (ascending). */
  sort_order: Scalars['Int']['output'];
};

export type Version_Catalog_Case_Source = {
  __typename?: 'version_catalog_case_source';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Version_Catalog_Case_Status_Update_Matter_Stage = {
  __typename?: 'version_catalog_case_status_update_matter_stage';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type Version_Catalog_Case_Status_Update_Matter_Status = {
  __typename?: 'version_catalog_case_status_update_matter_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type Version_Catalog_Communication_Preference = {
  __typename?: 'version_catalog_communication_preference';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Version_Catalog_Community_Expiration_Duration = {
  __typename?: 'version_catalog_community_expiration_duration';
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Company_Size = {
  __typename?: 'version_catalog_company_size';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type Version_Catalog_Contact_Type = {
  __typename?: 'version_catalog_contact_type';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Credit_Price_Type = {
  __typename?: 'version_catalog_credit_price_type';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Version_Catalog_Credit_Status = {
  __typename?: 'version_catalog_credit_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Education_Grade = {
  __typename?: 'version_catalog_education_grade';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Exempt_Email_Domain = {
  __typename?: 'version_catalog_exempt_email_domain';
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  domain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Version_Catalog_Fee = {
  __typename?: 'version_catalog_fee';
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price_type?: Maybe<Scalars['JSON']['output']>;
  stripe_price_id: Scalars['String']['output'];
};

export type Version_Catalog_Fee_Agreement_Status = {
  __typename?: 'version_catalog_fee_agreement_status';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Version_Catalog_Financing_Source = {
  __typename?: 'version_catalog_financing_source';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Firm_Relationship = {
  __typename?: 'version_catalog_firm_relationship';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type Version_Catalog_Invite_Status = {
  __typename?: 'version_catalog_invite_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Language = {
  __typename?: 'version_catalog_language';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_License_Status = {
  __typename?: 'version_catalog_license_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Malpractice_Insurance = {
  __typename?: 'version_catalog_malpractice_insurance';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
};

export type Version_Catalog_Membership_Type = {
  __typename?: 'version_catalog_membership_type';
  id: Scalars['ID']['output'];
  is_default?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Notification_Level = {
  __typename?: 'version_catalog_notification_level';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type Version_Catalog_Oauth_Integration = {
  __typename?: 'version_catalog_oauth_integration';
  connect_url_envar: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Version_Catalog_Payment_Method = {
  __typename?: 'version_catalog_payment_method';
  id: Scalars['ID']['output'];
  is_default?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Payment_Status = {
  __typename?: 'version_catalog_payment_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Practice_Area = {
  __typename?: 'version_catalog_practice_area';
  id: Scalars['ID']['output'];
  is_default?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  practice_area_bundle?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Catalog_Practice_Area_Bundle = {
  __typename?: 'version_catalog_practice_area_bundle';
  bundle_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Version_Catalog_Process_Stage = {
  __typename?: 'version_catalog_process_stage';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

export type Version_Catalog_Referral_Network_List_Item_Status = {
  __typename?: 'version_catalog_referral_network_list_item_status';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Version_Catalog_Referral_Network_List_Status = {
  __typename?: 'version_catalog_referral_network_list_status';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Version_Catalog_Referral_Network_Type = {
  __typename?: 'version_catalog_referral_network_type';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Version_Catalog_Role_Invite = {
  __typename?: 'version_catalog_role_invite';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Catalog_Sign_Request_Status = {
  __typename?: 'version_catalog_sign_request_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Time_Unit = {
  __typename?: 'version_catalog_time_unit';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Us_State = {
  __typename?: 'version_catalog_us_state';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Waterfall_Duration = {
  __typename?: 'version_catalog_waterfall_duration';
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Waterfall_Status = {
  __typename?: 'version_catalog_waterfall_status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Catalog_Years_Practice = {
  __typename?: 'version_catalog_years_practice';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type Version_Catalog_Zip_Code = {
  __typename?: 'version_catalog_zip_code';
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  created_at_func?: Maybe<Datetime_Functions>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  updated_at_func?: Maybe<Datetime_Functions>;
  zip_code: Scalars['ID']['output'];
};

export type Version_Config_Lcms_Leaddocket = {
  __typename?: 'version_config_lcms_leaddocket';
  api_key?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  instance_url?: Maybe<Scalars['String']['output']>;
  intake_form_url?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Dismissed_Invite_Suggestions = {
  __typename?: 'version_dismissed_invite_suggestions';
  attorney_id?: Maybe<Scalars['JSON']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  dismissed_by_user_id?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Fct_Affiliation_Members = {
  __typename?: 'version_fct_affiliation_members';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  affiliation?: Maybe<Scalars['String']['output']>;
  affiliation_id?: Maybe<Scalars['String']['output']>;
  attorney_id?: Maybe<Scalars['String']['output']>;
  bar_license_number?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  member_id: Scalars['ID']['output'];
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  phone_number?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Filter_Daily_Digest_Pending = {
  __typename?: 'version_filter_daily_digest_pending';
  /** Matched case ID */
  case_id?: Maybe<Scalars['String']['output']>;
  /** Jurisdiction name */
  case_jurisdiction?: Maybe<Scalars['String']['output']>;
  /** Direct link to case */
  case_link: Scalars['String']['output'];
  /** Case name snapshot */
  case_name: Scalars['String']['output'];
  /** Practice area name */
  case_type?: Maybe<Scalars['String']['output']>;
  /** When the pending row was created */
  created_at?: Maybe<Scalars['Date']['output']>;
  created_at_func?: Maybe<Datetime_Functions>;
  /** Asking fee */
  fee?: Maybe<Scalars['Int']['output']>;
  filter_id?: Maybe<Scalars['JSON']['output']>;
  /** Filter name at time of match */
  filter_name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** On-behalf-of email */
  on_behalf_of_email?: Maybe<Scalars['String']['output']>;
  /** Seller organization ID */
  organization_id?: Maybe<Scalars['String']['output']>;
  /** Seller organization name */
  organization_name?: Maybe<Scalars['String']['output']>;
  /** Seller first name */
  seller_first_name?: Maybe<Scalars['String']['output']>;
  /** Seller last name */
  seller_last_name?: Maybe<Scalars['String']['output']>;
  /** When the digest was sent (NULL = pending) */
  sent_at?: Maybe<Scalars['Date']['output']>;
  sent_at_func?: Maybe<Datetime_Functions>;
  /** Recipient email */
  user_email: Scalars['String']['output'];
};

export type Version_Filter_Redundant = {
  __typename?: 'version_filter_redundant';
  /** Dimension: affiliation name or *. */
  affiliations_id?: Maybe<Scalars['String']['output']>;
  /** Dimension: community name or *. */
  communities_id?: Maybe<Scalars['String']['output']>;
  /** Dimension: firm name or *. */
  created_by_firm_id?: Maybe<Scalars['String']['output']>;
  /** Dimension: created by user name or *. */
  created_by_user_id?: Maybe<Scalars['String']['output']>;
  /** FK to saved_filters. */
  filter_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Dimension: market_fit or *. */
  market_fit?: Maybe<Scalars['String']['output']>;
  /** Email of user for saved_filters.on_behalf_of. */
  on_behalf_of_email?: Maybe<Scalars['String']['output']>;
  /** Dimension: practice area or *. */
  practice_area_id?: Maybe<Scalars['String']['output']>;
  /** Dimension: process stage or *. */
  process_stage_id?: Maybe<Scalars['String']['output']>;
  /** Dimension: state name or *. */
  us_state_id?: Maybe<Scalars['String']['output']>;
  /** Email of saved_filters.user_id. */
  user_email?: Maybe<Scalars['String']['output']>;
  /** Organization id of filter owner from organization_user. */
  user_organization_id?: Maybe<Scalars['String']['output']>;
  /** Dimension: zip code or *. */
  zip_code?: Maybe<Scalars['String']['output']>;
  /** Dimension: city zip or *. */
  zip_code_city_zip_code?: Maybe<Scalars['String']['output']>;
  /** Dimension: "County, ST" or *. */
  zip_code_county?: Maybe<Scalars['String']['output']>;
};

export type Version_Invitation_Discount = {
  __typename?: 'version_invitation_discount';
  amount: Scalars['Float']['output'];
  apply_to_invitation?: Maybe<Scalars['Boolean']['output']>;
  apply_to_waterfall?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  end_date?: Maybe<Scalars['Date']['output']>;
  end_date_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['JSON']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  start_date_func?: Maybe<Datetime_Functions>;
};

export type Version_Lcms_Case_Mapping = {
  __typename?: 'version_lcms_case_mapping';
  case_id?: Maybe<Scalars['ID']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  lcms_case_id?: Maybe<Scalars['String']['output']>;
  lcms_id?: Maybe<Scalars['String']['output']>;
  lcms_lead_id?: Maybe<Scalars['String']['output']>;
  lcms_opportunity_id?: Maybe<Scalars['String']['output']>;
  updated_ts?: Maybe<Scalars['Date']['output']>;
};

export type Version_Lcms_Health_Check = {
  __typename?: 'version_lcms_health_check';
  health_check_timestamp: Scalars['Date']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  lcms_config_id?: Maybe<Scalars['String']['output']>;
  lcms_health: Scalars['Boolean']['output'];
  lcms_health_http_status_code: Scalars['Int']['output'];
  org_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Master_Attorney = {
  __typename?: 'version_master_attorney';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  affiliations?: Maybe<Scalars['String']['output']>;
  attorney_id: Scalars['ID']['output'];
  calendar_id?: Maybe<Scalars['String']['output']>;
  case_management_software?: Maybe<Scalars['String']['output']>;
  connected_case_management_software?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  education_law_school?: Maybe<Scalars['String']['output']>;
  education_undergraduate_school?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  has_profile_photo?: Maybe<Scalars['Boolean']['output']>;
  is_vetted?: Maybe<Scalars['Boolean']['output']>;
  jurisdictions?: Maybe<Scalars['String']['output']>;
  klaviyo_profile_id?: Maybe<Scalars['String']['output']>;
  languages_spoken?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  membership_type?: Maybe<Scalars['String']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  notification_level?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  practice_areas?: Maybe<Scalars['String']['output']>;
  primary_license_bar_number?: Maybe<Scalars['String']['output']>;
  primary_license_state?: Maybe<Scalars['String']['output']>;
  referral_source?: Maybe<Scalars['String']['output']>;
  role_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  years_practice?: Maybe<Scalars['String']['output']>;
};

export type Version_Master_Case = {
  __typename?: 'version_master_case';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  attorney_id?: Maybe<Scalars['String']['output']>;
  attorney_name?: Maybe<Scalars['String']['output']>;
  calendar_id?: Maybe<Scalars['String']['output']>;
  case_id: Scalars['ID']['output'];
  case_type?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  description?: Maybe<Scalars['String']['output']>;
  desired_fee_perc?: Maybe<Scalars['Float']['output']>;
  financing_source?: Maybe<Scalars['String']['output']>;
  internal_case_number?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  lcms_case_id?: Maybe<Scalars['String']['output']>;
  lcms_name?: Maybe<Scalars['String']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  name?: Maybe<Scalars['String']['output']>;
  num_negotiations?: Maybe<Scalars['Float']['output']>;
  num_watchers?: Maybe<Scalars['Float']['output']>;
  organization_id?: Maybe<Scalars['String']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  practice_area?: Maybe<Scalars['String']['output']>;
  preferred_language?: Maybe<Scalars['String']['output']>;
  process_stage?: Maybe<Scalars['String']['output']>;
  reporting_status?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_ts?: Maybe<Scalars['Date']['output']>;
  status_ts_func?: Maybe<Datetime_Functions>;
};

export type Version_Master_Organization = {
  __typename?: 'version_master_organization';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  address_city?: Maybe<Scalars['String']['output']>;
  address_state?: Maybe<Scalars['String']['output']>;
  address_street?: Maybe<Scalars['String']['output']>;
  calendar_id?: Maybe<Scalars['String']['output']>;
  connected_case_management_software?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  description?: Maybe<Scalars['String']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id: Scalars['ID']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type Version_Master_Referral = {
  __typename?: 'version_master_referral';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  calendar_id?: Maybe<Scalars['String']['output']>;
  calendar_id_auto_charge?: Maybe<Scalars['String']['output']>;
  calendar_id_expiration?: Maybe<Scalars['String']['output']>;
  calendar_id_match_fee_expected_collection_date?: Maybe<Scalars['String']['output']>;
  calendar_id_match_fee_paid_on?: Maybe<Scalars['String']['output']>;
  calendar_id_matched?: Maybe<Scalars['String']['output']>;
  calendar_id_signed?: Maybe<Scalars['String']['output']>;
  calendar_id_status_update?: Maybe<Scalars['String']['output']>;
  case_created_ts?: Maybe<Scalars['Date']['output']>;
  case_created_ts_func?: Maybe<Datetime_Functions>;
  case_id?: Maybe<Scalars['String']['output']>;
  case_name?: Maybe<Scalars['String']['output']>;
  case_status?: Maybe<Scalars['String']['output']>;
  case_status_ts?: Maybe<Scalars['Date']['output']>;
  case_status_ts_func?: Maybe<Datetime_Functions>;
  case_status_update_comments?: Maybe<Scalars['String']['output']>;
  case_status_update_created_ts?: Maybe<Scalars['Date']['output']>;
  case_status_update_created_ts_func?: Maybe<Datetime_Functions>;
  case_status_update_matter_stage?: Maybe<Scalars['String']['output']>;
  case_status_update_matter_status?: Maybe<Scalars['String']['output']>;
  case_type?: Maybe<Scalars['String']['output']>;
  contact_first_name?: Maybe<Scalars['String']['output']>;
  contact_last_name?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  days_until_match_fee_collection?: Maybe<Scalars['Float']['output']>;
  fee_percentage?: Maybe<Scalars['Float']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  match_date?: Maybe<Scalars['Date']['output']>;
  match_date_func?: Maybe<Datetime_Functions>;
  match_fee_amount_expected?: Maybe<Scalars['Float']['output']>;
  match_fee_amount_paid?: Maybe<Scalars['Float']['output']>;
  match_fee_expected_amount?: Maybe<Scalars['Float']['output']>;
  match_fee_expected_collection_date?: Maybe<Scalars['Date']['output']>;
  match_fee_expected_collection_date_func?: Maybe<Date_Functions>;
  match_fee_paid_on?: Maybe<Scalars['Date']['output']>;
  match_fee_paid_on_func?: Maybe<Datetime_Functions>;
  match_fee_payment_method?: Maybe<Scalars['String']['output']>;
  match_fee_payment_status?: Maybe<Scalars['String']['output']>;
  match_fee_payment_type?: Maybe<Scalars['String']['output']>;
  matched_date_ts?: Maybe<Scalars['Date']['output']>;
  matched_date_ts_func?: Maybe<Datetime_Functions>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  practice_area?: Maybe<Scalars['String']['output']>;
  prospect_attorney_id?: Maybe<Scalars['String']['output']>;
  prospect_attorney_name?: Maybe<Scalars['String']['output']>;
  prospect_membership_type?: Maybe<Scalars['String']['output']>;
  prospect_organization_id?: Maybe<Scalars['String']['output']>;
  prospect_organization_name?: Maybe<Scalars['String']['output']>;
  referral_id: Scalars['ID']['output'];
  referring_attorney_id?: Maybe<Scalars['String']['output']>;
  referring_attorney_name?: Maybe<Scalars['String']['output']>;
  referring_membership_type?: Maybe<Scalars['String']['output']>;
  referring_organization_id?: Maybe<Scalars['String']['output']>;
  referring_organization_name?: Maybe<Scalars['String']['output']>;
  signed_date_ts?: Maybe<Scalars['Date']['output']>;
  signed_date_ts_func?: Maybe<Datetime_Functions>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type Version_Network_User_Invite = {
  __typename?: 'version_network_user_invite';
  completed_ts?: Maybe<Scalars['Date']['output']>;
  completed_user_id?: Maybe<Scalars['JSON']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  send_ts?: Maybe<Scalars['Date']['output']>;
  sender_user_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Notification = {
  __typename?: 'version_notification';
  /** Notification content/message */
  content: Scalars['String']['output'];
  /** When the notification was created */
  created_at?: Maybe<Scalars['Date']['output']>;
  created_at_func?: Maybe<Datetime_Functions>;
  /** When the notification expires */
  expires_at?: Maybe<Scalars['Date']['output']>;
  expires_at_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  /** Additional metadata for the notification */
  metadata?: Maybe<Scalars['JSON']['output']>;
  metadata_func?: Maybe<Count_Functions>;
  /** When the notification was read */
  read_at?: Maybe<Scalars['Date']['output']>;
  read_at_func?: Maybe<Datetime_Functions>;
  /** Notification status */
  status?: Maybe<Scalars['String']['output']>;
  /** Notification title */
  title: Scalars['String']['output'];
  /** Type of notification */
  type: Scalars['String']['output'];
  /** When the notification was last updated */
  updated_at?: Maybe<Scalars['Date']['output']>;
  updated_at_func?: Maybe<Datetime_Functions>;
  user_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Organization = {
  __typename?: 'version_organization';
  allow_attorney_wf_list?: Maybe<Scalars['Boolean']['output']>;
  /** Exit-survey reason captured on self-service Premium cancellation. */
  cancellation_reason?: Maybe<Scalars['String']['output']>;
  /** Free-text detail when cancellation_reason = other. */
  cancellation_reason_other?: Maybe<Scalars['String']['output']>;
  /** When the firm confirmed self-service cancellation. */
  cancellation_requested_at?: Maybe<Scalars['Date']['output']>;
  created_by_user_id?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  credits?: Maybe<Scalars['Int']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
  /** End of billing cycle when Basic takes effect. */
  downgrade_effective_at?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lcms_waterfall_default_duration?: Maybe<Scalars['String']['output']>;
  lcms_waterfall_mapping_enabled?: Maybe<Scalars['Boolean']['output']>;
  partner_source?: Maybe<Scalars['String']['output']>;
  /** Stripe-driven payment health for the firm. 'failed' set on invoice.payment_failed; cleared on invoice.paid. Audit trail lives in attorney_share.firm_payment_failure. */
  payment_status?: Maybe<Scalars['String']['output']>;
  practice_attorney_mapping?: Maybe<Scalars['JSON']['output']>;
  profiles?: Maybe<Scalars['JSON']['output']>;
  /** Derived firm-facing subscription status. Read-only — written by the subscriptions service, not editable in Directus. */
  subscription_status?: Maybe<Scalars['String']['output']>;
  /** Set when the firm's one-time partner trial (e.g. Supio 30-day Premium) is granted. While set, no further trial is granted at subscribe. Clear this field to deliberately re-grant a trial. */
  trial_used_at?: Maybe<Scalars['Date']['output']>;
  users?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Organization_Block = {
  __typename?: 'version_organization_block';
  blocked_org_id?: Maybe<Scalars['JSON']['output']>;
  blocking_org_id?: Maybe<Scalars['JSON']['output']>;
  created_by_user_id?: Maybe<Scalars['JSON']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Version_Organization_Connected_Lcms = {
  __typename?: 'version_organization_connected_lcms';
  case_management_software_id?: Maybe<Scalars['String']['output']>;
  config_id?: Maybe<Scalars['String']['output']>;
  created_by?: Maybe<Scalars['JSON']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organization_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Organization_Discount = {
  __typename?: 'version_organization_discount';
  comment: Scalars['String']['output'];
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  discount_id: Scalars['String']['output'];
  expiration_date?: Maybe<Scalars['Date']['output']>;
  expiration_date_func?: Maybe<Date_Functions>;
  id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['JSON']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  start_date_func?: Maybe<Date_Functions>;
};

export type Version_Organization_Profile = {
  __typename?: 'version_organization_profile';
  address?: Maybe<Scalars['String']['output']>;
  case_management_software?: Maybe<Scalars['String']['output']>;
  /** ENG-1998: firm-wide case notification level; NULL reads as Essential */
  case_notification_level?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company_size?: Maybe<Scalars['String']['output']>;
  /** ENG-1998: Shared Inbox Address (firm contact email), lowercased */
  contact_email?: Maybe<Scalars['String']['output']>;
  /** ENG-1998: server-maintained, set once when the firm first sets a contact email */
  contact_email_set_ts?: Maybe<Scalars['Date']['output']>;
  /** ENG-1998: show the firm contact email on cases */
  contact_email_show_on_cases?: Maybe<Scalars['Boolean']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Domain part from the E-mail of an Organization's initial user */
  email_domain?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  main_goal?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['JSON']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type Version_Organization_Referral_Settings = {
  __typename?: 'version_organization_referral_settings';
  created_ts?: Maybe<Scalars['Date']['output']>;
  default_referral_fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organization_id?: Maybe<Scalars['JSON']['output']>;
  referral_text?: Maybe<Scalars['String']['output']>;
  updated_ts?: Maybe<Scalars['Date']['output']>;
};

export type Version_Organization_User = {
  __typename?: 'version_organization_user';
  can_create_wf_lists?: Maybe<Scalars['Boolean']['output']>;
  /** ENG-1998: member also receives a copy of case notifications at the account email */
  case_notification_copy?: Maybe<Scalars['Boolean']['output']>;
  delegated_organization_user_id?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  organization_id?: Maybe<Scalars['JSON']['output']>;
  position_bio?: Maybe<Scalars['String']['output']>;
  position_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Practice_Area_Overrides = {
  __typename?: 'version_practice_area_overrides';
  auto_charge_days?: Maybe<Scalars['Int']['output']>;
  expiration_days?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  match_fee?: Maybe<Scalars['Float']['output']>;
  practice_area_id?: Maybe<Scalars['JSON']['output']>;
  process_stage_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Practice_Attorney_Mapping = {
  __typename?: 'version_practice_attorney_mapping';
  attorney_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  jurisdiction_id?: Maybe<Scalars['String']['output']>;
  organization_id?: Maybe<Scalars['JSON']['output']>;
  practice_area_id?: Maybe<Scalars['String']['output']>;
};

export type Version_Referral_Network = {
  __typename?: 'version_referral_network';
  attorneys_per_round?: Maybe<Scalars['Int']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  marketplace_fallback_rounds?: Maybe<Scalars['Int']['output']>;
  maximum_attorneys?: Maybe<Scalars['Int']['output']>;
  organization_id?: Maybe<Scalars['JSON']['output']>;
  time_per_attorney?: Maybe<Scalars['Int']['output']>;
  time_per_round?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['JSON']['output']>;
  updated_ts?: Maybe<Scalars['Date']['output']>;
  updated_ts_func?: Maybe<Datetime_Functions>;
};

export type Version_Referral_Network_Broadcast_Audit = {
  __typename?: 'version_referral_network_broadcast_audit';
  accepted_by_attorney_id?: Maybe<Scalars['String']['output']>;
  accepted_in_round?: Maybe<Scalars['Int']['output']>;
  attorneys_per_round: Scalars['Int']['output'];
  case_id?: Maybe<Scalars['JSON']['output']>;
  case_owner_attorney_id: Scalars['String']['output'];
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  ended_at?: Maybe<Scalars['Date']['output']>;
  ended_at_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  jurisdiction_id?: Maybe<Scalars['String']['output']>;
  list_id?: Maybe<Scalars['JSON']['output']>;
  marketplace_fallback_rounds: Scalars['Int']['output'];
  network_id?: Maybe<Scalars['JSON']['output']>;
  organization_id: Scalars['String']['output'];
  outcome?: Maybe<Scalars['String']['output']>;
  practice_area_id?: Maybe<Scalars['String']['output']>;
  started_at?: Maybe<Scalars['Date']['output']>;
  started_at_func?: Maybe<Datetime_Functions>;
  time_per_round: Scalars['Int']['output'];
  total_attorneys_invited: Scalars['Int']['output'];
  total_rounds_executed?: Maybe<Scalars['Int']['output']>;
  updated_ts?: Maybe<Scalars['Date']['output']>;
  updated_ts_func?: Maybe<Datetime_Functions>;
};

export type Version_Referral_Network_List = {
  __typename?: 'version_referral_network_list';
  case_id?: Maybe<Scalars['JSON']['output']>;
  completed_at?: Maybe<Scalars['Date']['output']>;
  completed_at_func?: Maybe<Datetime_Functions>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  network_id?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Referral_Network_List_Item = {
  __typename?: 'version_referral_network_list_item';
  attorney_id?: Maybe<Scalars['JSON']['output']>;
  case_purchase_id?: Maybe<Scalars['JSON']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  expires_at?: Maybe<Scalars['Date']['output']>;
  expires_at_func?: Maybe<Datetime_Functions>;
  fee_percentage: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  list_id?: Maybe<Scalars['JSON']['output']>;
  notified_at?: Maybe<Scalars['Date']['output']>;
  notified_at_func?: Maybe<Datetime_Functions>;
  previous_item?: Maybe<Scalars['JSON']['output']>;
  responded_at?: Maybe<Scalars['Date']['output']>;
  responded_at_func?: Maybe<Datetime_Functions>;
  /** Broadcast round number (NULL for waterfall items) */
  round_number?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Referral_Network_Member = {
  __typename?: 'version_referral_network_member';
  added_ts?: Maybe<Scalars['Date']['output']>;
  added_ts_func?: Maybe<Datetime_Functions>;
  attorney_id?: Maybe<Scalars['JSON']['output']>;
  deleted_ts?: Maybe<Scalars['Date']['output']>;
  deleted_ts_func?: Maybe<Datetime_Functions>;
  fee_percentage: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  jurisdictions?: Maybe<Scalars['JSON']['output']>;
  jurisdictions_func?: Maybe<Count_Functions>;
  last_assignation_ts?: Maybe<Scalars['Date']['output']>;
  last_assignation_ts_func?: Maybe<Datetime_Functions>;
  network_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Referral_Network_Member_Jurisdiction = {
  __typename?: 'version_referral_network_member_jurisdiction';
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID']['output'];
  jurisdiction_id?: Maybe<Scalars['JSON']['output']>;
  member_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_Saved_Filters = {
  __typename?: 'version_saved_filters';
  /** Automatically create proposals for matching cases */
  auto_proposal: Scalars['Boolean']['output'];
  /** When the filter was created */
  created_ts?: Maybe<Scalars['Date']['output']>;
  created_ts_func?: Maybe<Datetime_Functions>;
  /** Enable email notifications for this filter */
  email_notifications: Scalars['Boolean']['output'];
  /** Filter criteria stored as JSON */
  filters?: Maybe<Scalars['JSON']['output']>;
  filters_func?: Maybe<Count_Functions>;
  /** Filter criteria with IDs (UUIDs) instead of names/codes. Same structure as filters column but with ID values. */
  filters_ids?: Maybe<Scalars['JSON']['output']>;
  filters_ids_func?: Maybe<Count_Functions>;
  id: Scalars['ID']['output'];
  /** Maximum referral fee percentage (0-100) */
  maximum_referral_fee?: Maybe<Scalars['Int']['output']>;
  /** Name of the saved filter */
  name: Scalars['String']['output'];
  /** Email notification frequency: never, instant, or daily digest */
  notification_frequency?: Maybe<Scalars['String']['output']>;
  on_behalf_of?: Maybe<Scalars['JSON']['output']>;
  /** Enable SMS notifications for this filter */
  sms_notifications: Scalars['Boolean']['output'];
  /** When the filter was last updated */
  updated_ts?: Maybe<Scalars['Date']['output']>;
  updated_ts_func?: Maybe<Datetime_Functions>;
  user_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_School = {
  __typename?: 'version_school';
  name?: Maybe<Scalars['String']['output']>;
};

export type Version_Sum_Analytics_Attorney_Metrics = {
  __typename?: 'version_sum_analytics_attorney_metrics';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  attorney_id: Scalars['ID']['output'];
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  invites_received_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Float']['output']>;
  matches_as_referee_count?: Maybe<Scalars['Float']['output']>;
  matches_as_referee_percentage?: Maybe<Scalars['Float']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  posted_cases_count?: Maybe<Scalars['Float']['output']>;
  proposals_sent_count?: Maybe<Scalars['Float']['output']>;
  signed_as_referee_count?: Maybe<Scalars['Float']['output']>;
  signed_as_referee_percentage?: Maybe<Scalars['Float']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
};

export type Version_Sum_Analytics_Freshness = {
  __typename?: 'version_sum_analytics_freshness';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  last_successful_run?: Maybe<Scalars['Date']['output']>;
  last_successful_run_func?: Maybe<Datetime_Functions>;
  next_scheduled_run?: Maybe<Scalars['Date']['output']>;
  next_scheduled_run_func?: Maybe<Datetime_Functions>;
  run_id: Scalars['ID']['output'];
};

export type Version_Sum_Analytics_Org_Metrics = {
  __typename?: 'version_sum_analytics_org_metrics';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  invites_received_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Float']['output']>;
  matches_as_referee_count?: Maybe<Scalars['Float']['output']>;
  matches_as_referee_percentage?: Maybe<Scalars['Float']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  organization_id: Scalars['ID']['output'];
  posted_cases_count?: Maybe<Scalars['Float']['output']>;
  proposals_sent_count?: Maybe<Scalars['Float']['output']>;
  signed_as_referee_count?: Maybe<Scalars['Float']['output']>;
  signed_as_referee_percentage?: Maybe<Scalars['Float']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
};

export type Version_Sum_Analytics_Org_Practice_Areas_Buyer = {
  __typename?: 'version_sum_analytics_org_practice_areas_buyer';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Float']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  metric_id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  practice_area?: Maybe<Scalars['String']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
  signed_matched_ratio?: Maybe<Scalars['Float']['output']>;
  total_cases_count?: Maybe<Scalars['Float']['output']>;
};

export type Version_Sum_Analytics_Org_Practice_Areas_Seller = {
  __typename?: 'version_sum_analytics_org_practice_areas_seller';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  matched_cases_percentage?: Maybe<Scalars['Float']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  metric_id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  practice_area?: Maybe<Scalars['String']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
  signed_matched_ratio?: Maybe<Scalars['Float']['output']>;
  total_cases_count?: Maybe<Scalars['Float']['output']>;
};

export type Version_Sum_Analytics_Org_Top_Attorneys_Buyer = {
  __typename?: 'version_sum_analytics_org_top_attorneys_buyer';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  attorney_id?: Maybe<Scalars['String']['output']>;
  attorney_name?: Maybe<Scalars['String']['output']>;
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  metric_id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  referring_organization_id?: Maybe<Scalars['String']['output']>;
  referring_organization_name?: Maybe<Scalars['String']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
};

export type Version_Sum_Analytics_Org_Top_Attorneys_Seller = {
  __typename?: 'version_sum_analytics_org_top_attorneys_seller';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  attorney_id?: Maybe<Scalars['String']['output']>;
  attorney_name?: Maybe<Scalars['String']['output']>;
  avg_referring_fees?: Maybe<Scalars['Float']['output']>;
  matched_cases_count?: Maybe<Scalars['Float']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  metric_id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  organization_name?: Maybe<Scalars['String']['output']>;
  referee_organization_id?: Maybe<Scalars['String']['output']>;
  referee_organization_name?: Maybe<Scalars['String']['output']>;
  signed_cases_count?: Maybe<Scalars['Float']['output']>;
  signed_cases_percentage?: Maybe<Scalars['Float']['output']>;
};

export type Version_Sum_Analytics_Top_Attorneys = {
  __typename?: 'version_sum_analytics_top_attorneys';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  attorney_id?: Maybe<Scalars['String']['output']>;
  attorney_name?: Maybe<Scalars['String']['output']>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  metric_id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  referee_count?: Maybe<Scalars['Float']['output']>;
  referring_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

export type Version_Sum_Analytics_Top_Practice_Areas = {
  __typename?: 'version_sum_analytics_top_practice_areas';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  metric_id: Scalars['ID']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  practice_area?: Maybe<Scalars['String']['output']>;
  referee_count?: Maybe<Scalars['Float']['output']>;
  referring_count?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
};

export type Version_Sum_Ratings_Attorney_Buyer = {
  __typename?: 'version_sum_ratings_attorney_buyer';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  attorney_id: Scalars['ID']['output'];
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  num_case_status_updates_completed?: Maybe<Scalars['Float']['output']>;
  num_case_status_updates_requested?: Maybe<Scalars['Float']['output']>;
  num_matches?: Maybe<Scalars['Float']['output']>;
  num_signed?: Maybe<Scalars['Float']['output']>;
  percent_case_status_updates_completed?: Maybe<Scalars['String']['output']>;
  percent_signed?: Maybe<Scalars['String']['output']>;
  responsiveness_label?: Maybe<Scalars['String']['output']>;
};

export type Version_Sum_Ratings_Attorney_Seller = {
  __typename?: 'version_sum_ratings_attorney_seller';
  _fivetran_deleted?: Maybe<Scalars['Boolean']['output']>;
  _fivetran_synced?: Maybe<Scalars['Date']['output']>;
  _fivetran_synced_func?: Maybe<Datetime_Functions>;
  attorney_id: Scalars['ID']['output'];
  meta_load_date?: Maybe<Scalars['Date']['output']>;
  meta_load_date_func?: Maybe<Datetime_Functions>;
  num_matches?: Maybe<Scalars['Float']['output']>;
  num_referrals?: Maybe<Scalars['Float']['output']>;
  num_signed?: Maybe<Scalars['Float']['output']>;
  percent_matched?: Maybe<Scalars['String']['output']>;
  percent_signed?: Maybe<Scalars['String']['output']>;
  responsiveness_label?: Maybe<Scalars['String']['output']>;
};

export type Version_User_Account_Type = {
  __typename?: 'version_user_account_type';
  account_type_id?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  user_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_User_Allowed_File = {
  __typename?: 'version_user_allowed_file';
  case_id?: Maybe<Scalars['JSON']['output']>;
  file_id?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  user_id?: Maybe<Scalars['JSON']['output']>;
};

export type Version_User_Email_Validation = {
  __typename?: 'version_user_email_validation';
  email: Scalars['String']['output'];
  target_organization_id: Scalars['String']['output'];
  target_role_id?: Maybe<Scalars['JSON']['output']>;
  user_id?: Maybe<Scalars['JSON']['output']>;
  validation_ts?: Maybe<Scalars['Date']['output']>;
  validation_ts_func?: Maybe<Datetime_Functions>;
};

export type Version_User_File_Access_Request = {
  __typename?: 'version_user_file_access_request';
  attorney_id?: Maybe<Scalars['String']['output']>;
  created_ts?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  is_granted?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  requested_by_user_id?: Maybe<Scalars['JSON']['output']>;
  requested_case_id?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export const OrgMetricsFieldsFragmentDoc = gql`
    fragment OrgMetricsFields on sum_analytics_org_metrics {
  organization_id
  posted_cases_count
  matched_cases_count
  matched_cases_percentage
  signed_cases_count
  signed_cases_percentage
  avg_referring_fees
  proposals_sent_count
  invites_received_count
  matches_as_referee_count
  matches_as_referee_percentage
  signed_as_referee_count
  signed_as_referee_percentage
}
    `;
export const TopBuyerAttorneysFieldsFragmentDoc = gql`
    fragment TopBuyerAttorneysFields on sum_analytics_org_top_attorneys_buyer {
  attorney_id
  attorney_name
  matched_cases_count
  signed_cases_count
  signed_cases_percentage
  organization_name
  referring_organization_name
  referring_organization_id
  organization_id
  avg_referring_fees
}
    `;
export const TopSellerAttorneysFieldsFragmentDoc = gql`
    fragment TopSellerAttorneysFields on sum_analytics_org_top_attorneys_seller {
  attorney_id
  attorney_name
  matched_cases_count
  signed_cases_count
  signed_cases_percentage
  organization_name
  referee_organization_id
  referee_organization_name
  organization_id
  avg_referring_fees
}
    `;
export const PracticeAreaPerformanceFieldsFragmentDoc = gql`
    fragment PracticeAreaPerformanceFields on sum_analytics_org_practice_areas_seller {
  metric_id
  practice_area
  total_cases_count
  matched_cases_count
  matched_cases_percentage
  signed_cases_count
  signed_cases_percentage
  signed_matched_ratio
  avg_referring_fees
}
    `;
export const PracticeAreaBuyerPerformanceFieldsFragmentDoc = gql`
    fragment PracticeAreaBuyerPerformanceFields on sum_analytics_org_practice_areas_buyer {
  metric_id
  practice_area
  total_cases_count
  matched_cases_count
  matched_cases_percentage
  signed_cases_count
  signed_cases_percentage
  signed_matched_ratio
  avg_referring_fees
}
    `;
export const AttorneyMetricsFieldsFragmentDoc = gql`
    fragment AttorneyMetricsFields on sum_analytics_attorney_metrics {
  attorney_id
  posted_cases_count
  matched_cases_count
  matched_cases_percentage
  signed_cases_count
  signed_cases_percentage
  avg_referring_fees
  proposals_sent_count
  invites_received_count
  matches_as_referee_count
  matches_as_referee_percentage
  signed_as_referee_count
  signed_as_referee_percentage
}
    `;
export const OrgMembersFieldsFragmentDoc = gql`
    fragment OrgMembersFields on organization_user {
  id
  user_id {
    id
    avatar {
      id
      filename_disk
    }
    last_name
    first_name
    attorneys {
      id
    }
  }
}
    `;
export const CreateNewCaseDocument = gql`
    mutation CreateNewCase($data: create_case_input!) {
  create_case_item(data: $data) {
    id
  }
}
    `;
export type CreateNewCaseMutationFn = Apollo.MutationFunction<CreateNewCaseMutation, CreateNewCaseMutationVariables>;

/**
 * __useCreateNewCaseMutation__
 *
 * To run a mutation, you first call `useCreateNewCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewCaseMutation, { data, loading, error }] = useCreateNewCaseMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateNewCaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewCaseMutation, CreateNewCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewCaseMutation, CreateNewCaseMutationVariables>(CreateNewCaseDocument, options);
      }
export type CreateNewCaseMutationHookResult = ReturnType<typeof useCreateNewCaseMutation>;
export type CreateNewCaseMutationResult = Apollo.MutationResult<CreateNewCaseMutation>;
export type CreateNewCaseMutationOptions = Apollo.BaseMutationOptions<CreateNewCaseMutation, CreateNewCaseMutationVariables>;
export const CreateWaterfallItemDocument = gql`
    mutation CreateWaterfallItem($data: create_attorney_waterfall_input!) {
  create_attorney_waterfall_item(data: $data) {
    id
  }
}
    `;
export type CreateWaterfallItemMutationFn = Apollo.MutationFunction<CreateWaterfallItemMutation, CreateWaterfallItemMutationVariables>;

/**
 * __useCreateWaterfallItemMutation__
 *
 * To run a mutation, you first call `useCreateWaterfallItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWaterfallItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWaterfallItemMutation, { data, loading, error }] = useCreateWaterfallItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateWaterfallItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateWaterfallItemMutation, CreateWaterfallItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWaterfallItemMutation, CreateWaterfallItemMutationVariables>(CreateWaterfallItemDocument, options);
      }
export type CreateWaterfallItemMutationHookResult = ReturnType<typeof useCreateWaterfallItemMutation>;
export type CreateWaterfallItemMutationResult = Apollo.MutationResult<CreateWaterfallItemMutation>;
export type CreateWaterfallItemMutationOptions = Apollo.BaseMutationOptions<CreateWaterfallItemMutation, CreateWaterfallItemMutationVariables>;
export const CreateCaseCatalogsDocument = gql`
    query CreateCaseCatalogs($filter: catalog_us_state_filter, $sort: [String]) {
  catalog_financing_source {
    id
    name
  }
  catalog_process_stage(sort: $sort) {
    id
    name
  }
  catalog_us_state(filter: $filter) {
    id
    name
    code
  }
  catalog_language {
    id
    name
  }
  catalog_practice_area {
    id
    name
  }
}
    `;

/**
 * __useCreateCaseCatalogsQuery__
 *
 * To run a query within a React component, call `useCreateCaseCatalogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseCatalogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateCaseCatalogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCreateCaseCatalogsQuery(baseOptions?: Apollo.QueryHookOptions<CreateCaseCatalogsQuery, CreateCaseCatalogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateCaseCatalogsQuery, CreateCaseCatalogsQueryVariables>(CreateCaseCatalogsDocument, options);
      }
export function useCreateCaseCatalogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateCaseCatalogsQuery, CreateCaseCatalogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateCaseCatalogsQuery, CreateCaseCatalogsQueryVariables>(CreateCaseCatalogsDocument, options);
        }
export type CreateCaseCatalogsQueryHookResult = ReturnType<typeof useCreateCaseCatalogsQuery>;
export type CreateCaseCatalogsLazyQueryHookResult = ReturnType<typeof useCreateCaseCatalogsLazyQuery>;
export type CreateCaseCatalogsQueryResult = Apollo.QueryResult<CreateCaseCatalogsQuery, CreateCaseCatalogsQueryVariables>;
export function refetchCreateCaseCatalogsQuery(variables?: CreateCaseCatalogsQueryVariables) {
      return { query: CreateCaseCatalogsDocument, variables: variables }
    }
export const TimeUnitsDocument = gql`
    query TimeUnits {
  catalog_time_unit {
    id
    name
  }
}
    `;

/**
 * __useTimeUnitsQuery__
 *
 * To run a query within a React component, call `useTimeUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTimeUnitsQuery(baseOptions?: Apollo.QueryHookOptions<TimeUnitsQuery, TimeUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeUnitsQuery, TimeUnitsQueryVariables>(TimeUnitsDocument, options);
      }
export function useTimeUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeUnitsQuery, TimeUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeUnitsQuery, TimeUnitsQueryVariables>(TimeUnitsDocument, options);
        }
export type TimeUnitsQueryHookResult = ReturnType<typeof useTimeUnitsQuery>;
export type TimeUnitsLazyQueryHookResult = ReturnType<typeof useTimeUnitsLazyQuery>;
export type TimeUnitsQueryResult = Apollo.QueryResult<TimeUnitsQuery, TimeUnitsQueryVariables>;
export function refetchTimeUnitsQuery(variables?: TimeUnitsQueryVariables) {
      return { query: TimeUnitsDocument, variables: variables }
    }
export const CaseFeeOverridesDocument = gql`
    query CaseFeeOverrides($filter: case_fee_overrides_filter) {
  case_fee_overrides(filter: $filter) {
    auto_charge_date
    auto_charge_days
    expiration_date
    expiration_days
    id
    created_ts
    match_fee
  }
}
    `;

/**
 * __useCaseFeeOverridesQuery__
 *
 * To run a query within a React component, call `useCaseFeeOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseFeeOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseFeeOverridesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCaseFeeOverridesQuery(baseOptions?: Apollo.QueryHookOptions<CaseFeeOverridesQuery, CaseFeeOverridesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaseFeeOverridesQuery, CaseFeeOverridesQueryVariables>(CaseFeeOverridesDocument, options);
      }
export function useCaseFeeOverridesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaseFeeOverridesQuery, CaseFeeOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaseFeeOverridesQuery, CaseFeeOverridesQueryVariables>(CaseFeeOverridesDocument, options);
        }
export type CaseFeeOverridesQueryHookResult = ReturnType<typeof useCaseFeeOverridesQuery>;
export type CaseFeeOverridesLazyQueryHookResult = ReturnType<typeof useCaseFeeOverridesLazyQuery>;
export type CaseFeeOverridesQueryResult = Apollo.QueryResult<CaseFeeOverridesQuery, CaseFeeOverridesQueryVariables>;
export function refetchCaseFeeOverridesQuery(variables?: CaseFeeOverridesQueryVariables) {
      return { query: CaseFeeOverridesDocument, variables: variables }
    }
export const CreateCaseActivityPurchaseDocument = gql`
    mutation createCaseActivityPurchase($data: create_case_purchase_activity_input!) {
  create_case_purchase_activity_item(data: $data) {
    id
    fee
  }
}
    `;
export type CreateCaseActivityPurchaseMutationFn = Apollo.MutationFunction<CreateCaseActivityPurchaseMutation, CreateCaseActivityPurchaseMutationVariables>;

/**
 * __useCreateCaseActivityPurchaseMutation__
 *
 * To run a mutation, you first call `useCreateCaseActivityPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseActivityPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseActivityPurchaseMutation, { data, loading, error }] = useCreateCaseActivityPurchaseMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCaseActivityPurchaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseActivityPurchaseMutation, CreateCaseActivityPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseActivityPurchaseMutation, CreateCaseActivityPurchaseMutationVariables>(CreateCaseActivityPurchaseDocument, options);
      }
export type CreateCaseActivityPurchaseMutationHookResult = ReturnType<typeof useCreateCaseActivityPurchaseMutation>;
export type CreateCaseActivityPurchaseMutationResult = Apollo.MutationResult<CreateCaseActivityPurchaseMutation>;
export type CreateCaseActivityPurchaseMutationOptions = Apollo.BaseMutationOptions<CreateCaseActivityPurchaseMutation, CreateCaseActivityPurchaseMutationVariables>;
export const GetActivityPurchaseDocument = gql`
    query getActivityPurchase($filter: case_purchase_activity_filter) {
  case_purchase_activity(filter: $filter) {
    id
    fee
    created_ts
    created_by {
      profiles {
        id
        first_name
        last_name
        id
        firms {
          name
        }
        attorney_id {
          id
          is_vetted
          membership_type {
            id
          }
          user_id {
            id
            email
            avatar {
              id
            }
          }
        }
      }
      is_vetted
      membership_type {
        id
      }
    }
    case_purchase_id {
      id
      active_ts
      fee_agreement_status {
        id
        name
      }
      created_by {
        profiles {
          id
          first_name
          last_name
          firms {
            name
          }
          attorney_id {
            id
            is_vetted
            membership_type {
              id
            }
            user_id {
              id
              email
              avatar {
                id
              }
            }
          }
        }
      }
      case_id {
        id
        fee
        name
        proposal_due_date
        case_alias
        incident_date
        description
        description_formatted
        following_count
        status
        created_ts
        attorney_id {
          id
          is_vetted
          membership_type {
            id
          }
          profiles {
            id
            first_name
            last_name
            firms {
              name
            }
            attorney_id {
              id
              is_vetted
              membership_type {
                id
              }
              user_id {
                id
                email
                avatar {
                  id
                }
                current_organization {
                  organization_id {
                    profiles {
                      name
                    }
                  }
                }
              }
            }
          }
        }
        mp_visibility {
          id
          name
        }
        preferred_language {
          name
        }
        process_stage {
          name
        }
        type {
          id
          name
        }
        case_number
        financing_source {
          id
          name
        }
        jurisdiction {
          name
          code
        }
        files {
          file_id {
            id
            filename_download
            metadata
          }
        }
        leads {
          id
          first_name
          last_name
          contacts {
            type {
              id
              name
            }
            value
          }
        }
        ownerships {
          id
          user_id {
            id
            role {
              id
            }
            first_name
            last_name
            avatar {
              id
            }
            current_organization {
              id
              organization_id {
                id
              }
            }
          }
        }
      }
      prospect_attorney_id {
        profiles {
          id
          first_name
          last_name
          contacts {
            type {
              id
              name
            }
            value
          }
          firms {
            name
          }
          attorney_id {
            id
            is_vetted
            membership_type {
              id
            }
            user_id {
              id
              email
              avatar {
                id
              }
              current_organization {
                organization_id {
                  profiles {
                    name
                  }
                }
              }
            }
          }
        }
      }
      waterfall_id {
        id
        current_item_order
        status {
          name
        }
        attorney_id {
          id
          is_vetted
          membership_type {
            id
          }
          user_id {
            id
            email
            avatar {
              id
            }
            current_organization {
              organization_id {
                profiles {
                  name
                }
              }
            }
          }
          profiles {
            id
            first_name
            last_name
          }
        }
        item_count
        items {
          time_unit {
            id
          }
          timed_access_limit
        }
      }
      status {
        id
        name
      }
      id
      payments {
        attorney_id {
          id
        }
        id
        payment_status_id {
          name
          id
        }
        amount
        payment_method
      }
      sign_request {
        sign_request_status_id {
          id
          name
        }
        url_request
      }
      ownerships {
        id
        user_id {
          id
          role {
            id
          }
          first_name
          last_name
          avatar {
            id
          }
          current_organization {
            id
            organization_id {
              id
            }
          }
        }
      }
    }
    activity_entry_status {
      id
      name
    }
    message
  }
}
    `;

/**
 * __useGetActivityPurchaseQuery__
 *
 * To run a query within a React component, call `useGetActivityPurchaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityPurchaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityPurchaseQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetActivityPurchaseQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityPurchaseQuery, GetActivityPurchaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityPurchaseQuery, GetActivityPurchaseQueryVariables>(GetActivityPurchaseDocument, options);
      }
export function useGetActivityPurchaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityPurchaseQuery, GetActivityPurchaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityPurchaseQuery, GetActivityPurchaseQueryVariables>(GetActivityPurchaseDocument, options);
        }
export type GetActivityPurchaseQueryHookResult = ReturnType<typeof useGetActivityPurchaseQuery>;
export type GetActivityPurchaseLazyQueryHookResult = ReturnType<typeof useGetActivityPurchaseLazyQuery>;
export type GetActivityPurchaseQueryResult = Apollo.QueryResult<GetActivityPurchaseQuery, GetActivityPurchaseQueryVariables>;
export function refetchGetActivityPurchaseQuery(variables?: GetActivityPurchaseQueryVariables) {
      return { query: GetActivityPurchaseDocument, variables: variables }
    }
export const GetCasesWatchingDocument = gql`
    query getCasesWatching($preferenceFilter: attorney_case_mp_preference_filter, $casePurchaseFilter: case_purchase_filter) {
  attorney_case_mp_preference(filter: $preferenceFilter) {
    id
    attorney_id {
      id
      is_vetted
      membership_type {
        id
      }
      user_id {
        id
        email
        avatar {
          id
        }
      }
      profiles {
        id
        first_name
        last_name
        firms {
          name
        }
      }
    }
    case_id {
      id
      name
      fee
      incident_date
      proposal_due_date
      following_count
    }
    case_mp_preference_id {
      id
      name
    }
  }
  case_purchase(filter: $casePurchaseFilter) {
    case_id {
      id
    }
  }
}
    `;

/**
 * __useGetCasesWatchingQuery__
 *
 * To run a query within a React component, call `useGetCasesWatchingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasesWatchingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasesWatchingQuery({
 *   variables: {
 *      preferenceFilter: // value for 'preferenceFilter'
 *      casePurchaseFilter: // value for 'casePurchaseFilter'
 *   },
 * });
 */
export function useGetCasesWatchingQuery(baseOptions?: Apollo.QueryHookOptions<GetCasesWatchingQuery, GetCasesWatchingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasesWatchingQuery, GetCasesWatchingQueryVariables>(GetCasesWatchingDocument, options);
      }
export function useGetCasesWatchingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasesWatchingQuery, GetCasesWatchingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasesWatchingQuery, GetCasesWatchingQueryVariables>(GetCasesWatchingDocument, options);
        }
export type GetCasesWatchingQueryHookResult = ReturnType<typeof useGetCasesWatchingQuery>;
export type GetCasesWatchingLazyQueryHookResult = ReturnType<typeof useGetCasesWatchingLazyQuery>;
export type GetCasesWatchingQueryResult = Apollo.QueryResult<GetCasesWatchingQuery, GetCasesWatchingQueryVariables>;
export function refetchGetCasesWatchingQuery(variables?: GetCasesWatchingQueryVariables) {
      return { query: GetCasesWatchingDocument, variables: variables }
    }
export const GetCasesFollowingDocument = gql`
    query GetCasesFollowing($filter: attorney_case_mp_preference_filter) {
  attorney_case_mp_preference(filter: $filter) {
    id
    case_id {
      id
    }
  }
}
    `;

/**
 * __useGetCasesFollowingQuery__
 *
 * To run a query within a React component, call `useGetCasesFollowingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasesFollowingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasesFollowingQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCasesFollowingQuery(baseOptions?: Apollo.QueryHookOptions<GetCasesFollowingQuery, GetCasesFollowingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasesFollowingQuery, GetCasesFollowingQueryVariables>(GetCasesFollowingDocument, options);
      }
export function useGetCasesFollowingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasesFollowingQuery, GetCasesFollowingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasesFollowingQuery, GetCasesFollowingQueryVariables>(GetCasesFollowingDocument, options);
        }
export type GetCasesFollowingQueryHookResult = ReturnType<typeof useGetCasesFollowingQuery>;
export type GetCasesFollowingLazyQueryHookResult = ReturnType<typeof useGetCasesFollowingLazyQuery>;
export type GetCasesFollowingQueryResult = Apollo.QueryResult<GetCasesFollowingQuery, GetCasesFollowingQueryVariables>;
export function refetchGetCasesFollowingQuery(variables?: GetCasesFollowingQueryVariables) {
      return { query: GetCasesFollowingDocument, variables: variables }
    }
export const UpdateOrganizationAndProfileDocument = gql`
    mutation UpdateOrganizationAndProfile($updateOrganizationProfileItemId: ID!, $organizationProfileData: update_organization_profile_input!, $updateProfileData: update_attorney_profile_input!, $updateAttorneyProfileItemId: ID!) {
  update_organization_profile_item(
    id: $updateOrganizationProfileItemId
    data: $organizationProfileData
  ) {
    id
  }
  update_attorney_profile_item(
    data: $updateProfileData
    id: $updateAttorneyProfileItemId
  ) {
    id
  }
}
    `;
export type UpdateOrganizationAndProfileMutationFn = Apollo.MutationFunction<UpdateOrganizationAndProfileMutation, UpdateOrganizationAndProfileMutationVariables>;

/**
 * __useUpdateOrganizationAndProfileMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAndProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAndProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAndProfileMutation, { data, loading, error }] = useUpdateOrganizationAndProfileMutation({
 *   variables: {
 *      updateOrganizationProfileItemId: // value for 'updateOrganizationProfileItemId'
 *      organizationProfileData: // value for 'organizationProfileData'
 *      updateProfileData: // value for 'updateProfileData'
 *      updateAttorneyProfileItemId: // value for 'updateAttorneyProfileItemId'
 *   },
 * });
 */
export function useUpdateOrganizationAndProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationAndProfileMutation, UpdateOrganizationAndProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationAndProfileMutation, UpdateOrganizationAndProfileMutationVariables>(UpdateOrganizationAndProfileDocument, options);
      }
export type UpdateOrganizationAndProfileMutationHookResult = ReturnType<typeof useUpdateOrganizationAndProfileMutation>;
export type UpdateOrganizationAndProfileMutationResult = Apollo.MutationResult<UpdateOrganizationAndProfileMutation>;
export type UpdateOrganizationAndProfileMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationAndProfileMutation, UpdateOrganizationAndProfileMutationVariables>;
export const UpdateOrganizationUserDocument = gql`
    mutation UpdateOrganizationUser($updateOrganizationUserItemId: ID!, $data: update_organization_user_input!) {
  update_organization_user_item(id: $updateOrganizationUserItemId, data: $data) {
    id
  }
}
    `;
export type UpdateOrganizationUserMutationFn = Apollo.MutationFunction<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>;

/**
 * __useUpdateOrganizationUserMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationUserMutation, { data, loading, error }] = useUpdateOrganizationUserMutation({
 *   variables: {
 *      updateOrganizationUserItemId: // value for 'updateOrganizationUserItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>(UpdateOrganizationUserDocument, options);
      }
export type UpdateOrganizationUserMutationHookResult = ReturnType<typeof useUpdateOrganizationUserMutation>;
export type UpdateOrganizationUserMutationResult = Apollo.MutationResult<UpdateOrganizationUserMutation>;
export type UpdateOrganizationUserMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>;
export const UpdateOrganizationFirmDocument = gql`
    mutation updateOrganizationFirm($updateOrganizationProfileItemId: ID!, $data: update_organization_profile_input!) {
  update_organization_profile_item(
    id: $updateOrganizationProfileItemId
    data: $data
  ) {
    id
  }
}
    `;
export type UpdateOrganizationFirmMutationFn = Apollo.MutationFunction<UpdateOrganizationFirmMutation, UpdateOrganizationFirmMutationVariables>;

/**
 * __useUpdateOrganizationFirmMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationFirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationFirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationFirmMutation, { data, loading, error }] = useUpdateOrganizationFirmMutation({
 *   variables: {
 *      updateOrganizationProfileItemId: // value for 'updateOrganizationProfileItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganizationFirmMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationFirmMutation, UpdateOrganizationFirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationFirmMutation, UpdateOrganizationFirmMutationVariables>(UpdateOrganizationFirmDocument, options);
      }
export type UpdateOrganizationFirmMutationHookResult = ReturnType<typeof useUpdateOrganizationFirmMutation>;
export type UpdateOrganizationFirmMutationResult = Apollo.MutationResult<UpdateOrganizationFirmMutation>;
export type UpdateOrganizationFirmMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationFirmMutation, UpdateOrganizationFirmMutationVariables>;
export const UpdateOrganizationItemDocument = gql`
    mutation updateOrganizationItem($updateOrganizationProfileItemId: ID!, $data: update_organization_profile_input!) {
  update_organization_profile_item(
    id: $updateOrganizationProfileItemId
    data: $data
  ) {
    id
  }
}
    `;
export type UpdateOrganizationItemMutationFn = Apollo.MutationFunction<UpdateOrganizationItemMutation, UpdateOrganizationItemMutationVariables>;

/**
 * __useUpdateOrganizationItemMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationItemMutation, { data, loading, error }] = useUpdateOrganizationItemMutation({
 *   variables: {
 *      updateOrganizationProfileItemId: // value for 'updateOrganizationProfileItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganizationItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationItemMutation, UpdateOrganizationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationItemMutation, UpdateOrganizationItemMutationVariables>(UpdateOrganizationItemDocument, options);
      }
export type UpdateOrganizationItemMutationHookResult = ReturnType<typeof useUpdateOrganizationItemMutation>;
export type UpdateOrganizationItemMutationResult = Apollo.MutationResult<UpdateOrganizationItemMutation>;
export type UpdateOrganizationItemMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationItemMutation, UpdateOrganizationItemMutationVariables>;
export const CreatePracticeAttorneyMappingItemsDocument = gql`
    mutation CreatePracticeAttorneyMappingItems($data: [create_practice_attorney_mapping_input!]) {
  create_practice_attorney_mapping_items(data: $data) {
    id
  }
}
    `;
export type CreatePracticeAttorneyMappingItemsMutationFn = Apollo.MutationFunction<CreatePracticeAttorneyMappingItemsMutation, CreatePracticeAttorneyMappingItemsMutationVariables>;

/**
 * __useCreatePracticeAttorneyMappingItemsMutation__
 *
 * To run a mutation, you first call `useCreatePracticeAttorneyMappingItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePracticeAttorneyMappingItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPracticeAttorneyMappingItemsMutation, { data, loading, error }] = useCreatePracticeAttorneyMappingItemsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePracticeAttorneyMappingItemsMutation(baseOptions?: Apollo.MutationHookOptions<CreatePracticeAttorneyMappingItemsMutation, CreatePracticeAttorneyMappingItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePracticeAttorneyMappingItemsMutation, CreatePracticeAttorneyMappingItemsMutationVariables>(CreatePracticeAttorneyMappingItemsDocument, options);
      }
export type CreatePracticeAttorneyMappingItemsMutationHookResult = ReturnType<typeof useCreatePracticeAttorneyMappingItemsMutation>;
export type CreatePracticeAttorneyMappingItemsMutationResult = Apollo.MutationResult<CreatePracticeAttorneyMappingItemsMutation>;
export type CreatePracticeAttorneyMappingItemsMutationOptions = Apollo.BaseMutationOptions<CreatePracticeAttorneyMappingItemsMutation, CreatePracticeAttorneyMappingItemsMutationVariables>;
export const DeletePracticeAttorneyMappingItemsDocument = gql`
    mutation DeletePracticeAttorneyMappingItems($ids: [ID]!) {
  delete_practice_attorney_mapping_items(ids: $ids) {
    ids
  }
}
    `;
export type DeletePracticeAttorneyMappingItemsMutationFn = Apollo.MutationFunction<DeletePracticeAttorneyMappingItemsMutation, DeletePracticeAttorneyMappingItemsMutationVariables>;

/**
 * __useDeletePracticeAttorneyMappingItemsMutation__
 *
 * To run a mutation, you first call `useDeletePracticeAttorneyMappingItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePracticeAttorneyMappingItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePracticeAttorneyMappingItemsMutation, { data, loading, error }] = useDeletePracticeAttorneyMappingItemsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeletePracticeAttorneyMappingItemsMutation(baseOptions?: Apollo.MutationHookOptions<DeletePracticeAttorneyMappingItemsMutation, DeletePracticeAttorneyMappingItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePracticeAttorneyMappingItemsMutation, DeletePracticeAttorneyMappingItemsMutationVariables>(DeletePracticeAttorneyMappingItemsDocument, options);
      }
export type DeletePracticeAttorneyMappingItemsMutationHookResult = ReturnType<typeof useDeletePracticeAttorneyMappingItemsMutation>;
export type DeletePracticeAttorneyMappingItemsMutationResult = Apollo.MutationResult<DeletePracticeAttorneyMappingItemsMutation>;
export type DeletePracticeAttorneyMappingItemsMutationOptions = Apollo.BaseMutationOptions<DeletePracticeAttorneyMappingItemsMutation, DeletePracticeAttorneyMappingItemsMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($updateOrganizationItemId: ID!, $data: update_organization_input!) {
  update_organization_item(id: $updateOrganizationItemId, data: $data) {
    id
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      updateOrganizationItemId: // value for 'updateOrganizationItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const CreateOrganizationBlocksDocument = gql`
    mutation CreateOrganizationBlocks($data: [create_organization_block_input!]) {
  create_organization_block_items(data: $data) {
    id
  }
}
    `;
export type CreateOrganizationBlocksMutationFn = Apollo.MutationFunction<CreateOrganizationBlocksMutation, CreateOrganizationBlocksMutationVariables>;

/**
 * __useCreateOrganizationBlocksMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationBlocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationBlocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationBlocksMutation, { data, loading, error }] = useCreateOrganizationBlocksMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrganizationBlocksMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationBlocksMutation, CreateOrganizationBlocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationBlocksMutation, CreateOrganizationBlocksMutationVariables>(CreateOrganizationBlocksDocument, options);
      }
export type CreateOrganizationBlocksMutationHookResult = ReturnType<typeof useCreateOrganizationBlocksMutation>;
export type CreateOrganizationBlocksMutationResult = Apollo.MutationResult<CreateOrganizationBlocksMutation>;
export type CreateOrganizationBlocksMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationBlocksMutation, CreateOrganizationBlocksMutationVariables>;
export const DeleteOrganizationBlockDocument = gql`
    mutation DeleteOrganizationBlock($id: ID!) {
  delete_organization_block_item(id: $id) {
    id
  }
}
    `;
export type DeleteOrganizationBlockMutationFn = Apollo.MutationFunction<DeleteOrganizationBlockMutation, DeleteOrganizationBlockMutationVariables>;

/**
 * __useDeleteOrganizationBlockMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationBlockMutation, { data, loading, error }] = useDeleteOrganizationBlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationBlockMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationBlockMutation, DeleteOrganizationBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationBlockMutation, DeleteOrganizationBlockMutationVariables>(DeleteOrganizationBlockDocument, options);
      }
export type DeleteOrganizationBlockMutationHookResult = ReturnType<typeof useDeleteOrganizationBlockMutation>;
export type DeleteOrganizationBlockMutationResult = Apollo.MutationResult<DeleteOrganizationBlockMutation>;
export type DeleteOrganizationBlockMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationBlockMutation, DeleteOrganizationBlockMutationVariables>;
export const CreateOrganizationReferralSettingsDocument = gql`
    mutation CreateOrganizationReferralSettings($data: create_organization_referral_settings_input!) {
  create_organization_referral_settings_item(data: $data) {
    id
  }
}
    `;
export type CreateOrganizationReferralSettingsMutationFn = Apollo.MutationFunction<CreateOrganizationReferralSettingsMutation, CreateOrganizationReferralSettingsMutationVariables>;

/**
 * __useCreateOrganizationReferralSettingsMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationReferralSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationReferralSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationReferralSettingsMutation, { data, loading, error }] = useCreateOrganizationReferralSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrganizationReferralSettingsMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationReferralSettingsMutation, CreateOrganizationReferralSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationReferralSettingsMutation, CreateOrganizationReferralSettingsMutationVariables>(CreateOrganizationReferralSettingsDocument, options);
      }
export type CreateOrganizationReferralSettingsMutationHookResult = ReturnType<typeof useCreateOrganizationReferralSettingsMutation>;
export type CreateOrganizationReferralSettingsMutationResult = Apollo.MutationResult<CreateOrganizationReferralSettingsMutation>;
export type CreateOrganizationReferralSettingsMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationReferralSettingsMutation, CreateOrganizationReferralSettingsMutationVariables>;
export const UpdateOrganizationReferralSettingsDocument = gql`
    mutation UpdateOrganizationReferralSettings($updateOrganizationReferralSettingsItemId: ID!, $data: update_organization_referral_settings_input!) {
  update_organization_referral_settings_item(
    id: $updateOrganizationReferralSettingsItemId
    data: $data
  ) {
    id
  }
}
    `;
export type UpdateOrganizationReferralSettingsMutationFn = Apollo.MutationFunction<UpdateOrganizationReferralSettingsMutation, UpdateOrganizationReferralSettingsMutationVariables>;

/**
 * __useUpdateOrganizationReferralSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationReferralSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationReferralSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationReferralSettingsMutation, { data, loading, error }] = useUpdateOrganizationReferralSettingsMutation({
 *   variables: {
 *      updateOrganizationReferralSettingsItemId: // value for 'updateOrganizationReferralSettingsItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganizationReferralSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationReferralSettingsMutation, UpdateOrganizationReferralSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationReferralSettingsMutation, UpdateOrganizationReferralSettingsMutationVariables>(UpdateOrganizationReferralSettingsDocument, options);
      }
export type UpdateOrganizationReferralSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationReferralSettingsMutation>;
export type UpdateOrganizationReferralSettingsMutationResult = Apollo.MutationResult<UpdateOrganizationReferralSettingsMutation>;
export type UpdateOrganizationReferralSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationReferralSettingsMutation, UpdateOrganizationReferralSettingsMutationVariables>;
export const GetOrganizationProfileDocument = gql`
    query getOrganizationProfile($filter: organization_profile_filter) {
  organization_profile(filter: $filter) {
    id
    name
    description
    address
    state
    city
    zipcode
    company_size
    case_management_software
    website_url
  }
}
    `;

/**
 * __useGetOrganizationProfileQuery__
 *
 * To run a query within a React component, call `useGetOrganizationProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationProfileQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrganizationProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables>(GetOrganizationProfileDocument, options);
      }
export function useGetOrganizationProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables>(GetOrganizationProfileDocument, options);
        }
export type GetOrganizationProfileQueryHookResult = ReturnType<typeof useGetOrganizationProfileQuery>;
export type GetOrganizationProfileLazyQueryHookResult = ReturnType<typeof useGetOrganizationProfileLazyQuery>;
export type GetOrganizationProfileQueryResult = Apollo.QueryResult<GetOrganizationProfileQuery, GetOrganizationProfileQueryVariables>;
export function refetchGetOrganizationProfileQuery(variables?: GetOrganizationProfileQueryVariables) {
      return { query: GetOrganizationProfileDocument, variables: variables }
    }
export const GetOrgAttorneysAndLicenseJurisdictionsDocument = gql`
    query GetOrgAttorneysAndLicenseJurisdictions($organizationFilter: organization_filter, $userFilter: organization_user_filter, $sort: [String]) {
  organization(filter: $organizationFilter) {
    practice_attorney_mapping(sort: $sort) {
      id
      attorney_id {
        id
      }
      organization_id {
        id
      }
      practice_area_id {
        id
      }
      jurisdiction_id {
        id
      }
    }
    users(filter: $userFilter) {
      user_id {
        attorneys {
          profiles {
            id
            first_name
            last_name
            attorney_id {
              id
              is_vetted
              membership_type {
                id
              }
              user_id {
                id
                avatar {
                  id
                }
                current_organization {
                  id
                  organization_id {
                    id
                    profiles {
                      name
                    }
                  }
                }
              }
            }
            licenses {
              license_state {
                id
                code
                name
              }
              status {
                name
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrgAttorneysAndLicenseJurisdictionsQuery__
 *
 * To run a query within a React component, call `useGetOrgAttorneysAndLicenseJurisdictionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgAttorneysAndLicenseJurisdictionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgAttorneysAndLicenseJurisdictionsQuery({
 *   variables: {
 *      organizationFilter: // value for 'organizationFilter'
 *      userFilter: // value for 'userFilter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetOrgAttorneysAndLicenseJurisdictionsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrgAttorneysAndLicenseJurisdictionsQuery, GetOrgAttorneysAndLicenseJurisdictionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgAttorneysAndLicenseJurisdictionsQuery, GetOrgAttorneysAndLicenseJurisdictionsQueryVariables>(GetOrgAttorneysAndLicenseJurisdictionsDocument, options);
      }
export function useGetOrgAttorneysAndLicenseJurisdictionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgAttorneysAndLicenseJurisdictionsQuery, GetOrgAttorneysAndLicenseJurisdictionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgAttorneysAndLicenseJurisdictionsQuery, GetOrgAttorneysAndLicenseJurisdictionsQueryVariables>(GetOrgAttorneysAndLicenseJurisdictionsDocument, options);
        }
export type GetOrgAttorneysAndLicenseJurisdictionsQueryHookResult = ReturnType<typeof useGetOrgAttorneysAndLicenseJurisdictionsQuery>;
export type GetOrgAttorneysAndLicenseJurisdictionsLazyQueryHookResult = ReturnType<typeof useGetOrgAttorneysAndLicenseJurisdictionsLazyQuery>;
export type GetOrgAttorneysAndLicenseJurisdictionsQueryResult = Apollo.QueryResult<GetOrgAttorneysAndLicenseJurisdictionsQuery, GetOrgAttorneysAndLicenseJurisdictionsQueryVariables>;
export function refetchGetOrgAttorneysAndLicenseJurisdictionsQuery(variables?: GetOrgAttorneysAndLicenseJurisdictionsQueryVariables) {
      return { query: GetOrgAttorneysAndLicenseJurisdictionsDocument, variables: variables }
    }
export const GetOrganizationLcmsWaterfallsInfoDocument = gql`
    query GetOrganizationLcmsWaterfallsInfo($filter: organization_filter) {
  organization(filter: $filter) {
    lcms_waterfall_default_duration {
      id
    }
    lcms_waterfall_mapping_enabled
  }
}
    `;

/**
 * __useGetOrganizationLcmsWaterfallsInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizationLcmsWaterfallsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationLcmsWaterfallsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationLcmsWaterfallsInfoQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrganizationLcmsWaterfallsInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationLcmsWaterfallsInfoQuery, GetOrganizationLcmsWaterfallsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationLcmsWaterfallsInfoQuery, GetOrganizationLcmsWaterfallsInfoQueryVariables>(GetOrganizationLcmsWaterfallsInfoDocument, options);
      }
export function useGetOrganizationLcmsWaterfallsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationLcmsWaterfallsInfoQuery, GetOrganizationLcmsWaterfallsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationLcmsWaterfallsInfoQuery, GetOrganizationLcmsWaterfallsInfoQueryVariables>(GetOrganizationLcmsWaterfallsInfoDocument, options);
        }
export type GetOrganizationLcmsWaterfallsInfoQueryHookResult = ReturnType<typeof useGetOrganizationLcmsWaterfallsInfoQuery>;
export type GetOrganizationLcmsWaterfallsInfoLazyQueryHookResult = ReturnType<typeof useGetOrganizationLcmsWaterfallsInfoLazyQuery>;
export type GetOrganizationLcmsWaterfallsInfoQueryResult = Apollo.QueryResult<GetOrganizationLcmsWaterfallsInfoQuery, GetOrganizationLcmsWaterfallsInfoQueryVariables>;
export function refetchGetOrganizationLcmsWaterfallsInfoQuery(variables?: GetOrganizationLcmsWaterfallsInfoQueryVariables) {
      return { query: GetOrganizationLcmsWaterfallsInfoDocument, variables: variables }
    }
export const GetOrganizationBlocksDocument = gql`
    query GetOrganizationBlocks($filter: organization_block_filter) {
  organization_block(filter: $filter) {
    id
    blocked_org_id {
      id
      profiles {
        name
      }
    }
    blocking_org_id {
      id
    }
    created_ts
  }
}
    `;

/**
 * __useGetOrganizationBlocksQuery__
 *
 * To run a query within a React component, call `useGetOrganizationBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationBlocksQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrganizationBlocksQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationBlocksQuery, GetOrganizationBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationBlocksQuery, GetOrganizationBlocksQueryVariables>(GetOrganizationBlocksDocument, options);
      }
export function useGetOrganizationBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationBlocksQuery, GetOrganizationBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationBlocksQuery, GetOrganizationBlocksQueryVariables>(GetOrganizationBlocksDocument, options);
        }
export type GetOrganizationBlocksQueryHookResult = ReturnType<typeof useGetOrganizationBlocksQuery>;
export type GetOrganizationBlocksLazyQueryHookResult = ReturnType<typeof useGetOrganizationBlocksLazyQuery>;
export type GetOrganizationBlocksQueryResult = Apollo.QueryResult<GetOrganizationBlocksQuery, GetOrganizationBlocksQueryVariables>;
export function refetchGetOrganizationBlocksQuery(variables?: GetOrganizationBlocksQueryVariables) {
      return { query: GetOrganizationBlocksDocument, variables: variables }
    }
export const GetOrganizationReferralSettingsDocument = gql`
    query GetOrganizationReferralSettings($filter: organization_referral_settings_filter) {
  organization_referral_settings(filter: $filter) {
    id
    default_referral_fee
    referral_text
    organization_id {
      id
    }
  }
}
    `;

/**
 * __useGetOrganizationReferralSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationReferralSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationReferralSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationReferralSettingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrganizationReferralSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationReferralSettingsQuery, GetOrganizationReferralSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationReferralSettingsQuery, GetOrganizationReferralSettingsQueryVariables>(GetOrganizationReferralSettingsDocument, options);
      }
export function useGetOrganizationReferralSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationReferralSettingsQuery, GetOrganizationReferralSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationReferralSettingsQuery, GetOrganizationReferralSettingsQueryVariables>(GetOrganizationReferralSettingsDocument, options);
        }
export type GetOrganizationReferralSettingsQueryHookResult = ReturnType<typeof useGetOrganizationReferralSettingsQuery>;
export type GetOrganizationReferralSettingsLazyQueryHookResult = ReturnType<typeof useGetOrganizationReferralSettingsLazyQuery>;
export type GetOrganizationReferralSettingsQueryResult = Apollo.QueryResult<GetOrganizationReferralSettingsQuery, GetOrganizationReferralSettingsQueryVariables>;
export function refetchGetOrganizationReferralSettingsQuery(variables?: GetOrganizationReferralSettingsQueryVariables) {
      return { query: GetOrganizationReferralSettingsDocument, variables: variables }
    }
export const GetAnalyticsDocument = gql`
    query getAnalytics($attorneyMetricsFilter: sum_analytics_attorney_metrics_filter, $orgId: String, $limit: Int) {
  sum_analytics_org_metrics(
    filter: {organization_id: {_eq: $orgId}}
    limit: $limit
  ) {
    ...OrgMetricsFields
  }
  sum_analytics_org_top_attorneys_buyer(
    filter: {organization_id: {_eq: $orgId}}
    limit: $limit
    sort: "-matched_cases_count"
  ) {
    ...TopBuyerAttorneysFields
  }
  sum_analytics_org_top_attorneys_seller(
    filter: {organization_id: {_eq: $orgId}}
    limit: $limit
    sort: "-matched_cases_count"
  ) {
    ...TopSellerAttorneysFields
  }
  sum_analytics_org_practice_areas_seller(
    filter: {organization_id: {_eq: $orgId}}
    limit: $limit
    sort: "-total_cases_count"
  ) {
    ...PracticeAreaPerformanceFields
  }
  sum_analytics_org_practice_areas_buyer(
    filter: {organization_id: {_eq: $orgId}}
    limit: $limit
    sort: "-total_cases_count"
  ) {
    ...PracticeAreaBuyerPerformanceFields
  }
  sum_analytics_attorney_metrics(filter: $attorneyMetricsFilter, limit: $limit) {
    ...AttorneyMetricsFields
  }
  organization(filter: {id: {_eq: $orgId}}) {
    users {
      ...OrgMembersFields
    }
  }
  sum_analytics_freshness(sort: "-_fivetran_synced") {
    last_successful_run
    next_scheduled_run
  }
}
    ${OrgMetricsFieldsFragmentDoc}
${TopBuyerAttorneysFieldsFragmentDoc}
${TopSellerAttorneysFieldsFragmentDoc}
${PracticeAreaPerformanceFieldsFragmentDoc}
${PracticeAreaBuyerPerformanceFieldsFragmentDoc}
${AttorneyMetricsFieldsFragmentDoc}
${OrgMembersFieldsFragmentDoc}`;

/**
 * __useGetAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsQuery({
 *   variables: {
 *      attorneyMetricsFilter: // value for 'attorneyMetricsFilter'
 *      orgId: // value for 'orgId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<GetAnalyticsQuery, GetAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsQuery, GetAnalyticsQueryVariables>(GetAnalyticsDocument, options);
      }
export function useGetAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsQuery, GetAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsQuery, GetAnalyticsQueryVariables>(GetAnalyticsDocument, options);
        }
export type GetAnalyticsQueryHookResult = ReturnType<typeof useGetAnalyticsQuery>;
export type GetAnalyticsLazyQueryHookResult = ReturnType<typeof useGetAnalyticsLazyQuery>;
export type GetAnalyticsQueryResult = Apollo.QueryResult<GetAnalyticsQuery, GetAnalyticsQueryVariables>;
export function refetchGetAnalyticsQuery(variables?: GetAnalyticsQueryVariables) {
      return { query: GetAnalyticsDocument, variables: variables }
    }
export const GetAttorneyPerformanceDocument = gql`
    query getAttorneyPerformance($attorneyId: String!) {
  sum_analytics_attorney_metrics(filter: {attorney_id: {_eq: $attorneyId}}) {
    ...AttorneyMetricsFields
  }
}
    ${AttorneyMetricsFieldsFragmentDoc}`;

/**
 * __useGetAttorneyPerformanceQuery__
 *
 * To run a query within a React component, call `useGetAttorneyPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttorneyPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttorneyPerformanceQuery({
 *   variables: {
 *      attorneyId: // value for 'attorneyId'
 *   },
 * });
 */
export function useGetAttorneyPerformanceQuery(baseOptions: Apollo.QueryHookOptions<GetAttorneyPerformanceQuery, GetAttorneyPerformanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttorneyPerformanceQuery, GetAttorneyPerformanceQueryVariables>(GetAttorneyPerformanceDocument, options);
      }
export function useGetAttorneyPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttorneyPerformanceQuery, GetAttorneyPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttorneyPerformanceQuery, GetAttorneyPerformanceQueryVariables>(GetAttorneyPerformanceDocument, options);
        }
export type GetAttorneyPerformanceQueryHookResult = ReturnType<typeof useGetAttorneyPerformanceQuery>;
export type GetAttorneyPerformanceLazyQueryHookResult = ReturnType<typeof useGetAttorneyPerformanceLazyQuery>;
export type GetAttorneyPerformanceQueryResult = Apollo.QueryResult<GetAttorneyPerformanceQuery, GetAttorneyPerformanceQueryVariables>;
export function refetchGetAttorneyPerformanceQuery(variables: GetAttorneyPerformanceQueryVariables) {
      return { query: GetAttorneyPerformanceDocument, variables: variables }
    }
export const GetMasterCasesDocument = gql`
    query getMasterCases($filter: master_case_filter) {
  master_case(filter: $filter) {
    case_id
    name
    desired_fee_perc
    created_ts
    status
    status_ts
    attorney_name
    attorney_id
  }
}
    `;

/**
 * __useGetMasterCasesQuery__
 *
 * To run a query within a React component, call `useGetMasterCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterCasesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMasterCasesQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterCasesQuery, GetMasterCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterCasesQuery, GetMasterCasesQueryVariables>(GetMasterCasesDocument, options);
      }
export function useGetMasterCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterCasesQuery, GetMasterCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterCasesQuery, GetMasterCasesQueryVariables>(GetMasterCasesDocument, options);
        }
export type GetMasterCasesQueryHookResult = ReturnType<typeof useGetMasterCasesQuery>;
export type GetMasterCasesLazyQueryHookResult = ReturnType<typeof useGetMasterCasesLazyQuery>;
export type GetMasterCasesQueryResult = Apollo.QueryResult<GetMasterCasesQuery, GetMasterCasesQueryVariables>;
export function refetchGetMasterCasesQuery(variables?: GetMasterCasesQueryVariables) {
      return { query: GetMasterCasesDocument, variables: variables }
    }
export const GetMasterReferralCasesDocument = gql`
    query getMasterReferralCases($filter: master_referral_filter) {
  master_referral(filter: $filter) {
    case_created_ts
    case_id
    case_name
    case_status
    case_type
    created_ts
    fee_percentage
    jurisdiction
    match_date
    match_fee_expected_amount
    match_fee_expected_collection_date
    match_fee_payment_status
    matched_date_ts
    practice_area
    prospect_attorney_id
    prospect_attorney_name
    prospect_organization_name
    referring_attorney_name
    referring_organization_name
    signed_date_ts
    prospect_organization_id
    referring_organization_id
  }
}
    `;

/**
 * __useGetMasterReferralCasesQuery__
 *
 * To run a query within a React component, call `useGetMasterReferralCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterReferralCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterReferralCasesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMasterReferralCasesQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterReferralCasesQuery, GetMasterReferralCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterReferralCasesQuery, GetMasterReferralCasesQueryVariables>(GetMasterReferralCasesDocument, options);
      }
export function useGetMasterReferralCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterReferralCasesQuery, GetMasterReferralCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterReferralCasesQuery, GetMasterReferralCasesQueryVariables>(GetMasterReferralCasesDocument, options);
        }
export type GetMasterReferralCasesQueryHookResult = ReturnType<typeof useGetMasterReferralCasesQuery>;
export type GetMasterReferralCasesLazyQueryHookResult = ReturnType<typeof useGetMasterReferralCasesLazyQuery>;
export type GetMasterReferralCasesQueryResult = Apollo.QueryResult<GetMasterReferralCasesQuery, GetMasterReferralCasesQueryVariables>;
export function refetchGetMasterReferralCasesQuery(variables?: GetMasterReferralCasesQueryVariables) {
      return { query: GetMasterReferralCasesDocument, variables: variables }
    }
export const GetAttorneyStatsDocument = gql`
    query GetAttorneyStats($attorneyId: ID!) {
  sum_ratings_attorney_buyer_by_id(id: $attorneyId) {
    responsiveness_label
    percent_case_status_updates_completed
    num_case_status_updates_requested
    num_case_status_updates_completed
    num_matches
    num_signed
    percent_signed
  }
  sum_ratings_attorney_seller_by_id(id: $attorneyId) {
    responsiveness_label
    num_referrals
    num_matches
    num_signed
    percent_signed
    percent_matched
  }
  attorney_by_id(id: $attorneyId) {
    id
    is_vetted
    membership_type {
      id
    }
    profiles {
      first_name
      last_name
      bio
      practice_areas {
        practice_area_id {
          id
          name
        }
      }
      licenses {
        license_state {
          name
          code
        }
      }
      affiliations {
        affiliation_id {
          badge_image_url
          id
          name
          priority
        }
      }
      education {
        grade {
          id
          name
        }
        school_id {
          id
          name
        }
      }
      languages {
        language_id {
          id
          name
        }
      }
    }
    user_id {
      current_organization {
        organization_id {
          id
          profiles {
            name
          }
        }
      }
      avatar {
        id
      }
    }
  }
}
    `;

/**
 * __useGetAttorneyStatsQuery__
 *
 * To run a query within a React component, call `useGetAttorneyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttorneyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttorneyStatsQuery({
 *   variables: {
 *      attorneyId: // value for 'attorneyId'
 *   },
 * });
 */
export function useGetAttorneyStatsQuery(baseOptions: Apollo.QueryHookOptions<GetAttorneyStatsQuery, GetAttorneyStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttorneyStatsQuery, GetAttorneyStatsQueryVariables>(GetAttorneyStatsDocument, options);
      }
export function useGetAttorneyStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttorneyStatsQuery, GetAttorneyStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttorneyStatsQuery, GetAttorneyStatsQueryVariables>(GetAttorneyStatsDocument, options);
        }
export type GetAttorneyStatsQueryHookResult = ReturnType<typeof useGetAttorneyStatsQuery>;
export type GetAttorneyStatsLazyQueryHookResult = ReturnType<typeof useGetAttorneyStatsLazyQuery>;
export type GetAttorneyStatsQueryResult = Apollo.QueryResult<GetAttorneyStatsQuery, GetAttorneyStatsQueryVariables>;
export function refetchGetAttorneyStatsQuery(variables: GetAttorneyStatsQueryVariables) {
      return { query: GetAttorneyStatsDocument, variables: variables }
    }
export const GetAttorneyStatsProfilePageDocument = gql`
    query GetAttorneyStatsProfilePage($attorneyId: ID!, $filter: attorney_profile_filter, $licenseFilter: attorney_profile_license_filter) {
  sum_ratings_attorney_buyer_by_id(id: $attorneyId) {
    responsiveness_label
    percent_case_status_updates_completed
    num_case_status_updates_requested
    num_case_status_updates_completed
    num_matches
    num_signed
    percent_signed
  }
  sum_ratings_attorney_seller_by_id(id: $attorneyId) {
    responsiveness_label
    num_referrals
    num_matches
    num_signed
    percent_signed
    percent_matched
  }
  attorney_profile(filter: $filter) {
    id
    first_name
    last_name
    bio
    years_practice {
      name
    }
    attorney_id {
      id
      is_vetted
      membership_type {
        id
      }
      user_id {
        id
        email
        last_access
        avatar {
          id
        }
        current_organization {
          id
          position_name
          organization_id {
            id
            profiles {
              name
            }
          }
        }
      }
    }
    affiliations {
      affiliation_id {
        id
        name
        badge_image_url
        priority
      }
    }
    awards {
      award_id {
        id
        name
      }
    }
    firms {
      name
      address
      state {
        name
        code
      }
      city
      zip
      size {
        name
      }
      relationship {
        name
      }
    }
    contacts {
      type {
        name
      }
      value
    }
    education {
      grade {
        id
        name
      }
      school_id {
        id
        name
      }
    }
    licenses(filter: $licenseFilter) {
      bar_number
      has_been_disciplined_by_bar
      has_been_sued_by_malpractice
      is_license_suspended
      license_state {
        name
        code
      }
      insurances {
        expiration_date
        insurance_coverage_id {
          id
        }
      }
    }
    case_management_softwares {
      case_management_software_id {
        name
      }
    }
    languages {
      language_id {
        id
        name
      }
    }
    practice_areas {
      practice_area_id {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAttorneyStatsProfilePageQuery__
 *
 * To run a query within a React component, call `useGetAttorneyStatsProfilePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttorneyStatsProfilePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttorneyStatsProfilePageQuery({
 *   variables: {
 *      attorneyId: // value for 'attorneyId'
 *      filter: // value for 'filter'
 *      licenseFilter: // value for 'licenseFilter'
 *   },
 * });
 */
export function useGetAttorneyStatsProfilePageQuery(baseOptions: Apollo.QueryHookOptions<GetAttorneyStatsProfilePageQuery, GetAttorneyStatsProfilePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttorneyStatsProfilePageQuery, GetAttorneyStatsProfilePageQueryVariables>(GetAttorneyStatsProfilePageDocument, options);
      }
export function useGetAttorneyStatsProfilePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttorneyStatsProfilePageQuery, GetAttorneyStatsProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttorneyStatsProfilePageQuery, GetAttorneyStatsProfilePageQueryVariables>(GetAttorneyStatsProfilePageDocument, options);
        }
export type GetAttorneyStatsProfilePageQueryHookResult = ReturnType<typeof useGetAttorneyStatsProfilePageQuery>;
export type GetAttorneyStatsProfilePageLazyQueryHookResult = ReturnType<typeof useGetAttorneyStatsProfilePageLazyQuery>;
export type GetAttorneyStatsProfilePageQueryResult = Apollo.QueryResult<GetAttorneyStatsProfilePageQuery, GetAttorneyStatsProfilePageQueryVariables>;
export function refetchGetAttorneyStatsProfilePageQuery(variables: GetAttorneyStatsProfilePageQueryVariables) {
      return { query: GetAttorneyStatsProfilePageDocument, variables: variables }
    }
export const CreateCasePurchaseDocument = gql`
    mutation CreateCasePurchase($data: create_case_purchase_input!) {
  create_case_purchase_item(data: $data) {
    id
  }
}
    `;
export type CreateCasePurchaseMutationFn = Apollo.MutationFunction<CreateCasePurchaseMutation, CreateCasePurchaseMutationVariables>;

/**
 * __useCreateCasePurchaseMutation__
 *
 * To run a mutation, you first call `useCreateCasePurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCasePurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCasePurchaseMutation, { data, loading, error }] = useCreateCasePurchaseMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCasePurchaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCasePurchaseMutation, CreateCasePurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCasePurchaseMutation, CreateCasePurchaseMutationVariables>(CreateCasePurchaseDocument, options);
      }
export type CreateCasePurchaseMutationHookResult = ReturnType<typeof useCreateCasePurchaseMutation>;
export type CreateCasePurchaseMutationResult = Apollo.MutationResult<CreateCasePurchaseMutation>;
export type CreateCasePurchaseMutationOptions = Apollo.BaseMutationOptions<CreateCasePurchaseMutation, CreateCasePurchaseMutationVariables>;
export const BulkCreateCasePurchaseDocument = gql`
    mutation bulkCreateCasePurchase($data: [create_case_purchase_input!]) {
  create_case_purchase_items(data: $data) {
    id
  }
}
    `;
export type BulkCreateCasePurchaseMutationFn = Apollo.MutationFunction<BulkCreateCasePurchaseMutation, BulkCreateCasePurchaseMutationVariables>;

/**
 * __useBulkCreateCasePurchaseMutation__
 *
 * To run a mutation, you first call `useBulkCreateCasePurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateCasePurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateCasePurchaseMutation, { data, loading, error }] = useBulkCreateCasePurchaseMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkCreateCasePurchaseMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateCasePurchaseMutation, BulkCreateCasePurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateCasePurchaseMutation, BulkCreateCasePurchaseMutationVariables>(BulkCreateCasePurchaseDocument, options);
      }
export type BulkCreateCasePurchaseMutationHookResult = ReturnType<typeof useBulkCreateCasePurchaseMutation>;
export type BulkCreateCasePurchaseMutationResult = Apollo.MutationResult<BulkCreateCasePurchaseMutation>;
export type BulkCreateCasePurchaseMutationOptions = Apollo.BaseMutationOptions<BulkCreateCasePurchaseMutation, BulkCreateCasePurchaseMutationVariables>;
export const DeleteCaseDocument = gql`
    mutation deleteCase($deleteCaseItemId: ID!) {
  delete_case_item(id: $deleteCaseItemId) {
    id
  }
}
    `;
export type DeleteCaseMutationFn = Apollo.MutationFunction<DeleteCaseMutation, DeleteCaseMutationVariables>;

/**
 * __useDeleteCaseMutation__
 *
 * To run a mutation, you first call `useDeleteCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaseMutation, { data, loading, error }] = useDeleteCaseMutation({
 *   variables: {
 *      deleteCaseItemId: // value for 'deleteCaseItemId'
 *   },
 * });
 */
export function useDeleteCaseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaseMutation, DeleteCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaseMutation, DeleteCaseMutationVariables>(DeleteCaseDocument, options);
      }
export type DeleteCaseMutationHookResult = ReturnType<typeof useDeleteCaseMutation>;
export type DeleteCaseMutationResult = Apollo.MutationResult<DeleteCaseMutation>;
export type DeleteCaseMutationOptions = Apollo.BaseMutationOptions<DeleteCaseMutation, DeleteCaseMutationVariables>;
export const UpdateCaseItemDocument = gql`
    mutation updateCaseItem($data: update_case_input!, $updateCaseItemId: ID!) {
  update_case_item(data: $data, id: $updateCaseItemId) {
    id
  }
}
    `;
export type UpdateCaseItemMutationFn = Apollo.MutationFunction<UpdateCaseItemMutation, UpdateCaseItemMutationVariables>;

/**
 * __useUpdateCaseItemMutation__
 *
 * To run a mutation, you first call `useUpdateCaseItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseItemMutation, { data, loading, error }] = useUpdateCaseItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *      updateCaseItemId: // value for 'updateCaseItemId'
 *   },
 * });
 */
export function useUpdateCaseItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseItemMutation, UpdateCaseItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseItemMutation, UpdateCaseItemMutationVariables>(UpdateCaseItemDocument, options);
      }
export type UpdateCaseItemMutationHookResult = ReturnType<typeof useUpdateCaseItemMutation>;
export type UpdateCaseItemMutationResult = Apollo.MutationResult<UpdateCaseItemMutation>;
export type UpdateCaseItemMutationOptions = Apollo.BaseMutationOptions<UpdateCaseItemMutation, UpdateCaseItemMutationVariables>;
export const CreateCasePurchaseOwnershipItemDocument = gql`
    mutation createCasePurchaseOwnershipItem($data: create_case_purchase_ownership_input!) {
  create_case_purchase_ownership_item(data: $data) {
    id
  }
}
    `;
export type CreateCasePurchaseOwnershipItemMutationFn = Apollo.MutationFunction<CreateCasePurchaseOwnershipItemMutation, CreateCasePurchaseOwnershipItemMutationVariables>;

/**
 * __useCreateCasePurchaseOwnershipItemMutation__
 *
 * To run a mutation, you first call `useCreateCasePurchaseOwnershipItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCasePurchaseOwnershipItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCasePurchaseOwnershipItemMutation, { data, loading, error }] = useCreateCasePurchaseOwnershipItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCasePurchaseOwnershipItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateCasePurchaseOwnershipItemMutation, CreateCasePurchaseOwnershipItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCasePurchaseOwnershipItemMutation, CreateCasePurchaseOwnershipItemMutationVariables>(CreateCasePurchaseOwnershipItemDocument, options);
      }
export type CreateCasePurchaseOwnershipItemMutationHookResult = ReturnType<typeof useCreateCasePurchaseOwnershipItemMutation>;
export type CreateCasePurchaseOwnershipItemMutationResult = Apollo.MutationResult<CreateCasePurchaseOwnershipItemMutation>;
export type CreateCasePurchaseOwnershipItemMutationOptions = Apollo.BaseMutationOptions<CreateCasePurchaseOwnershipItemMutation, CreateCasePurchaseOwnershipItemMutationVariables>;
export const CreateCasePurchaseOwnershipItemsDocument = gql`
    mutation CreateCasePurchaseOwnershipItems($data: [create_case_purchase_ownership_input!]) {
  create_case_purchase_ownership_items(data: $data) {
    id
  }
}
    `;
export type CreateCasePurchaseOwnershipItemsMutationFn = Apollo.MutationFunction<CreateCasePurchaseOwnershipItemsMutation, CreateCasePurchaseOwnershipItemsMutationVariables>;

/**
 * __useCreateCasePurchaseOwnershipItemsMutation__
 *
 * To run a mutation, you first call `useCreateCasePurchaseOwnershipItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCasePurchaseOwnershipItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCasePurchaseOwnershipItemsMutation, { data, loading, error }] = useCreateCasePurchaseOwnershipItemsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCasePurchaseOwnershipItemsMutation(baseOptions?: Apollo.MutationHookOptions<CreateCasePurchaseOwnershipItemsMutation, CreateCasePurchaseOwnershipItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCasePurchaseOwnershipItemsMutation, CreateCasePurchaseOwnershipItemsMutationVariables>(CreateCasePurchaseOwnershipItemsDocument, options);
      }
export type CreateCasePurchaseOwnershipItemsMutationHookResult = ReturnType<typeof useCreateCasePurchaseOwnershipItemsMutation>;
export type CreateCasePurchaseOwnershipItemsMutationResult = Apollo.MutationResult<CreateCasePurchaseOwnershipItemsMutation>;
export type CreateCasePurchaseOwnershipItemsMutationOptions = Apollo.BaseMutationOptions<CreateCasePurchaseOwnershipItemsMutation, CreateCasePurchaseOwnershipItemsMutationVariables>;
export const CreateCaseOwnershipItemsDocument = gql`
    mutation CreateCaseOwnershipItems($data: [create_case_ownership_input!]) {
  create_case_ownership_items(data: $data) {
    case_id {
      id
    }
    user_id {
      id
    }
  }
}
    `;
export type CreateCaseOwnershipItemsMutationFn = Apollo.MutationFunction<CreateCaseOwnershipItemsMutation, CreateCaseOwnershipItemsMutationVariables>;

/**
 * __useCreateCaseOwnershipItemsMutation__
 *
 * To run a mutation, you first call `useCreateCaseOwnershipItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseOwnershipItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseOwnershipItemsMutation, { data, loading, error }] = useCreateCaseOwnershipItemsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCaseOwnershipItemsMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseOwnershipItemsMutation, CreateCaseOwnershipItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseOwnershipItemsMutation, CreateCaseOwnershipItemsMutationVariables>(CreateCaseOwnershipItemsDocument, options);
      }
export type CreateCaseOwnershipItemsMutationHookResult = ReturnType<typeof useCreateCaseOwnershipItemsMutation>;
export type CreateCaseOwnershipItemsMutationResult = Apollo.MutationResult<CreateCaseOwnershipItemsMutation>;
export type CreateCaseOwnershipItemsMutationOptions = Apollo.BaseMutationOptions<CreateCaseOwnershipItemsMutation, CreateCaseOwnershipItemsMutationVariables>;
export const DeleteCaseOwnershipItemDocument = gql`
    mutation DeleteCaseOwnershipItem($deleteCaseOwnershipItemId: ID!) {
  delete_case_ownership_item(id: $deleteCaseOwnershipItemId) {
    id
  }
}
    `;
export type DeleteCaseOwnershipItemMutationFn = Apollo.MutationFunction<DeleteCaseOwnershipItemMutation, DeleteCaseOwnershipItemMutationVariables>;

/**
 * __useDeleteCaseOwnershipItemMutation__
 *
 * To run a mutation, you first call `useDeleteCaseOwnershipItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaseOwnershipItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaseOwnershipItemMutation, { data, loading, error }] = useDeleteCaseOwnershipItemMutation({
 *   variables: {
 *      deleteCaseOwnershipItemId: // value for 'deleteCaseOwnershipItemId'
 *   },
 * });
 */
export function useDeleteCaseOwnershipItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaseOwnershipItemMutation, DeleteCaseOwnershipItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaseOwnershipItemMutation, DeleteCaseOwnershipItemMutationVariables>(DeleteCaseOwnershipItemDocument, options);
      }
export type DeleteCaseOwnershipItemMutationHookResult = ReturnType<typeof useDeleteCaseOwnershipItemMutation>;
export type DeleteCaseOwnershipItemMutationResult = Apollo.MutationResult<DeleteCaseOwnershipItemMutation>;
export type DeleteCaseOwnershipItemMutationOptions = Apollo.BaseMutationOptions<DeleteCaseOwnershipItemMutation, DeleteCaseOwnershipItemMutationVariables>;
export const DeleteCasePurchaseOwnershipItemDocument = gql`
    mutation DeleteCasePurchaseOwnershipItem($deleteCasePurchaseOwnershipItemId: ID!) {
  delete_case_purchase_ownership_item(id: $deleteCasePurchaseOwnershipItemId) {
    id
  }
}
    `;
export type DeleteCasePurchaseOwnershipItemMutationFn = Apollo.MutationFunction<DeleteCasePurchaseOwnershipItemMutation, DeleteCasePurchaseOwnershipItemMutationVariables>;

/**
 * __useDeleteCasePurchaseOwnershipItemMutation__
 *
 * To run a mutation, you first call `useDeleteCasePurchaseOwnershipItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCasePurchaseOwnershipItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCasePurchaseOwnershipItemMutation, { data, loading, error }] = useDeleteCasePurchaseOwnershipItemMutation({
 *   variables: {
 *      deleteCasePurchaseOwnershipItemId: // value for 'deleteCasePurchaseOwnershipItemId'
 *   },
 * });
 */
export function useDeleteCasePurchaseOwnershipItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCasePurchaseOwnershipItemMutation, DeleteCasePurchaseOwnershipItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCasePurchaseOwnershipItemMutation, DeleteCasePurchaseOwnershipItemMutationVariables>(DeleteCasePurchaseOwnershipItemDocument, options);
      }
export type DeleteCasePurchaseOwnershipItemMutationHookResult = ReturnType<typeof useDeleteCasePurchaseOwnershipItemMutation>;
export type DeleteCasePurchaseOwnershipItemMutationResult = Apollo.MutationResult<DeleteCasePurchaseOwnershipItemMutation>;
export type DeleteCasePurchaseOwnershipItemMutationOptions = Apollo.BaseMutationOptions<DeleteCasePurchaseOwnershipItemMutation, DeleteCasePurchaseOwnershipItemMutationVariables>;
export const UpdateCasePurchaseFeeAgreementStatusDocument = gql`
    mutation UpdateCasePurchaseFeeAgreementStatus($updateCasePurchaseItemId: ID!, $data: update_case_purchase_input!) {
  update_case_purchase_item(id: $updateCasePurchaseItemId, data: $data) {
    id
  }
}
    `;
export type UpdateCasePurchaseFeeAgreementStatusMutationFn = Apollo.MutationFunction<UpdateCasePurchaseFeeAgreementStatusMutation, UpdateCasePurchaseFeeAgreementStatusMutationVariables>;

/**
 * __useUpdateCasePurchaseFeeAgreementStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCasePurchaseFeeAgreementStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCasePurchaseFeeAgreementStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCasePurchaseFeeAgreementStatusMutation, { data, loading, error }] = useUpdateCasePurchaseFeeAgreementStatusMutation({
 *   variables: {
 *      updateCasePurchaseItemId: // value for 'updateCasePurchaseItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCasePurchaseFeeAgreementStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCasePurchaseFeeAgreementStatusMutation, UpdateCasePurchaseFeeAgreementStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCasePurchaseFeeAgreementStatusMutation, UpdateCasePurchaseFeeAgreementStatusMutationVariables>(UpdateCasePurchaseFeeAgreementStatusDocument, options);
      }
export type UpdateCasePurchaseFeeAgreementStatusMutationHookResult = ReturnType<typeof useUpdateCasePurchaseFeeAgreementStatusMutation>;
export type UpdateCasePurchaseFeeAgreementStatusMutationResult = Apollo.MutationResult<UpdateCasePurchaseFeeAgreementStatusMutation>;
export type UpdateCasePurchaseFeeAgreementStatusMutationOptions = Apollo.BaseMutationOptions<UpdateCasePurchaseFeeAgreementStatusMutation, UpdateCasePurchaseFeeAgreementStatusMutationVariables>;
export const UpdateCaseFilesForRepostDocument = gql`
    mutation UpdateCaseFilesForRepost($data: update_case_file_input!, $ids: [ID]!) {
  update_case_file_items(data: $data, ids: $ids) {
    id
  }
}
    `;
export type UpdateCaseFilesForRepostMutationFn = Apollo.MutationFunction<UpdateCaseFilesForRepostMutation, UpdateCaseFilesForRepostMutationVariables>;

/**
 * __useUpdateCaseFilesForRepostMutation__
 *
 * To run a mutation, you first call `useUpdateCaseFilesForRepostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseFilesForRepostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseFilesForRepostMutation, { data, loading, error }] = useUpdateCaseFilesForRepostMutation({
 *   variables: {
 *      data: // value for 'data'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUpdateCaseFilesForRepostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseFilesForRepostMutation, UpdateCaseFilesForRepostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseFilesForRepostMutation, UpdateCaseFilesForRepostMutationVariables>(UpdateCaseFilesForRepostDocument, options);
      }
export type UpdateCaseFilesForRepostMutationHookResult = ReturnType<typeof useUpdateCaseFilesForRepostMutation>;
export type UpdateCaseFilesForRepostMutationResult = Apollo.MutationResult<UpdateCaseFilesForRepostMutation>;
export type UpdateCaseFilesForRepostMutationOptions = Apollo.BaseMutationOptions<UpdateCaseFilesForRepostMutation, UpdateCaseFilesForRepostMutationVariables>;
export const GetCasesDocument = gql`
    query getCases($filter: case_filter) {
  case(filter: $filter) {
    id
    name
    description
    description_formatted
    following_count
    status
    mp_visibility {
      id
      name
    }
    fee
    financing_source {
      name
      id
    }
    type {
      id
      name
    }
    leads {
      id
      first_name
      last_name
      contacts {
        type {
          id
          name
        }
        value
      }
    }
    attorney_id {
      id
      is_vetted
      membership_type {
        id
      }
      user_id {
        id
        current_organization {
          id
          organization_id {
            id
            profiles {
              name
            }
          }
        }
        avatar {
          id
        }
      }
      profiles {
        bio
        firms {
          id
          name
        }
        first_name
        id
        last_name
      }
    }
    incident_date
    proposal_due_date
    case_number
    case_alias
    created_ts
    internal_case_number
    jurisdiction {
      code
      name
    }
    preferred_language {
      code
      id
      name
    }
    process_stage {
      name
    }
    files {
      id
      file_id {
        id
        title
        type
        filename_download
        metadata
      }
    }
    ownerships {
      id
      user_id {
        id
        first_name
        last_name
        role {
          id
        }
        avatar {
          id
        }
        current_organization {
          id
          organization_id {
            id
          }
        }
      }
    }
    zip_code {
      city
      state
      zip_code
    }
  }
}
    `;

/**
 * __useGetCasesQuery__
 *
 * To run a query within a React component, call `useGetCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCasesQuery(baseOptions?: Apollo.QueryHookOptions<GetCasesQuery, GetCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasesQuery, GetCasesQueryVariables>(GetCasesDocument, options);
      }
export function useGetCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasesQuery, GetCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasesQuery, GetCasesQueryVariables>(GetCasesDocument, options);
        }
export type GetCasesQueryHookResult = ReturnType<typeof useGetCasesQuery>;
export type GetCasesLazyQueryHookResult = ReturnType<typeof useGetCasesLazyQuery>;
export type GetCasesQueryResult = Apollo.QueryResult<GetCasesQuery, GetCasesQueryVariables>;
export function refetchGetCasesQuery(variables?: GetCasesQueryVariables) {
      return { query: GetCasesDocument, variables: variables }
    }
export const CaseExistsDocument = gql`
    query caseExists($filter: case_filter) {
  case(filter: $filter) {
    id
  }
}
    `;

/**
 * __useCaseExistsQuery__
 *
 * To run a query within a React component, call `useCaseExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseExistsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCaseExistsQuery(baseOptions?: Apollo.QueryHookOptions<CaseExistsQuery, CaseExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaseExistsQuery, CaseExistsQueryVariables>(CaseExistsDocument, options);
      }
export function useCaseExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaseExistsQuery, CaseExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaseExistsQuery, CaseExistsQueryVariables>(CaseExistsDocument, options);
        }
export type CaseExistsQueryHookResult = ReturnType<typeof useCaseExistsQuery>;
export type CaseExistsLazyQueryHookResult = ReturnType<typeof useCaseExistsLazyQuery>;
export type CaseExistsQueryResult = Apollo.QueryResult<CaseExistsQuery, CaseExistsQueryVariables>;
export function refetchCaseExistsQuery(variables?: CaseExistsQueryVariables) {
      return { query: CaseExistsDocument, variables: variables }
    }
export const GetAcceptedPublicCasePurchasesDocument = gql`
    query getAcceptedPublicCasePurchases($filter: case_purchase_filter) {
  case_purchase(filter: $filter) {
    case_id {
      id
    }
  }
}
    `;

/**
 * __useGetAcceptedPublicCasePurchasesQuery__
 *
 * To run a query within a React component, call `useGetAcceptedPublicCasePurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcceptedPublicCasePurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcceptedPublicCasePurchasesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAcceptedPublicCasePurchasesQuery(baseOptions?: Apollo.QueryHookOptions<GetAcceptedPublicCasePurchasesQuery, GetAcceptedPublicCasePurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAcceptedPublicCasePurchasesQuery, GetAcceptedPublicCasePurchasesQueryVariables>(GetAcceptedPublicCasePurchasesDocument, options);
      }
export function useGetAcceptedPublicCasePurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAcceptedPublicCasePurchasesQuery, GetAcceptedPublicCasePurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAcceptedPublicCasePurchasesQuery, GetAcceptedPublicCasePurchasesQueryVariables>(GetAcceptedPublicCasePurchasesDocument, options);
        }
export type GetAcceptedPublicCasePurchasesQueryHookResult = ReturnType<typeof useGetAcceptedPublicCasePurchasesQuery>;
export type GetAcceptedPublicCasePurchasesLazyQueryHookResult = ReturnType<typeof useGetAcceptedPublicCasePurchasesLazyQuery>;
export type GetAcceptedPublicCasePurchasesQueryResult = Apollo.QueryResult<GetAcceptedPublicCasePurchasesQuery, GetAcceptedPublicCasePurchasesQueryVariables>;
export function refetchGetAcceptedPublicCasePurchasesQuery(variables?: GetAcceptedPublicCasePurchasesQueryVariables) {
      return { query: GetAcceptedPublicCasePurchasesDocument, variables: variables }
    }
export const IsDeletedDocument = gql`
    query isDeleted($filter: case_filter) {
  case(filter: $filter) {
    id
    deleted
  }
}
    `;

/**
 * __useIsDeletedQuery__
 *
 * To run a query within a React component, call `useIsDeletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsDeletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsDeletedQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIsDeletedQuery(baseOptions?: Apollo.QueryHookOptions<IsDeletedQuery, IsDeletedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsDeletedQuery, IsDeletedQueryVariables>(IsDeletedDocument, options);
      }
export function useIsDeletedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsDeletedQuery, IsDeletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsDeletedQuery, IsDeletedQueryVariables>(IsDeletedDocument, options);
        }
export type IsDeletedQueryHookResult = ReturnType<typeof useIsDeletedQuery>;
export type IsDeletedLazyQueryHookResult = ReturnType<typeof useIsDeletedLazyQuery>;
export type IsDeletedQueryResult = Apollo.QueryResult<IsDeletedQuery, IsDeletedQueryVariables>;
export function refetchIsDeletedQuery(variables?: IsDeletedQueryVariables) {
      return { query: IsDeletedDocument, variables: variables }
    }
export const GetCasesForWithdrawalDocument = gql`
    query GetCasesForWithdrawal($filter: case_filter) {
  case(filter: $filter) {
    id
    attorney_id {
      id
      user_id {
        id
        current_organization {
          id
          organization_id {
            id
          }
        }
      }
    }
    mp_visibility {
      id
    }
  }
}
    `;

/**
 * __useGetCasesForWithdrawalQuery__
 *
 * To run a query within a React component, call `useGetCasesForWithdrawalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasesForWithdrawalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasesForWithdrawalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCasesForWithdrawalQuery(baseOptions?: Apollo.QueryHookOptions<GetCasesForWithdrawalQuery, GetCasesForWithdrawalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasesForWithdrawalQuery, GetCasesForWithdrawalQueryVariables>(GetCasesForWithdrawalDocument, options);
      }
export function useGetCasesForWithdrawalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasesForWithdrawalQuery, GetCasesForWithdrawalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasesForWithdrawalQuery, GetCasesForWithdrawalQueryVariables>(GetCasesForWithdrawalDocument, options);
        }
export type GetCasesForWithdrawalQueryHookResult = ReturnType<typeof useGetCasesForWithdrawalQuery>;
export type GetCasesForWithdrawalLazyQueryHookResult = ReturnType<typeof useGetCasesForWithdrawalLazyQuery>;
export type GetCasesForWithdrawalQueryResult = Apollo.QueryResult<GetCasesForWithdrawalQuery, GetCasesForWithdrawalQueryVariables>;
export function refetchGetCasesForWithdrawalQuery(variables?: GetCasesForWithdrawalQueryVariables) {
      return { query: GetCasesForWithdrawalDocument, variables: variables }
    }
export const GetActivityPurchaseFromMyOrgDocument = gql`
    query GetActivityPurchaseFromMyOrg($filter: case_purchase_activity_filter, $sort: [String]) {
  case_purchase_activity(filter: $filter, sort: $sort) {
    id
    created_ts
    activity_entry_status {
      id
      name
    }
    case_purchase_id {
      case_id {
        attorney_id {
          id
          user_id {
            id
            current_organization {
              organization_id {
                id
              }
            }
          }
        }
      }
      prospect_attorney_id {
        profiles {
          id
          first_name
          last_name
          firms {
            name
          }
          attorney_id {
            id
            is_vetted
            membership_type {
              id
            }
            user_id {
              id
              email
              avatar {
                id
              }
              current_organization {
                organization_id {
                  profiles {
                    name
                  }
                }
              }
            }
          }
        }
        user_id {
          id
          email
          avatar {
            id
          }
          current_organization {
            organization_id {
              id
              profiles {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetActivityPurchaseFromMyOrgQuery__
 *
 * To run a query within a React component, call `useGetActivityPurchaseFromMyOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityPurchaseFromMyOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityPurchaseFromMyOrgQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetActivityPurchaseFromMyOrgQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityPurchaseFromMyOrgQuery, GetActivityPurchaseFromMyOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityPurchaseFromMyOrgQuery, GetActivityPurchaseFromMyOrgQueryVariables>(GetActivityPurchaseFromMyOrgDocument, options);
      }
export function useGetActivityPurchaseFromMyOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityPurchaseFromMyOrgQuery, GetActivityPurchaseFromMyOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityPurchaseFromMyOrgQuery, GetActivityPurchaseFromMyOrgQueryVariables>(GetActivityPurchaseFromMyOrgDocument, options);
        }
export type GetActivityPurchaseFromMyOrgQueryHookResult = ReturnType<typeof useGetActivityPurchaseFromMyOrgQuery>;
export type GetActivityPurchaseFromMyOrgLazyQueryHookResult = ReturnType<typeof useGetActivityPurchaseFromMyOrgLazyQuery>;
export type GetActivityPurchaseFromMyOrgQueryResult = Apollo.QueryResult<GetActivityPurchaseFromMyOrgQuery, GetActivityPurchaseFromMyOrgQueryVariables>;
export function refetchGetActivityPurchaseFromMyOrgQuery(variables?: GetActivityPurchaseFromMyOrgQueryVariables) {
      return { query: GetActivityPurchaseFromMyOrgDocument, variables: variables }
    }
export const GetCompleteCaseDocument = gql`
    query getCompleteCase($filter: case_filter) {
  case(filter: $filter) {
    id
    name
    description
    description_formatted
    following_count
    status
    mp_visibility {
      id
      name
    }
    fee
    financing_source {
      id
      name
    }
    type {
      id
      name
    }
    leads {
      id
      first_name
      last_name
      contacts {
        type {
          id
          name
        }
        value
      }
    }
    attorney_id {
      id
      is_vetted
      membership_type {
        id
      }
      user_id {
        id
        current_organization {
          id
          organization_id {
            id
            profiles {
              name
            }
          }
        }
        avatar {
          id
        }
      }
      profiles {
        bio
        firms {
          id
          name
        }
        first_name
        id
        last_name
      }
    }
    incident_date
    proposal_due_date
    case_number
    case_alias
    created_ts
    internal_case_number
    client_currently_represented
    jurisdiction {
      id
      code
      name
    }
    preferred_language {
      id
      code
      name
    }
    process_stage {
      id
      name
    }
    files {
      id
    }
    ownerships {
      id
      user_id {
        id
        first_name
        last_name
        role {
          id
        }
        avatar {
          id
        }
        current_organization {
          id
          organization_id {
            id
          }
        }
      }
    }
    zip_code {
      city
      state
      zip_code
    }
  }
}
    `;

/**
 * __useGetCompleteCaseQuery__
 *
 * To run a query within a React component, call `useGetCompleteCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompleteCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompleteCaseQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCompleteCaseQuery(baseOptions?: Apollo.QueryHookOptions<GetCompleteCaseQuery, GetCompleteCaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompleteCaseQuery, GetCompleteCaseQueryVariables>(GetCompleteCaseDocument, options);
      }
export function useGetCompleteCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompleteCaseQuery, GetCompleteCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompleteCaseQuery, GetCompleteCaseQueryVariables>(GetCompleteCaseDocument, options);
        }
export type GetCompleteCaseQueryHookResult = ReturnType<typeof useGetCompleteCaseQuery>;
export type GetCompleteCaseLazyQueryHookResult = ReturnType<typeof useGetCompleteCaseLazyQuery>;
export type GetCompleteCaseQueryResult = Apollo.QueryResult<GetCompleteCaseQuery, GetCompleteCaseQueryVariables>;
export function refetchGetCompleteCaseQuery(variables?: GetCompleteCaseQueryVariables) {
      return { query: GetCompleteCaseDocument, variables: variables }
    }
export const CatalogLanguageDocument = gql`
    query CatalogLanguage($filter: catalog_language_filter, $sort: [String]) {
  catalog_language(filter: $filter, sort: $sort) {
    id
    name
    code
  }
}
    `;

/**
 * __useCatalogLanguageQuery__
 *
 * To run a query within a React component, call `useCatalogLanguageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogLanguageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogLanguageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCatalogLanguageQuery(baseOptions?: Apollo.QueryHookOptions<CatalogLanguageQuery, CatalogLanguageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogLanguageQuery, CatalogLanguageQueryVariables>(CatalogLanguageDocument, options);
      }
export function useCatalogLanguageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogLanguageQuery, CatalogLanguageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogLanguageQuery, CatalogLanguageQueryVariables>(CatalogLanguageDocument, options);
        }
export type CatalogLanguageQueryHookResult = ReturnType<typeof useCatalogLanguageQuery>;
export type CatalogLanguageLazyQueryHookResult = ReturnType<typeof useCatalogLanguageLazyQuery>;
export type CatalogLanguageQueryResult = Apollo.QueryResult<CatalogLanguageQuery, CatalogLanguageQueryVariables>;
export function refetchCatalogLanguageQuery(variables?: CatalogLanguageQueryVariables) {
      return { query: CatalogLanguageDocument, variables: variables }
    }
export const CatalogUsStateDocument = gql`
    query CatalogUsState($filter: catalog_us_state_filter, $sort: [String]) {
  catalog_us_state(filter: $filter, sort: $sort) {
    id
    code
    name
  }
}
    `;

/**
 * __useCatalogUsStateQuery__
 *
 * To run a query within a React component, call `useCatalogUsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogUsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogUsStateQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCatalogUsStateQuery(baseOptions?: Apollo.QueryHookOptions<CatalogUsStateQuery, CatalogUsStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogUsStateQuery, CatalogUsStateQueryVariables>(CatalogUsStateDocument, options);
      }
export function useCatalogUsStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogUsStateQuery, CatalogUsStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogUsStateQuery, CatalogUsStateQueryVariables>(CatalogUsStateDocument, options);
        }
export type CatalogUsStateQueryHookResult = ReturnType<typeof useCatalogUsStateQuery>;
export type CatalogUsStateLazyQueryHookResult = ReturnType<typeof useCatalogUsStateLazyQuery>;
export type CatalogUsStateQueryResult = Apollo.QueryResult<CatalogUsStateQuery, CatalogUsStateQueryVariables>;
export function refetchCatalogUsStateQuery(variables?: CatalogUsStateQueryVariables) {
      return { query: CatalogUsStateDocument, variables: variables }
    }
export const CatalogPracticeAreaDocument = gql`
    query CatalogPracticeArea($sort: [String]) {
  catalog_practice_area(sort: $sort) {
    id
    is_default
    name
  }
}
    `;

/**
 * __useCatalogPracticeAreaQuery__
 *
 * To run a query within a React component, call `useCatalogPracticeAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogPracticeAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogPracticeAreaQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCatalogPracticeAreaQuery(baseOptions?: Apollo.QueryHookOptions<CatalogPracticeAreaQuery, CatalogPracticeAreaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogPracticeAreaQuery, CatalogPracticeAreaQueryVariables>(CatalogPracticeAreaDocument, options);
      }
export function useCatalogPracticeAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogPracticeAreaQuery, CatalogPracticeAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogPracticeAreaQuery, CatalogPracticeAreaQueryVariables>(CatalogPracticeAreaDocument, options);
        }
export type CatalogPracticeAreaQueryHookResult = ReturnType<typeof useCatalogPracticeAreaQuery>;
export type CatalogPracticeAreaLazyQueryHookResult = ReturnType<typeof useCatalogPracticeAreaLazyQuery>;
export type CatalogPracticeAreaQueryResult = Apollo.QueryResult<CatalogPracticeAreaQuery, CatalogPracticeAreaQueryVariables>;
export function refetchCatalogPracticeAreaQuery(variables?: CatalogPracticeAreaQueryVariables) {
      return { query: CatalogPracticeAreaDocument, variables: variables }
    }
export const GradesDocument = gql`
    query Grades {
  catalog_education_grade {
    id
    name
  }
}
    `;

/**
 * __useGradesQuery__
 *
 * To run a query within a React component, call `useGradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGradesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGradesQuery(baseOptions?: Apollo.QueryHookOptions<GradesQuery, GradesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GradesQuery, GradesQueryVariables>(GradesDocument, options);
      }
export function useGradesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GradesQuery, GradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GradesQuery, GradesQueryVariables>(GradesDocument, options);
        }
export type GradesQueryHookResult = ReturnType<typeof useGradesQuery>;
export type GradesLazyQueryHookResult = ReturnType<typeof useGradesLazyQuery>;
export type GradesQueryResult = Apollo.QueryResult<GradesQuery, GradesQueryVariables>;
export function refetchGradesQuery(variables?: GradesQueryVariables) {
      return { query: GradesDocument, variables: variables }
    }
export const CaseTypesDocument = gql`
    query CaseTypes {
  catalog_practice_area {
    id
    name
  }
}
    `;

/**
 * __useCaseTypesQuery__
 *
 * To run a query within a React component, call `useCaseTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCaseTypesQuery(baseOptions?: Apollo.QueryHookOptions<CaseTypesQuery, CaseTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaseTypesQuery, CaseTypesQueryVariables>(CaseTypesDocument, options);
      }
export function useCaseTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaseTypesQuery, CaseTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaseTypesQuery, CaseTypesQueryVariables>(CaseTypesDocument, options);
        }
export type CaseTypesQueryHookResult = ReturnType<typeof useCaseTypesQuery>;
export type CaseTypesLazyQueryHookResult = ReturnType<typeof useCaseTypesLazyQuery>;
export type CaseTypesQueryResult = Apollo.QueryResult<CaseTypesQuery, CaseTypesQueryVariables>;
export function refetchCaseTypesQuery(variables?: CaseTypesQueryVariables) {
      return { query: CaseTypesDocument, variables: variables }
    }
export const CatalogCasePurchaseDeclineReasonDocument = gql`
    query CatalogCasePurchaseDeclineReason($filter: catalog_case_purchase_decline_reason_filter) {
  catalog_case_purchase_decline_reason(filter: $filter) {
    id
    name
    is_case_relistable
  }
}
    `;

/**
 * __useCatalogCasePurchaseDeclineReasonQuery__
 *
 * To run a query within a React component, call `useCatalogCasePurchaseDeclineReasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogCasePurchaseDeclineReasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogCasePurchaseDeclineReasonQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCatalogCasePurchaseDeclineReasonQuery(baseOptions?: Apollo.QueryHookOptions<CatalogCasePurchaseDeclineReasonQuery, CatalogCasePurchaseDeclineReasonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogCasePurchaseDeclineReasonQuery, CatalogCasePurchaseDeclineReasonQueryVariables>(CatalogCasePurchaseDeclineReasonDocument, options);
      }
export function useCatalogCasePurchaseDeclineReasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogCasePurchaseDeclineReasonQuery, CatalogCasePurchaseDeclineReasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogCasePurchaseDeclineReasonQuery, CatalogCasePurchaseDeclineReasonQueryVariables>(CatalogCasePurchaseDeclineReasonDocument, options);
        }
export type CatalogCasePurchaseDeclineReasonQueryHookResult = ReturnType<typeof useCatalogCasePurchaseDeclineReasonQuery>;
export type CatalogCasePurchaseDeclineReasonLazyQueryHookResult = ReturnType<typeof useCatalogCasePurchaseDeclineReasonLazyQuery>;
export type CatalogCasePurchaseDeclineReasonQueryResult = Apollo.QueryResult<CatalogCasePurchaseDeclineReasonQuery, CatalogCasePurchaseDeclineReasonQueryVariables>;
export function refetchCatalogCasePurchaseDeclineReasonQuery(variables?: CatalogCasePurchaseDeclineReasonQueryVariables) {
      return { query: CatalogCasePurchaseDeclineReasonDocument, variables: variables }
    }
export const MalpracticeInsuranceDocument = gql`
    query MalpracticeInsurance($sort: [String]) {
  catalog_malpractice_insurance(sort: $sort) {
    id
    name
  }
}
    `;

/**
 * __useMalpracticeInsuranceQuery__
 *
 * To run a query within a React component, call `useMalpracticeInsuranceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMalpracticeInsuranceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMalpracticeInsuranceQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMalpracticeInsuranceQuery(baseOptions?: Apollo.QueryHookOptions<MalpracticeInsuranceQuery, MalpracticeInsuranceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MalpracticeInsuranceQuery, MalpracticeInsuranceQueryVariables>(MalpracticeInsuranceDocument, options);
      }
export function useMalpracticeInsuranceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MalpracticeInsuranceQuery, MalpracticeInsuranceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MalpracticeInsuranceQuery, MalpracticeInsuranceQueryVariables>(MalpracticeInsuranceDocument, options);
        }
export type MalpracticeInsuranceQueryHookResult = ReturnType<typeof useMalpracticeInsuranceQuery>;
export type MalpracticeInsuranceLazyQueryHookResult = ReturnType<typeof useMalpracticeInsuranceLazyQuery>;
export type MalpracticeInsuranceQueryResult = Apollo.QueryResult<MalpracticeInsuranceQuery, MalpracticeInsuranceQueryVariables>;
export function refetchMalpracticeInsuranceQuery(variables?: MalpracticeInsuranceQueryVariables) {
      return { query: MalpracticeInsuranceDocument, variables: variables }
    }
export const CatalogCommunicationPreferenceDocument = gql`
    query CatalogCommunicationPreference {
  catalog_communication_preference {
    id
    name
  }
}
    `;

/**
 * __useCatalogCommunicationPreferenceQuery__
 *
 * To run a query within a React component, call `useCatalogCommunicationPreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogCommunicationPreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogCommunicationPreferenceQuery({
 *   variables: {
 *   },
 * });
 */
export function useCatalogCommunicationPreferenceQuery(baseOptions?: Apollo.QueryHookOptions<CatalogCommunicationPreferenceQuery, CatalogCommunicationPreferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogCommunicationPreferenceQuery, CatalogCommunicationPreferenceQueryVariables>(CatalogCommunicationPreferenceDocument, options);
      }
export function useCatalogCommunicationPreferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogCommunicationPreferenceQuery, CatalogCommunicationPreferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogCommunicationPreferenceQuery, CatalogCommunicationPreferenceQueryVariables>(CatalogCommunicationPreferenceDocument, options);
        }
export type CatalogCommunicationPreferenceQueryHookResult = ReturnType<typeof useCatalogCommunicationPreferenceQuery>;
export type CatalogCommunicationPreferenceLazyQueryHookResult = ReturnType<typeof useCatalogCommunicationPreferenceLazyQuery>;
export type CatalogCommunicationPreferenceQueryResult = Apollo.QueryResult<CatalogCommunicationPreferenceQuery, CatalogCommunicationPreferenceQueryVariables>;
export function refetchCatalogCommunicationPreferenceQuery(variables?: CatalogCommunicationPreferenceQueryVariables) {
      return { query: CatalogCommunicationPreferenceDocument, variables: variables }
    }
export const GetCatalogWaterfallDurationDocument = gql`
    query GetCatalogWaterfallDuration {
  catalog_waterfall_duration {
    id
    duration
    name
  }
}
    `;

/**
 * __useGetCatalogWaterfallDurationQuery__
 *
 * To run a query within a React component, call `useGetCatalogWaterfallDurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogWaterfallDurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogWaterfallDurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCatalogWaterfallDurationQuery(baseOptions?: Apollo.QueryHookOptions<GetCatalogWaterfallDurationQuery, GetCatalogWaterfallDurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCatalogWaterfallDurationQuery, GetCatalogWaterfallDurationQueryVariables>(GetCatalogWaterfallDurationDocument, options);
      }
export function useGetCatalogWaterfallDurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCatalogWaterfallDurationQuery, GetCatalogWaterfallDurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCatalogWaterfallDurationQuery, GetCatalogWaterfallDurationQueryVariables>(GetCatalogWaterfallDurationDocument, options);
        }
export type GetCatalogWaterfallDurationQueryHookResult = ReturnType<typeof useGetCatalogWaterfallDurationQuery>;
export type GetCatalogWaterfallDurationLazyQueryHookResult = ReturnType<typeof useGetCatalogWaterfallDurationLazyQuery>;
export type GetCatalogWaterfallDurationQueryResult = Apollo.QueryResult<GetCatalogWaterfallDurationQuery, GetCatalogWaterfallDurationQueryVariables>;
export function refetchGetCatalogWaterfallDurationQuery(variables?: GetCatalogWaterfallDurationQueryVariables) {
      return { query: GetCatalogWaterfallDurationDocument, variables: variables }
    }
export const CatalogAffiliationsDocument = gql`
    query CatalogAffiliations($filter: catalog_affiliation_filter) {
  catalog_affiliation(filter: $filter) {
    id
    is_hidden
    name
    badge_image_url
    priority
  }
}
    `;

/**
 * __useCatalogAffiliationsQuery__
 *
 * To run a query within a React component, call `useCatalogAffiliationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogAffiliationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogAffiliationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCatalogAffiliationsQuery(baseOptions?: Apollo.QueryHookOptions<CatalogAffiliationsQuery, CatalogAffiliationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogAffiliationsQuery, CatalogAffiliationsQueryVariables>(CatalogAffiliationsDocument, options);
      }
export function useCatalogAffiliationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogAffiliationsQuery, CatalogAffiliationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogAffiliationsQuery, CatalogAffiliationsQueryVariables>(CatalogAffiliationsDocument, options);
        }
export type CatalogAffiliationsQueryHookResult = ReturnType<typeof useCatalogAffiliationsQuery>;
export type CatalogAffiliationsLazyQueryHookResult = ReturnType<typeof useCatalogAffiliationsLazyQuery>;
export type CatalogAffiliationsQueryResult = Apollo.QueryResult<CatalogAffiliationsQuery, CatalogAffiliationsQueryVariables>;
export function refetchCatalogAffiliationsQuery(variables?: CatalogAffiliationsQueryVariables) {
      return { query: CatalogAffiliationsDocument, variables: variables }
    }
export const CatalogPriorityAccessTimesDocument = gql`
    query CatalogPriorityAccessTimes {
  catalog_community_expiration_duration {
    id
    duration
    name
  }
}
    `;

/**
 * __useCatalogPriorityAccessTimesQuery__
 *
 * To run a query within a React component, call `useCatalogPriorityAccessTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogPriorityAccessTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogPriorityAccessTimesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCatalogPriorityAccessTimesQuery(baseOptions?: Apollo.QueryHookOptions<CatalogPriorityAccessTimesQuery, CatalogPriorityAccessTimesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogPriorityAccessTimesQuery, CatalogPriorityAccessTimesQueryVariables>(CatalogPriorityAccessTimesDocument, options);
      }
export function useCatalogPriorityAccessTimesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogPriorityAccessTimesQuery, CatalogPriorityAccessTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogPriorityAccessTimesQuery, CatalogPriorityAccessTimesQueryVariables>(CatalogPriorityAccessTimesDocument, options);
        }
export type CatalogPriorityAccessTimesQueryHookResult = ReturnType<typeof useCatalogPriorityAccessTimesQuery>;
export type CatalogPriorityAccessTimesLazyQueryHookResult = ReturnType<typeof useCatalogPriorityAccessTimesLazyQuery>;
export type CatalogPriorityAccessTimesQueryResult = Apollo.QueryResult<CatalogPriorityAccessTimesQuery, CatalogPriorityAccessTimesQueryVariables>;
export function refetchCatalogPriorityAccessTimesQuery(variables?: CatalogPriorityAccessTimesQueryVariables) {
      return { query: CatalogPriorityAccessTimesDocument, variables: variables }
    }
export const CatalogCaseStatusUpdateMatterStageDocument = gql`
    query CatalogCaseStatusUpdateMatterStage($sort: [String]) {
  catalog_case_status_update_matter_stage(sort: $sort) {
    id
    name
    sort_order
  }
}
    `;

/**
 * __useCatalogCaseStatusUpdateMatterStageQuery__
 *
 * To run a query within a React component, call `useCatalogCaseStatusUpdateMatterStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogCaseStatusUpdateMatterStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogCaseStatusUpdateMatterStageQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCatalogCaseStatusUpdateMatterStageQuery(baseOptions?: Apollo.QueryHookOptions<CatalogCaseStatusUpdateMatterStageQuery, CatalogCaseStatusUpdateMatterStageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogCaseStatusUpdateMatterStageQuery, CatalogCaseStatusUpdateMatterStageQueryVariables>(CatalogCaseStatusUpdateMatterStageDocument, options);
      }
export function useCatalogCaseStatusUpdateMatterStageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogCaseStatusUpdateMatterStageQuery, CatalogCaseStatusUpdateMatterStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogCaseStatusUpdateMatterStageQuery, CatalogCaseStatusUpdateMatterStageQueryVariables>(CatalogCaseStatusUpdateMatterStageDocument, options);
        }
export type CatalogCaseStatusUpdateMatterStageQueryHookResult = ReturnType<typeof useCatalogCaseStatusUpdateMatterStageQuery>;
export type CatalogCaseStatusUpdateMatterStageLazyQueryHookResult = ReturnType<typeof useCatalogCaseStatusUpdateMatterStageLazyQuery>;
export type CatalogCaseStatusUpdateMatterStageQueryResult = Apollo.QueryResult<CatalogCaseStatusUpdateMatterStageQuery, CatalogCaseStatusUpdateMatterStageQueryVariables>;
export function refetchCatalogCaseStatusUpdateMatterStageQuery(variables?: CatalogCaseStatusUpdateMatterStageQueryVariables) {
      return { query: CatalogCaseStatusUpdateMatterStageDocument, variables: variables }
    }
export const CatalogCaseStatusUpdateMatterStatusDocument = gql`
    query CatalogCaseStatusUpdateMatterStatus($sort: [String]) {
  catalog_case_status_update_matter_status(sort: $sort) {
    id
    name
    sort_order
  }
}
    `;

/**
 * __useCatalogCaseStatusUpdateMatterStatusQuery__
 *
 * To run a query within a React component, call `useCatalogCaseStatusUpdateMatterStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogCaseStatusUpdateMatterStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogCaseStatusUpdateMatterStatusQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCatalogCaseStatusUpdateMatterStatusQuery(baseOptions?: Apollo.QueryHookOptions<CatalogCaseStatusUpdateMatterStatusQuery, CatalogCaseStatusUpdateMatterStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogCaseStatusUpdateMatterStatusQuery, CatalogCaseStatusUpdateMatterStatusQueryVariables>(CatalogCaseStatusUpdateMatterStatusDocument, options);
      }
export function useCatalogCaseStatusUpdateMatterStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogCaseStatusUpdateMatterStatusQuery, CatalogCaseStatusUpdateMatterStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogCaseStatusUpdateMatterStatusQuery, CatalogCaseStatusUpdateMatterStatusQueryVariables>(CatalogCaseStatusUpdateMatterStatusDocument, options);
        }
export type CatalogCaseStatusUpdateMatterStatusQueryHookResult = ReturnType<typeof useCatalogCaseStatusUpdateMatterStatusQuery>;
export type CatalogCaseStatusUpdateMatterStatusLazyQueryHookResult = ReturnType<typeof useCatalogCaseStatusUpdateMatterStatusLazyQuery>;
export type CatalogCaseStatusUpdateMatterStatusQueryResult = Apollo.QueryResult<CatalogCaseStatusUpdateMatterStatusQuery, CatalogCaseStatusUpdateMatterStatusQueryVariables>;
export function refetchCatalogCaseStatusUpdateMatterStatusQuery(variables?: CatalogCaseStatusUpdateMatterStatusQueryVariables) {
      return { query: CatalogCaseStatusUpdateMatterStatusDocument, variables: variables }
    }
export const CreateCreditsPaymentDocument = gql`
    mutation CreateCreditsPayment($data: create_case_purchase_payment_input!) {
  create_case_purchase_payment_item(data: $data) {
    id
  }
}
    `;
export type CreateCreditsPaymentMutationFn = Apollo.MutationFunction<CreateCreditsPaymentMutation, CreateCreditsPaymentMutationVariables>;

/**
 * __useCreateCreditsPaymentMutation__
 *
 * To run a mutation, you first call `useCreateCreditsPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditsPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditsPaymentMutation, { data, loading, error }] = useCreateCreditsPaymentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCreditsPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCreditsPaymentMutation, CreateCreditsPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCreditsPaymentMutation, CreateCreditsPaymentMutationVariables>(CreateCreditsPaymentDocument, options);
      }
export type CreateCreditsPaymentMutationHookResult = ReturnType<typeof useCreateCreditsPaymentMutation>;
export type CreateCreditsPaymentMutationResult = Apollo.MutationResult<CreateCreditsPaymentMutation>;
export type CreateCreditsPaymentMutationOptions = Apollo.BaseMutationOptions<CreateCreditsPaymentMutation, CreateCreditsPaymentMutationVariables>;
export const CreateFileAccessRequestDocument = gql`
    mutation CreateFileAccessRequest($data: create_user_file_access_request_input!) {
  create_user_file_access_request_item(data: $data) {
    id
  }
}
    `;
export type CreateFileAccessRequestMutationFn = Apollo.MutationFunction<CreateFileAccessRequestMutation, CreateFileAccessRequestMutationVariables>;

/**
 * __useCreateFileAccessRequestMutation__
 *
 * To run a mutation, you first call `useCreateFileAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileAccessRequestMutation, { data, loading, error }] = useCreateFileAccessRequestMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFileAccessRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileAccessRequestMutation, CreateFileAccessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileAccessRequestMutation, CreateFileAccessRequestMutationVariables>(CreateFileAccessRequestDocument, options);
      }
export type CreateFileAccessRequestMutationHookResult = ReturnType<typeof useCreateFileAccessRequestMutation>;
export type CreateFileAccessRequestMutationResult = Apollo.MutationResult<CreateFileAccessRequestMutation>;
export type CreateFileAccessRequestMutationOptions = Apollo.BaseMutationOptions<CreateFileAccessRequestMutation, CreateFileAccessRequestMutationVariables>;
export const CreateBulkFileAccessRequestDocument = gql`
    mutation CreateBulkFileAccessRequest($data: [create_user_file_access_request_input!]) {
  create_user_file_access_request_items(data: $data) {
    id
  }
}
    `;
export type CreateBulkFileAccessRequestMutationFn = Apollo.MutationFunction<CreateBulkFileAccessRequestMutation, CreateBulkFileAccessRequestMutationVariables>;

/**
 * __useCreateBulkFileAccessRequestMutation__
 *
 * To run a mutation, you first call `useCreateBulkFileAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkFileAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkFileAccessRequestMutation, { data, loading, error }] = useCreateBulkFileAccessRequestMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBulkFileAccessRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateBulkFileAccessRequestMutation, CreateBulkFileAccessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBulkFileAccessRequestMutation, CreateBulkFileAccessRequestMutationVariables>(CreateBulkFileAccessRequestDocument, options);
      }
export type CreateBulkFileAccessRequestMutationHookResult = ReturnType<typeof useCreateBulkFileAccessRequestMutation>;
export type CreateBulkFileAccessRequestMutationResult = Apollo.MutationResult<CreateBulkFileAccessRequestMutation>;
export type CreateBulkFileAccessRequestMutationOptions = Apollo.BaseMutationOptions<CreateBulkFileAccessRequestMutation, CreateBulkFileAccessRequestMutationVariables>;
export const UpdateUserFileAccessRequestItemDocument = gql`
    mutation UpdateUserFileAccessRequestItem($updateUserFileAccessRequestItemId: ID!, $data: update_user_file_access_request_input!) {
  update_user_file_access_request_item(
    id: $updateUserFileAccessRequestItemId
    data: $data
  ) {
    id
  }
}
    `;
export type UpdateUserFileAccessRequestItemMutationFn = Apollo.MutationFunction<UpdateUserFileAccessRequestItemMutation, UpdateUserFileAccessRequestItemMutationVariables>;

/**
 * __useUpdateUserFileAccessRequestItemMutation__
 *
 * To run a mutation, you first call `useUpdateUserFileAccessRequestItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserFileAccessRequestItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserFileAccessRequestItemMutation, { data, loading, error }] = useUpdateUserFileAccessRequestItemMutation({
 *   variables: {
 *      updateUserFileAccessRequestItemId: // value for 'updateUserFileAccessRequestItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserFileAccessRequestItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserFileAccessRequestItemMutation, UpdateUserFileAccessRequestItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserFileAccessRequestItemMutation, UpdateUserFileAccessRequestItemMutationVariables>(UpdateUserFileAccessRequestItemDocument, options);
      }
export type UpdateUserFileAccessRequestItemMutationHookResult = ReturnType<typeof useUpdateUserFileAccessRequestItemMutation>;
export type UpdateUserFileAccessRequestItemMutationResult = Apollo.MutationResult<UpdateUserFileAccessRequestItemMutation>;
export type UpdateUserFileAccessRequestItemMutationOptions = Apollo.BaseMutationOptions<UpdateUserFileAccessRequestItemMutation, UpdateUserFileAccessRequestItemMutationVariables>;
export const GetUserFileAccessRequestDocument = gql`
    query GetUserFileAccessRequest($filter: user_file_access_request_filter, $sort: [String]) {
  user_file_access_request(filter: $filter, sort: $sort) {
    id
    is_granted
    attorney_id {
      id
      user_id {
        id
      }
      profiles {
        first_name
        last_name
        attorney_id {
          is_vetted
          user_id {
            avatar {
              id
            }
            current_organization {
              organization_id {
                profiles {
                  name
                }
              }
            }
          }
        }
      }
    }
    status {
      id
    }
    created_ts
  }
}
    `;

/**
 * __useGetUserFileAccessRequestQuery__
 *
 * To run a query within a React component, call `useGetUserFileAccessRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFileAccessRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFileAccessRequestQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetUserFileAccessRequestQuery(baseOptions?: Apollo.QueryHookOptions<GetUserFileAccessRequestQuery, GetUserFileAccessRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFileAccessRequestQuery, GetUserFileAccessRequestQueryVariables>(GetUserFileAccessRequestDocument, options);
      }
export function useGetUserFileAccessRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFileAccessRequestQuery, GetUserFileAccessRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFileAccessRequestQuery, GetUserFileAccessRequestQueryVariables>(GetUserFileAccessRequestDocument, options);
        }
export type GetUserFileAccessRequestQueryHookResult = ReturnType<typeof useGetUserFileAccessRequestQuery>;
export type GetUserFileAccessRequestLazyQueryHookResult = ReturnType<typeof useGetUserFileAccessRequestLazyQuery>;
export type GetUserFileAccessRequestQueryResult = Apollo.QueryResult<GetUserFileAccessRequestQuery, GetUserFileAccessRequestQueryVariables>;
export function refetchGetUserFileAccessRequestQuery(variables?: GetUserFileAccessRequestQueryVariables) {
      return { query: GetUserFileAccessRequestDocument, variables: variables }
    }
export const RemoveFavoriteAttorneyDocument = gql`
    mutation removeFavoriteAttorney($deleteAttorneyFavoriteItemId: ID!) {
  delete_attorney_favorite_item(id: $deleteAttorneyFavoriteItemId) {
    id
  }
}
    `;
export type RemoveFavoriteAttorneyMutationFn = Apollo.MutationFunction<RemoveFavoriteAttorneyMutation, RemoveFavoriteAttorneyMutationVariables>;

/**
 * __useRemoveFavoriteAttorneyMutation__
 *
 * To run a mutation, you first call `useRemoveFavoriteAttorneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavoriteAttorneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavoriteAttorneyMutation, { data, loading, error }] = useRemoveFavoriteAttorneyMutation({
 *   variables: {
 *      deleteAttorneyFavoriteItemId: // value for 'deleteAttorneyFavoriteItemId'
 *   },
 * });
 */
export function useRemoveFavoriteAttorneyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFavoriteAttorneyMutation, RemoveFavoriteAttorneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFavoriteAttorneyMutation, RemoveFavoriteAttorneyMutationVariables>(RemoveFavoriteAttorneyDocument, options);
      }
export type RemoveFavoriteAttorneyMutationHookResult = ReturnType<typeof useRemoveFavoriteAttorneyMutation>;
export type RemoveFavoriteAttorneyMutationResult = Apollo.MutationResult<RemoveFavoriteAttorneyMutation>;
export type RemoveFavoriteAttorneyMutationOptions = Apollo.BaseMutationOptions<RemoveFavoriteAttorneyMutation, RemoveFavoriteAttorneyMutationVariables>;
export const AddFavoriteAttorneyDocument = gql`
    mutation addFavoriteAttorney($data: create_attorney_favorite_input!) {
  create_attorney_favorite_item(data: $data) {
    id
  }
}
    `;
export type AddFavoriteAttorneyMutationFn = Apollo.MutationFunction<AddFavoriteAttorneyMutation, AddFavoriteAttorneyMutationVariables>;

/**
 * __useAddFavoriteAttorneyMutation__
 *
 * To run a mutation, you first call `useAddFavoriteAttorneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteAttorneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteAttorneyMutation, { data, loading, error }] = useAddFavoriteAttorneyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddFavoriteAttorneyMutation(baseOptions?: Apollo.MutationHookOptions<AddFavoriteAttorneyMutation, AddFavoriteAttorneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFavoriteAttorneyMutation, AddFavoriteAttorneyMutationVariables>(AddFavoriteAttorneyDocument, options);
      }
export type AddFavoriteAttorneyMutationHookResult = ReturnType<typeof useAddFavoriteAttorneyMutation>;
export type AddFavoriteAttorneyMutationResult = Apollo.MutationResult<AddFavoriteAttorneyMutation>;
export type AddFavoriteAttorneyMutationOptions = Apollo.BaseMutationOptions<AddFavoriteAttorneyMutation, AddFavoriteAttorneyMutationVariables>;
export const GetFavoritesByUserIdDocument = gql`
    query getFavoritesByUserId($filter: attorney_favorite_filter) {
  attorney_favorite(filter: $filter) {
    id
    favorite_attorney_id {
      id
      profiles {
        attorney_id {
          id
          is_vetted
          membership_type {
            id
          }
          user_id {
            id
            avatar {
              id
            }
          }
        }
        first_name
        last_name
        firms {
          name
        }
        practice_areas {
          practice_area_id {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetFavoritesByUserIdQuery__
 *
 * To run a query within a React component, call `useGetFavoritesByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoritesByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoritesByUserIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFavoritesByUserIdQuery(baseOptions?: Apollo.QueryHookOptions<GetFavoritesByUserIdQuery, GetFavoritesByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoritesByUserIdQuery, GetFavoritesByUserIdQueryVariables>(GetFavoritesByUserIdDocument, options);
      }
export function useGetFavoritesByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoritesByUserIdQuery, GetFavoritesByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoritesByUserIdQuery, GetFavoritesByUserIdQueryVariables>(GetFavoritesByUserIdDocument, options);
        }
export type GetFavoritesByUserIdQueryHookResult = ReturnType<typeof useGetFavoritesByUserIdQuery>;
export type GetFavoritesByUserIdLazyQueryHookResult = ReturnType<typeof useGetFavoritesByUserIdLazyQuery>;
export type GetFavoritesByUserIdQueryResult = Apollo.QueryResult<GetFavoritesByUserIdQuery, GetFavoritesByUserIdQueryVariables>;
export function refetchGetFavoritesByUserIdQuery(variables?: GetFavoritesByUserIdQueryVariables) {
      return { query: GetFavoritesByUserIdDocument, variables: variables }
    }
export const CreateIntegrationDocument = gql`
    mutation createIntegration($data: create_attorney_oauth_integration_input!) {
  create_attorney_oauth_integration_item(data: $data) {
    code
  }
}
    `;
export type CreateIntegrationMutationFn = Apollo.MutationFunction<CreateIntegrationMutation, CreateIntegrationMutationVariables>;

/**
 * __useCreateIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntegrationMutation, { data, loading, error }] = useCreateIntegrationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateIntegrationMutation, CreateIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIntegrationMutation, CreateIntegrationMutationVariables>(CreateIntegrationDocument, options);
      }
export type CreateIntegrationMutationHookResult = ReturnType<typeof useCreateIntegrationMutation>;
export type CreateIntegrationMutationResult = Apollo.MutationResult<CreateIntegrationMutation>;
export type CreateIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateIntegrationMutation, CreateIntegrationMutationVariables>;
export const DeleteIntegrationItemDocument = gql`
    mutation deleteIntegrationItem($deleteAttorneyOauthIntegrationItemId: ID!) {
  delete_attorney_oauth_integration_item(
    id: $deleteAttorneyOauthIntegrationItemId
  ) {
    id
  }
}
    `;
export type DeleteIntegrationItemMutationFn = Apollo.MutationFunction<DeleteIntegrationItemMutation, DeleteIntegrationItemMutationVariables>;

/**
 * __useDeleteIntegrationItemMutation__
 *
 * To run a mutation, you first call `useDeleteIntegrationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntegrationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntegrationItemMutation, { data, loading, error }] = useDeleteIntegrationItemMutation({
 *   variables: {
 *      deleteAttorneyOauthIntegrationItemId: // value for 'deleteAttorneyOauthIntegrationItemId'
 *   },
 * });
 */
export function useDeleteIntegrationItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIntegrationItemMutation, DeleteIntegrationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIntegrationItemMutation, DeleteIntegrationItemMutationVariables>(DeleteIntegrationItemDocument, options);
      }
export type DeleteIntegrationItemMutationHookResult = ReturnType<typeof useDeleteIntegrationItemMutation>;
export type DeleteIntegrationItemMutationResult = Apollo.MutationResult<DeleteIntegrationItemMutation>;
export type DeleteIntegrationItemMutationOptions = Apollo.BaseMutationOptions<DeleteIntegrationItemMutation, DeleteIntegrationItemMutationVariables>;
export const CreateLcmsMappingDocument = gql`
    mutation createLcmsMapping($data: create_lcms_case_mapping_input!) {
  create_lcms_case_mapping_item(data: $data) {
    case_id
  }
}
    `;
export type CreateLcmsMappingMutationFn = Apollo.MutationFunction<CreateLcmsMappingMutation, CreateLcmsMappingMutationVariables>;

/**
 * __useCreateLcmsMappingMutation__
 *
 * To run a mutation, you first call `useCreateLcmsMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLcmsMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLcmsMappingMutation, { data, loading, error }] = useCreateLcmsMappingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLcmsMappingMutation(baseOptions?: Apollo.MutationHookOptions<CreateLcmsMappingMutation, CreateLcmsMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLcmsMappingMutation, CreateLcmsMappingMutationVariables>(CreateLcmsMappingDocument, options);
      }
export type CreateLcmsMappingMutationHookResult = ReturnType<typeof useCreateLcmsMappingMutation>;
export type CreateLcmsMappingMutationResult = Apollo.MutationResult<CreateLcmsMappingMutation>;
export type CreateLcmsMappingMutationOptions = Apollo.BaseMutationOptions<CreateLcmsMappingMutation, CreateLcmsMappingMutationVariables>;
export const GetIntegrationsDocument = gql`
    query getIntegrations {
  catalog_oauth_integration {
    id
    name
    connect_url_envar
  }
}
    `;

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
      }
export function useGetIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>;
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>;
export type GetIntegrationsQueryResult = Apollo.QueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export function refetchGetIntegrationsQuery(variables?: GetIntegrationsQueryVariables) {
      return { query: GetIntegrationsDocument, variables: variables }
    }
export const GetAttorneyIntegrationsDocument = gql`
    query getAttorneyIntegrations($filter: attorney_oauth_integration_filter) {
  attorney_oauth_integration(filter: $filter) {
    id
    attorney_id {
      id
    }
    integration_id {
      id
      name
      connect_url_envar
    }
    code
  }
}
    `;

/**
 * __useGetAttorneyIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetAttorneyIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttorneyIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttorneyIntegrationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAttorneyIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAttorneyIntegrationsQuery, GetAttorneyIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttorneyIntegrationsQuery, GetAttorneyIntegrationsQueryVariables>(GetAttorneyIntegrationsDocument, options);
      }
export function useGetAttorneyIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttorneyIntegrationsQuery, GetAttorneyIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttorneyIntegrationsQuery, GetAttorneyIntegrationsQueryVariables>(GetAttorneyIntegrationsDocument, options);
        }
export type GetAttorneyIntegrationsQueryHookResult = ReturnType<typeof useGetAttorneyIntegrationsQuery>;
export type GetAttorneyIntegrationsLazyQueryHookResult = ReturnType<typeof useGetAttorneyIntegrationsLazyQuery>;
export type GetAttorneyIntegrationsQueryResult = Apollo.QueryResult<GetAttorneyIntegrationsQuery, GetAttorneyIntegrationsQueryVariables>;
export function refetchGetAttorneyIntegrationsQuery(variables?: GetAttorneyIntegrationsQueryVariables) {
      return { query: GetAttorneyIntegrationsDocument, variables: variables }
    }
export const GetOrganizationConnectedDocument = gql`
    query getOrganizationConnected($search: String) {
  organization_connected_lcms(search: $search) {
    id
    case_management_software_id {
      id
      name
    }
    organization_id {
      id
    }
    created_by {
      id
      role {
        id
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationConnectedQuery__
 *
 * To run a query within a React component, call `useGetOrganizationConnectedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationConnectedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationConnectedQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetOrganizationConnectedQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationConnectedQuery, GetOrganizationConnectedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationConnectedQuery, GetOrganizationConnectedQueryVariables>(GetOrganizationConnectedDocument, options);
      }
export function useGetOrganizationConnectedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationConnectedQuery, GetOrganizationConnectedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationConnectedQuery, GetOrganizationConnectedQueryVariables>(GetOrganizationConnectedDocument, options);
        }
export type GetOrganizationConnectedQueryHookResult = ReturnType<typeof useGetOrganizationConnectedQuery>;
export type GetOrganizationConnectedLazyQueryHookResult = ReturnType<typeof useGetOrganizationConnectedLazyQuery>;
export type GetOrganizationConnectedQueryResult = Apollo.QueryResult<GetOrganizationConnectedQuery, GetOrganizationConnectedQueryVariables>;
export function refetchGetOrganizationConnectedQuery(variables?: GetOrganizationConnectedQueryVariables) {
      return { query: GetOrganizationConnectedDocument, variables: variables }
    }
export const BulkInviteAttorneyDocument = gql`
    mutation bulkInviteAttorney($data: [create_attorney_invite_input!]) {
  create_attorney_invite_items(data: $data) {
    id
    email
    token
  }
}
    `;
export type BulkInviteAttorneyMutationFn = Apollo.MutationFunction<BulkInviteAttorneyMutation, BulkInviteAttorneyMutationVariables>;

/**
 * __useBulkInviteAttorneyMutation__
 *
 * To run a mutation, you first call `useBulkInviteAttorneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkInviteAttorneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkInviteAttorneyMutation, { data, loading, error }] = useBulkInviteAttorneyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkInviteAttorneyMutation(baseOptions?: Apollo.MutationHookOptions<BulkInviteAttorneyMutation, BulkInviteAttorneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkInviteAttorneyMutation, BulkInviteAttorneyMutationVariables>(BulkInviteAttorneyDocument, options);
      }
export type BulkInviteAttorneyMutationHookResult = ReturnType<typeof useBulkInviteAttorneyMutation>;
export type BulkInviteAttorneyMutationResult = Apollo.MutationResult<BulkInviteAttorneyMutation>;
export type BulkInviteAttorneyMutationOptions = Apollo.BaseMutationOptions<BulkInviteAttorneyMutation, BulkInviteAttorneyMutationVariables>;
export const UpdateInviteAttorneyDocument = gql`
    mutation updateInviteAttorney($updateAttorneyInviteItemId: ID!, $data: update_attorney_invite_input!) {
  update_attorney_invite_item(id: $updateAttorneyInviteItemId, data: $data) {
    id
  }
}
    `;
export type UpdateInviteAttorneyMutationFn = Apollo.MutationFunction<UpdateInviteAttorneyMutation, UpdateInviteAttorneyMutationVariables>;

/**
 * __useUpdateInviteAttorneyMutation__
 *
 * To run a mutation, you first call `useUpdateInviteAttorneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInviteAttorneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInviteAttorneyMutation, { data, loading, error }] = useUpdateInviteAttorneyMutation({
 *   variables: {
 *      updateAttorneyInviteItemId: // value for 'updateAttorneyInviteItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateInviteAttorneyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInviteAttorneyMutation, UpdateInviteAttorneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInviteAttorneyMutation, UpdateInviteAttorneyMutationVariables>(UpdateInviteAttorneyDocument, options);
      }
export type UpdateInviteAttorneyMutationHookResult = ReturnType<typeof useUpdateInviteAttorneyMutation>;
export type UpdateInviteAttorneyMutationResult = Apollo.MutationResult<UpdateInviteAttorneyMutation>;
export type UpdateInviteAttorneyMutationOptions = Apollo.BaseMutationOptions<UpdateInviteAttorneyMutation, UpdateInviteAttorneyMutationVariables>;
export const BulkUpdateNetworkUserInviteDocument = gql`
    mutation bulkUpdateNetworkUserInvite($data: [create_network_user_invite_input!]) {
  create_network_user_invite_items(data: $data) {
    id
    email
    first_name
    last_name
  }
}
    `;
export type BulkUpdateNetworkUserInviteMutationFn = Apollo.MutationFunction<BulkUpdateNetworkUserInviteMutation, BulkUpdateNetworkUserInviteMutationVariables>;

/**
 * __useBulkUpdateNetworkUserInviteMutation__
 *
 * To run a mutation, you first call `useBulkUpdateNetworkUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateNetworkUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateNetworkUserInviteMutation, { data, loading, error }] = useBulkUpdateNetworkUserInviteMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBulkUpdateNetworkUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateNetworkUserInviteMutation, BulkUpdateNetworkUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateNetworkUserInviteMutation, BulkUpdateNetworkUserInviteMutationVariables>(BulkUpdateNetworkUserInviteDocument, options);
      }
export type BulkUpdateNetworkUserInviteMutationHookResult = ReturnType<typeof useBulkUpdateNetworkUserInviteMutation>;
export type BulkUpdateNetworkUserInviteMutationResult = Apollo.MutationResult<BulkUpdateNetworkUserInviteMutation>;
export type BulkUpdateNetworkUserInviteMutationOptions = Apollo.BaseMutationOptions<BulkUpdateNetworkUserInviteMutation, BulkUpdateNetworkUserInviteMutationVariables>;
export const UpdateOrganziationItemDocument = gql`
    mutation updateOrganziationItem($updateOrganizationUserItemId: ID!, $data: update_organization_user_input!) {
  update_organization_user_item(id: $updateOrganizationUserItemId, data: $data) {
    id
  }
}
    `;
export type UpdateOrganziationItemMutationFn = Apollo.MutationFunction<UpdateOrganziationItemMutation, UpdateOrganziationItemMutationVariables>;

/**
 * __useUpdateOrganziationItemMutation__
 *
 * To run a mutation, you first call `useUpdateOrganziationItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganziationItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganziationItemMutation, { data, loading, error }] = useUpdateOrganziationItemMutation({
 *   variables: {
 *      updateOrganizationUserItemId: // value for 'updateOrganizationUserItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOrganziationItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganziationItemMutation, UpdateOrganziationItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganziationItemMutation, UpdateOrganziationItemMutationVariables>(UpdateOrganziationItemDocument, options);
      }
export type UpdateOrganziationItemMutationHookResult = ReturnType<typeof useUpdateOrganziationItemMutation>;
export type UpdateOrganziationItemMutationResult = Apollo.MutationResult<UpdateOrganziationItemMutation>;
export type UpdateOrganziationItemMutationOptions = Apollo.BaseMutationOptions<UpdateOrganziationItemMutation, UpdateOrganziationItemMutationVariables>;
export const GetRoleInviteCatalogDocument = gql`
    query getRoleInviteCatalog {
  catalog_role_invite {
    name
    role_id {
      id
    }
  }
}
    `;

/**
 * __useGetRoleInviteCatalogQuery__
 *
 * To run a query within a React component, call `useGetRoleInviteCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleInviteCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleInviteCatalogQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRoleInviteCatalogQuery(baseOptions?: Apollo.QueryHookOptions<GetRoleInviteCatalogQuery, GetRoleInviteCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleInviteCatalogQuery, GetRoleInviteCatalogQueryVariables>(GetRoleInviteCatalogDocument, options);
      }
export function useGetRoleInviteCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleInviteCatalogQuery, GetRoleInviteCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleInviteCatalogQuery, GetRoleInviteCatalogQueryVariables>(GetRoleInviteCatalogDocument, options);
        }
export type GetRoleInviteCatalogQueryHookResult = ReturnType<typeof useGetRoleInviteCatalogQuery>;
export type GetRoleInviteCatalogLazyQueryHookResult = ReturnType<typeof useGetRoleInviteCatalogLazyQuery>;
export type GetRoleInviteCatalogQueryResult = Apollo.QueryResult<GetRoleInviteCatalogQuery, GetRoleInviteCatalogQueryVariables>;
export function refetchGetRoleInviteCatalogQuery(variables?: GetRoleInviteCatalogQueryVariables) {
      return { query: GetRoleInviteCatalogDocument, variables: variables }
    }
export const GetInvitationsSentDocument = gql`
    query getInvitationsSent($filter: attorney_invite_filter) {
  attorney_invite(filter: $filter) {
    id
    email
    invite_status_id {
      id
    }
    sent_ts
    target_role_id {
      id
      name
    }
  }
}
    `;

/**
 * __useGetInvitationsSentQuery__
 *
 * To run a query within a React component, call `useGetInvitationsSentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitationsSentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitationsSentQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetInvitationsSentQuery(baseOptions?: Apollo.QueryHookOptions<GetInvitationsSentQuery, GetInvitationsSentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitationsSentQuery, GetInvitationsSentQueryVariables>(GetInvitationsSentDocument, options);
      }
export function useGetInvitationsSentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitationsSentQuery, GetInvitationsSentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitationsSentQuery, GetInvitationsSentQueryVariables>(GetInvitationsSentDocument, options);
        }
export type GetInvitationsSentQueryHookResult = ReturnType<typeof useGetInvitationsSentQuery>;
export type GetInvitationsSentLazyQueryHookResult = ReturnType<typeof useGetInvitationsSentLazyQuery>;
export type GetInvitationsSentQueryResult = Apollo.QueryResult<GetInvitationsSentQuery, GetInvitationsSentQueryVariables>;
export function refetchGetInvitationsSentQuery(variables?: GetInvitationsSentQueryVariables) {
      return { query: GetInvitationsSentDocument, variables: variables }
    }
export const GetNetworkUserInvitesSentDocument = gql`
    query getNetworkUserInvitesSent($filter: network_user_invite_filter) {
  network_user_invite(filter: $filter) {
    id
    email
    first_name
    last_name
    send_ts
  }
}
    `;

/**
 * __useGetNetworkUserInvitesSentQuery__
 *
 * To run a query within a React component, call `useGetNetworkUserInvitesSentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetworkUserInvitesSentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetworkUserInvitesSentQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetNetworkUserInvitesSentQuery(baseOptions?: Apollo.QueryHookOptions<GetNetworkUserInvitesSentQuery, GetNetworkUserInvitesSentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNetworkUserInvitesSentQuery, GetNetworkUserInvitesSentQueryVariables>(GetNetworkUserInvitesSentDocument, options);
      }
export function useGetNetworkUserInvitesSentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNetworkUserInvitesSentQuery, GetNetworkUserInvitesSentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNetworkUserInvitesSentQuery, GetNetworkUserInvitesSentQueryVariables>(GetNetworkUserInvitesSentDocument, options);
        }
export type GetNetworkUserInvitesSentQueryHookResult = ReturnType<typeof useGetNetworkUserInvitesSentQuery>;
export type GetNetworkUserInvitesSentLazyQueryHookResult = ReturnType<typeof useGetNetworkUserInvitesSentLazyQuery>;
export type GetNetworkUserInvitesSentQueryResult = Apollo.QueryResult<GetNetworkUserInvitesSentQuery, GetNetworkUserInvitesSentQueryVariables>;
export function refetchGetNetworkUserInvitesSentQuery(variables?: GetNetworkUserInvitesSentQueryVariables) {
      return { query: GetNetworkUserInvitesSentDocument, variables: variables }
    }
export const GetOrganizationMembersDocument = gql`
    query getOrganizationMembers($filter: organization_user_filter, $sort: [String]) {
  organization_user(filter: $filter, sort: $sort) {
    id
    user_id {
      id
      first_name
      last_name
      role {
        id
        name
      }
      avatar {
        id
      }
      attorneys {
        id
        is_vetted
        membership_type {
          id
        }
        profiles {
          first_name
          last_name
          affiliations {
            affiliation_id {
              id
              name
              badge_image_url
              priority
            }
          }
        }
      }
      current_organization {
        position_name
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationMembersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationMembersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetOrganizationMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>(GetOrganizationMembersDocument, options);
      }
export function useGetOrganizationMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>(GetOrganizationMembersDocument, options);
        }
export type GetOrganizationMembersQueryHookResult = ReturnType<typeof useGetOrganizationMembersQuery>;
export type GetOrganizationMembersLazyQueryHookResult = ReturnType<typeof useGetOrganizationMembersLazyQuery>;
export type GetOrganizationMembersQueryResult = Apollo.QueryResult<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>;
export function refetchGetOrganizationMembersQuery(variables?: GetOrganizationMembersQueryVariables) {
      return { query: GetOrganizationMembersDocument, variables: variables }
    }
export const CreateCaseMpPreferenceDocument = gql`
    mutation CreateCaseMpPreference($data: create_attorney_case_mp_preference_input!) {
  create_attorney_case_mp_preference_item(data: $data) {
    id
  }
}
    `;
export type CreateCaseMpPreferenceMutationFn = Apollo.MutationFunction<CreateCaseMpPreferenceMutation, CreateCaseMpPreferenceMutationVariables>;

/**
 * __useCreateCaseMpPreferenceMutation__
 *
 * To run a mutation, you first call `useCreateCaseMpPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseMpPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseMpPreferenceMutation, { data, loading, error }] = useCreateCaseMpPreferenceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCaseMpPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseMpPreferenceMutation, CreateCaseMpPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseMpPreferenceMutation, CreateCaseMpPreferenceMutationVariables>(CreateCaseMpPreferenceDocument, options);
      }
export type CreateCaseMpPreferenceMutationHookResult = ReturnType<typeof useCreateCaseMpPreferenceMutation>;
export type CreateCaseMpPreferenceMutationResult = Apollo.MutationResult<CreateCaseMpPreferenceMutation>;
export type CreateCaseMpPreferenceMutationOptions = Apollo.BaseMutationOptions<CreateCaseMpPreferenceMutation, CreateCaseMpPreferenceMutationVariables>;
export const DeleteCaseMpPreferenceItemDocument = gql`
    mutation DeleteCaseMpPreferenceItem($deleteAttorneyCaseMpPreferenceItemId: ID!) {
  delete_attorney_case_mp_preference_item(
    id: $deleteAttorneyCaseMpPreferenceItemId
  ) {
    id
  }
}
    `;
export type DeleteCaseMpPreferenceItemMutationFn = Apollo.MutationFunction<DeleteCaseMpPreferenceItemMutation, DeleteCaseMpPreferenceItemMutationVariables>;

/**
 * __useDeleteCaseMpPreferenceItemMutation__
 *
 * To run a mutation, you first call `useDeleteCaseMpPreferenceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaseMpPreferenceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaseMpPreferenceItemMutation, { data, loading, error }] = useDeleteCaseMpPreferenceItemMutation({
 *   variables: {
 *      deleteAttorneyCaseMpPreferenceItemId: // value for 'deleteAttorneyCaseMpPreferenceItemId'
 *   },
 * });
 */
export function useDeleteCaseMpPreferenceItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaseMpPreferenceItemMutation, DeleteCaseMpPreferenceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaseMpPreferenceItemMutation, DeleteCaseMpPreferenceItemMutationVariables>(DeleteCaseMpPreferenceItemDocument, options);
      }
export type DeleteCaseMpPreferenceItemMutationHookResult = ReturnType<typeof useDeleteCaseMpPreferenceItemMutation>;
export type DeleteCaseMpPreferenceItemMutationResult = Apollo.MutationResult<DeleteCaseMpPreferenceItemMutation>;
export type DeleteCaseMpPreferenceItemMutationOptions = Apollo.BaseMutationOptions<DeleteCaseMpPreferenceItemMutation, DeleteCaseMpPreferenceItemMutationVariables>;
export const GetMarketplacePreferencesDocument = gql`
    query getMarketplacePreferences($filter: attorney_case_mp_preference_filter) {
  attorney_case_mp_preference(filter: $filter) {
    case_id {
      id
    }
    case_mp_preference_id {
      id
      name
    }
    id
  }
}
    `;

/**
 * __useGetMarketplacePreferencesQuery__
 *
 * To run a query within a React component, call `useGetMarketplacePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketplacePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketplacePreferencesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMarketplacePreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetMarketplacePreferencesQuery, GetMarketplacePreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketplacePreferencesQuery, GetMarketplacePreferencesQueryVariables>(GetMarketplacePreferencesDocument, options);
      }
export function useGetMarketplacePreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketplacePreferencesQuery, GetMarketplacePreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketplacePreferencesQuery, GetMarketplacePreferencesQueryVariables>(GetMarketplacePreferencesDocument, options);
        }
export type GetMarketplacePreferencesQueryHookResult = ReturnType<typeof useGetMarketplacePreferencesQuery>;
export type GetMarketplacePreferencesLazyQueryHookResult = ReturnType<typeof useGetMarketplacePreferencesLazyQuery>;
export type GetMarketplacePreferencesQueryResult = Apollo.QueryResult<GetMarketplacePreferencesQuery, GetMarketplacePreferencesQueryVariables>;
export function refetchGetMarketplacePreferencesQuery(variables?: GetMarketplacePreferencesQueryVariables) {
      return { query: GetMarketplacePreferencesDocument, variables: variables }
    }
export const GetAttorneyPaymentMembershipDocument = gql`
    query getAttorneyPaymentMembership($filter: attorney_payment_membership_filter) {
  attorney_payment_membership(filter: $filter) {
    payment_status_id {
      id
    }
  }
}
    `;

/**
 * __useGetAttorneyPaymentMembershipQuery__
 *
 * To run a query within a React component, call `useGetAttorneyPaymentMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttorneyPaymentMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttorneyPaymentMembershipQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAttorneyPaymentMembershipQuery(baseOptions?: Apollo.QueryHookOptions<GetAttorneyPaymentMembershipQuery, GetAttorneyPaymentMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttorneyPaymentMembershipQuery, GetAttorneyPaymentMembershipQueryVariables>(GetAttorneyPaymentMembershipDocument, options);
      }
export function useGetAttorneyPaymentMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttorneyPaymentMembershipQuery, GetAttorneyPaymentMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttorneyPaymentMembershipQuery, GetAttorneyPaymentMembershipQueryVariables>(GetAttorneyPaymentMembershipDocument, options);
        }
export type GetAttorneyPaymentMembershipQueryHookResult = ReturnType<typeof useGetAttorneyPaymentMembershipQuery>;
export type GetAttorneyPaymentMembershipLazyQueryHookResult = ReturnType<typeof useGetAttorneyPaymentMembershipLazyQuery>;
export type GetAttorneyPaymentMembershipQueryResult = Apollo.QueryResult<GetAttorneyPaymentMembershipQuery, GetAttorneyPaymentMembershipQueryVariables>;
export function refetchGetAttorneyPaymentMembershipQuery(variables?: GetAttorneyPaymentMembershipQueryVariables) {
      return { query: GetAttorneyPaymentMembershipDocument, variables: variables }
    }
export const CreateCaseStatusUpdateDocument = gql`
    mutation CreateCaseStatusUpdate($data: create_case_status_update_input!) {
  create_case_status_update_item(data: $data) {
    id
  }
}
    `;
export type CreateCaseStatusUpdateMutationFn = Apollo.MutationFunction<CreateCaseStatusUpdateMutation, CreateCaseStatusUpdateMutationVariables>;

/**
 * __useCreateCaseStatusUpdateMutation__
 *
 * To run a mutation, you first call `useCreateCaseStatusUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseStatusUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseStatusUpdateMutation, { data, loading, error }] = useCreateCaseStatusUpdateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCaseStatusUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseStatusUpdateMutation, CreateCaseStatusUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseStatusUpdateMutation, CreateCaseStatusUpdateMutationVariables>(CreateCaseStatusUpdateDocument, options);
      }
export type CreateCaseStatusUpdateMutationHookResult = ReturnType<typeof useCreateCaseStatusUpdateMutation>;
export type CreateCaseStatusUpdateMutationResult = Apollo.MutationResult<CreateCaseStatusUpdateMutation>;
export type CreateCaseStatusUpdateMutationOptions = Apollo.BaseMutationOptions<CreateCaseStatusUpdateMutation, CreateCaseStatusUpdateMutationVariables>;
export const CreateCaseStatusSchedulerTaskDocument = gql`
    mutation CreateCaseStatusSchedulerTask($data: create_case_status_update_scheduler_task_input!) {
  create_case_status_update_scheduler_task_item(data: $data) {
    id
  }
}
    `;
export type CreateCaseStatusSchedulerTaskMutationFn = Apollo.MutationFunction<CreateCaseStatusSchedulerTaskMutation, CreateCaseStatusSchedulerTaskMutationVariables>;

/**
 * __useCreateCaseStatusSchedulerTaskMutation__
 *
 * To run a mutation, you first call `useCreateCaseStatusSchedulerTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseStatusSchedulerTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseStatusSchedulerTaskMutation, { data, loading, error }] = useCreateCaseStatusSchedulerTaskMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCaseStatusSchedulerTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseStatusSchedulerTaskMutation, CreateCaseStatusSchedulerTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseStatusSchedulerTaskMutation, CreateCaseStatusSchedulerTaskMutationVariables>(CreateCaseStatusSchedulerTaskDocument, options);
      }
export type CreateCaseStatusSchedulerTaskMutationHookResult = ReturnType<typeof useCreateCaseStatusSchedulerTaskMutation>;
export type CreateCaseStatusSchedulerTaskMutationResult = Apollo.MutationResult<CreateCaseStatusSchedulerTaskMutation>;
export type CreateCaseStatusSchedulerTaskMutationOptions = Apollo.BaseMutationOptions<CreateCaseStatusSchedulerTaskMutation, CreateCaseStatusSchedulerTaskMutationVariables>;
export const UpdateCaseStatusSchedulerTaskDocument = gql`
    mutation UpdateCaseStatusSchedulerTask($id: ID!, $data: update_case_status_update_scheduler_task_input!) {
  update_case_status_update_scheduler_task_item(id: $id, data: $data) {
    id
  }
}
    `;
export type UpdateCaseStatusSchedulerTaskMutationFn = Apollo.MutationFunction<UpdateCaseStatusSchedulerTaskMutation, UpdateCaseStatusSchedulerTaskMutationVariables>;

/**
 * __useUpdateCaseStatusSchedulerTaskMutation__
 *
 * To run a mutation, you first call `useUpdateCaseStatusSchedulerTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseStatusSchedulerTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseStatusSchedulerTaskMutation, { data, loading, error }] = useUpdateCaseStatusSchedulerTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCaseStatusSchedulerTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseStatusSchedulerTaskMutation, UpdateCaseStatusSchedulerTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseStatusSchedulerTaskMutation, UpdateCaseStatusSchedulerTaskMutationVariables>(UpdateCaseStatusSchedulerTaskDocument, options);
      }
export type UpdateCaseStatusSchedulerTaskMutationHookResult = ReturnType<typeof useUpdateCaseStatusSchedulerTaskMutation>;
export type UpdateCaseStatusSchedulerTaskMutationResult = Apollo.MutationResult<UpdateCaseStatusSchedulerTaskMutation>;
export type UpdateCaseStatusSchedulerTaskMutationOptions = Apollo.BaseMutationOptions<UpdateCaseStatusSchedulerTaskMutation, UpdateCaseStatusSchedulerTaskMutationVariables>;
export const GetOrganizationsDocument = gql`
    query getOrganizations($filter: organization_filter, $limit: Int) {
  organization(filter: $filter, limit: $limit) {
    id
    profiles {
      name
    }
  }
}
    `;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export function refetchGetOrganizationsQuery(variables?: GetOrganizationsQueryVariables) {
      return { query: GetOrganizationsDocument, variables: variables }
    }
export const GetAttorneysProfileByIdDocument = gql`
    query getAttorneysProfileById($filter: attorney_profile_filter, $licenseFilter: attorney_profile_license_filter, $limit: Int, $offset: Int, $profileSort: [String]) {
  attorney_profile_aggregated(filter: $filter) {
    countDistinct {
      attorney_id
    }
  }
  attorney_profile(
    filter: $filter
    limit: $limit
    offset: $offset
    sort: $profileSort
  ) {
    id
    first_name
    last_name
    bio
    years_practice {
      name
    }
    attorney_id {
      id
      is_vetted
      membership_type {
        id
      }
      user_id {
        id
        email
        last_access
        avatar {
          id
        }
        current_organization {
          id
          position_name
          organization_id {
            id
          }
        }
      }
    }
    affiliations {
      affiliation_id {
        id
        name
        badge_image_url
        priority
      }
    }
    awards {
      award_id {
        id
        name
      }
    }
    firms {
      name
      address
      state {
        name
        code
      }
      city
      zip
      size {
        name
      }
      relationship {
        name
      }
    }
    contacts {
      type {
        name
      }
      value
    }
    education {
      grade {
        id
        name
      }
      school_id {
        id
        name
      }
    }
    licenses(filter: $licenseFilter) {
      bar_number
      has_been_disciplined_by_bar
      has_been_sued_by_malpractice
      is_license_suspended
      license_state {
        name
        code
      }
      insurances {
        expiration_date
        insurance_coverage_id {
          id
        }
      }
    }
    case_management_softwares {
      case_management_software_id {
        name
      }
    }
    languages {
      language_id {
        id
        name
      }
    }
    practice_areas {
      practice_area_id {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAttorneysProfileByIdQuery__
 *
 * To run a query within a React component, call `useGetAttorneysProfileByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttorneysProfileByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttorneysProfileByIdQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      licenseFilter: // value for 'licenseFilter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      profileSort: // value for 'profileSort'
 *   },
 * });
 */
export function useGetAttorneysProfileByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetAttorneysProfileByIdQuery, GetAttorneysProfileByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttorneysProfileByIdQuery, GetAttorneysProfileByIdQueryVariables>(GetAttorneysProfileByIdDocument, options);
      }
export function useGetAttorneysProfileByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttorneysProfileByIdQuery, GetAttorneysProfileByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttorneysProfileByIdQuery, GetAttorneysProfileByIdQueryVariables>(GetAttorneysProfileByIdDocument, options);
        }
export type GetAttorneysProfileByIdQueryHookResult = ReturnType<typeof useGetAttorneysProfileByIdQuery>;
export type GetAttorneysProfileByIdLazyQueryHookResult = ReturnType<typeof useGetAttorneysProfileByIdLazyQuery>;
export type GetAttorneysProfileByIdQueryResult = Apollo.QueryResult<GetAttorneysProfileByIdQuery, GetAttorneysProfileByIdQueryVariables>;
export function refetchGetAttorneysProfileByIdQuery(variables?: GetAttorneysProfileByIdQueryVariables) {
      return { query: GetAttorneysProfileByIdDocument, variables: variables }
    }
export const UpdateAttorneyProfileItemDocument = gql`
    mutation UpdateAttorneyProfileItem($data: update_attorney_profile_input!, $updateAttorneyProfileItemId: ID!) {
  update_attorney_profile_item(data: $data, id: $updateAttorneyProfileItemId) {
    first_name
    bio
    last_name
    languages {
      language_id {
        id
        name
      }
    }
    awards {
      id
      award_id {
        id
        name
      }
    }
  }
}
    `;
export type UpdateAttorneyProfileItemMutationFn = Apollo.MutationFunction<UpdateAttorneyProfileItemMutation, UpdateAttorneyProfileItemMutationVariables>;

/**
 * __useUpdateAttorneyProfileItemMutation__
 *
 * To run a mutation, you first call `useUpdateAttorneyProfileItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttorneyProfileItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttorneyProfileItemMutation, { data, loading, error }] = useUpdateAttorneyProfileItemMutation({
 *   variables: {
 *      data: // value for 'data'
 *      updateAttorneyProfileItemId: // value for 'updateAttorneyProfileItemId'
 *   },
 * });
 */
export function useUpdateAttorneyProfileItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttorneyProfileItemMutation, UpdateAttorneyProfileItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttorneyProfileItemMutation, UpdateAttorneyProfileItemMutationVariables>(UpdateAttorneyProfileItemDocument, options);
      }
export type UpdateAttorneyProfileItemMutationHookResult = ReturnType<typeof useUpdateAttorneyProfileItemMutation>;
export type UpdateAttorneyProfileItemMutationResult = Apollo.MutationResult<UpdateAttorneyProfileItemMutation>;
export type UpdateAttorneyProfileItemMutationOptions = Apollo.BaseMutationOptions<UpdateAttorneyProfileItemMutation, UpdateAttorneyProfileItemMutationVariables>;
export const DeleteAttorneyProfileLanguageItemDocument = gql`
    mutation DeleteAttorneyProfileLanguageItem($deleteAttorneyProfileLanguageItemId: ID!) {
  delete_attorney_profile_language_item(id: $deleteAttorneyProfileLanguageItemId) {
    id
  }
}
    `;
export type DeleteAttorneyProfileLanguageItemMutationFn = Apollo.MutationFunction<DeleteAttorneyProfileLanguageItemMutation, DeleteAttorneyProfileLanguageItemMutationVariables>;

/**
 * __useDeleteAttorneyProfileLanguageItemMutation__
 *
 * To run a mutation, you first call `useDeleteAttorneyProfileLanguageItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttorneyProfileLanguageItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttorneyProfileLanguageItemMutation, { data, loading, error }] = useDeleteAttorneyProfileLanguageItemMutation({
 *   variables: {
 *      deleteAttorneyProfileLanguageItemId: // value for 'deleteAttorneyProfileLanguageItemId'
 *   },
 * });
 */
export function useDeleteAttorneyProfileLanguageItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttorneyProfileLanguageItemMutation, DeleteAttorneyProfileLanguageItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttorneyProfileLanguageItemMutation, DeleteAttorneyProfileLanguageItemMutationVariables>(DeleteAttorneyProfileLanguageItemDocument, options);
      }
export type DeleteAttorneyProfileLanguageItemMutationHookResult = ReturnType<typeof useDeleteAttorneyProfileLanguageItemMutation>;
export type DeleteAttorneyProfileLanguageItemMutationResult = Apollo.MutationResult<DeleteAttorneyProfileLanguageItemMutation>;
export type DeleteAttorneyProfileLanguageItemMutationOptions = Apollo.BaseMutationOptions<DeleteAttorneyProfileLanguageItemMutation, DeleteAttorneyProfileLanguageItemMutationVariables>;
export const DeleteAttorneyProfileAwardItemDocument = gql`
    mutation DeleteAttorneyProfileAwardItem($deleteAttorneyProfileAwardItemId: ID!) {
  delete_attorney_profile_award_item(id: $deleteAttorneyProfileAwardItemId) {
    id
  }
}
    `;
export type DeleteAttorneyProfileAwardItemMutationFn = Apollo.MutationFunction<DeleteAttorneyProfileAwardItemMutation, DeleteAttorneyProfileAwardItemMutationVariables>;

/**
 * __useDeleteAttorneyProfileAwardItemMutation__
 *
 * To run a mutation, you first call `useDeleteAttorneyProfileAwardItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttorneyProfileAwardItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttorneyProfileAwardItemMutation, { data, loading, error }] = useDeleteAttorneyProfileAwardItemMutation({
 *   variables: {
 *      deleteAttorneyProfileAwardItemId: // value for 'deleteAttorneyProfileAwardItemId'
 *   },
 * });
 */
export function useDeleteAttorneyProfileAwardItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttorneyProfileAwardItemMutation, DeleteAttorneyProfileAwardItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttorneyProfileAwardItemMutation, DeleteAttorneyProfileAwardItemMutationVariables>(DeleteAttorneyProfileAwardItemDocument, options);
      }
export type DeleteAttorneyProfileAwardItemMutationHookResult = ReturnType<typeof useDeleteAttorneyProfileAwardItemMutation>;
export type DeleteAttorneyProfileAwardItemMutationResult = Apollo.MutationResult<DeleteAttorneyProfileAwardItemMutation>;
export type DeleteAttorneyProfileAwardItemMutationOptions = Apollo.BaseMutationOptions<DeleteAttorneyProfileAwardItemMutation, DeleteAttorneyProfileAwardItemMutationVariables>;
export const DeleteAttorneyProfileLanguageItemsDocument = gql`
    mutation DeleteAttorneyProfileLanguageItems($ids: [ID]!) {
  delete_attorney_profile_language_items(ids: $ids) {
    ids
  }
}
    `;
export type DeleteAttorneyProfileLanguageItemsMutationFn = Apollo.MutationFunction<DeleteAttorneyProfileLanguageItemsMutation, DeleteAttorneyProfileLanguageItemsMutationVariables>;

/**
 * __useDeleteAttorneyProfileLanguageItemsMutation__
 *
 * To run a mutation, you first call `useDeleteAttorneyProfileLanguageItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttorneyProfileLanguageItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttorneyProfileLanguageItemsMutation, { data, loading, error }] = useDeleteAttorneyProfileLanguageItemsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteAttorneyProfileLanguageItemsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttorneyProfileLanguageItemsMutation, DeleteAttorneyProfileLanguageItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttorneyProfileLanguageItemsMutation, DeleteAttorneyProfileLanguageItemsMutationVariables>(DeleteAttorneyProfileLanguageItemsDocument, options);
      }
export type DeleteAttorneyProfileLanguageItemsMutationHookResult = ReturnType<typeof useDeleteAttorneyProfileLanguageItemsMutation>;
export type DeleteAttorneyProfileLanguageItemsMutationResult = Apollo.MutationResult<DeleteAttorneyProfileLanguageItemsMutation>;
export type DeleteAttorneyProfileLanguageItemsMutationOptions = Apollo.BaseMutationOptions<DeleteAttorneyProfileLanguageItemsMutation, DeleteAttorneyProfileLanguageItemsMutationVariables>;
export const DeleteAttorneyProfileAwardItemsDocument = gql`
    mutation DeleteAttorneyProfileAwardItems($ids: [ID]!) {
  delete_attorney_profile_award_items(ids: $ids) {
    ids
  }
}
    `;
export type DeleteAttorneyProfileAwardItemsMutationFn = Apollo.MutationFunction<DeleteAttorneyProfileAwardItemsMutation, DeleteAttorneyProfileAwardItemsMutationVariables>;

/**
 * __useDeleteAttorneyProfileAwardItemsMutation__
 *
 * To run a mutation, you first call `useDeleteAttorneyProfileAwardItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttorneyProfileAwardItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttorneyProfileAwardItemsMutation, { data, loading, error }] = useDeleteAttorneyProfileAwardItemsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteAttorneyProfileAwardItemsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttorneyProfileAwardItemsMutation, DeleteAttorneyProfileAwardItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttorneyProfileAwardItemsMutation, DeleteAttorneyProfileAwardItemsMutationVariables>(DeleteAttorneyProfileAwardItemsDocument, options);
      }
export type DeleteAttorneyProfileAwardItemsMutationHookResult = ReturnType<typeof useDeleteAttorneyProfileAwardItemsMutation>;
export type DeleteAttorneyProfileAwardItemsMutationResult = Apollo.MutationResult<DeleteAttorneyProfileAwardItemsMutation>;
export type DeleteAttorneyProfileAwardItemsMutationOptions = Apollo.BaseMutationOptions<DeleteAttorneyProfileAwardItemsMutation, DeleteAttorneyProfileAwardItemsMutationVariables>;
export const DeleteAttorneyProfilePracticeAreaItemsDocument = gql`
    mutation DeleteAttorneyProfilePracticeAreaItems($ids: [ID]!) {
  delete_attorney_profile_practice_area_items(ids: $ids) {
    ids
  }
}
    `;
export type DeleteAttorneyProfilePracticeAreaItemsMutationFn = Apollo.MutationFunction<DeleteAttorneyProfilePracticeAreaItemsMutation, DeleteAttorneyProfilePracticeAreaItemsMutationVariables>;

/**
 * __useDeleteAttorneyProfilePracticeAreaItemsMutation__
 *
 * To run a mutation, you first call `useDeleteAttorneyProfilePracticeAreaItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttorneyProfilePracticeAreaItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttorneyProfilePracticeAreaItemsMutation, { data, loading, error }] = useDeleteAttorneyProfilePracticeAreaItemsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteAttorneyProfilePracticeAreaItemsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttorneyProfilePracticeAreaItemsMutation, DeleteAttorneyProfilePracticeAreaItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttorneyProfilePracticeAreaItemsMutation, DeleteAttorneyProfilePracticeAreaItemsMutationVariables>(DeleteAttorneyProfilePracticeAreaItemsDocument, options);
      }
export type DeleteAttorneyProfilePracticeAreaItemsMutationHookResult = ReturnType<typeof useDeleteAttorneyProfilePracticeAreaItemsMutation>;
export type DeleteAttorneyProfilePracticeAreaItemsMutationResult = Apollo.MutationResult<DeleteAttorneyProfilePracticeAreaItemsMutation>;
export type DeleteAttorneyProfilePracticeAreaItemsMutationOptions = Apollo.BaseMutationOptions<DeleteAttorneyProfilePracticeAreaItemsMutation, DeleteAttorneyProfilePracticeAreaItemsMutationVariables>;
export const UpdateAttorneyProfileDocument = gql`
    mutation UpdateAttorneyProfile($updateAttorneyProfileItemId: ID!, $data: update_attorney_profile_input!) {
  update_attorney_profile_item(id: $updateAttorneyProfileItemId, data: $data) {
    id
  }
}
    `;
export type UpdateAttorneyProfileMutationFn = Apollo.MutationFunction<UpdateAttorneyProfileMutation, UpdateAttorneyProfileMutationVariables>;

/**
 * __useUpdateAttorneyProfileMutation__
 *
 * To run a mutation, you first call `useUpdateAttorneyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttorneyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttorneyProfileMutation, { data, loading, error }] = useUpdateAttorneyProfileMutation({
 *   variables: {
 *      updateAttorneyProfileItemId: // value for 'updateAttorneyProfileItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAttorneyProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttorneyProfileMutation, UpdateAttorneyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttorneyProfileMutation, UpdateAttorneyProfileMutationVariables>(UpdateAttorneyProfileDocument, options);
      }
export type UpdateAttorneyProfileMutationHookResult = ReturnType<typeof useUpdateAttorneyProfileMutation>;
export type UpdateAttorneyProfileMutationResult = Apollo.MutationResult<UpdateAttorneyProfileMutation>;
export type UpdateAttorneyProfileMutationOptions = Apollo.BaseMutationOptions<UpdateAttorneyProfileMutation, UpdateAttorneyProfileMutationVariables>;
export const DeleteAttorneyProfileEducationItemsDocument = gql`
    mutation DeleteAttorneyProfileEducationItems($ids: [ID]!) {
  delete_attorney_profile_education_items(ids: $ids) {
    ids
  }
}
    `;
export type DeleteAttorneyProfileEducationItemsMutationFn = Apollo.MutationFunction<DeleteAttorneyProfileEducationItemsMutation, DeleteAttorneyProfileEducationItemsMutationVariables>;

/**
 * __useDeleteAttorneyProfileEducationItemsMutation__
 *
 * To run a mutation, you first call `useDeleteAttorneyProfileEducationItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttorneyProfileEducationItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttorneyProfileEducationItemsMutation, { data, loading, error }] = useDeleteAttorneyProfileEducationItemsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteAttorneyProfileEducationItemsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttorneyProfileEducationItemsMutation, DeleteAttorneyProfileEducationItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttorneyProfileEducationItemsMutation, DeleteAttorneyProfileEducationItemsMutationVariables>(DeleteAttorneyProfileEducationItemsDocument, options);
      }
export type DeleteAttorneyProfileEducationItemsMutationHookResult = ReturnType<typeof useDeleteAttorneyProfileEducationItemsMutation>;
export type DeleteAttorneyProfileEducationItemsMutationResult = Apollo.MutationResult<DeleteAttorneyProfileEducationItemsMutation>;
export type DeleteAttorneyProfileEducationItemsMutationOptions = Apollo.BaseMutationOptions<DeleteAttorneyProfileEducationItemsMutation, DeleteAttorneyProfileEducationItemsMutationVariables>;
export const CreateEmailNotificationLevelDocument = gql`
    mutation CreateEmailNotificationLevel($data: [create_attorney_profile_notification_level_input!]) {
  create_attorney_profile_notification_level_items(data: $data) {
    notification_level {
      id
    }
  }
}
    `;
export type CreateEmailNotificationLevelMutationFn = Apollo.MutationFunction<CreateEmailNotificationLevelMutation, CreateEmailNotificationLevelMutationVariables>;

/**
 * __useCreateEmailNotificationLevelMutation__
 *
 * To run a mutation, you first call `useCreateEmailNotificationLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailNotificationLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailNotificationLevelMutation, { data, loading, error }] = useCreateEmailNotificationLevelMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEmailNotificationLevelMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailNotificationLevelMutation, CreateEmailNotificationLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailNotificationLevelMutation, CreateEmailNotificationLevelMutationVariables>(CreateEmailNotificationLevelDocument, options);
      }
export type CreateEmailNotificationLevelMutationHookResult = ReturnType<typeof useCreateEmailNotificationLevelMutation>;
export type CreateEmailNotificationLevelMutationResult = Apollo.MutationResult<CreateEmailNotificationLevelMutation>;
export type CreateEmailNotificationLevelMutationOptions = Apollo.BaseMutationOptions<CreateEmailNotificationLevelMutation, CreateEmailNotificationLevelMutationVariables>;
export const UpdateEmailNotificationLevelDocument = gql`
    mutation UpdateEmailNotificationLevel($updateAttorneyProfileNotificationLevelItemId: ID!, $data: update_attorney_profile_notification_level_input!) {
  update_attorney_profile_notification_level_item(
    id: $updateAttorneyProfileNotificationLevelItemId
    data: $data
  ) {
    id
  }
}
    `;
export type UpdateEmailNotificationLevelMutationFn = Apollo.MutationFunction<UpdateEmailNotificationLevelMutation, UpdateEmailNotificationLevelMutationVariables>;

/**
 * __useUpdateEmailNotificationLevelMutation__
 *
 * To run a mutation, you first call `useUpdateEmailNotificationLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailNotificationLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailNotificationLevelMutation, { data, loading, error }] = useUpdateEmailNotificationLevelMutation({
 *   variables: {
 *      updateAttorneyProfileNotificationLevelItemId: // value for 'updateAttorneyProfileNotificationLevelItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateEmailNotificationLevelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailNotificationLevelMutation, UpdateEmailNotificationLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailNotificationLevelMutation, UpdateEmailNotificationLevelMutationVariables>(UpdateEmailNotificationLevelDocument, options);
      }
export type UpdateEmailNotificationLevelMutationHookResult = ReturnType<typeof useUpdateEmailNotificationLevelMutation>;
export type UpdateEmailNotificationLevelMutationResult = Apollo.MutationResult<UpdateEmailNotificationLevelMutation>;
export type UpdateEmailNotificationLevelMutationOptions = Apollo.BaseMutationOptions<UpdateEmailNotificationLevelMutation, UpdateEmailNotificationLevelMutationVariables>;
export const AttorneyDocument = gql`
    query Attorney($filter: attorney_filter, $educationSort2: [String], $licenseSort: [String], $licenseFilter: attorney_profile_license_filter) {
  attorney(filter: $filter) {
    id
    is_vetted
    membership_type {
      id
    }
    user_id {
      current_organization {
        id
        position_bio
        position_name
      }
    }
    profiles {
      bio
      first_name
      last_name
      id
      languages {
        id
        language_id {
          name
          id
        }
      }
      awards {
        id
        award_id {
          id
          name
        }
      }
      affiliations {
        affiliation_id {
          id
          name
          badge_image_url
          priority
        }
      }
      firms {
        id
        name
        city
        address
        zip
        state {
          code
          id
          name
        }
        size {
          id
          name
        }
        relationship {
          id
          name
        }
      }
      education(sort: $educationSort2) {
        id
        school_id {
          id
          name
        }
        grade {
          id
          name
        }
      }
      licenses(filter: $licenseFilter, sort: $licenseSort) {
        id
        bar_number
        has_been_disciplined_by_bar
        has_been_sued_by_malpractice
        is_license_suspended
        license_state {
          name
          code
        }
        insurances {
          id
          expiration_date
          insurance_coverage_id {
            id
          }
        }
      }
      languages {
        id
        language_id {
          id
          code
          name
        }
      }
      practice_areas {
        id
        practice_area_id {
          id
          is_default
          name
        }
      }
      awards {
        id
        award_id {
          id
          name
        }
      }
      years_practice {
        id
        name
      }
      case_management_softwares {
        id
        case_management_software_id {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useAttorneyQuery__
 *
 * To run a query within a React component, call `useAttorneyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttorneyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttorneyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      educationSort2: // value for 'educationSort2'
 *      licenseSort: // value for 'licenseSort'
 *      licenseFilter: // value for 'licenseFilter'
 *   },
 * });
 */
export function useAttorneyQuery(baseOptions?: Apollo.QueryHookOptions<AttorneyQuery, AttorneyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttorneyQuery, AttorneyQueryVariables>(AttorneyDocument, options);
      }
export function useAttorneyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttorneyQuery, AttorneyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttorneyQuery, AttorneyQueryVariables>(AttorneyDocument, options);
        }
export type AttorneyQueryHookResult = ReturnType<typeof useAttorneyQuery>;
export type AttorneyLazyQueryHookResult = ReturnType<typeof useAttorneyLazyQuery>;
export type AttorneyQueryResult = Apollo.QueryResult<AttorneyQuery, AttorneyQueryVariables>;
export function refetchAttorneyQuery(variables?: AttorneyQueryVariables) {
      return { query: AttorneyDocument, variables: variables }
    }
export const AttorneyByEmailDocument = gql`
    query AttorneyByEmail($filter: attorney_filter) {
  attorney(filter: $filter) {
    id
    is_vetted
    membership_type {
      id
    }
    user_id {
      id
    }
    profiles {
      id
    }
  }
}
    `;

/**
 * __useAttorneyByEmailQuery__
 *
 * To run a query within a React component, call `useAttorneyByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttorneyByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttorneyByEmailQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAttorneyByEmailQuery(baseOptions?: Apollo.QueryHookOptions<AttorneyByEmailQuery, AttorneyByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttorneyByEmailQuery, AttorneyByEmailQueryVariables>(AttorneyByEmailDocument, options);
      }
export function useAttorneyByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttorneyByEmailQuery, AttorneyByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttorneyByEmailQuery, AttorneyByEmailQueryVariables>(AttorneyByEmailDocument, options);
        }
export type AttorneyByEmailQueryHookResult = ReturnType<typeof useAttorneyByEmailQuery>;
export type AttorneyByEmailLazyQueryHookResult = ReturnType<typeof useAttorneyByEmailLazyQuery>;
export type AttorneyByEmailQueryResult = Apollo.QueryResult<AttorneyByEmailQuery, AttorneyByEmailQueryVariables>;
export function refetchAttorneyByEmailQuery(variables?: AttorneyByEmailQueryVariables) {
      return { query: AttorneyByEmailDocument, variables: variables }
    }
export const PracticeAreasDocument = gql`
    query PracticeAreas($sort: [String]) {
  catalog_practice_area(sort: $sort) {
    id
    name
    is_default
  }
}
    `;

/**
 * __usePracticeAreasQuery__
 *
 * To run a query within a React component, call `usePracticeAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `usePracticeAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePracticeAreasQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePracticeAreasQuery(baseOptions?: Apollo.QueryHookOptions<PracticeAreasQuery, PracticeAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PracticeAreasQuery, PracticeAreasQueryVariables>(PracticeAreasDocument, options);
      }
export function usePracticeAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PracticeAreasQuery, PracticeAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PracticeAreasQuery, PracticeAreasQueryVariables>(PracticeAreasDocument, options);
        }
export type PracticeAreasQueryHookResult = ReturnType<typeof usePracticeAreasQuery>;
export type PracticeAreasLazyQueryHookResult = ReturnType<typeof usePracticeAreasLazyQuery>;
export type PracticeAreasQueryResult = Apollo.QueryResult<PracticeAreasQuery, PracticeAreasQueryVariables>;
export function refetchPracticeAreasQuery(variables?: PracticeAreasQueryVariables) {
      return { query: PracticeAreasDocument, variables: variables }
    }
export const LawFirmCatalogsDocument = gql`
    query LawFirmCatalogs($sortCaseSoftware: [String], $sort: [String], $catalogFirmRelationshipSort2: [String], $catalogUsStateSort2: [String], $catalogYearsPracticeSort2: [String]) {
  catalog_company_size(sort: $sort) {
    id
    name
  }
  catalog_firm_relationship(sort: $catalogFirmRelationshipSort2) {
    id
    name
  }
  catalog_years_practice(sort: $catalogYearsPracticeSort2) {
    id
    name
  }
  case_management_software(sort: $sortCaseSoftware) {
    id
    name
  }
  catalog_us_state(sort: $catalogUsStateSort2) {
    id
    name
    code
  }
}
    `;

/**
 * __useLawFirmCatalogsQuery__
 *
 * To run a query within a React component, call `useLawFirmCatalogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLawFirmCatalogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLawFirmCatalogsQuery({
 *   variables: {
 *      sortCaseSoftware: // value for 'sortCaseSoftware'
 *      sort: // value for 'sort'
 *      catalogFirmRelationshipSort2: // value for 'catalogFirmRelationshipSort2'
 *      catalogUsStateSort2: // value for 'catalogUsStateSort2'
 *      catalogYearsPracticeSort2: // value for 'catalogYearsPracticeSort2'
 *   },
 * });
 */
export function useLawFirmCatalogsQuery(baseOptions?: Apollo.QueryHookOptions<LawFirmCatalogsQuery, LawFirmCatalogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LawFirmCatalogsQuery, LawFirmCatalogsQueryVariables>(LawFirmCatalogsDocument, options);
      }
export function useLawFirmCatalogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LawFirmCatalogsQuery, LawFirmCatalogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LawFirmCatalogsQuery, LawFirmCatalogsQueryVariables>(LawFirmCatalogsDocument, options);
        }
export type LawFirmCatalogsQueryHookResult = ReturnType<typeof useLawFirmCatalogsQuery>;
export type LawFirmCatalogsLazyQueryHookResult = ReturnType<typeof useLawFirmCatalogsLazyQuery>;
export type LawFirmCatalogsQueryResult = Apollo.QueryResult<LawFirmCatalogsQuery, LawFirmCatalogsQueryVariables>;
export function refetchLawFirmCatalogsQuery(variables?: LawFirmCatalogsQueryVariables) {
      return { query: LawFirmCatalogsDocument, variables: variables }
    }
export const SchoolsDocument = gql`
    query Schools($search: String, $filter: school_filter) {
  school(search: $search, filter: $filter) {
    id
    name
  }
}
    `;

/**
 * __useSchoolsQuery__
 *
 * To run a query within a React component, call `useSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSchoolsQuery(baseOptions?: Apollo.QueryHookOptions<SchoolsQuery, SchoolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolsQuery, SchoolsQueryVariables>(SchoolsDocument, options);
      }
export function useSchoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolsQuery, SchoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolsQuery, SchoolsQueryVariables>(SchoolsDocument, options);
        }
export type SchoolsQueryHookResult = ReturnType<typeof useSchoolsQuery>;
export type SchoolsLazyQueryHookResult = ReturnType<typeof useSchoolsLazyQuery>;
export type SchoolsQueryResult = Apollo.QueryResult<SchoolsQuery, SchoolsQueryVariables>;
export function refetchSchoolsQuery(variables?: SchoolsQueryVariables) {
      return { query: SchoolsDocument, variables: variables }
    }
export const AwardsDocument = gql`
    query Awards {
  catalog_award {
    id
    name
  }
}
    `;

/**
 * __useAwardsQuery__
 *
 * To run a query within a React component, call `useAwardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAwardsQuery(baseOptions?: Apollo.QueryHookOptions<AwardsQuery, AwardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwardsQuery, AwardsQueryVariables>(AwardsDocument, options);
      }
export function useAwardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwardsQuery, AwardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwardsQuery, AwardsQueryVariables>(AwardsDocument, options);
        }
export type AwardsQueryHookResult = ReturnType<typeof useAwardsQuery>;
export type AwardsLazyQueryHookResult = ReturnType<typeof useAwardsLazyQuery>;
export type AwardsQueryResult = Apollo.QueryResult<AwardsQuery, AwardsQueryVariables>;
export function refetchAwardsQuery(variables?: AwardsQueryVariables) {
      return { query: AwardsDocument, variables: variables }
    }
export const AttorneyNameAndOrgDocument = gql`
    query AttorneyNameAndOrg($filter: attorney_profile_filter, $sort: [String], $search: String, $limit: Int) {
  attorney_profile(filter: $filter, sort: $sort, search: $search, limit: $limit) {
    id
    first_name
    last_name
    attorney_id {
      id
      is_vetted
      membership_type {
        id
      }
      user_id {
        id
        avatar {
          id
        }
        current_organization {
          id
          organization_id {
            id
            profiles {
              name
            }
          }
        }
      }
    }
    affiliations {
      affiliation_id {
        id
        name
        priority
        badge_image_url
      }
    }
  }
}
    `;

/**
 * __useAttorneyNameAndOrgQuery__
 *
 * To run a query within a React component, call `useAttorneyNameAndOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttorneyNameAndOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttorneyNameAndOrgQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAttorneyNameAndOrgQuery(baseOptions?: Apollo.QueryHookOptions<AttorneyNameAndOrgQuery, AttorneyNameAndOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttorneyNameAndOrgQuery, AttorneyNameAndOrgQueryVariables>(AttorneyNameAndOrgDocument, options);
      }
export function useAttorneyNameAndOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttorneyNameAndOrgQuery, AttorneyNameAndOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttorneyNameAndOrgQuery, AttorneyNameAndOrgQueryVariables>(AttorneyNameAndOrgDocument, options);
        }
export type AttorneyNameAndOrgQueryHookResult = ReturnType<typeof useAttorneyNameAndOrgQuery>;
export type AttorneyNameAndOrgLazyQueryHookResult = ReturnType<typeof useAttorneyNameAndOrgLazyQuery>;
export type AttorneyNameAndOrgQueryResult = Apollo.QueryResult<AttorneyNameAndOrgQuery, AttorneyNameAndOrgQueryVariables>;
export function refetchAttorneyNameAndOrgQuery(variables?: AttorneyNameAndOrgQueryVariables) {
      return { query: AttorneyNameAndOrgDocument, variables: variables }
    }
export const GetVettedAttorneysInOrgDocument = gql`
    query GetVettedAttorneysInOrg($filter: attorney_filter) {
  attorney(filter: $filter) {
    id
    is_vetted
    membership_type {
      id
    }
    profiles {
      first_name
      last_name
    }
    user_id {
      id
      first_name
      last_name
      avatar {
        id
      }
      current_organization {
        organization_id {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetVettedAttorneysInOrgQuery__
 *
 * To run a query within a React component, call `useGetVettedAttorneysInOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVettedAttorneysInOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVettedAttorneysInOrgQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetVettedAttorneysInOrgQuery(baseOptions?: Apollo.QueryHookOptions<GetVettedAttorneysInOrgQuery, GetVettedAttorneysInOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVettedAttorneysInOrgQuery, GetVettedAttorneysInOrgQueryVariables>(GetVettedAttorneysInOrgDocument, options);
      }
export function useGetVettedAttorneysInOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVettedAttorneysInOrgQuery, GetVettedAttorneysInOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVettedAttorneysInOrgQuery, GetVettedAttorneysInOrgQueryVariables>(GetVettedAttorneysInOrgDocument, options);
        }
export type GetVettedAttorneysInOrgQueryHookResult = ReturnType<typeof useGetVettedAttorneysInOrgQuery>;
export type GetVettedAttorneysInOrgLazyQueryHookResult = ReturnType<typeof useGetVettedAttorneysInOrgLazyQuery>;
export type GetVettedAttorneysInOrgQueryResult = Apollo.QueryResult<GetVettedAttorneysInOrgQuery, GetVettedAttorneysInOrgQueryVariables>;
export function refetchGetVettedAttorneysInOrgQuery(variables?: GetVettedAttorneysInOrgQueryVariables) {
      return { query: GetVettedAttorneysInOrgDocument, variables: variables }
    }
export const GetCaseManagersInOrgDocument = gql`
    query GetCaseManagersInOrg($filter: attorney_filter) {
  attorney(filter: $filter) {
    id
    is_vetted
    user_id {
      id
      first_name
      last_name
      avatar {
        id
      }
    }
  }
}
    `;

/**
 * __useGetCaseManagersInOrgQuery__
 *
 * To run a query within a React component, call `useGetCaseManagersInOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseManagersInOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseManagersInOrgQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCaseManagersInOrgQuery(baseOptions?: Apollo.QueryHookOptions<GetCaseManagersInOrgQuery, GetCaseManagersInOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseManagersInOrgQuery, GetCaseManagersInOrgQueryVariables>(GetCaseManagersInOrgDocument, options);
      }
export function useGetCaseManagersInOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseManagersInOrgQuery, GetCaseManagersInOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseManagersInOrgQuery, GetCaseManagersInOrgQueryVariables>(GetCaseManagersInOrgDocument, options);
        }
export type GetCaseManagersInOrgQueryHookResult = ReturnType<typeof useGetCaseManagersInOrgQuery>;
export type GetCaseManagersInOrgLazyQueryHookResult = ReturnType<typeof useGetCaseManagersInOrgLazyQuery>;
export type GetCaseManagersInOrgQueryResult = Apollo.QueryResult<GetCaseManagersInOrgQuery, GetCaseManagersInOrgQueryVariables>;
export function refetchGetCaseManagersInOrgQuery(variables?: GetCaseManagersInOrgQueryVariables) {
      return { query: GetCaseManagersInOrgDocument, variables: variables }
    }
export const GetCommunicationPreferencesDocument = gql`
    query GetCommunicationPreferences($filter: attorney_profile_filter) {
  attorney_profile(filter: $filter) {
    id
    communication_preference {
      is_sms_enabled
      is_notification_enabled
      is_email_enabled
      id
      notification_level {
        name
        id
      }
    }
    attorney_id {
      user_id {
        role {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetCommunicationPreferencesQuery__
 *
 * To run a query within a React component, call `useGetCommunicationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunicationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunicationPreferencesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCommunicationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetCommunicationPreferencesQuery, GetCommunicationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunicationPreferencesQuery, GetCommunicationPreferencesQueryVariables>(GetCommunicationPreferencesDocument, options);
      }
export function useGetCommunicationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunicationPreferencesQuery, GetCommunicationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunicationPreferencesQuery, GetCommunicationPreferencesQueryVariables>(GetCommunicationPreferencesDocument, options);
        }
export type GetCommunicationPreferencesQueryHookResult = ReturnType<typeof useGetCommunicationPreferencesQuery>;
export type GetCommunicationPreferencesLazyQueryHookResult = ReturnType<typeof useGetCommunicationPreferencesLazyQuery>;
export type GetCommunicationPreferencesQueryResult = Apollo.QueryResult<GetCommunicationPreferencesQuery, GetCommunicationPreferencesQueryVariables>;
export function refetchGetCommunicationPreferencesQuery(variables?: GetCommunicationPreferencesQueryVariables) {
      return { query: GetCommunicationPreferencesDocument, variables: variables }
    }
export const GetEmailNotificationLevelDocument = gql`
    query GetEmailNotificationLevel($filter: attorney_profile_filter) {
  attorney_profile(filter: $filter) {
    id
    notification_levels {
      id
      notification_level {
        id
        name
        sort_order
      }
    }
  }
}
    `;

/**
 * __useGetEmailNotificationLevelQuery__
 *
 * To run a query within a React component, call `useGetEmailNotificationLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailNotificationLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailNotificationLevelQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEmailNotificationLevelQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailNotificationLevelQuery, GetEmailNotificationLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailNotificationLevelQuery, GetEmailNotificationLevelQueryVariables>(GetEmailNotificationLevelDocument, options);
      }
export function useGetEmailNotificationLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailNotificationLevelQuery, GetEmailNotificationLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailNotificationLevelQuery, GetEmailNotificationLevelQueryVariables>(GetEmailNotificationLevelDocument, options);
        }
export type GetEmailNotificationLevelQueryHookResult = ReturnType<typeof useGetEmailNotificationLevelQuery>;
export type GetEmailNotificationLevelLazyQueryHookResult = ReturnType<typeof useGetEmailNotificationLevelLazyQuery>;
export type GetEmailNotificationLevelQueryResult = Apollo.QueryResult<GetEmailNotificationLevelQuery, GetEmailNotificationLevelQueryVariables>;
export function refetchGetEmailNotificationLevelQuery(variables?: GetEmailNotificationLevelQueryVariables) {
      return { query: GetEmailNotificationLevelDocument, variables: variables }
    }
export const Attorney_StripeDocument = gql`
    query Attorney_stripe($filter: attorney_stripe_filter) {
  attorney_stripe(filter: $filter) {
    stripe_customer_id
  }
}
    `;

/**
 * __useAttorney_StripeQuery__
 *
 * To run a query within a React component, call `useAttorney_StripeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttorney_StripeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttorney_StripeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAttorney_StripeQuery(baseOptions?: Apollo.QueryHookOptions<Attorney_StripeQuery, Attorney_StripeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Attorney_StripeQuery, Attorney_StripeQueryVariables>(Attorney_StripeDocument, options);
      }
export function useAttorney_StripeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Attorney_StripeQuery, Attorney_StripeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Attorney_StripeQuery, Attorney_StripeQueryVariables>(Attorney_StripeDocument, options);
        }
export type Attorney_StripeQueryHookResult = ReturnType<typeof useAttorney_StripeQuery>;
export type Attorney_StripeLazyQueryHookResult = ReturnType<typeof useAttorney_StripeLazyQuery>;
export type Attorney_StripeQueryResult = Apollo.QueryResult<Attorney_StripeQuery, Attorney_StripeQueryVariables>;
export function refetchAttorney_StripeQuery(variables?: Attorney_StripeQueryVariables) {
      return { query: Attorney_StripeDocument, variables: variables }
    }
export const CheckValidationAndInvitationDocument = gql`
    query CheckValidationAndInvitation($filter: user_email_validation_filter, $attorneyInviteFilter: attorney_invite_filter) {
  user_email_validation(filter: $filter) {
    validation_ts
    email
  }
  attorney_invite(filter: $attorneyInviteFilter) {
    email
  }
}
    `;

/**
 * __useCheckValidationAndInvitationQuery__
 *
 * To run a query within a React component, call `useCheckValidationAndInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckValidationAndInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckValidationAndInvitationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      attorneyInviteFilter: // value for 'attorneyInviteFilter'
 *   },
 * });
 */
export function useCheckValidationAndInvitationQuery(baseOptions?: Apollo.QueryHookOptions<CheckValidationAndInvitationQuery, CheckValidationAndInvitationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckValidationAndInvitationQuery, CheckValidationAndInvitationQueryVariables>(CheckValidationAndInvitationDocument, options);
      }
export function useCheckValidationAndInvitationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckValidationAndInvitationQuery, CheckValidationAndInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckValidationAndInvitationQuery, CheckValidationAndInvitationQueryVariables>(CheckValidationAndInvitationDocument, options);
        }
export type CheckValidationAndInvitationQueryHookResult = ReturnType<typeof useCheckValidationAndInvitationQuery>;
export type CheckValidationAndInvitationLazyQueryHookResult = ReturnType<typeof useCheckValidationAndInvitationLazyQuery>;
export type CheckValidationAndInvitationQueryResult = Apollo.QueryResult<CheckValidationAndInvitationQuery, CheckValidationAndInvitationQueryVariables>;
export function refetchCheckValidationAndInvitationQuery(variables?: CheckValidationAndInvitationQueryVariables) {
      return { query: CheckValidationAndInvitationDocument, variables: variables }
    }
export type CreateNewCaseMutationVariables = Exact<{
  data: Create_Case_Input;
}>;


export type CreateNewCaseMutation = { __typename?: 'Mutation', create_case_item?: { __typename?: 'case', id: string } | null };

export type CreateWaterfallItemMutationVariables = Exact<{
  data: Create_Attorney_Waterfall_Input;
}>;


export type CreateWaterfallItemMutation = { __typename?: 'Mutation', create_attorney_waterfall_item?: { __typename?: 'attorney_waterfall', id: string } | null };

export type CreateCaseCatalogsQueryVariables = Exact<{
  filter?: InputMaybe<Catalog_Us_State_Filter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateCaseCatalogsQuery = { __typename?: 'Query', catalog_financing_source: Array<{ __typename?: 'catalog_financing_source', id: string, name?: string | null }>, catalog_process_stage: Array<{ __typename?: 'catalog_process_stage', id: string, name?: string | null }>, catalog_us_state: Array<{ __typename?: 'catalog_us_state', id: string, name?: string | null, code?: string | null }>, catalog_language: Array<{ __typename?: 'catalog_language', id: string, name?: string | null }>, catalog_practice_area: Array<{ __typename?: 'catalog_practice_area', id: string, name?: string | null }> };

export type TimeUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type TimeUnitsQuery = { __typename?: 'Query', catalog_time_unit: Array<{ __typename?: 'catalog_time_unit', id: string, name?: string | null }> };

export type CaseFeeOverridesQueryVariables = Exact<{
  filter?: InputMaybe<Case_Fee_Overrides_Filter>;
}>;


export type CaseFeeOverridesQuery = { __typename?: 'Query', case_fee_overrides: Array<{ __typename?: 'case_fee_overrides', auto_charge_date?: any | null, auto_charge_days?: number | null, expiration_date?: any | null, expiration_days?: number | null, id: string, created_ts?: any | null, match_fee?: number | null }> };

export type CreateCaseActivityPurchaseMutationVariables = Exact<{
  data: Create_Case_Purchase_Activity_Input;
}>;


export type CreateCaseActivityPurchaseMutation = { __typename?: 'Mutation', create_case_purchase_activity_item?: { __typename?: 'case_purchase_activity', id: string, fee: number } | null };

export type GetActivityPurchaseQueryVariables = Exact<{
  filter?: InputMaybe<Case_Purchase_Activity_Filter>;
}>;


export type GetActivityPurchaseQuery = { __typename?: 'Query', case_purchase_activity: Array<{ __typename?: 'case_purchase_activity', id: string, fee: number, created_ts?: any | null, message?: string | null, created_by?: { __typename?: 'attorney', is_vetted?: boolean | null, profiles?: Array<{ __typename?: 'attorney_profile', id: string, first_name?: string | null, last_name?: string | null, firms?: Array<{ __typename?: 'attorney_profile_firm', name: string } | null> | null, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string, email?: string | null, avatar?: { __typename?: 'directus_files', id: string } | null } | null } | null } | null> | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null } | null, case_purchase_id?: { __typename?: 'case_purchase', id: string, active_ts?: any | null, fee_agreement_status?: { __typename?: 'catalog_fee_agreement_status', id: string, name: string } | null, created_by?: { __typename?: 'attorney', profiles?: Array<{ __typename?: 'attorney_profile', id: string, first_name?: string | null, last_name?: string | null, firms?: Array<{ __typename?: 'attorney_profile_firm', name: string } | null> | null, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string, email?: string | null, avatar?: { __typename?: 'directus_files', id: string } | null } | null } | null } | null> | null } | null, case_id?: { __typename?: 'case', id: string, fee?: number | null, name?: string | null, proposal_due_date?: any | null, case_alias?: string | null, incident_date?: any | null, description?: string | null, description_formatted?: string | null, following_count?: number | null, status?: string | null, created_ts?: any | null, case_number?: string | null, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, profiles?: Array<{ __typename?: 'attorney_profile', id: string, first_name?: string | null, last_name?: string | null, firms?: Array<{ __typename?: 'attorney_profile_firm', name: string } | null> | null, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string, email?: string | null, avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', organization_id?: { __typename?: 'organization', profiles?: Array<{ __typename?: 'organization_profile', name?: string | null } | null> | null } | null } | null> | null } | null } | null } | null> | null } | null, mp_visibility?: { __typename?: 'catalog_case_mp_visibility', id: string, name?: string | null } | null, preferred_language?: { __typename?: 'catalog_language', name?: string | null } | null, process_stage?: { __typename?: 'catalog_process_stage', name?: string | null } | null, type?: { __typename?: 'catalog_practice_area', id: string, name?: string | null } | null, financing_source?: { __typename?: 'catalog_financing_source', id: string, name?: string | null } | null, jurisdiction?: { __typename?: 'catalog_us_state', name?: string | null, code?: string | null } | null, files?: Array<{ __typename?: 'case_file', file_id?: { __typename?: 'directus_files', id: string, filename_download: string, metadata?: any | null } | null } | null> | null, leads?: Array<{ __typename?: 'case_lead', id: string, first_name?: string | null, last_name?: string | null, contacts?: Array<{ __typename?: 'case_lead_contact', value: string, type?: { __typename?: 'catalog_contact_type', id: string, name?: string | null } | null } | null> | null } | null> | null, ownerships?: Array<{ __typename?: 'case_ownership', id: string, user_id?: { __typename?: 'directus_users', id: string, first_name?: string | null, last_name?: string | null, role?: { __typename?: 'directus_roles', id: string } | null, avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', id: string, organization_id?: { __typename?: 'organization', id: string } | null } | null> | null } | null } | null> | null } | null, prospect_attorney_id?: { __typename?: 'attorney', profiles?: Array<{ __typename?: 'attorney_profile', id: string, first_name?: string | null, last_name?: string | null, contacts?: Array<{ __typename?: 'attorney_profile_contact', value: string, type?: { __typename?: 'catalog_contact_type', id: string, name?: string | null } | null } | null> | null, firms?: Array<{ __typename?: 'attorney_profile_firm', name: string } | null> | null, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string, email?: string | null, avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', organization_id?: { __typename?: 'organization', profiles?: Array<{ __typename?: 'organization_profile', name?: string | null } | null> | null } | null } | null> | null } | null } | null } | null> | null } | null, waterfall_id?: { __typename?: 'attorney_waterfall', id: string, current_item_order?: number | null, item_count?: number | null, status?: { __typename?: 'catalog_waterfall_status', name?: string | null } | null, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string, email?: string | null, avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', organization_id?: { __typename?: 'organization', profiles?: Array<{ __typename?: 'organization_profile', name?: string | null } | null> | null } | null } | null> | null } | null, profiles?: Array<{ __typename?: 'attorney_profile', id: string, first_name?: string | null, last_name?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'case_purchase', timed_access_limit?: number | null, time_unit?: { __typename?: 'catalog_time_unit', id: string } | null } | null> | null } | null, status?: { __typename?: 'catalog_case_purchase_status', id: string, name?: string | null } | null, payments?: Array<{ __typename?: 'case_purchase_payment', id: string, amount: number, payment_method?: string | null, attorney_id?: { __typename?: 'attorney', id: string } | null, payment_status_id?: { __typename?: 'catalog_payment_status', name?: string | null, id: string } | null } | null> | null, sign_request?: Array<{ __typename?: 'case_purchase_sign_request', url_request?: string | null, sign_request_status_id?: { __typename?: 'catalog_sign_request_status', id: string, name?: string | null } | null } | null> | null, ownerships?: Array<{ __typename?: 'case_purchase_ownership', id: string, user_id?: { __typename?: 'directus_users', id: string, first_name?: string | null, last_name?: string | null, role?: { __typename?: 'directus_roles', id: string } | null, avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', id: string, organization_id?: { __typename?: 'organization', id: string } | null } | null> | null } | null } | null> | null } | null, activity_entry_status?: { __typename?: 'catalog_case_purchase_status', id: string, name?: string | null } | null }> };

export type GetCasesWatchingQueryVariables = Exact<{
  preferenceFilter?: InputMaybe<Attorney_Case_Mp_Preference_Filter>;
  casePurchaseFilter?: InputMaybe<Case_Purchase_Filter>;
}>;


export type GetCasesWatchingQuery = { __typename?: 'Query', attorney_case_mp_preference: Array<{ __typename?: 'attorney_case_mp_preference', id: string, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string, email?: string | null, avatar?: { __typename?: 'directus_files', id: string } | null } | null, profiles?: Array<{ __typename?: 'attorney_profile', id: string, first_name?: string | null, last_name?: string | null, firms?: Array<{ __typename?: 'attorney_profile_firm', name: string } | null> | null } | null> | null } | null, case_id?: { __typename?: 'case', id: string, name?: string | null, fee?: number | null, incident_date?: any | null, proposal_due_date?: any | null, following_count?: number | null } | null, case_mp_preference_id?: { __typename?: 'catalog_case_mp_preference', id: string, name?: string | null } | null }>, case_purchase: Array<{ __typename?: 'case_purchase', case_id?: { __typename?: 'case', id: string } | null }> };

export type GetCasesFollowingQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Case_Mp_Preference_Filter>;
}>;


export type GetCasesFollowingQuery = { __typename?: 'Query', attorney_case_mp_preference: Array<{ __typename?: 'attorney_case_mp_preference', id: string, case_id?: { __typename?: 'case', id: string } | null }> };

export type UpdateOrganizationAndProfileMutationVariables = Exact<{
  updateOrganizationProfileItemId: Scalars['ID']['input'];
  organizationProfileData: Update_Organization_Profile_Input;
  updateProfileData: Update_Attorney_Profile_Input;
  updateAttorneyProfileItemId: Scalars['ID']['input'];
}>;


export type UpdateOrganizationAndProfileMutation = { __typename?: 'Mutation', update_organization_profile_item?: { __typename?: 'organization_profile', id: string } | null, update_attorney_profile_item?: { __typename?: 'attorney_profile', id: string } | null };

export type UpdateOrganizationUserMutationVariables = Exact<{
  updateOrganizationUserItemId: Scalars['ID']['input'];
  data: Update_Organization_User_Input;
}>;


export type UpdateOrganizationUserMutation = { __typename?: 'Mutation', update_organization_user_item?: { __typename?: 'organization_user', id: string } | null };

export type UpdateOrganizationFirmMutationVariables = Exact<{
  updateOrganizationProfileItemId: Scalars['ID']['input'];
  data: Update_Organization_Profile_Input;
}>;


export type UpdateOrganizationFirmMutation = { __typename?: 'Mutation', update_organization_profile_item?: { __typename?: 'organization_profile', id: string } | null };

export type UpdateOrganizationItemMutationVariables = Exact<{
  updateOrganizationProfileItemId: Scalars['ID']['input'];
  data: Update_Organization_Profile_Input;
}>;


export type UpdateOrganizationItemMutation = { __typename?: 'Mutation', update_organization_profile_item?: { __typename?: 'organization_profile', id: string } | null };

export type CreatePracticeAttorneyMappingItemsMutationVariables = Exact<{
  data?: InputMaybe<Array<Create_Practice_Attorney_Mapping_Input> | Create_Practice_Attorney_Mapping_Input>;
}>;


export type CreatePracticeAttorneyMappingItemsMutation = { __typename?: 'Mutation', create_practice_attorney_mapping_items: Array<{ __typename?: 'practice_attorney_mapping', id: string }> };

export type DeletePracticeAttorneyMappingItemsMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type DeletePracticeAttorneyMappingItemsMutation = { __typename?: 'Mutation', delete_practice_attorney_mapping_items?: { __typename?: 'delete_many', ids: Array<string | null> } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  updateOrganizationItemId: Scalars['ID']['input'];
  data: Update_Organization_Input;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', update_organization_item?: { __typename?: 'organization', id: string } | null };

export type CreateOrganizationBlocksMutationVariables = Exact<{
  data?: InputMaybe<Array<Create_Organization_Block_Input> | Create_Organization_Block_Input>;
}>;


export type CreateOrganizationBlocksMutation = { __typename?: 'Mutation', create_organization_block_items: Array<{ __typename?: 'organization_block', id: string }> };

export type DeleteOrganizationBlockMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOrganizationBlockMutation = { __typename?: 'Mutation', delete_organization_block_item?: { __typename?: 'delete_one', id: string } | null };

export type CreateOrganizationReferralSettingsMutationVariables = Exact<{
  data: Create_Organization_Referral_Settings_Input;
}>;


export type CreateOrganizationReferralSettingsMutation = { __typename?: 'Mutation', create_organization_referral_settings_item?: { __typename?: 'organization_referral_settings', id: string } | null };

export type UpdateOrganizationReferralSettingsMutationVariables = Exact<{
  updateOrganizationReferralSettingsItemId: Scalars['ID']['input'];
  data: Update_Organization_Referral_Settings_Input;
}>;


export type UpdateOrganizationReferralSettingsMutation = { __typename?: 'Mutation', update_organization_referral_settings_item?: { __typename?: 'organization_referral_settings', id: string } | null };

export type GetOrganizationProfileQueryVariables = Exact<{
  filter?: InputMaybe<Organization_Profile_Filter>;
}>;


export type GetOrganizationProfileQuery = { __typename?: 'Query', organization_profile: Array<{ __typename?: 'organization_profile', id: string, name?: string | null, description?: string | null, address?: string | null, state?: string | null, city?: string | null, zipcode?: string | null, company_size?: string | null, case_management_software?: string | null, website_url?: string | null }> };

export type GetOrgAttorneysAndLicenseJurisdictionsQueryVariables = Exact<{
  organizationFilter?: InputMaybe<Organization_Filter>;
  userFilter?: InputMaybe<Organization_User_Filter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetOrgAttorneysAndLicenseJurisdictionsQuery = { __typename?: 'Query', organization: Array<{ __typename?: 'organization', practice_attorney_mapping?: Array<{ __typename?: 'practice_attorney_mapping', id: string, attorney_id?: { __typename?: 'attorney', id: string } | null, organization_id?: { __typename?: 'organization', id: string } | null, practice_area_id?: { __typename?: 'catalog_practice_area', id: string } | null, jurisdiction_id?: { __typename?: 'catalog_us_state', id: string } | null } | null> | null, users?: Array<{ __typename?: 'organization_user', user_id?: { __typename?: 'directus_users', attorneys?: Array<{ __typename?: 'attorney', profiles?: Array<{ __typename?: 'attorney_profile', id: string, first_name?: string | null, last_name?: string | null, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string, avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', id: string, organization_id?: { __typename?: 'organization', id: string, profiles?: Array<{ __typename?: 'organization_profile', name?: string | null } | null> | null } | null } | null> | null } | null } | null, licenses?: Array<{ __typename?: 'attorney_profile_license', license_state?: { __typename?: 'catalog_us_state', id: string, code?: string | null, name?: string | null } | null, status?: { __typename?: 'catalog_license_status', name?: string | null, id: string } | null } | null> | null } | null> | null } | null> | null } | null } | null> | null }> };

export type GetOrganizationLcmsWaterfallsInfoQueryVariables = Exact<{
  filter?: InputMaybe<Organization_Filter>;
}>;


export type GetOrganizationLcmsWaterfallsInfoQuery = { __typename?: 'Query', organization: Array<{ __typename?: 'organization', lcms_waterfall_mapping_enabled?: boolean | null, lcms_waterfall_default_duration?: { __typename?: 'catalog_waterfall_duration', id: string } | null }> };

export type GetOrganizationBlocksQueryVariables = Exact<{
  filter?: InputMaybe<Organization_Block_Filter>;
}>;


export type GetOrganizationBlocksQuery = { __typename?: 'Query', organization_block: Array<{ __typename?: 'organization_block', id: string, created_ts?: any | null, blocked_org_id?: { __typename?: 'organization', id: string, profiles?: Array<{ __typename?: 'organization_profile', name?: string | null } | null> | null } | null, blocking_org_id?: { __typename?: 'organization', id: string } | null }> };

export type GetOrganizationReferralSettingsQueryVariables = Exact<{
  filter?: InputMaybe<Organization_Referral_Settings_Filter>;
}>;


export type GetOrganizationReferralSettingsQuery = { __typename?: 'Query', organization_referral_settings: Array<{ __typename?: 'organization_referral_settings', id: string, default_referral_fee?: number | null, referral_text?: string | null, organization_id?: { __typename?: 'organization', id: string } | null }> };

export type OrgMetricsFieldsFragment = { __typename?: 'sum_analytics_org_metrics', organization_id: string, posted_cases_count?: number | null, matched_cases_count?: number | null, matched_cases_percentage?: number | null, signed_cases_count?: number | null, signed_cases_percentage?: number | null, avg_referring_fees?: number | null, proposals_sent_count?: number | null, invites_received_count?: number | null, matches_as_referee_count?: number | null, matches_as_referee_percentage?: number | null, signed_as_referee_count?: number | null, signed_as_referee_percentage?: number | null };

export type TopBuyerAttorneysFieldsFragment = { __typename?: 'sum_analytics_org_top_attorneys_buyer', attorney_id?: string | null, attorney_name?: string | null, matched_cases_count?: number | null, signed_cases_count?: number | null, signed_cases_percentage?: number | null, organization_name?: string | null, referring_organization_name?: string | null, referring_organization_id?: string | null, organization_id?: string | null, avg_referring_fees?: number | null };

export type TopSellerAttorneysFieldsFragment = { __typename?: 'sum_analytics_org_top_attorneys_seller', attorney_id?: string | null, attorney_name?: string | null, matched_cases_count?: number | null, signed_cases_count?: number | null, signed_cases_percentage?: number | null, organization_name?: string | null, referee_organization_id?: string | null, referee_organization_name?: string | null, organization_id?: string | null, avg_referring_fees?: number | null };

export type PracticeAreaPerformanceFieldsFragment = { __typename?: 'sum_analytics_org_practice_areas_seller', metric_id: string, practice_area?: string | null, total_cases_count?: number | null, matched_cases_count?: number | null, matched_cases_percentage?: number | null, signed_cases_count?: number | null, signed_cases_percentage?: number | null, signed_matched_ratio?: number | null, avg_referring_fees?: number | null };

export type PracticeAreaBuyerPerformanceFieldsFragment = { __typename?: 'sum_analytics_org_practice_areas_buyer', metric_id: string, practice_area?: string | null, total_cases_count?: number | null, matched_cases_count?: number | null, matched_cases_percentage?: number | null, signed_cases_count?: number | null, signed_cases_percentage?: number | null, signed_matched_ratio?: number | null, avg_referring_fees?: number | null };

export type AttorneyMetricsFieldsFragment = { __typename?: 'sum_analytics_attorney_metrics', attorney_id: string, posted_cases_count?: number | null, matched_cases_count?: number | null, matched_cases_percentage?: number | null, signed_cases_count?: number | null, signed_cases_percentage?: number | null, avg_referring_fees?: number | null, proposals_sent_count?: number | null, invites_received_count?: number | null, matches_as_referee_count?: number | null, matches_as_referee_percentage?: number | null, signed_as_referee_count?: number | null, signed_as_referee_percentage?: number | null };

export type OrgMembersFieldsFragment = { __typename?: 'organization_user', id: string, user_id?: { __typename?: 'directus_users', id: string, last_name?: string | null, first_name?: string | null, avatar?: { __typename?: 'directus_files', id: string, filename_disk?: string | null } | null, attorneys?: Array<{ __typename?: 'attorney', id: string } | null> | null } | null };

export type GetAnalyticsQueryVariables = Exact<{
  attorneyMetricsFilter?: InputMaybe<Sum_Analytics_Attorney_Metrics_Filter>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAnalyticsQuery = { __typename?: 'Query', sum_analytics_org_metrics: Array<{ __typename?: 'sum_analytics_org_metrics', organization_id: string, posted_cases_count?: number | null, matched_cases_count?: number | null, matched_cases_percentage?: number | null, signed_cases_count?: number | null, signed_cases_percentage?: number | null, avg_referring_fees?: number | null, proposals_sent_count?: number | null, invites_received_count?: number | null, matches_as_referee_count?: number | null, matches_as_referee_percentage?: number | null, signed_as_referee_count?: number | null, signed_as_referee_percentage?: number | null }>, sum_analytics_org_top_attorneys_buyer: Array<{ __typename?: 'sum_analytics_org_top_attorneys_buyer', attorney_id?: string | null, attorney_name?: string | null, matched_cases_count?: number | null, signed_cases_count?: number | null, signed_cases_percentage?: number | null, organization_name?: string | null, referring_organization_name?: string | null, referring_organization_id?: string | null, organization_id?: string | null, avg_referring_fees?: number | null }>, sum_analytics_org_top_attorneys_seller: Array<{ __typename?: 'sum_analytics_org_top_attorneys_seller', attorney_id?: string | null, attorney_name?: string | null, matched_cases_count?: number | null, signed_cases_count?: number | null, signed_cases_percentage?: number | null, organization_name?: string | null, referee_organization_id?: string | null, referee_organization_name?: string | null, organization_id?: string | null, avg_referring_fees?: number | null }>, sum_analytics_org_practice_areas_seller: Array<{ __typename?: 'sum_analytics_org_practice_areas_seller', metric_id: string, practice_area?: string | null, total_cases_count?: number | null, matched_cases_count?: number | null, matched_cases_percentage?: number | null, signed_cases_count?: number | null, signed_cases_percentage?: number | null, signed_matched_ratio?: number | null, avg_referring_fees?: number | null }>, sum_analytics_org_practice_areas_buyer: Array<{ __typename?: 'sum_analytics_org_practice_areas_buyer', metric_id: string, practice_area?: string | null, total_cases_count?: number | null, matched_cases_count?: number | null, matched_cases_percentage?: number | null, signed_cases_count?: number | null, signed_cases_percentage?: number | null, signed_matched_ratio?: number | null, avg_referring_fees?: number | null }>, sum_analytics_attorney_metrics: Array<{ __typename?: 'sum_analytics_attorney_metrics', attorney_id: string, posted_cases_count?: number | null, matched_cases_count?: number | null, matched_cases_percentage?: number | null, signed_cases_count?: number | null, signed_cases_percentage?: number | null, avg_referring_fees?: number | null, proposals_sent_count?: number | null, invites_received_count?: number | null, matches_as_referee_count?: number | null, matches_as_referee_percentage?: number | null, signed_as_referee_count?: number | null, signed_as_referee_percentage?: number | null }>, organization: Array<{ __typename?: 'organization', users?: Array<{ __typename?: 'organization_user', id: string, user_id?: { __typename?: 'directus_users', id: string, last_name?: string | null, first_name?: string | null, avatar?: { __typename?: 'directus_files', id: string, filename_disk?: string | null } | null, attorneys?: Array<{ __typename?: 'attorney', id: string } | null> | null } | null } | null> | null }>, sum_analytics_freshness: Array<{ __typename?: 'sum_analytics_freshness', last_successful_run?: any | null, next_scheduled_run?: any | null }> };

export type GetAttorneyPerformanceQueryVariables = Exact<{
  attorneyId: Scalars['String']['input'];
}>;


export type GetAttorneyPerformanceQuery = { __typename?: 'Query', sum_analytics_attorney_metrics: Array<{ __typename?: 'sum_analytics_attorney_metrics', attorney_id: string, posted_cases_count?: number | null, matched_cases_count?: number | null, matched_cases_percentage?: number | null, signed_cases_count?: number | null, signed_cases_percentage?: number | null, avg_referring_fees?: number | null, proposals_sent_count?: number | null, invites_received_count?: number | null, matches_as_referee_count?: number | null, matches_as_referee_percentage?: number | null, signed_as_referee_count?: number | null, signed_as_referee_percentage?: number | null }> };

export type GetMasterCasesQueryVariables = Exact<{
  filter?: InputMaybe<Master_Case_Filter>;
}>;


export type GetMasterCasesQuery = { __typename?: 'Query', master_case: Array<{ __typename?: 'master_case', case_id: string, name?: string | null, desired_fee_perc?: number | null, created_ts?: any | null, status?: string | null, status_ts?: any | null, attorney_name?: string | null, attorney_id?: string | null }> };

export type GetMasterReferralCasesQueryVariables = Exact<{
  filter?: InputMaybe<Master_Referral_Filter>;
}>;


export type GetMasterReferralCasesQuery = { __typename?: 'Query', master_referral: Array<{ __typename?: 'master_referral', case_created_ts?: any | null, case_id?: string | null, case_name?: string | null, case_status?: string | null, case_type?: string | null, created_ts?: any | null, fee_percentage?: number | null, jurisdiction?: string | null, match_date?: any | null, match_fee_expected_amount?: number | null, match_fee_expected_collection_date?: any | null, match_fee_payment_status?: string | null, matched_date_ts?: any | null, practice_area?: string | null, prospect_attorney_id?: string | null, prospect_attorney_name?: string | null, prospect_organization_name?: string | null, referring_attorney_name?: string | null, referring_organization_name?: string | null, signed_date_ts?: any | null, prospect_organization_id?: string | null, referring_organization_id?: string | null }> };

export type GetAttorneyStatsQueryVariables = Exact<{
  attorneyId: Scalars['ID']['input'];
}>;


export type GetAttorneyStatsQuery = { __typename?: 'Query', sum_ratings_attorney_buyer_by_id?: { __typename?: 'sum_ratings_attorney_buyer', responsiveness_label?: string | null, percent_case_status_updates_completed?: string | null, num_case_status_updates_requested?: number | null, num_case_status_updates_completed?: number | null, num_matches?: number | null, num_signed?: number | null, percent_signed?: string | null } | null, sum_ratings_attorney_seller_by_id?: { __typename?: 'sum_ratings_attorney_seller', responsiveness_label?: string | null, num_referrals?: number | null, num_matches?: number | null, num_signed?: number | null, percent_signed?: string | null, percent_matched?: string | null } | null, attorney_by_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, profiles?: Array<{ __typename?: 'attorney_profile', first_name?: string | null, last_name?: string | null, bio?: string | null, practice_areas?: Array<{ __typename?: 'attorney_profile_practice_area', practice_area_id?: { __typename?: 'catalog_practice_area', id: string, name?: string | null } | null } | null> | null, licenses?: Array<{ __typename?: 'attorney_profile_license', license_state?: { __typename?: 'catalog_us_state', name?: string | null, code?: string | null } | null } | null> | null, affiliations?: Array<{ __typename?: 'attorney_profile_affiliation', affiliation_id?: { __typename?: 'catalog_affiliation', badge_image_url?: string | null, id: string, name: string, priority?: number | null } | null } | null> | null, education?: Array<{ __typename?: 'attorney_profile_education', grade?: { __typename?: 'catalog_education_grade', id: string, name?: string | null } | null, school_id?: { __typename?: 'school', id: string, name?: string | null } | null } | null> | null, languages?: Array<{ __typename?: 'attorney_profile_language', language_id?: { __typename?: 'catalog_language', id: string, name?: string | null } | null } | null> | null } | null> | null, user_id?: { __typename?: 'directus_users', current_organization?: Array<{ __typename?: 'organization_user', organization_id?: { __typename?: 'organization', id: string, profiles?: Array<{ __typename?: 'organization_profile', name?: string | null } | null> | null } | null } | null> | null, avatar?: { __typename?: 'directus_files', id: string } | null } | null } | null };

export type GetAttorneyStatsProfilePageQueryVariables = Exact<{
  attorneyId: Scalars['ID']['input'];
  filter?: InputMaybe<Attorney_Profile_Filter>;
  licenseFilter?: InputMaybe<Attorney_Profile_License_Filter>;
}>;


export type GetAttorneyStatsProfilePageQuery = { __typename?: 'Query', sum_ratings_attorney_buyer_by_id?: { __typename?: 'sum_ratings_attorney_buyer', responsiveness_label?: string | null, percent_case_status_updates_completed?: string | null, num_case_status_updates_requested?: number | null, num_case_status_updates_completed?: number | null, num_matches?: number | null, num_signed?: number | null, percent_signed?: string | null } | null, sum_ratings_attorney_seller_by_id?: { __typename?: 'sum_ratings_attorney_seller', responsiveness_label?: string | null, num_referrals?: number | null, num_matches?: number | null, num_signed?: number | null, percent_signed?: string | null, percent_matched?: string | null } | null, attorney_profile: Array<{ __typename?: 'attorney_profile', id: string, first_name?: string | null, last_name?: string | null, bio?: string | null, years_practice?: { __typename?: 'catalog_years_practice', name?: string | null } | null, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string, email?: string | null, last_access?: any | null, avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', id: string, position_name?: string | null, organization_id?: { __typename?: 'organization', id: string, profiles?: Array<{ __typename?: 'organization_profile', name?: string | null } | null> | null } | null } | null> | null } | null } | null, affiliations?: Array<{ __typename?: 'attorney_profile_affiliation', affiliation_id?: { __typename?: 'catalog_affiliation', id: string, name: string, badge_image_url?: string | null, priority?: number | null } | null } | null> | null, awards?: Array<{ __typename?: 'attorney_profile_award', award_id?: { __typename?: 'catalog_award', id: string, name?: string | null } | null } | null> | null, firms?: Array<{ __typename?: 'attorney_profile_firm', name: string, address: string, city?: string | null, zip?: number | null, state?: { __typename?: 'catalog_us_state', name?: string | null, code?: string | null } | null, size?: { __typename?: 'catalog_company_size', name?: string | null } | null, relationship?: { __typename?: 'catalog_firm_relationship', name?: string | null } | null } | null> | null, contacts?: Array<{ __typename?: 'attorney_profile_contact', value: string, type?: { __typename?: 'catalog_contact_type', name?: string | null } | null } | null> | null, education?: Array<{ __typename?: 'attorney_profile_education', grade?: { __typename?: 'catalog_education_grade', id: string, name?: string | null } | null, school_id?: { __typename?: 'school', id: string, name?: string | null } | null } | null> | null, licenses?: Array<{ __typename?: 'attorney_profile_license', bar_number: string, has_been_disciplined_by_bar: boolean, has_been_sued_by_malpractice: boolean, is_license_suspended: boolean, license_state?: { __typename?: 'catalog_us_state', name?: string | null, code?: string | null } | null, insurances?: Array<{ __typename?: 'attorney_profile_license_insurance', expiration_date?: any | null, insurance_coverage_id?: { __typename?: 'catalog_malpractice_insurance', id: string } | null } | null> | null } | null> | null, case_management_softwares?: Array<{ __typename?: 'attorney_profile_case_management_software', case_management_software_id?: { __typename?: 'case_management_software', name?: string | null } | null } | null> | null, languages?: Array<{ __typename?: 'attorney_profile_language', language_id?: { __typename?: 'catalog_language', id: string, name?: string | null } | null } | null> | null, practice_areas?: Array<{ __typename?: 'attorney_profile_practice_area', practice_area_id?: { __typename?: 'catalog_practice_area', id: string, name?: string | null } | null } | null> | null }> };

export type CreateCasePurchaseMutationVariables = Exact<{
  data: Create_Case_Purchase_Input;
}>;


export type CreateCasePurchaseMutation = { __typename?: 'Mutation', create_case_purchase_item?: { __typename?: 'case_purchase', id: string } | null };

export type BulkCreateCasePurchaseMutationVariables = Exact<{
  data?: InputMaybe<Array<Create_Case_Purchase_Input> | Create_Case_Purchase_Input>;
}>;


export type BulkCreateCasePurchaseMutation = { __typename?: 'Mutation', create_case_purchase_items: Array<{ __typename?: 'case_purchase', id: string }> };

export type DeleteCaseMutationVariables = Exact<{
  deleteCaseItemId: Scalars['ID']['input'];
}>;


export type DeleteCaseMutation = { __typename?: 'Mutation', delete_case_item?: { __typename?: 'delete_one', id: string } | null };

export type UpdateCaseItemMutationVariables = Exact<{
  data: Update_Case_Input;
  updateCaseItemId: Scalars['ID']['input'];
}>;


export type UpdateCaseItemMutation = { __typename?: 'Mutation', update_case_item?: { __typename?: 'case', id: string } | null };

export type CreateCasePurchaseOwnershipItemMutationVariables = Exact<{
  data: Create_Case_Purchase_Ownership_Input;
}>;


export type CreateCasePurchaseOwnershipItemMutation = { __typename?: 'Mutation', create_case_purchase_ownership_item?: { __typename?: 'case_purchase_ownership', id: string } | null };

export type CreateCasePurchaseOwnershipItemsMutationVariables = Exact<{
  data?: InputMaybe<Array<Create_Case_Purchase_Ownership_Input> | Create_Case_Purchase_Ownership_Input>;
}>;


export type CreateCasePurchaseOwnershipItemsMutation = { __typename?: 'Mutation', create_case_purchase_ownership_items: Array<{ __typename?: 'case_purchase_ownership', id: string }> };

export type CreateCaseOwnershipItemsMutationVariables = Exact<{
  data?: InputMaybe<Array<Create_Case_Ownership_Input> | Create_Case_Ownership_Input>;
}>;


export type CreateCaseOwnershipItemsMutation = { __typename?: 'Mutation', create_case_ownership_items: Array<{ __typename?: 'case_ownership', case_id?: { __typename?: 'case', id: string } | null, user_id?: { __typename?: 'directus_users', id: string } | null }> };

export type DeleteCaseOwnershipItemMutationVariables = Exact<{
  deleteCaseOwnershipItemId: Scalars['ID']['input'];
}>;


export type DeleteCaseOwnershipItemMutation = { __typename?: 'Mutation', delete_case_ownership_item?: { __typename?: 'delete_one', id: string } | null };

export type DeleteCasePurchaseOwnershipItemMutationVariables = Exact<{
  deleteCasePurchaseOwnershipItemId: Scalars['ID']['input'];
}>;


export type DeleteCasePurchaseOwnershipItemMutation = { __typename?: 'Mutation', delete_case_purchase_ownership_item?: { __typename?: 'delete_one', id: string } | null };

export type UpdateCasePurchaseFeeAgreementStatusMutationVariables = Exact<{
  updateCasePurchaseItemId: Scalars['ID']['input'];
  data: Update_Case_Purchase_Input;
}>;


export type UpdateCasePurchaseFeeAgreementStatusMutation = { __typename?: 'Mutation', update_case_purchase_item?: { __typename?: 'case_purchase', id: string } | null };

export type UpdateCaseFilesForRepostMutationVariables = Exact<{
  data: Update_Case_File_Input;
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateCaseFilesForRepostMutation = { __typename?: 'Mutation', update_case_file_items: Array<{ __typename?: 'case_file', id: string }> };

export type GetCasesQueryVariables = Exact<{
  filter?: InputMaybe<Case_Filter>;
}>;


export type GetCasesQuery = { __typename?: 'Query', case: Array<{ __typename?: 'case', id: string, name?: string | null, description?: string | null, description_formatted?: string | null, following_count?: number | null, status?: string | null, fee?: number | null, incident_date?: any | null, proposal_due_date?: any | null, case_number?: string | null, case_alias?: string | null, created_ts?: any | null, internal_case_number?: string | null, mp_visibility?: { __typename?: 'catalog_case_mp_visibility', id: string, name?: string | null } | null, financing_source?: { __typename?: 'catalog_financing_source', name?: string | null, id: string } | null, type?: { __typename?: 'catalog_practice_area', id: string, name?: string | null } | null, leads?: Array<{ __typename?: 'case_lead', id: string, first_name?: string | null, last_name?: string | null, contacts?: Array<{ __typename?: 'case_lead_contact', value: string, type?: { __typename?: 'catalog_contact_type', id: string, name?: string | null } | null } | null> | null } | null> | null, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string, current_organization?: Array<{ __typename?: 'organization_user', id: string, organization_id?: { __typename?: 'organization', id: string, profiles?: Array<{ __typename?: 'organization_profile', name?: string | null } | null> | null } | null } | null> | null, avatar?: { __typename?: 'directus_files', id: string } | null } | null, profiles?: Array<{ __typename?: 'attorney_profile', bio?: string | null, first_name?: string | null, id: string, last_name?: string | null, firms?: Array<{ __typename?: 'attorney_profile_firm', id: string, name: string } | null> | null } | null> | null } | null, jurisdiction?: { __typename?: 'catalog_us_state', code?: string | null, name?: string | null } | null, preferred_language?: { __typename?: 'catalog_language', code?: string | null, id: string, name?: string | null } | null, process_stage?: { __typename?: 'catalog_process_stage', name?: string | null } | null, files?: Array<{ __typename?: 'case_file', id: string, file_id?: { __typename?: 'directus_files', id: string, title?: string | null, type?: string | null, filename_download: string, metadata?: any | null } | null } | null> | null, ownerships?: Array<{ __typename?: 'case_ownership', id: string, user_id?: { __typename?: 'directus_users', id: string, first_name?: string | null, last_name?: string | null, role?: { __typename?: 'directus_roles', id: string } | null, avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', id: string, organization_id?: { __typename?: 'organization', id: string } | null } | null> | null } | null } | null> | null, zip_code?: { __typename?: 'catalog_zip_code', city?: string | null, state?: string | null, zip_code: string } | null }> };

export type CaseExistsQueryVariables = Exact<{
  filter?: InputMaybe<Case_Filter>;
}>;


export type CaseExistsQuery = { __typename?: 'Query', case: Array<{ __typename?: 'case', id: string }> };

export type GetAcceptedPublicCasePurchasesQueryVariables = Exact<{
  filter?: InputMaybe<Case_Purchase_Filter>;
}>;


export type GetAcceptedPublicCasePurchasesQuery = { __typename?: 'Query', case_purchase: Array<{ __typename?: 'case_purchase', case_id?: { __typename?: 'case', id: string } | null }> };

export type IsDeletedQueryVariables = Exact<{
  filter?: InputMaybe<Case_Filter>;
}>;


export type IsDeletedQuery = { __typename?: 'Query', case: Array<{ __typename?: 'case', id: string, deleted?: boolean | null }> };

export type GetCasesForWithdrawalQueryVariables = Exact<{
  filter?: InputMaybe<Case_Filter>;
}>;


export type GetCasesForWithdrawalQuery = { __typename?: 'Query', case: Array<{ __typename?: 'case', id: string, attorney_id?: { __typename?: 'attorney', id: string, user_id?: { __typename?: 'directus_users', id: string, current_organization?: Array<{ __typename?: 'organization_user', id: string, organization_id?: { __typename?: 'organization', id: string } | null } | null> | null } | null } | null, mp_visibility?: { __typename?: 'catalog_case_mp_visibility', id: string } | null }> };

export type GetActivityPurchaseFromMyOrgQueryVariables = Exact<{
  filter?: InputMaybe<Case_Purchase_Activity_Filter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetActivityPurchaseFromMyOrgQuery = { __typename?: 'Query', case_purchase_activity: Array<{ __typename?: 'case_purchase_activity', id: string, created_ts?: any | null, activity_entry_status?: { __typename?: 'catalog_case_purchase_status', id: string, name?: string | null } | null, case_purchase_id?: { __typename?: 'case_purchase', case_id?: { __typename?: 'case', attorney_id?: { __typename?: 'attorney', id: string, user_id?: { __typename?: 'directus_users', id: string, current_organization?: Array<{ __typename?: 'organization_user', organization_id?: { __typename?: 'organization', id: string } | null } | null> | null } | null } | null } | null, prospect_attorney_id?: { __typename?: 'attorney', profiles?: Array<{ __typename?: 'attorney_profile', id: string, first_name?: string | null, last_name?: string | null, firms?: Array<{ __typename?: 'attorney_profile_firm', name: string } | null> | null, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string, email?: string | null, avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', organization_id?: { __typename?: 'organization', profiles?: Array<{ __typename?: 'organization_profile', name?: string | null } | null> | null } | null } | null> | null } | null } | null } | null> | null, user_id?: { __typename?: 'directus_users', id: string, email?: string | null, avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', organization_id?: { __typename?: 'organization', id: string, profiles?: Array<{ __typename?: 'organization_profile', name?: string | null } | null> | null } | null } | null> | null } | null } | null } | null }> };

export type GetCompleteCaseQueryVariables = Exact<{
  filter?: InputMaybe<Case_Filter>;
}>;


export type GetCompleteCaseQuery = { __typename?: 'Query', case: Array<{ __typename?: 'case', id: string, name?: string | null, description?: string | null, description_formatted?: string | null, following_count?: number | null, status?: string | null, fee?: number | null, incident_date?: any | null, proposal_due_date?: any | null, case_number?: string | null, case_alias?: string | null, created_ts?: any | null, internal_case_number?: string | null, client_currently_represented?: boolean | null, mp_visibility?: { __typename?: 'catalog_case_mp_visibility', id: string, name?: string | null } | null, financing_source?: { __typename?: 'catalog_financing_source', id: string, name?: string | null } | null, type?: { __typename?: 'catalog_practice_area', id: string, name?: string | null } | null, leads?: Array<{ __typename?: 'case_lead', id: string, first_name?: string | null, last_name?: string | null, contacts?: Array<{ __typename?: 'case_lead_contact', value: string, type?: { __typename?: 'catalog_contact_type', id: string, name?: string | null } | null } | null> | null } | null> | null, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string, current_organization?: Array<{ __typename?: 'organization_user', id: string, organization_id?: { __typename?: 'organization', id: string, profiles?: Array<{ __typename?: 'organization_profile', name?: string | null } | null> | null } | null } | null> | null, avatar?: { __typename?: 'directus_files', id: string } | null } | null, profiles?: Array<{ __typename?: 'attorney_profile', bio?: string | null, first_name?: string | null, id: string, last_name?: string | null, firms?: Array<{ __typename?: 'attorney_profile_firm', id: string, name: string } | null> | null } | null> | null } | null, jurisdiction?: { __typename?: 'catalog_us_state', id: string, code?: string | null, name?: string | null } | null, preferred_language?: { __typename?: 'catalog_language', id: string, code?: string | null, name?: string | null } | null, process_stage?: { __typename?: 'catalog_process_stage', id: string, name?: string | null } | null, files?: Array<{ __typename?: 'case_file', id: string } | null> | null, ownerships?: Array<{ __typename?: 'case_ownership', id: string, user_id?: { __typename?: 'directus_users', id: string, first_name?: string | null, last_name?: string | null, role?: { __typename?: 'directus_roles', id: string } | null, avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', id: string, organization_id?: { __typename?: 'organization', id: string } | null } | null> | null } | null } | null> | null, zip_code?: { __typename?: 'catalog_zip_code', city?: string | null, state?: string | null, zip_code: string } | null }> };

export type CatalogLanguageQueryVariables = Exact<{
  filter?: InputMaybe<Catalog_Language_Filter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CatalogLanguageQuery = { __typename?: 'Query', catalog_language: Array<{ __typename?: 'catalog_language', id: string, name?: string | null, code?: string | null }> };

export type CatalogUsStateQueryVariables = Exact<{
  filter?: InputMaybe<Catalog_Us_State_Filter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CatalogUsStateQuery = { __typename?: 'Query', catalog_us_state: Array<{ __typename?: 'catalog_us_state', id: string, code?: string | null, name?: string | null }> };

export type CatalogPracticeAreaQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CatalogPracticeAreaQuery = { __typename?: 'Query', catalog_practice_area: Array<{ __typename?: 'catalog_practice_area', id: string, is_default?: boolean | null, name?: string | null }> };

export type GradesQueryVariables = Exact<{ [key: string]: never; }>;


export type GradesQuery = { __typename?: 'Query', catalog_education_grade: Array<{ __typename?: 'catalog_education_grade', id: string, name?: string | null }> };

export type CaseTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CaseTypesQuery = { __typename?: 'Query', catalog_practice_area: Array<{ __typename?: 'catalog_practice_area', id: string, name?: string | null }> };

export type CatalogCasePurchaseDeclineReasonQueryVariables = Exact<{
  filter?: InputMaybe<Catalog_Case_Purchase_Decline_Reason_Filter>;
}>;


export type CatalogCasePurchaseDeclineReasonQuery = { __typename?: 'Query', catalog_case_purchase_decline_reason: Array<{ __typename?: 'catalog_case_purchase_decline_reason', id: string, name: string, is_case_relistable?: boolean | null }> };

export type MalpracticeInsuranceQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type MalpracticeInsuranceQuery = { __typename?: 'Query', catalog_malpractice_insurance: Array<{ __typename?: 'catalog_malpractice_insurance', id: string, name: string }> };

export type CatalogCommunicationPreferenceQueryVariables = Exact<{ [key: string]: never; }>;


export type CatalogCommunicationPreferenceQuery = { __typename?: 'Query', catalog_communication_preference: Array<{ __typename?: 'catalog_communication_preference', id: string, name: string }> };

export type GetCatalogWaterfallDurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCatalogWaterfallDurationQuery = { __typename?: 'Query', catalog_waterfall_duration: Array<{ __typename?: 'catalog_waterfall_duration', id: string, duration?: number | null, name?: string | null }> };

export type CatalogAffiliationsQueryVariables = Exact<{
  filter?: InputMaybe<Catalog_Affiliation_Filter>;
}>;


export type CatalogAffiliationsQuery = { __typename?: 'Query', catalog_affiliation: Array<{ __typename?: 'catalog_affiliation', id: string, is_hidden: boolean, name: string, badge_image_url?: string | null, priority?: number | null }> };

export type CatalogPriorityAccessTimesQueryVariables = Exact<{ [key: string]: never; }>;


export type CatalogPriorityAccessTimesQuery = { __typename?: 'Query', catalog_community_expiration_duration: Array<{ __typename?: 'catalog_community_expiration_duration', id: string, duration?: number | null, name?: string | null }> };

export type CatalogCaseStatusUpdateMatterStageQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CatalogCaseStatusUpdateMatterStageQuery = { __typename?: 'Query', catalog_case_status_update_matter_stage: Array<{ __typename?: 'catalog_case_status_update_matter_stage', id: string, name?: string | null, sort_order?: number | null }> };

export type CatalogCaseStatusUpdateMatterStatusQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CatalogCaseStatusUpdateMatterStatusQuery = { __typename?: 'Query', catalog_case_status_update_matter_status: Array<{ __typename?: 'catalog_case_status_update_matter_status', id: string, name?: string | null, sort_order?: number | null }> };

export type CreateCreditsPaymentMutationVariables = Exact<{
  data: Create_Case_Purchase_Payment_Input;
}>;


export type CreateCreditsPaymentMutation = { __typename?: 'Mutation', create_case_purchase_payment_item?: { __typename?: 'case_purchase_payment', id: string } | null };

export type CreateFileAccessRequestMutationVariables = Exact<{
  data: Create_User_File_Access_Request_Input;
}>;


export type CreateFileAccessRequestMutation = { __typename?: 'Mutation', create_user_file_access_request_item?: { __typename?: 'user_file_access_request', id: string } | null };

export type CreateBulkFileAccessRequestMutationVariables = Exact<{
  data?: InputMaybe<Array<Create_User_File_Access_Request_Input> | Create_User_File_Access_Request_Input>;
}>;


export type CreateBulkFileAccessRequestMutation = { __typename?: 'Mutation', create_user_file_access_request_items: Array<{ __typename?: 'user_file_access_request', id: string }> };

export type UpdateUserFileAccessRequestItemMutationVariables = Exact<{
  updateUserFileAccessRequestItemId: Scalars['ID']['input'];
  data: Update_User_File_Access_Request_Input;
}>;


export type UpdateUserFileAccessRequestItemMutation = { __typename?: 'Mutation', update_user_file_access_request_item?: { __typename?: 'user_file_access_request', id: string } | null };

export type GetUserFileAccessRequestQueryVariables = Exact<{
  filter?: InputMaybe<User_File_Access_Request_Filter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetUserFileAccessRequestQuery = { __typename?: 'Query', user_file_access_request: Array<{ __typename?: 'user_file_access_request', id: string, is_granted?: boolean | null, created_ts?: any | null, attorney_id?: { __typename?: 'attorney', id: string, user_id?: { __typename?: 'directus_users', id: string } | null, profiles?: Array<{ __typename?: 'attorney_profile', first_name?: string | null, last_name?: string | null, attorney_id?: { __typename?: 'attorney', is_vetted?: boolean | null, user_id?: { __typename?: 'directus_users', avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', organization_id?: { __typename?: 'organization', profiles?: Array<{ __typename?: 'organization_profile', name?: string | null } | null> | null } | null } | null> | null } | null } | null } | null> | null } | null, status?: { __typename?: 'catalog_access_request_status', id: string } | null }> };

export type RemoveFavoriteAttorneyMutationVariables = Exact<{
  deleteAttorneyFavoriteItemId: Scalars['ID']['input'];
}>;


export type RemoveFavoriteAttorneyMutation = { __typename?: 'Mutation', delete_attorney_favorite_item?: { __typename?: 'delete_one', id: string } | null };

export type AddFavoriteAttorneyMutationVariables = Exact<{
  data: Create_Attorney_Favorite_Input;
}>;


export type AddFavoriteAttorneyMutation = { __typename?: 'Mutation', create_attorney_favorite_item?: { __typename?: 'attorney_favorite', id: string } | null };

export type GetFavoritesByUserIdQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Favorite_Filter>;
}>;


export type GetFavoritesByUserIdQuery = { __typename?: 'Query', attorney_favorite: Array<{ __typename?: 'attorney_favorite', id: string, favorite_attorney_id?: { __typename?: 'attorney', id: string, profiles?: Array<{ __typename?: 'attorney_profile', first_name?: string | null, last_name?: string | null, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string, avatar?: { __typename?: 'directus_files', id: string } | null } | null } | null, firms?: Array<{ __typename?: 'attorney_profile_firm', name: string } | null> | null, practice_areas?: Array<{ __typename?: 'attorney_profile_practice_area', practice_area_id?: { __typename?: 'catalog_practice_area', name?: string | null } | null } | null> | null } | null> | null } | null }> };

export type CreateIntegrationMutationVariables = Exact<{
  data: Create_Attorney_Oauth_Integration_Input;
}>;


export type CreateIntegrationMutation = { __typename?: 'Mutation', create_attorney_oauth_integration_item?: { __typename?: 'attorney_oauth_integration', code: string } | null };

export type DeleteIntegrationItemMutationVariables = Exact<{
  deleteAttorneyOauthIntegrationItemId: Scalars['ID']['input'];
}>;


export type DeleteIntegrationItemMutation = { __typename?: 'Mutation', delete_attorney_oauth_integration_item?: { __typename?: 'delete_one', id: string } | null };

export type CreateLcmsMappingMutationVariables = Exact<{
  data: Create_Lcms_Case_Mapping_Input;
}>;


export type CreateLcmsMappingMutation = { __typename?: 'Mutation', create_lcms_case_mapping_item?: { __typename?: 'lcms_case_mapping', case_id: string } | null };

export type GetIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntegrationsQuery = { __typename?: 'Query', catalog_oauth_integration: Array<{ __typename?: 'catalog_oauth_integration', id: string, name: string, connect_url_envar: string }> };

export type GetAttorneyIntegrationsQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Oauth_Integration_Filter>;
}>;


export type GetAttorneyIntegrationsQuery = { __typename?: 'Query', attorney_oauth_integration: Array<{ __typename?: 'attorney_oauth_integration', id: string, code: string, attorney_id?: { __typename?: 'attorney', id: string } | null, integration_id?: { __typename?: 'catalog_oauth_integration', id: string, name: string, connect_url_envar: string } | null }> };

export type GetOrganizationConnectedQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationConnectedQuery = { __typename?: 'Query', organization_connected_lcms: Array<{ __typename?: 'organization_connected_lcms', id: string, case_management_software_id?: { __typename?: 'case_management_software', id: string, name?: string | null } | null, organization_id?: { __typename?: 'organization', id: string } | null, created_by?: { __typename?: 'directus_users', id: string, role?: { __typename?: 'directus_roles', id: string } | null } | null }> };

export type BulkInviteAttorneyMutationVariables = Exact<{
  data?: InputMaybe<Array<Create_Attorney_Invite_Input> | Create_Attorney_Invite_Input>;
}>;


export type BulkInviteAttorneyMutation = { __typename?: 'Mutation', create_attorney_invite_items: Array<{ __typename?: 'attorney_invite', id: string, email: string, token?: string | null }> };

export type UpdateInviteAttorneyMutationVariables = Exact<{
  updateAttorneyInviteItemId: Scalars['ID']['input'];
  data: Update_Attorney_Invite_Input;
}>;


export type UpdateInviteAttorneyMutation = { __typename?: 'Mutation', update_attorney_invite_item?: { __typename?: 'attorney_invite', id: string } | null };

export type BulkUpdateNetworkUserInviteMutationVariables = Exact<{
  data?: InputMaybe<Array<Create_Network_User_Invite_Input> | Create_Network_User_Invite_Input>;
}>;


export type BulkUpdateNetworkUserInviteMutation = { __typename?: 'Mutation', create_network_user_invite_items: Array<{ __typename?: 'network_user_invite', id: string, email: string, first_name: string, last_name: string }> };

export type UpdateOrganziationItemMutationVariables = Exact<{
  updateOrganizationUserItemId: Scalars['ID']['input'];
  data: Update_Organization_User_Input;
}>;


export type UpdateOrganziationItemMutation = { __typename?: 'Mutation', update_organization_user_item?: { __typename?: 'organization_user', id: string } | null };

export type GetRoleInviteCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoleInviteCatalogQuery = { __typename?: 'Query', catalog_role_invite: Array<{ __typename?: 'catalog_role_invite', name?: string | null, role_id?: { __typename?: 'directus_roles', id: string } | null }> };

export type GetInvitationsSentQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Invite_Filter>;
}>;


export type GetInvitationsSentQuery = { __typename?: 'Query', attorney_invite: Array<{ __typename?: 'attorney_invite', id: string, email: string, sent_ts?: any | null, invite_status_id?: { __typename?: 'catalog_invite_status', id: string } | null, target_role_id?: { __typename?: 'directus_roles', id: string, name: string } | null }> };

export type GetNetworkUserInvitesSentQueryVariables = Exact<{
  filter?: InputMaybe<Network_User_Invite_Filter>;
}>;


export type GetNetworkUserInvitesSentQuery = { __typename?: 'Query', network_user_invite: Array<{ __typename?: 'network_user_invite', id: string, email: string, first_name: string, last_name: string, send_ts?: any | null }> };

export type GetOrganizationMembersQueryVariables = Exact<{
  filter?: InputMaybe<Organization_User_Filter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetOrganizationMembersQuery = { __typename?: 'Query', organization_user: Array<{ __typename?: 'organization_user', id: string, user_id?: { __typename?: 'directus_users', id: string, first_name?: string | null, last_name?: string | null, role?: { __typename?: 'directus_roles', id: string, name: string } | null, avatar?: { __typename?: 'directus_files', id: string } | null, attorneys?: Array<{ __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, profiles?: Array<{ __typename?: 'attorney_profile', first_name?: string | null, last_name?: string | null, affiliations?: Array<{ __typename?: 'attorney_profile_affiliation', affiliation_id?: { __typename?: 'catalog_affiliation', id: string, name: string, badge_image_url?: string | null, priority?: number | null } | null } | null> | null } | null> | null } | null> | null, current_organization?: Array<{ __typename?: 'organization_user', position_name?: string | null } | null> | null } | null }> };

export type CreateCaseMpPreferenceMutationVariables = Exact<{
  data: Create_Attorney_Case_Mp_Preference_Input;
}>;


export type CreateCaseMpPreferenceMutation = { __typename?: 'Mutation', create_attorney_case_mp_preference_item?: { __typename?: 'attorney_case_mp_preference', id: string } | null };

export type DeleteCaseMpPreferenceItemMutationVariables = Exact<{
  deleteAttorneyCaseMpPreferenceItemId: Scalars['ID']['input'];
}>;


export type DeleteCaseMpPreferenceItemMutation = { __typename?: 'Mutation', delete_attorney_case_mp_preference_item?: { __typename?: 'delete_one', id: string } | null };

export type GetMarketplacePreferencesQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Case_Mp_Preference_Filter>;
}>;


export type GetMarketplacePreferencesQuery = { __typename?: 'Query', attorney_case_mp_preference: Array<{ __typename?: 'attorney_case_mp_preference', id: string, case_id?: { __typename?: 'case', id: string } | null, case_mp_preference_id?: { __typename?: 'catalog_case_mp_preference', id: string, name?: string | null } | null }> };

export type GetAttorneyPaymentMembershipQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Payment_Membership_Filter>;
}>;


export type GetAttorneyPaymentMembershipQuery = { __typename?: 'Query', attorney_payment_membership: Array<{ __typename?: 'attorney_payment_membership', payment_status_id?: { __typename?: 'catalog_payment_status', id: string } | null }> };

export type CreateCaseStatusUpdateMutationVariables = Exact<{
  data: Create_Case_Status_Update_Input;
}>;


export type CreateCaseStatusUpdateMutation = { __typename?: 'Mutation', create_case_status_update_item?: { __typename?: 'case_status_update', id: string } | null };

export type CreateCaseStatusSchedulerTaskMutationVariables = Exact<{
  data: Create_Case_Status_Update_Scheduler_Task_Input;
}>;


export type CreateCaseStatusSchedulerTaskMutation = { __typename?: 'Mutation', create_case_status_update_scheduler_task_item?: { __typename?: 'case_status_update_scheduler_task', id: string } | null };

export type UpdateCaseStatusSchedulerTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: Update_Case_Status_Update_Scheduler_Task_Input;
}>;


export type UpdateCaseStatusSchedulerTaskMutation = { __typename?: 'Mutation', update_case_status_update_scheduler_task_item?: { __typename?: 'case_status_update_scheduler_task', id: string } | null };

export type GetOrganizationsQueryVariables = Exact<{
  filter?: InputMaybe<Organization_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', organization: Array<{ __typename?: 'organization', id: string, profiles?: Array<{ __typename?: 'organization_profile', name?: string | null } | null> | null }> };

export type GetAttorneysProfileByIdQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Profile_Filter>;
  licenseFilter?: InputMaybe<Attorney_Profile_License_Filter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  profileSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetAttorneysProfileByIdQuery = { __typename?: 'Query', attorney_profile_aggregated: Array<{ __typename?: 'attorney_profile_aggregated', countDistinct?: { __typename?: 'attorney_profile_aggregated_count', attorney_id?: number | null } | null }>, attorney_profile: Array<{ __typename?: 'attorney_profile', id: string, first_name?: string | null, last_name?: string | null, bio?: string | null, years_practice?: { __typename?: 'catalog_years_practice', name?: string | null } | null, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string, email?: string | null, last_access?: any | null, avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', id: string, position_name?: string | null, organization_id?: { __typename?: 'organization', id: string } | null } | null> | null } | null } | null, affiliations?: Array<{ __typename?: 'attorney_profile_affiliation', affiliation_id?: { __typename?: 'catalog_affiliation', id: string, name: string, badge_image_url?: string | null, priority?: number | null } | null } | null> | null, awards?: Array<{ __typename?: 'attorney_profile_award', award_id?: { __typename?: 'catalog_award', id: string, name?: string | null } | null } | null> | null, firms?: Array<{ __typename?: 'attorney_profile_firm', name: string, address: string, city?: string | null, zip?: number | null, state?: { __typename?: 'catalog_us_state', name?: string | null, code?: string | null } | null, size?: { __typename?: 'catalog_company_size', name?: string | null } | null, relationship?: { __typename?: 'catalog_firm_relationship', name?: string | null } | null } | null> | null, contacts?: Array<{ __typename?: 'attorney_profile_contact', value: string, type?: { __typename?: 'catalog_contact_type', name?: string | null } | null } | null> | null, education?: Array<{ __typename?: 'attorney_profile_education', grade?: { __typename?: 'catalog_education_grade', id: string, name?: string | null } | null, school_id?: { __typename?: 'school', id: string, name?: string | null } | null } | null> | null, licenses?: Array<{ __typename?: 'attorney_profile_license', bar_number: string, has_been_disciplined_by_bar: boolean, has_been_sued_by_malpractice: boolean, is_license_suspended: boolean, license_state?: { __typename?: 'catalog_us_state', name?: string | null, code?: string | null } | null, insurances?: Array<{ __typename?: 'attorney_profile_license_insurance', expiration_date?: any | null, insurance_coverage_id?: { __typename?: 'catalog_malpractice_insurance', id: string } | null } | null> | null } | null> | null, case_management_softwares?: Array<{ __typename?: 'attorney_profile_case_management_software', case_management_software_id?: { __typename?: 'case_management_software', name?: string | null } | null } | null> | null, languages?: Array<{ __typename?: 'attorney_profile_language', language_id?: { __typename?: 'catalog_language', id: string, name?: string | null } | null } | null> | null, practice_areas?: Array<{ __typename?: 'attorney_profile_practice_area', practice_area_id?: { __typename?: 'catalog_practice_area', id: string, name?: string | null } | null } | null> | null }> };

export type UpdateAttorneyProfileItemMutationVariables = Exact<{
  data: Update_Attorney_Profile_Input;
  updateAttorneyProfileItemId: Scalars['ID']['input'];
}>;


export type UpdateAttorneyProfileItemMutation = { __typename?: 'Mutation', update_attorney_profile_item?: { __typename?: 'attorney_profile', first_name?: string | null, bio?: string | null, last_name?: string | null, languages?: Array<{ __typename?: 'attorney_profile_language', language_id?: { __typename?: 'catalog_language', id: string, name?: string | null } | null } | null> | null, awards?: Array<{ __typename?: 'attorney_profile_award', id: string, award_id?: { __typename?: 'catalog_award', id: string, name?: string | null } | null } | null> | null } | null };

export type DeleteAttorneyProfileLanguageItemMutationVariables = Exact<{
  deleteAttorneyProfileLanguageItemId: Scalars['ID']['input'];
}>;


export type DeleteAttorneyProfileLanguageItemMutation = { __typename?: 'Mutation', delete_attorney_profile_language_item?: { __typename?: 'delete_one', id: string } | null };

export type DeleteAttorneyProfileAwardItemMutationVariables = Exact<{
  deleteAttorneyProfileAwardItemId: Scalars['ID']['input'];
}>;


export type DeleteAttorneyProfileAwardItemMutation = { __typename?: 'Mutation', delete_attorney_profile_award_item?: { __typename?: 'delete_one', id: string } | null };

export type DeleteAttorneyProfileLanguageItemsMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteAttorneyProfileLanguageItemsMutation = { __typename?: 'Mutation', delete_attorney_profile_language_items?: { __typename?: 'delete_many', ids: Array<string | null> } | null };

export type DeleteAttorneyProfileAwardItemsMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteAttorneyProfileAwardItemsMutation = { __typename?: 'Mutation', delete_attorney_profile_award_items?: { __typename?: 'delete_many', ids: Array<string | null> } | null };

export type DeleteAttorneyProfilePracticeAreaItemsMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteAttorneyProfilePracticeAreaItemsMutation = { __typename?: 'Mutation', delete_attorney_profile_practice_area_items?: { __typename?: 'delete_many', ids: Array<string | null> } | null };

export type UpdateAttorneyProfileMutationVariables = Exact<{
  updateAttorneyProfileItemId: Scalars['ID']['input'];
  data: Update_Attorney_Profile_Input;
}>;


export type UpdateAttorneyProfileMutation = { __typename?: 'Mutation', update_attorney_profile_item?: { __typename?: 'attorney_profile', id: string } | null };

export type DeleteAttorneyProfileEducationItemsMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteAttorneyProfileEducationItemsMutation = { __typename?: 'Mutation', delete_attorney_profile_education_items?: { __typename?: 'delete_many', ids: Array<string | null> } | null };

export type CreateEmailNotificationLevelMutationVariables = Exact<{
  data?: InputMaybe<Array<Create_Attorney_Profile_Notification_Level_Input> | Create_Attorney_Profile_Notification_Level_Input>;
}>;


export type CreateEmailNotificationLevelMutation = { __typename?: 'Mutation', create_attorney_profile_notification_level_items: Array<{ __typename?: 'attorney_profile_notification_level', notification_level?: { __typename?: 'catalog_notification_level', id: string } | null }> };

export type UpdateEmailNotificationLevelMutationVariables = Exact<{
  updateAttorneyProfileNotificationLevelItemId: Scalars['ID']['input'];
  data: Update_Attorney_Profile_Notification_Level_Input;
}>;


export type UpdateEmailNotificationLevelMutation = { __typename?: 'Mutation', update_attorney_profile_notification_level_item?: { __typename?: 'attorney_profile_notification_level', id: string } | null };

export type AttorneyQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Filter>;
  educationSort2?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  licenseSort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  licenseFilter?: InputMaybe<Attorney_Profile_License_Filter>;
}>;


export type AttorneyQuery = { __typename?: 'Query', attorney: Array<{ __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', current_organization?: Array<{ __typename?: 'organization_user', id: string, position_bio?: string | null, position_name?: string | null } | null> | null } | null, profiles?: Array<{ __typename?: 'attorney_profile', bio?: string | null, first_name?: string | null, last_name?: string | null, id: string, languages?: Array<{ __typename?: 'attorney_profile_language', id: string, language_id?: { __typename?: 'catalog_language', name?: string | null, id: string, code?: string | null } | null } | null> | null, awards?: Array<{ __typename?: 'attorney_profile_award', id: string, award_id?: { __typename?: 'catalog_award', id: string, name?: string | null } | null } | null> | null, affiliations?: Array<{ __typename?: 'attorney_profile_affiliation', affiliation_id?: { __typename?: 'catalog_affiliation', id: string, name: string, badge_image_url?: string | null, priority?: number | null } | null } | null> | null, firms?: Array<{ __typename?: 'attorney_profile_firm', id: string, name: string, city?: string | null, address: string, zip?: number | null, state?: { __typename?: 'catalog_us_state', code?: string | null, id: string, name?: string | null } | null, size?: { __typename?: 'catalog_company_size', id: string, name?: string | null } | null, relationship?: { __typename?: 'catalog_firm_relationship', id: string, name?: string | null } | null } | null> | null, education?: Array<{ __typename?: 'attorney_profile_education', id: string, school_id?: { __typename?: 'school', id: string, name?: string | null } | null, grade?: { __typename?: 'catalog_education_grade', id: string, name?: string | null } | null } | null> | null, licenses?: Array<{ __typename?: 'attorney_profile_license', id: string, bar_number: string, has_been_disciplined_by_bar: boolean, has_been_sued_by_malpractice: boolean, is_license_suspended: boolean, license_state?: { __typename?: 'catalog_us_state', name?: string | null, code?: string | null } | null, insurances?: Array<{ __typename?: 'attorney_profile_license_insurance', id: string, expiration_date?: any | null, insurance_coverage_id?: { __typename?: 'catalog_malpractice_insurance', id: string } | null } | null> | null } | null> | null, practice_areas?: Array<{ __typename?: 'attorney_profile_practice_area', id: string, practice_area_id?: { __typename?: 'catalog_practice_area', id: string, is_default?: boolean | null, name?: string | null } | null } | null> | null, years_practice?: { __typename?: 'catalog_years_practice', id: string, name?: string | null } | null, case_management_softwares?: Array<{ __typename?: 'attorney_profile_case_management_software', id: string, case_management_software_id?: { __typename?: 'case_management_software', id: string, name?: string | null } | null } | null> | null } | null> | null }> };

export type AttorneyByEmailQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Filter>;
}>;


export type AttorneyByEmailQuery = { __typename?: 'Query', attorney: Array<{ __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string } | null, profiles?: Array<{ __typename?: 'attorney_profile', id: string } | null> | null }> };

export type PracticeAreasQueryVariables = Exact<{
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type PracticeAreasQuery = { __typename?: 'Query', catalog_practice_area: Array<{ __typename?: 'catalog_practice_area', id: string, name?: string | null, is_default?: boolean | null }> };

export type LawFirmCatalogsQueryVariables = Exact<{
  sortCaseSoftware?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  catalogFirmRelationshipSort2?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  catalogUsStateSort2?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  catalogYearsPracticeSort2?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type LawFirmCatalogsQuery = { __typename?: 'Query', catalog_company_size: Array<{ __typename?: 'catalog_company_size', id: string, name?: string | null }>, catalog_firm_relationship: Array<{ __typename?: 'catalog_firm_relationship', id: string, name?: string | null }>, catalog_years_practice: Array<{ __typename?: 'catalog_years_practice', id: string, name?: string | null }>, case_management_software: Array<{ __typename?: 'case_management_software', id: string, name?: string | null }>, catalog_us_state: Array<{ __typename?: 'catalog_us_state', id: string, name?: string | null, code?: string | null }> };

export type SchoolsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<School_Filter>;
}>;


export type SchoolsQuery = { __typename?: 'Query', school: Array<{ __typename?: 'school', id: string, name?: string | null }> };

export type AwardsQueryVariables = Exact<{ [key: string]: never; }>;


export type AwardsQuery = { __typename?: 'Query', catalog_award: Array<{ __typename?: 'catalog_award', id: string, name?: string | null }> };

export type AttorneyNameAndOrgQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Profile_Filter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AttorneyNameAndOrgQuery = { __typename?: 'Query', attorney_profile: Array<{ __typename?: 'attorney_profile', id: string, first_name?: string | null, last_name?: string | null, attorney_id?: { __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, user_id?: { __typename?: 'directus_users', id: string, avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', id: string, organization_id?: { __typename?: 'organization', id: string, profiles?: Array<{ __typename?: 'organization_profile', name?: string | null } | null> | null } | null } | null> | null } | null } | null, affiliations?: Array<{ __typename?: 'attorney_profile_affiliation', affiliation_id?: { __typename?: 'catalog_affiliation', id: string, name: string, priority?: number | null, badge_image_url?: string | null } | null } | null> | null }> };

export type GetVettedAttorneysInOrgQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Filter>;
}>;


export type GetVettedAttorneysInOrgQuery = { __typename?: 'Query', attorney: Array<{ __typename?: 'attorney', id: string, is_vetted?: boolean | null, membership_type?: { __typename?: 'catalog_membership_type', id: string } | null, profiles?: Array<{ __typename?: 'attorney_profile', first_name?: string | null, last_name?: string | null } | null> | null, user_id?: { __typename?: 'directus_users', id: string, first_name?: string | null, last_name?: string | null, avatar?: { __typename?: 'directus_files', id: string } | null, current_organization?: Array<{ __typename?: 'organization_user', organization_id?: { __typename?: 'organization', id: string } | null } | null> | null } | null }> };

export type GetCaseManagersInOrgQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Filter>;
}>;


export type GetCaseManagersInOrgQuery = { __typename?: 'Query', attorney: Array<{ __typename?: 'attorney', id: string, is_vetted?: boolean | null, user_id?: { __typename?: 'directus_users', id: string, first_name?: string | null, last_name?: string | null, avatar?: { __typename?: 'directus_files', id: string } | null } | null }> };

export type GetCommunicationPreferencesQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Profile_Filter>;
}>;


export type GetCommunicationPreferencesQuery = { __typename?: 'Query', attorney_profile: Array<{ __typename?: 'attorney_profile', id: string, communication_preference?: Array<{ __typename?: 'attorney_profile_communication_preference', is_sms_enabled?: boolean | null, is_notification_enabled: boolean, is_email_enabled?: boolean | null, id: string, notification_level?: { __typename?: 'catalog_communication_preference', name: string, id: string } | null } | null> | null, attorney_id?: { __typename?: 'attorney', user_id?: { __typename?: 'directus_users', role?: { __typename?: 'directus_roles', id: string } | null } | null } | null }> };

export type GetEmailNotificationLevelQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Profile_Filter>;
}>;


export type GetEmailNotificationLevelQuery = { __typename?: 'Query', attorney_profile: Array<{ __typename?: 'attorney_profile', id: string, notification_levels?: Array<{ __typename?: 'attorney_profile_notification_level', id: string, notification_level?: { __typename?: 'catalog_notification_level', id: string, name?: string | null, sort_order?: number | null } | null } | null> | null }> };

export type Attorney_StripeQueryVariables = Exact<{
  filter?: InputMaybe<Attorney_Stripe_Filter>;
}>;


export type Attorney_StripeQuery = { __typename?: 'Query', attorney_stripe: Array<{ __typename?: 'attorney_stripe', stripe_customer_id?: string | null }> };

export type CheckValidationAndInvitationQueryVariables = Exact<{
  filter?: InputMaybe<User_Email_Validation_Filter>;
  attorneyInviteFilter?: InputMaybe<Attorney_Invite_Filter>;
}>;


export type CheckValidationAndInvitationQuery = { __typename?: 'Query', user_email_validation: Array<{ __typename?: 'user_email_validation', validation_ts?: any | null, email: string }>, attorney_invite: Array<{ __typename?: 'attorney_invite', email: string }> };
